import React, { createContext, useContext, useState, useEffect } from "react";

const dict = {
  it: {
    tagline: "Lasciare il mondo migliore di come lo abbiamo trovato.",
    hero_title: "Segnala. Verifica. Ripulisci.",
    hero_subtitle: "ToClean è la piattaforma globale per trasformare una segnalazione in un'azione concreta. Cittadini, volontari, associazioni e comuni, insieme sulla stessa mappa.",
    cta_map: "Apri la mappa",
    cta_report: "Crea segnalazione",
    cta_signin: "Accedi",
    cta_signup: "Registrati",
    cta_google: "Continua con Google",
    cta_donate: "Sostieni",
    nav_map: "Mappa",
    nav_stories: "Storie positive",
    nav_leaderboard: "Classifica",
    nav_profile: "Profilo",
    nav_admin: "Admin",
    nav_settings: "Impostazioni",
    nav_admin_dashboard: "Dashboard Admin",
    stats_reports: "segnalazioni totali",
    stats_resolved: "problemi risolti",
    stats_pending: "in lavorazione",
    stats_users: "membri attivi",
    filters: "Filtri",
    category: "Categoria",
    all: "Tutte",
    risk_level: "Rischio",
    status: "Stato",
    green: "Verde", yellow: "Giallo", red: "Rosso",
    st_published: "Pubblicata",
    st_in_progress: "In corso",
    st_resolved: "Risolta",
    st_pending: "In attesa",
    st_pending_moderation: "Da approvare",
    st_concluded: "Concluso",
    st_archived: "Archiviato",
    cat_waste: "Rifiuti",
    cat_environment: "Ambiente",
    cat_animals: "Animali",
    cat_urban: "Degrado urbano",
    cat_vegetation: "Vegetazione pericolosa su strada",
    cat_reusable: "Oggetti riutilizzabili",
    new_report: "Nuova segnalazione",
    subcategory: "Sottocategoria",
    description: "Descrizione",
    upload_photos: "Carica foto",
    submit: "Invia segnalazione",
    cancel: "Annulla",
    email: "Email",
    password: "Password",
    name: "Nome",
    role: "Ruolo",
    citizen: "Cittadino",
    volunteer: "Volontario",
    association: "Associazione",
    company: "Azienda / Sponsor",
    municipality: "Comune / Ente",
    operator: "Operatore",
    already: "Hai già un account?",
    new_here: "Nuovo su ToClean?",
    signin_now: "Accedi",
    signup_now: "Registrati",
    coordinate: "Coordina l'intervento",
    send_message: "Invia",
    write_message: "Scrivi un messaggio…",
    confirm: "Conferma",
    confirm_still: "Il problema esiste ancora",
    confirm_worsened: "È peggiorato",
    confirm_resolved: "Sembra risolto",
    confirm_not: "Non è più presente",
    take_item: "Ho preso l'oggetto",
    interested: "Sono interessato",
    logout: "Esci",
    reports_created: "Segnalazioni create",
    confirmations_made: "Conferme fornite",
    reputation: "Reputazione",
    donation_title: "Sostieni ToClean",
    donation_desc: "Il tuo contributo finanzia interventi verificati, ricompense per i volontari e lo sviluppo della piattaforma.",
    donation_amount: "Importo",
    donation_message: "Messaggio (opzionale)",
    donate_now: "Dona ora",
    donate_min_amount: "Importo minimo: 0,50 €. Puoi anche donare senza registrarti.",
    donate_min_error: "Importo minimo 0,50 €",
    donate_stripe_error: "Errore Stripe",
    donate_redirect: "Redirect…",
    donate_message_placeholder: "Un pensiero per la community…",
    donate_secure: "Pagamento sicuro via Stripe. Test card:",
    positive_title: "Storie positive dalla comunità",
    positive_desc: "Ogni marker grigio è un problema che qualcuno ha reso invisibile.",
    positive_empty: "Nessuna storia ancora. Le tue conferme e i tuoi interventi possono diventare la prossima.",
    positive_solved: "Risolto",
    ai_analyze: "Analizza con AI",
    ai_suggested: "Suggerimento AI",
    emergency_notice: "Nelle emergenze immediate (incendi, animali in pericolo di vita, sostanze pericolose) contatta subito i servizi di emergenza locali.",
    footer_mission: "ToClean è una piattaforma per l'azione ambientale. Ogni segnalazione conta.",
    footer_platform: "Piattaforma",
    footer_platform_items: "Mappa · Segnalazioni · Chat · Ricompense",
    footer_platform_lang: "Multi-lingua (IT · EN)",
    footer_platform_ai: "Moderazione AI (GPT-5.2)",
    footer_community: "Community",
    footer_made: "Creato con i volontari, per il pianeta.",
    hero_slide1_title: "Il pianeta è bellissimo.",
    hero_slide1_sub: "Ogni gesto minuscolo decide se lo resterà.",
    hero_slide2_title: "Insieme si può.",
    hero_slide2_sub: "Cittadini, volontari, associazioni, aziende, comuni — sulla stessa mappa.",
    hero_slide3_title: "Un'azione, una prova.",
    hero_slide3_sub: "Foto prima e dopo, ricevute, cronologia pubblica di ogni intervento.",
    hero_prev: "Precedente",
    hero_next: "Successivo",
    hero_play: "Play",
    hero_pause: "Pausa",
    hero_mute_on: "Attiva audio",
    hero_mute_off: "Muto",
    community_verified: "Community · verified",
    hero_action_leaves_mark: "Ogni azione lascia un segno.",
    risk_green_low: "Verde · Basso",
    risk_green_desc: "Piccoli rifiuti, oggetti, materiali non pericolosi.",
    risk_red_high: "Rosso · Alto",
    risk_red_desc: "Sostanze pericolose, maltrattamento animale, prove sensibili.",
    mission_kicker: "Missione & Scopo",
    mission_title: "Un pianeta più pulito non aspetta l'autorizzazione di nessuno.",
    mission_p1: "ToClean è una piattaforma <b>indipendente</b> nata per mettere in contatto chi vede un problema con chi può risolverlo. Cittadini, volontari, associazioni, aziende e amministrazioni — sulla stessa mappa, con gli stessi strumenti, per lo stesso obiettivo.",
    mission_p2: "Non è un altro social. Non è una petizione. È uno strumento operativo: <b>foto, verifica, coordinamento, prova del risultato.</b> Semplice, trasparente, verificabile.",
    // ---- MissionPage /missione (contenuto approvato — versione recuperata dalla cronologia c0d38b5)
    missionpage_kicker: "Missione",
    missionpage_title: "La nostra missione",
    missionpage_intro: "ToClean nasce per rendere la tutela dell'ambiente più semplice, concreta e condivisa. Vogliamo offrire alle persone uno spazio in cui segnalare problemi ambientali, seguire ciò che accade sul territorio, collaborare con la community e dare nuova vita agli oggetti ancora utilizzabili.",
    missionpage_s1_title: "Partecipazione ambientale",
    missionpage_s1_body: "ToClean permette alle persone di contribuire alla cura del territorio attraverso segnalazioni ambientali, aggiornamenti, iniziative locali ed eventi straordinari. Ogni contributo può aiutare a rendere più visibili i problemi e a favorire interventi, collaborazione e responsabilità condivisa.",
    missionpage_s2_title: "Riuso e community",
    missionpage_s2_body: "Attraverso le sezioni Vendo, Regalo e Oggetti riutilizzabili trovati, ToClean vuole ridurre gli sprechi e facilitare il riutilizzo di ciò che può ancora essere utile. L'obiettivo non è soltanto creare un Marketplace, ma favorire una community più attenta, responsabile e vicina al territorio.",
    missionpage_s3_title: "Donazioni e crescita del progetto",
    missionpage_s3_body: "Le persone potranno sostenere ToClean, le segnalazioni ambientali e i progetti di riforestazione attraverso contributi volontari. Le risorse raccolte potranno contribuire allo sviluppo, alla gestione e alla crescita del progetto, nel rispetto delle regole e delle informazioni che saranno rese pubbliche.",
    missionpage_future_title: "Visione futura: sponsor e ricompense",
    missionpage_future_p1: "ToClean crede che chi dedica tempo, energie e impegno concreto alla tutela dell'ambiente meriti di essere valorizzato.",
    missionpage_future_p2: "Con la crescita della community e il futuro sostegno di aziende, enti e sponsor, vogliamo sviluppare un programma trasparente di riconoscimento e ricompensa per i volontari più attivi e per le iniziative ambientali più significative.",
    missionpage_future_p3: "Gli sponsor potranno sostenere il progetto, contribuire alle ricompense e ottenere una visibilità chiaramente riconoscibile come sponsorizzazione. Una parte delle risorse potrà inoltre contribuire ai costi necessari per mantenere e far crescere ToClean.",
    missionpage_rewards_title: "Possibili ricompense future",
    missionpage_rewards_1: "Buoni o sconti messi a disposizione dagli sponsor",
    missionpage_rewards_2: "Prodotti ecosostenibili",
    missionpage_rewards_3: "Partecipazione a esperienze o eventi",
    missionpage_rewards_4: "Badge e riconoscimenti digitali",
    missionpage_rewards_5: "Premi collegati a iniziative ambientali",
    missionpage_rewards_6: "Sostegno concreto a gruppi o progetti di volontariato",
    missionpage_disclaimer: "Il programma di ricompense non è ancora attivo. Rappresenta una visione futura di ToClean e potrà essere realizzato gradualmente soltanto in presenza di una crescita reale della community, risorse disponibili e accordi concreti con sponsor e partner. Prima dell'attivazione saranno pubblicati criteri, regole, condizioni e modalità di assegnazione.",
    missionpage_updated_at: "Ultimo aggiornamento:",
    missionpage_back_home: "Torna alla Home",
    // ---- Publish chooser dialog + Marketplace listing types
    publish_chooser_title: "Cosa vuoi pubblicare?",
    publish_chooser_desc: "Scegli il tipo di contenuto: una segnalazione ambientale oppure un annuncio del Marketplace.",
    publish_chooser_report_title: "Segnalazione ambientale",
    publish_chooser_report_desc: "Rifiuti, abusi, incuria: contribuisce a monitorare e risolvere problemi ordinari.",
    publish_chooser_sale_title: "Oggetto in vendita",
    publish_chooser_sale_desc: "Pubblichi un annuncio con prezzo. Chat privata con potenziali acquirenti.",
    publish_chooser_gift_title: "Oggetto da regalare",
    publish_chooser_gift_desc: "Nessun prezzo. Decidi liberamente in chat a chi consegnarlo.",
    publish_chooser_reusable_title: "Riutilizzabile trovato",
    publish_chooser_reusable_desc: "Segnali un oggetto abbandonato o riutilizzabile. Chi arriva per primo lo prende.",
    listing_type_sale: "Vendo",
    listing_type_gift: "Regalo",
    listing_type_reusable: "Riutilizzabile trovato",
    pillar1_title: "Segnala ciò che vedi",
    pillar1_desc: "Rifiuti, degrado urbano, animali in difficoltà, incendi, oggetti riutilizzabili. Una foto, la posizione GPS, un livello di rischio. Basta.",
    pillar2_title: "Verifica con la comunità",
    pillar2_desc: "Chi è vicino conferma, aggiunge foto, indica se il problema è peggiorato o è stato risolto. L'affidabilità cresce con le conferme.",
    pillar3_title: "Coordina persone e mezzi",
    pillar3_desc: "Ogni segnalazione ha la sua chat. Volontari, associazioni, comuni e operatori professionali si mettono d'accordo lì, senza perdersi in DM privati.",
    pillar4_title: "Sostieni con donazioni e sponsor",
    pillar4_desc: "Aziende e privati possono finanziare interventi, premi e attrezzature. Ogni contributo è tracciato e collegato a un risultato reale.",
    pillar5_title: "Premia chi contribuisce",
    pillar5_desc: "Voucher, buoni, attrezzature, riconoscimenti dagli sponsor. Non si guadagna con ToClean — ma il tempo donato non viene mai dimenticato.",
    pillar6_title: "Risultati verificabili e trasparenti",
    pillar6_desc: "Foto prima e dopo, ricevute di conferimento, cronologia pubblica di ogni intervento. La sezione 'Storie positive' racconta ciò che è stato reso invisibile.",
    how_kicker: "Come funziona",
    how_title: "Cinque passaggi. Zero burocrazia.",
    how_sub: "Dalla foto sul telefono alla prova pubblica del risultato.",
    how_step_1: "Segnala",
    how_step_1_desc: "Foto, GPS, categoria, rischio percepito.",
    how_step_2: "Verifica",
    how_step_2_desc: "La community conferma o smentisce.",
    how_step_3: "Coordina",
    how_step_3_desc: "Chat dedicata per volontari e operatori.",
    how_step_4: "Intervieni",
    how_step_4_desc: "Si organizza il ritiro, la pulizia, il recupero.",
    how_step_5: "Dimostra",
    how_step_5_desc: "Foto prima/dopo, ricevute di conferimento.",
    cat_kicker: "5 categorie · segnalabili in secondi",
    cat_headline: "Rifiuti, ambiente, animali, degrado urbano e oggetti riutilizzabili.",
    gray_markers: "Marker grigi: problemi resi invisibili.",
    emergency_label: "Emergenze",
    support_chip: "Sostieni ToClean",
    support_title_1: "Non chiediamo un abbonamento.",
    support_title_2: "Chiediamo un",
    support_title_3: "gesto volontario.",
    support_p1: "ToClean è un progetto indipendente. Non appartiene a un fondo, non vende dati personali, non riempie l'interfaccia di banner pubblicitari. Cresce grazie a chi crede che <b>curare il territorio sia una responsabilità di tutti</b> — e sceglie di farlo anche con un piccolo contributo economico.",
    support_p2: "Ogni euro donato è completamente <b>facoltativo</b>. Non ricevi funzionalità premium, non ottieni corsie preferenziali, non appari più in alto in classifica. Ricevi qualcosa di più importante: <b>la certezza che una piattaforma per il bene comune resti libera, aperta e utile a chi verrà dopo di te.</b>",
    support_cta: "Sostieni ToClean",
    support_discover: "Scopri la missione",
    support_uses_title: "A cosa serve una donazione",
    support_use_1_title: "Server e infrastruttura",
    support_use_1_desc: "Mappa, foto, chat: tutto deve restare veloce e disponibile 24/7.",
    support_use_2_title: "Nuove funzionalità",
    support_use_2_desc: "Rilevamento duplicati AI, notifiche, premi automatici, app mobile nativa.",
    support_use_3_title: "Moderazione",
    support_use_3_desc: "Contenuti sensibili, tutela animale, chat pulite: il lavoro invisibile che rende l'app affidabile.",
    support_use_4_title: "Espansione in nuovi Paesi",
    support_use_4_desc: "Traduzioni, adattamento normativo, partner locali.",
    support_use_5_title: "Iniziative ambientali",
    support_use_5_desc: "Piccoli fondi per interventi comunitari verificati (attrezzatura, materiali).",
    support_use_6_title: "Miglioramento continuo",
    support_use_6_desc: "Ascolto degli utenti, correzioni, accessibilità, performance.",
    support_footnote: "Nessuna donazione è obbligatoria. Puoi usare ToClean per sempre, gratuitamente. Se un giorno vorrai contribuire, lo troveremo a portata di mano — mai in mezzo.",
    final_kicker: "Inizia ora",
    final_slogan: "ToClean è semplice, gratuita e rispettosa come la Terra. Aiutaci ad aiutarla.",
    final_desc: "Registrati e trasforma una semplice foto in un cambiamento reale. Ogni segnalazione è un passo.",
    feedback_kicker: "Feedback e proposte di miglioramento",
    feedback_title: "Aiutaci a migliorare ToClean.",
    feedback_desc: "Il tuo suggerimento vale più di dieci roadmap interne. Segnala un bug, proponi una nuova funzione, dicci cosa non torna. Puoi scriverci anche senza registrarti.",
    feedback_kind: "Tipologia",
    feedback_kind_suggestion: "Suggerimento",
    feedback_kind_bug: "Bug / Problema",
    feedback_kind_improvement: "Proposta di miglioramento",
    feedback_email_label: "Email (opzionale)",
    feedback_email_placeholder: "Solo se vuoi essere ricontattato",
    feedback_message: "Messaggio",
    feedback_message_placeholder: "Cosa possiamo migliorare?",
    feedback_submit: "Invia feedback",
    feedback_submitting: "Invio…",
    feedback_no_signup: "Non serve registrarsi.",
    feedback_min_words: "Scrivi almeno qualche parola",
    feedback_thanks: "Grazie per il tuo feedback!",
    feedback_error: "Errore",
    support_title: "Non chiediamo un abbonamento. Chiediamo un gesto volontario.",
    open_details: "Apri dettagli",
    close: "Chiudi",
    set_local_password: "Imposta password locale",
    set_password_desc: "Aggiungi una password locale al tuo account Google per accedere anche via email + password.",
    new_password: "Nuova password",
    save: "Salva",
    confirmations_short: "conf.",

    // MapHub
    map_locate_unsupported: "Il tuo browser non supporta la geolocalizzazione.",
    map_geo_disabled: "Geolocalizzazione disattivata nelle impostazioni.",
    map_geo_denied: "Permesso GPS negato.",
    map_geo_failed: "Impossibile ottenere la posizione.",
    map_locate_title: "La mia posizione",
    map_locate_here: "Centra qui",
    geo_no_results_for_area: "Nessun risultato per questa area.",
    geo_search_error: "Errore ricerca",
    geo_temp_unavailable: "Ricerca temporaneamente non disponibile — riprova",
    map_hide_filters: "Nascondi filtri",
    map_show_filters: "Mostra filtri",
    map_std: "Mappa",
    map_satellite: "Satellite",
    map_tiles_error: "Impossibile caricare le tile della mappa.",
    map_tiles_check: "Verifica la connessione e riprova.",
    map_retry: "Riprova",
    color: "Colore",
    show_all: "Mostra tutti",
    reset: "Azzera",
    all_subcategories: "Tutte le sottocategorie",
    legend: "Legenda",
    legend_green_low: "Verde · basso",
    legend_yellow_med: "Giallo · medio",
    legend_red_high: "Rosso · alto",
    legend_gray_resolved: "Grigio · risolto",
    legend_blue_progress: "Blu · in corso",
    legend_purple_reusable: "Viola · riutilizzabile",
    st_active: "Attiva",
    st_taken: "Presa in carico",
    st_review: "In revisione",
    st_standby: "In stand-by",
    st_reopened: "Riaperta",
    active_prefix: "Attiva:",
    fab_expand: "Mostra pulsante Crea segnalazione",
    fab_minimize: "Minimizza",

    // AuthPage
    auth_home: "Home",
    auth_signin_kicker: "Accedi",
    auth_signup_kicker: "Crea account",
    auth_signin_h: "Bentornato.",
    auth_signup_h: "Unisciti al movimento.",
    auth_slogan: "Ogni foto è un piccolo cambiamento.",
    auth_or: "oppure",
    welcome_back: "Bentornato!",
    welcome_new: "Benvenuto in ToClean!",
    generic_error: "Errore",
    forgot_password: "Password dimenticata?",
    signin_remember_me: "Ricordami su questo dispositivo",

    // PasswordReset
    reset_back_to_login: "Torna al login",
    reset_title: "Reimposta password",
    reset_request_desc: "Inserisci la tua email. Ti invieremo un token per reimpostare la password.",
    reset_confirm_desc: "Inserisci il token ricevuto e la nuova password.",
    reset_send_link: "Invia link",
    reset_update_pwd: "Aggiorna password",
    reset_updated: "Password aggiornata! Ora puoi accedere.",
    reset_dev_notice_b: "Ambiente demo:",
    reset_dev_notice: "token pre-compilato. In produzione arriva via email.",
    reset_min_chars: "Minimo 6 caratteri",
    token_label: "Token",

    // Settings
    settings_title: "Il tuo account",
    settings_desc: "Gestisci profilo, sicurezza, notifiche e privacy.",
    section_profile: "Profilo",
    section_password: "Password",
    section_notifications: "Notifiche",
    section_language: "Lingua",
    section_geolocation: "Geolocalizzazione",
    section_privacy: "Privacy",
    section_feedback: "Feedback e Suggerimenti",
    section_session: "Sessione",
    current_password: "Password attuale",
    new_password_min: "Nuova password (min. 6)",
    change_password: "Cambia password",
    fill_both_fields: "Compila entrambi i campi",
    profile_updated: "Profilo aggiornato",
    password_updated: "Password aggiornata",
    lang_updated: "Lingua aggiornata",
    local_password_set: "Password locale impostata!",
    notif_new_reports: "Nuove segnalazioni nella tua zona",
    notif_mentions: "Menzioni nelle chat",
    notif_status_changes: "Aggiornamenti di stato",
    notif_rewards: "Premi e voucher disponibili",
    geo_desc: "Se attiva, ToClean può richiedere il GPS del browser per centrare la mappa e pre-compilare la posizione delle segnalazioni. Puoi revocare il permesso in qualsiasi momento dalle impostazioni del browser.",
    geo_browser_denied: "Il browser ha negato il GPS. Abilitalo nelle impostazioni del browser.",
    privacy_public_b: "Profilo pubblico.",
    privacy_public_desc: "Il tuo nome, la reputazione e le tue segnalazioni sono visibili nella classifica e nella pagina profilo. Puoi disattivare la visibilità qui.",
    privacy_footnote: "Le foto delle segnalazioni sono sempre pubbliche. I dati sensibili (targhe, volti) sono nascosti fino all'approvazione dei moderatori.",
    logout_label: "Logout",
    delete_account: "Elimina account",
    delete_account_title: "Eliminare definitivamente l'account?",
    delete_account_desc: "Il tuo profilo verrà cancellato. Le tue segnalazioni resteranno visibili in forma anonima per preservare l'integrità dello storico. Questa azione è irreversibile.",
    delete: "Elimina",
    account_deleted: "Account eliminato",

    // Profile
    loading: "Caricamento…",
    reputation_short: "reputazione",

    // ReportCreate
    new_report_title: "Trasforma la foto in un'azione.",
    new_report_desc: "Compila i campi con cura. L'AI può aiutarti a categorizzare correttamente.",
    add: "Aggiungi",
    latitude: "Latitudine",
    longitude: "Longitudine",
    detect: "Rileva",
    position_on_map: "Posizione sulla mappa · tocca per selezionare",
    geo_denied_msg: "Permesso GPS negato. Puoi comunque selezionare la posizione toccando la mappa o inserendola manualmente.",
    tiles_not_loaded: "Tile non caricate.",
    risk_green_label: "Verde · rischio basso",
    risk_green_short_desc: "Piccoli rifiuti, oggetti non pericolosi",
    risk_yellow_label: "Giallo · rischio medio",
    risk_yellow_short_desc: "Molti sacchi, vetri, materiali pesanti",
    risk_red_label: "Rosso · rischio alto",
    risk_red_short_desc: "Sostanze pericolose, animali, contenuti sensibili",
    ai_analyze_desc: "Analizza foto e descrizione per suggerire categoria, sottocategoria e livello di rischio.",
    ai_analyze_action: "Analizza",
    ai_unavailable: "AI non disponibile",
    ai_completed: "Analisi AI completata",
    sensitive_content_b: "Contenuto sensibile.",
    sensitive_content_desc: "Il contenuto include volti, targhe, minori, prove o accuse. Verrà revisionato dai moderatori prima della pubblicazione.",
    describe_placeholder: "Cosa hai visto? Dimensione, contesto, materiali…",
    photo_uploaded: "Foto caricata",
    photo_upload_failed: "Upload fallito",
    add_photo_or_desc: "Aggiungi almeno una foto o descrizione",
    gps_missing: "Posizione GPS mancante",
    select_subcategory: "Seleziona sottocategoria",
    description_too_short: "Descrizione troppo breve",
    photo_required: "Almeno una foto è obbligatoria",
    report_submitted: "Segnalazione inviata!",
    gps_updated: "GPS aggiornato",
    gps_unavailable: "Geolocalizzazione non supportata",
    gps_pick_manual: "Impossibile ottenere la posizione — tocca la mappa qui sotto per selezionarla manualmente.",
    position_set: "Posizione impostata",

    // ReportDetail
    navigate: "Naviga",
    donate_short: "Dona",
    report_sent_b: "Segnalazione inviata!",
    report_sent_desc: "Grazie per il tuo contributo. La comunità potrà confermare e coordinarsi qui sotto.",
    back_to_map: "Torna alla mappa",
    risk_prefix: "rischio",
    confirmations_label: "conferme",
    still_exists: "Esiste ancora",
    worsened: "Peggiorato",
    resolved_short: "Risolto",
    not_present: "Non presente",
    reusable_not_available: "Probabilmente non più disponibile",
    timeline: "Cronologia",
    no_messages: "Nessun messaggio. Inizia la conversazione.",
    login_to_join: "Accedi per partecipare",
    of_author: "di",
    fullscreen: "Fullscreen",
    edit_message: "Modifica",
    message_edited: "modificato",
    saved_confirmation: "Conferma registrata",
    thanks: "Grazie!",
    donate_report_title: "Sostieni questa segnalazione",
    donate_report_desc_p1: "I fondi saranno usati",
    donate_report_desc_b1: "prioritariamente per risolvere questa segnalazione",
    donate_report_desc_p2: ". Se non fosse possibile, verranno destinati a interventi analoghi",
    donate_report_desc_b2: "nello stesso Comune o territorio",
    donate_report_desc_p3: ". Puoi donare",
    donate_report_desc_b3: "anche senza registrarti",
    donate_free_offer: "Offerta libera (min 0,50 €)",
    donate_report_placeholder: "Un messaggio per la comunità (opzionale)",
    not_authenticated: "Non autenticato",

    // AdminDashboard
    admin_dashboard_kicker: "Dashboard admin",
    admin_overview: "Panoramica moderazione",
    admin_users: "Utenti",
    admin_reports: "Segnalazioni",
    admin_pending: "In attesa",
    admin_red: "Rosse",
    admin_resolved: "Risolte",
    admin_donations: "Donazioni",
    tab_moderation: "Moderazione",
    tab_all_reports: "Tutte le segnalazioni",
    tab_users: "Utenti",
    tab_donations: "Donazioni & Sponsor",
    tab_logs: "Log",
    no_pending: "Nessuna segnalazione in attesa.",
    no_reports: "Nessuna segnalazione.",
    all_statuses: "Tutti gli stati",
    only_red_risk: "Solo rischio rosso",
    search_by_name_email: "Cerca per nome o email…",
    admin_rep_short: "rep",
    admin_suspended: "sospeso",
    admin_banned: "bannato",
    admin_reactivate: "Riattiva",
    admin_suspend: "Sospendi",
    admin_remove_ban: "Rimuovi ban",
    admin_ban: "Banna",
    approve: "Approva",
    reject: "Respingi",
    archive: "Archivia",
    reopen: "Riapri",
    hide_evidence: "Nascondi",
    show_evidence: "Mostra prove",
    sensitive_badge: "sensibile",
    proposed_label: "proposto:",
    author_line_by: "di",
    make_public: "Rendi pubblico",
    mark_sensitive: "Marca sensibile",
    st_pub_visible: "Visibile",
    st_hidden: "Nascosta",
    st_archived: "Archiviata",
    st_rejected: "Respinta",
    change_state_title: "Cambia stato segnalazione",
    current_status: "Stato attuale:",
    reason_optional: "Motivazione (facoltativa)",
    state_change_note: "Nascondere, sospendere o archiviare",
    state_change_note_b: "non elimina",
    state_change_note_2: "la segnalazione. Foto, coordinate, autore e cronologia restano invariati.",
    state_arrow: "Stato →",
    color_short: "Colore",
    admin_actions_title: "Azioni amministrative",
    delete_report_confirm_title: "Eliminare questa segnalazione?",
    delete_report_confirm_body: "La segnalazione verrà rimossa in modo definitivo. L'azione non è reversibile.",
    change_color_title: "Cambia colore (livello di rischio)",
    current_color: "Colore attuale:",
    color_reason_placeholder: "Perché stai cambiando il colore?",
    state_reason_placeholder: "Perché stai cambiando lo stato?",
    color_change_note: "La modifica del colore",
    color_change_note_b: "non",
    color_change_note_2: "pubblica, nasconde, archivia o elimina la segnalazione — cambia solo il livello di rischio visibile sulla mappa e nei filtri. Cronologia registrata.",
    apply: "Applica",
    delete_report_title: "Eliminare la segnalazione?",
    delete_report_desc: "Questa azione cancella definitivamente la segnalazione, le foto e la chat associate. Non è possibile annullarla.",
    load_error: "Errore caricamento",
    approved: "Approvata",
    updated: "Aggiornata",
    report_updated: "Segnalazione aggiornata",
    role_updated: "Ruolo aggiornato",
    user_updated: "Utente aggiornato",
    report_deleted: "Segnalazione eliminata",
    report_reopened: "Segnalazione riaperta",
    // Bulk selection (Lotto 3 #7/#8)
    bulk_select_all: "Seleziona tutti",
    bulk_selected_of: "{n} di {total} selezionati",
    bulk_select_row: "Seleziona questa riga",
    bulk_clear_selection: "Deseleziona",
    bulk_delete_confirm_title: "Eliminare gli elementi selezionati?",
    bulk_delete_confirm_body: "Stai per eliminare definitivamente {n} elementi. L'operazione non è reversibile.",
    bulk_deleted_ok: "{n} elementi eliminati",
    bulk_updated_ok: "{n} elementi aggiornati",
    bulk_notif_mark_read: "Segna come lette",
    bulk_notif_archive: "Archivia",
    no_donations: "Nessuna donazione registrata.",
    mod_logs: "Log di moderazione",
    no_logs: "Nessun log disponibile.",

    // Leaderboard
    leaderboard_h: "Chi sta lasciando il segno.",
    leaderboard_empty: "Ancora nessun membro attivo.",

    // PaymentResult
    thanks_donation: "Grazie di cuore!",
    donation_recorded: "La tua donazione di €{amount} è stata registrata.",
    confirming: "Confermando…",
    waiting_stripe: "Attendiamo la conferma di Stripe.",
    payment_cancelled: "Pagamento annullato",
    no_charge: "Nessun addebito effettuato.",
    back_to_map_btn: "Torna alla mappa",

    // Profile stats labels
    stat_reports_created: "Segnalazioni create",
    stat_confirmations_made: "Conferme fornite",
    stat_reputation: "Reputazione",
    back: "Indietro",
    // Sub-categories (all internal stable ids -> Italian labels)
    sub_small_pile: "Piccolo cumulo",
    sub_bags: "Sacchi di rifiuti",
    sub_plastic: "Plastica",
    sub_glass: "Vetro",
    sub_paper: "Carta",
    sub_organic: "Organico",
    sub_tires: "Pneumatici",
    sub_appliances: "Elettrodomestici",
    sub_furniture: "Mobili",
    sub_construction: "Materiali edili",
    sub_industrial: "Rifiuti industriali",
    sub_hazardous: "Rifiuti pericolosi",
    sub_asbestos: "Amianto",
    sub_chemicals: "Sostanze chimiche",
    sub_oil: "Oli",
    sub_batteries: "Batterie",
    sub_illegal_dump: "Discarica abusiva",
    sub_marine: "Rifiuti in mare",
    sub_river: "Rifiuti in fiume",
    sub_forest: "Rifiuti in bosco",
    sub_sewage_spill: "Sversamento fognario",
    sub_medical_waste: "Rifiuti sanitari",
    sub_explosive_flammable: "Esplosivi / infiammabili",
    sub_water_pollution: "Inquinamento idrico",
    sub_soil_pollution: "Inquinamento del suolo",
    sub_suspicious_discharge: "Scarico sospetto",
    sub_smoke_emissions: "Emissioni di fumo",
    sub_fire: "Incendio",
    sub_fire_damage: "Danni da incendio",
    sub_damaged_trees: "Alberi danneggiati",
    sub_degraded_green: "Verde degradato",
    sub_water_leak: "Perdita d'acqua",
    sub_erosion: "Erosione",
    sub_contamination: "Contaminazione",
    sub_beach_coast_degradation: "Degrado costiero",
    sub_injured: "Animale ferito",
    sub_abandoned: "Animale abbandonato",
    sub_trapped: "Animale intrappolato",
    sub_in_danger: "Animale in pericolo",
    sub_suspected_mistreatment: "Sospetto maltrattamento",
    sub_poor_conditions: "Condizioni precarie",
    sub_wildlife_distress: "Fauna in difficoltà",
    sub_broken_light: "Lampione rotto",
    sub_broken_bench: "Panchina rotta",
    sub_damaged_playground: "Parco giochi danneggiato",
    sub_pothole: "Buca stradale",
    sub_architectural_barrier: "Barriera architettonica",
    sub_dangerous_sidewalk: "Marciapiede pericoloso",
    sub_broken_signage: "Segnaletica rotta",
    sub_abandoned_public: "Edificio pubblico abbandonato",
    sub_vandalism: "Vandalismo",
    sub_other: "Altro",
    sub_tall_grass: "Erba alta",
    sub_brambles: "Rovi",
    sub_dangerous_branches: "Rami pericolosi",
    sub_obstructing_visibility: "Ostruisce la visibilità",
    sub_fallen_tree: "Albero caduto",
    sub_invasive_plants: "Piante invasive",
    sub_road_encroachment: "Invasione della carreggiata",
    sub_bed: "Letto",
    sub_mattress: "Materasso",
    sub_table: "Tavolo",
    sub_chair: "Sedia",
    sub_wardrobe: "Armadio",
    sub_sofa: "Divano",
    sub_home_decor: "Complementi d'arredo",
    sub_appliance: "Elettrodomestico",
    sub_electronics: "Elettronica",
    sub_computer: "Computer",
    sub_bicycle: "Bicicletta",
    sub_tools: "Attrezzi",
    sub_clothing: "Abbigliamento",
    sub_toys: "Giocattoli",
    sub_construction_materials: "Materiali edili",
    sub_books: "Libri",
    take_photo: "Scatta foto",
    from_gallery: "Scegli dalla galleria",
    camera_permission_denied: "Permesso fotocamera negato. Puoi comunque scegliere una foto dalla galleria.",
    suggested_color: "Colore suggerito",
    severity: "Gravità",
    urgency: "Urgenza",
    confidence: "Confidenza",
    trust: "Attendibilità",
    coherence: "Foto↔testo",
    ai_action: "Azione suggerita",
    add_photo: "Aggiungi una foto",
    add_photo_desc: "Documenta peggioramenti, cambiamenti, avanzamento lavori o risoluzione.",
    add_photo_note: "Nota opzionale",
    add_photo_note_placeholder: "Es. peggiorato dopo la pioggia, oppure quasi risolto…",
    add_photo_confirm: "Aggiungi",
    add_photo_success: "Foto aggiunta",
    add_photo_pending: "Foto inviata alla revisione admin (contenuto o coerenza da verificare)",
    add_photo_failed: "Aggiunta fallita",
    additional_photos: "Foto aggiuntive",
    pending_review: "In revisione",
    // Urgent temporary alerts
    urgent_alert: "Avviso urgente temporaneo",
    urgent_new: "Nuovo avviso urgente",
    urgent_desc: "Segnala un problema temporaneo (bocconi sospetti, ostacoli, ramo caduto, allagamento, fumo, sostanza pericolosa…).",
    urgent_duration: "Durata",
    urgent_1h: "1 ora", urgent_3h: "3 ore", urgent_6h: "6 ore", urgent_12h: "12 ore", urgent_24h: "24 ore",
    urgent_radius: "Raggio (m)",
    urgent_other: "Altro avviso urgente",
    urgent_free_desc: "Descrivi liberamente il problema e perché è urgente e temporaneo",
    urgent_submit: "Pubblica avviso",
    urgent_created: "Avviso pubblicato",
    urgent_state_active: "Attivo",
    urgent_state_expired: "Scaduto — da verificare",
    urgent_state_resolved: "Risolto",
    urgent_state_archived: "Archiviato",
    urgent_state_pending: "In revisione",
    urgent_still_present: "Confermo che è ancora presente",
    urgent_not_present: "Non è più presente",
    urgent_time_remaining: "Tempo rimanente",
    urgent_extend: "Proroga",
    urgent_expired: "Scaduto",
    fab_urgent: "Evento straordinario",
    fab_event: "Nuovo evento straordinario",
    extraordinary_event: "Evento straordinario",
    extraordinary_events: "Eventi straordinari",
    urgent_alerts_list: "Eventi straordinari attivi",
    no_urgent_alerts: "Nessun evento straordinario attivo.",
    ai_panel_title: "Analisi IA (GPT-5.2)",
    ai_problem: "Problema riconosciuto",
    ai_reason: "Motivazione",
    urg_low: "Bassa", urg_medium: "Media", urg_high: "Alta",
    ai_act_publish_auto: "Pubblicazione automatica",
    ai_act_review_admin: "Revisione admin",
    ai_act_reject: "Rifiuta",
    legal_badge: "legale",
    // Extraordinary events
    filter_urgent_alerts: "Eventi straordinari",
    filter_extraordinary_events: "Eventi straordinari",
    event_kind_wildfire: "Incendio boschivo",
    event_kind_flood: "Alluvione",
    event_kind_river_overflow: "Esondazione / piena",
    event_kind_landslide: "Frana / smottamento",
    event_kind_storm: "Tempesta eccezionale",
    event_kind_hailstorm: "Grandinata eccezionale",
    event_kind_tornado: "Tromba d'aria",
    event_kind_heavy_snow: "Forte nevicata",
    event_kind_avalanche: "Valanga",
    event_kind_sea_storm: "Mareggiata",
    event_kind_heatwave: "Ondata di caldo",
    event_kind_coldwave: "Ondata di gelo",
    urgent_pending_approval: "In attesa di approvazione",
    urgent_approved: "Avviso approvato",
    urgent_rejected: "Avviso rifiutato",
    approve_urgent: "Approva avviso",
    reject_urgent: "Rifiuta avviso",
    // Feature ⑧ — Map in urgent create
    urgent_map_pick: "Sposta la mappa e tocca per selezionare il punto",
    urgent_center_me: "Centra sulla mia posizione",
    // Feature ⑨ — Short explanation
    urgent_short_explanation: "Usa questa funzione per segnalare un problema urgente ma temporaneo. Indica il problema, la posizione, il raggio dell'area interessata e scegli quanto deve durare l'avviso. Dopo l'approvazione dell'Admin, l'avviso sarà visibile con un conto alla rovescia fino alla scadenza.",
    // Feature ⑤ ⑥ — Notifications
    notifications: "Notifiche",
    notif_empty: "Nessuna notifica.",
    notif_gone: "Notifica non più disponibile",
    notif_mark_read: "Segna come letta",
    notif_mark_unread: "Segna come non letta",
    notif_archive: "Archivia",
    notif_delete: "Elimina",
    notif_open: "Apri",
    notif_all_read: "Segna tutto come letto",
    notif_view_all: "Visualizza tutte le notifiche",
    notif_tab_all: "Tutte", notif_tab_unread: "Non lette", notif_tab_archived: "Archiviate",
    extensions_pending: "Proroghe in attesa",
    no_extensions_pending: "Nessuna proroga da approvare.",
    photos_pending: "Foto in revisione",
    // Phase 7 — Dashboard restructure + photo-review section + chat translator
    admin_home_title: "Panoramica moderazione",
    admin_home_desc: "Seleziona una sezione per iniziare.",
    admin_card_red: "Rosse",
    admin_card_yellow: "Gialle",
    admin_card_green: "Verdi",
    admin_card_photos_review: "Moderazione Admin",
    admin_card_urgent: "Eventi straordinari",
    admin_section_others: "Altro",
    admin_others_desc: "Utenti · Feedback · Donazioni · Chat · Log · Archivio · Impostazioni",
    admin_tab_users: "Utenti",
    admin_tab_feedback: "Feedback",
    admin_tab_donations: "Donazioni",
    admin_tab_logs: "Log",
    admin_tab_archive: "Archivio",
    admin_tab_settings: "Impostazioni",
    admin_filter_status: "Filtra per stato",
    admin_st_in_progress: "In corso",
    admin_st_pending_approval: "Richiesta approvazione",
    admin_st_approved: "Approvate",
    admin_st_archived: "Archiviate",
    admin_st_all: "Tutte",
    admin_urgent_state_pending: "Da approvare",
    admin_urgent_state_active: "Attivi",
    admin_urgent_state_expired: "Scaduti — da verificare",
    admin_urgent_ext_pending: "Proroghe in attesa",
    admin_urgent_state_archived: "Archiviati",
    admin_urgent_state_rejected: "Rifiutati",
    admin_urgent_state_all: "Tutti",
    filters: "Filtri",
    advanced_filters: "Filtri avanzati",
    filter_search_placeholder: "Cerca per titolo, descrizione, autore, luogo o ID",
    filter_ai_conf: "Confidenza IA",
    filter_sensitive: "Contenuti sensibili",
    filter_legal: "Possibili problemi legali",
    photos_review_title: "Moderazione Admin",
    photos_review_empty: "Nessuna foto da revisionare.",
    photos_review_source: "Provenienza",
    photos_review_reason: "Motivo",
    photos_review_priority: "Priorità",
    src_new_report: "Nuova segnalazione",
    src_added_photo: "Foto aggiunta",
    src_urgent: "Avviso urgente",
    src_extension: "Richiesta proroga",
    reason_photo_incoherent: "Foto incoerente",
    reason_photo_text_incoherent: "Foto e descrizione non coerenti",
    reason_category_mismatch: "Categoria errata",
    reason_subcategory_mismatch: "Sottocategoria errata",
    reason_severity_higher: "Gravità superiore",
    reason_color_mismatch: "Colore non coerente",
    reason_sensitive_content: "Contenuto sensibile",
    reason_legal_issues: "Possibile problema legale",
    reason_spam_or_irrelevant: "Spam o irrilevante",
    reason_low_ai_confidence: "Bassa confidenza IA",
    reason_ai_suggests_review: "IA consiglia revisione",
    reason_face_blur_failed: "Oscuramento volti fallito",
    reason_face_blur_uncertain: "Oscuramento volti incerto",
    reason_red_requires_approval: "Rossa: approvazione richiesta",
    reason_sensitive_animal_category: "Sottocategoria animale sensibile",
    reason_possibly_criminal_content: "Possibile scena di reato",
    publish_as_green: "Pubblica come Verde",
    publish_as_yellow: "Pubblica come Gialla",
    publish_as_red: "Pubblica come Rossa",
    photo_approved_as_color: "Foto approvata e pubblicata come {color}",
    original_unavailable: "Originale non più disponibile",
    original_unavailable_hint: "Originale non più disponibile — puoi comunque applicare un ulteriore oscuramento sulla versione attuale.",
    admin_card_events: "Eventi straordinari",
    total: "totali",
    admin_card_marketplace: "Marketplace",
    mk_updated: "Annuncio aggiornato",
    mk_deleted: "Annuncio eliminato",
    mk_owner_actions: "I tuoi controlli",
    mk_edit_listing: "Modifica annuncio",
    mk_delete_listing: "Elimina annuncio",
    mk_delete_listing_title: "Confermi l'eliminazione?",
    mk_delete_listing_desc: "L'annuncio verrà rimosso definitivamente dal Marketplace e dalla mappa. L'operazione non è reversibile.",
    mk_title: "Titolo",
    mk_description: "Descrizione",
    mk_price: "Prezzo (€)",
    mk_negotiable: "Prezzo trattabile",
    mk_condition: "Condizione",
    mk_color: "Colore",
    mk_keywords: "Parole chiave",
    mk_pickup: "Ritiro sul posto",
    mk_shipping: "Spedizione disponibile",
    mk_cond_new: "Nuovo",
    mk_cond_like_new: "Come nuovo",
    mk_cond_good: "Buone condizioni",
    mk_cond_fair: "Usato",
    users_shown: "utenti mostrati",
    no_results: "Nessun risultato",
    search_by_name_email: "Cerca per nome, cognome, username o email…",
    mk_type_sale: "Vendo",
    mk_type_gift: "Regalo",
    mk_type_reusable: "Riutilizzabile trovato",
    mk_st_published: "Attivo",
    mk_st_archived: "Archiviato",
    mk_st_closed: "Concluso",
    mk_st_pending: "In conferma",
    mk_search_placeholder: "Cerca titolo, autore, provincia…",
    mk_empty: "Nessun annuncio in questa vista",
    mk_admin_details: "Dettagli admin",
    mk_found_checks_title: "Conferme utenti",
    mk_found_present: "Oggetto presente",
    mk_found_not_present: "Oggetto non presente",
    mk_found_present_short: "Presente",
    mk_found_not_present_short: "Non presente",
    mk_found_no_checks: "Nessuna conferma finora.",
    mk_found_check_saved: "Grazie! La tua conferma è stata salvata.",
    mk_found_intro: "Sei stato sul posto? Aiuta la community: indica se l'oggetto è ancora lì.",
    mk_found_note_optional: "Nota (opzionale)",
    delete_listing_title: "Elimina annuncio",
    delete_listing_desc: "L'annuncio verrà eliminato definitivamente. L'operazione non è reversibile.",
    reactivate: "Riattiva",
    reactivated: "Riattivato",
    close: "Chiudi",
    // Chat translator
    chat_translate: "Traduci",
    chat_show_original: "Mostra originale",
    chat_translated_badge: "traduzione automatica",
    chat_translating: "Traduzione in corso…",
    chat_translate_error: "Traduzione non riuscita",
    // Phase 8 — user reports + confirm-replace + manual blur editor
    report_user: "Segnala utente",
    report_user_title: "Segnala questo utente",
    report_user_reason: "Motivo",
    ur_reason_spam: "Spam",
    ur_reason_offensive: "Linguaggio offensivo",
    ur_reason_harassment: "Molestie o minacce",
    ur_reason_misleading: "Contenuti falsi o ingannevoli",
    ur_reason_bad_chat: "Comportamento scorretto nelle chat",
    ur_reason_misuse: "Uso improprio dell'app",
    ur_reason_false_reports: "Segnalazioni ripetutamente false",
    ur_reason_other: "Altro motivo",
    report_user_explanation: "Breve spiegazione (opzionale)",
    report_user_send: "Invia segnalazione",
    report_user_sent: "Segnalazione inviata privatamente",
    report_user_privacy: "La segnalazione è privata e non verrà mostrata all'utente segnalato.",
    admin_tab_user_reports: "Segnalazioni utenti",
    ur_status_new: "Nuove",
    ur_status_in_review: "In revisione",
    ur_status_resolved: "Risolte",
    ur_status_archived: "Archiviate",
    ur_status_rejected: "Rifiutate",
    ur_status_all: "Tutte",
    ur_reports_count: "Precedenti",
    ur_action_warn: "Avvertimento",
    ur_action_limit_chat: "Limita chat",
    ur_action_limit_publish: "Limita pubblicazioni",
    ur_action_suspend: "Sospendi temporaneamente",
    ur_action_ban: "Blocca account",
    ur_action_close: "Archivia senza sanzioni",
    ur_action_hours: "Durata (ore)",
    ur_open_context: "Apri contesto",
    ur_no_items: "Nessuna segnalazione utente.",
    // Confirmations
    confirm_choose_status: "Scegli lo stato",
    confirm_resolved: "Risolta",
    confirm_in_progress: "In corso",
    confirm_worse: "Peggiorata",
    confirm_undo: "Annulla conferma",
    confirm_change_title: "Modifica conferma",
    confirm_change_desc: "Vuoi modificare la tua conferma da \"{from}\" a \"{to}\"?",
    confirm_change_ok: "Sì, modifica",
    confirm_your_current: "Tua conferma attuale",
    // Manual blur editor
    manual_blur: "Oscura manualmente",
    manual_blur_title: "Editor oscuramento",
    manual_blur_desc: "Disegna rettangoli sulle aree sensibili. Le foto vengono pubblicate solo dopo il salvataggio.",
    manual_blur_mode_blur: "Sfocatura",
    manual_blur_mode_pixel: "Pixelatura",
    manual_blur_undo: "Annulla",
    manual_blur_redo: "Ripristina",
    manual_blur_clear: "Cancella tutto",
    manual_blur_save: "Salva versione oscurata",
    manual_blur_saved: "Versione oscurata salvata",
    manual_blur_no_regions: "Aggiungi almeno un'area prima di salvare.",
    manual_blur_hint: "Clicca e trascina per disegnare. Trascina il bordo per ridimensionare. Doppio-click per eliminare.",
    // Download & replace
    download_original: "Scarica originale",
    upload_replacement: "Carica versione oscurata",
    replacement_uploaded: "Versione sostituita",
    admin_only_action: "Riservato agli Admin autorizzati",
    // Phase 9 — reforestation, geo, share, gift
    sub_gift: "Oggetto da regalare",
    nav_reforestation: "Riforestazione",
    share: "Condividi",
    deleted_user_label: "Utente eliminato",
    copy_link: "Copia link",
    copy_link_ok: "Link copiato negli appunti",
    copy_link_err: "Copia non riuscita",
    filter_area: "Provincia / area amministrativa",
    // Notification types
    notif_type_chat_message: "Nuovo messaggio in chat",
    notif_type_report_update: "Aggiornamento segnalazione",
    notif_type_photo_approved: "Foto approvata",
    notif_type_photo_rejected: "Foto rifiutata",
    notif_type_photo_review: "Foto in revisione",
    notif_type_urgent_approved: "Avviso approvato",
    notif_type_urgent_rejected: "Avviso rifiutato",
    notif_type_urgent_expiring: "Avviso in scadenza",
    notif_type_report_status: "Cambio stato segnalazione",
    notif_type_content_report_resolved: "Segnalazione contenuto gestita",
    notif_type_content_report_dismissed: "Segnalazione contenuto esaminata",
    // Admin notification types
    notif_type_new_feedback: "Nuovo feedback",
    notif_type_new_urgent: "Nuovo avviso urgente da approvare",
    notif_type_new_red: "Nuova segnalazione rossa",
    notif_type_photo_pending: "Foto da revisionare",
    notif_type_face_uncertain: "Volti da verificare",
    notif_type_manual_mod: "Moderazione manuale richiesta",
    notif_type_sensitive: "Contenuto sensibile",
    notif_type_legal: "Possibili problemi legali",
    notif_type_severe: "Segnalazione molto grave",
    // Onboarding tour
    tour_start: "Guida rapida",
    tour_next: "Avanti",
    tour_prev: "Indietro",
    tour_skip: "Salta",
    tour_close: "Chiudi guida",
    tour_dont_show: "Non mostrare più",
    tour_restart: "Riavvia guida",
    tour_step1_title: "Benvenuto in ToClean",
    tour_step1_desc: "Ti mostriamo come funziona in pochi secondi. Puoi saltare in qualsiasi momento.",
    tour_step2_title: "Crea una segnalazione",
    tour_step2_desc: "Usa il pulsante verde per segnalare un problema ambientale, urbano o legato agli animali.",
    tour_step3_title: "Apri una segnalazione",
    tour_step3_desc: "Tocca un marker sulla mappa per aprire la scheda della segnalazione.",
    tour_step4_title: "Segui e partecipa",
    tour_step4_desc: "Nella chat della segnalazione puoi scrivere messaggi, coordinare interventi e ricevere aggiornamenti.",
    tour_step5_title: "Marketplace",
    tour_step5_desc: "Vendi, regala o segnala oggetti riutilizzabili trovati. Tocca il pulsante Pubblica e scegli la tipologia.",
    tour_step6_title: "Eventi straordinari",
    tour_step6_desc: "Segnala emergenze estese come incendi, alluvioni o tempeste disegnando l'area sulla mappa. Le pubblicazioni seguono i permessi e la moderazione previsti dal ruolo dell'utente.",
    tour_step7_title: "Conferma o smentita",
    tour_step7_desc: "Se sei sul posto, puoi confermare che il problema è ancora presente oppure segnalarne la risoluzione.",

    // HomeSwipe (nuova home a scorrimento laterale)
    swipe_values_kicker: "Insieme cambiamo davvero",
    swipe_values_title: "Un gesto piccolo, un impatto reale sul territorio.",
    swipe_value_1_title: "Segnala un problema",
    swipe_value_1_desc: "Scatta, aggiungi la posizione e pubblica: la tua segnalazione è geolocalizzata e visibile a tutti.",
    swipe_value_2_title: "Segui ciò che accade nel tuo territorio",
    swipe_value_2_desc: "Mappa in tempo reale, avvisi urgenti e classifiche delle zone più attive.",
    swipe_value_3_title: "Contribuisci alla soluzione",
    swipe_value_3_desc: "Verifica, conferma la risoluzione o dona a un progetto reale di riforestazione.",
    swipe_cta_enter: "Entra in ToClean",
    swipe_cta_hint: "Puoi esplorare la mappa senza registrarti.",

    // Filtro stato compatto
    map_status_all: "Tutti gli stati",
    map_status_selected: "{n} stati selezionati",
    map_legend_hint_in_filter: "La legenda si apre dal pulsante in basso a sinistra della mappa.",
    apply: "Applica",
    cat_reusable_found: "Oggetti riutilizzabili trovati",
    cat_gift: "Oggetti in regalo",
    cat_sale: "Oggetti in vendita",

    // Gating accesso pubblico
    guest_gate_action: "Per continuare devi accedere o registrarti.",
    guest_gate_category_hidden: "Per vedere questa sezione devi accedere o registrarti.",
    guest_gate_marketplace: "Per vedere questa sezione devi accedere o registrarti.",
    guest_gate_title: "Accesso richiesto",
    guest_gate_login: "Accedi",
    guest_gate_signup: "Registrati",

    // Guided color wizard
    cw_intro: "Rispondi a poche domande: proporremo il colore giusto.",
    cw_step_label: "Passo {n}",
    cw_examples: "Esempi",
    cw_yes: "Sì",
    cw_no: "No",
    cw_unsure: "Non sono sicuro",
    cw_restart: "Rifai il test",
    cw_q1: "La situazione sta mettendo in pericolo, in questo momento, la vita o l'incolumità di persone o animali?",
    cw_q1_examples: "Incendio attivo, animale intrappolato, frana o allagamento con persone coinvolte.",
    cw_q1_reason: "Pericolo immediato per persone o animali.",
    cw_q2: "Vedi una fuoriuscita, dispersione o emissione di sostanze pericolose nell'acqua, nel terreno o nell'aria?",
    cw_q2_examples: "Carburanti, oli, sostanze chimiche, fumi tossici, amianto danneggiato, fusti che perdono, moria improvvisa di pesci o uccelli, danno grave all'ecosistema anche di causa ignota.",
    cw_q2_reason: "Contaminazione ambientale grave, attiva o difficile da riparare.",
    cw_q3: "Il problema è esteso, può peggiorare oppure richiede un intervento specializzato?",
    cw_q3_examples: "Grande discarica, albero pericolante, rifiuti elettronici, siringhe, corso d'acqua visibilmente inquinato.",
    cw_q3_reason: "Problema serio, esteso o che richiede personale specializzato.",
    cw_q4: "Il problema è circoscritto, senza rischi evidenti e risolvibile con una normale pulizia o manutenzione?",
    cw_q4_examples: "Piccoli rifiuti, cestino pieno, lieve degrado, oggetto abbandonato non pericoloso.",
    cw_q4_reason: "Problema ordinario, circoscritto e senza rischi evidenti.",
    cw_unsure_reason: "In caso di dubbio, applichiamo un giallo provvisorio: sarà rivalutato.",
    cw_result_red: "Rosso — Priorità massima",
    cw_result_yellow: "Giallo — Priorità media",
    cw_result_green: "Verde — Priorità ordinaria",
    cw_red_admin_note: "Le segnalazioni rosse vengono sempre verificate da un Admin prima della pubblicazione.",
    cw_required: "Completa la guida per stabilire il colore della segnalazione.",
  
    save_changes: "Salva modifiche",
    all_categories: "Tutte le categorie",
    all_types: "Tutti i tipi",
    reject_reason_title: "Motivazione rifiuto",
    only_photo: "Solo foto",
    entire_report: "Intera segnalazione",
    location_placeholder: "Paese, provincia o comune…",
    sort_by: "Ordina per",
    sort_recent: "Più recenti",
    sort_oldest: "Meno recenti",
    sort_price_asc: "Prezzo crescente",
    sort_price_desc: "Prezzo decrescente",
    condition_like_new: "Come nuovo",
    condition_fair: "Discreto",
    gift_delivered: "Consegnato",
    gift_unavailable: "Non più disponibile",
    gift_reopen: "Riapri come disponibile",
    manage_subscriptions: "Gestisci abbonamenti",
    one_time: "Una tantum",
    reject_photo_placeholder: "Es. Volto riconoscibile non mascherato correttamente",
    admin_log_note: "Nota per il log Admin",
    repeat_password: "Ripeti password",
    back_to_login: "Torna al login",
    report_not_available: "Segnalazione non disponibile",
    moderation_admin: "Moderazione admin",
    no_auto_dispatch: "Nessun invio automatico",
    certified_delivery: "Recapito certificato",
    cancel_dispatch: "Annulla preparazione",
    personal_section: "Sezione personale",
    stop_following: "Smetti di seguire",
    classifications_title: "Classifiche",
    concluded_events: "Eventi conclusi",
    past_extraordinary_events_label: "Storico eventi straordinari",
    previous_label: "Precedente",
    next_label: "Successivo",
    assistant_label: "Assistente",
    reforestation_new_title: "Nuovo progetto di riforestazione",
    reforestation_update_title: "Aggiorna progetto",
    no_chat_for_listing: "Nessuna chat per questo annuncio",
    reports_list_label: "Elenco segnalazioni",
    reset_province_filter: "Azzera filtro provincia",
    remove_prox_filter: "Rimuovi filtro prossimità",
    publish_new_tooltip: "Pubblica una nuova segnalazione o annuncio",
    seller_actions_label: "Azioni venditore",
    selected_as_buyer_label: "Sei stato selezionato come acquirente",
    sort_by_field: "Ordina per",
    search_placeholder_marketplace: "Titolo, descrizione, categoria, provincia…",
    search_placeholder_map: "Titolo, descrizione, provincia…",
    clear_search: "Cancella ricerca",
    tab_territories: "Territori",
    tab_generous: "Province più generose",
    most_generous_province_badge: "Provincia più generosa",
    assistant_open_tips: "Assistente: apri consigli",
    page_tips_title: "Consigli della pagina",
    delete_label: "Elimina",
    back_label: "Indietro",
    show_hide: "Mostra/nascondi",
  
    announcement_status: "Stato annuncio",
    in_agreement: "In accordo",
    closed_listing_note: "Questo annuncio è chiuso. La cronologia della chat resta visibile ma non sono ammessi nuovi messaggi di richiesta.",
    reject_reason_help: "La motivazione è obbligatoria. La nota è facoltativa e non sarà mostrata all'autore.",
    scope_label: "Ambito",
    motivation_required: "Motivazione *",
    internal_note_optional: "Nota (interna, facoltativa)",
    reject_action: "Rifiuta",
    confirm_reject: "Conferma rifiuto",
    chi_siamo: "Chi siamo",
    la_nostra_missione: "La nostra missione",
    search_marketplace_placeholder: "Titolo, descrizione, categoria, provincia…",
    search_map_placeholder: "Titolo, descrizione, provincia…",
    type_specific_label: "Tipo specifico",
    reset_password: "Reimposta password",
    declare_event_ended_title: "Dichiara evento concluso",
    new_reforestation_project: "Nuovo progetto di riforestazione",
    update_reforestation_project: "Aggiorna progetto",
    no_chat_yet: "Nessuna chat per questo annuncio",
    extraordinary_events_history: "Storico eventi straordinari",
    province_label: "Provincia",
  
    category_first: "Prima la categoria",
    subcategory_first: "Prima la sottocategoria",
    no_active_subscriptions: "Non hai ancora abbonamenti attivi.",
    monthly: "Mensile",
    near_me: "Vicino a me",
    near_me_activate: "Vicino a me (attiva la posizione)",
    lb_subtitle: "Confronto positivo — puntiamo sui risultati e sulla partecipazione, non sui problemi.",
    period_week: "Settimana",
    period_month: "Mese",
    period_year: "Anno",
    period_all: "Generale",
    assistant_status_on: "Assistente: Attivo",
    assistant_status_off: "Assistente: Disattivo",
    on: "Attiva",
    off: "Disattiva",
    reforestation_new_project_title: "Nuovo progetto di riforestazione",
    reforestation_update_project_title: "Aggiorna progetto",
    declare_event_ended_title_v2: "Dichiara evento concluso",
    reject_motivation_title: "Motivazione rifiuto",
    past_events_kicker: "Storico eventi straordinari",
    events_ended: "Eventi conclusi",
    search_by_word: "Cerca per parola",
    category_marketplace: "Categoria · Marketplace",
    min_currency: "Min €",
    max_currency: "Max €",
    condition_all: "Tutte",
    condition_new: "Nuovo",
    condition_good_v2: "Buono",
    condition_used: "Usato",
    condition_negotiable: "Trattabile",
    condition_label: "Condizione",
    score_label: "Score",
    no_data_period: "Nessun dato per il periodo selezionato.",
    no_donations_period: "Nessuna donazione registrata nel periodo selezionato.",
    sale_price_only: "Prezzo (solo Vendo)",
    price_min_gt_max: "Il minimo è maggiore del massimo: applichiamo comunque l'intervallo corretto.",
    publish_new_report_tooltip: "Pubblica una nuova segnalazione o annuncio",
    show_hide_label: "Mostra/nascondi",
    activate_position_note: "attiva la posizione",
  
    nav_marketplace: "Marketplace",
  
    backend_unauthorized: "Non autorizzato",
    backend_user_not_found: "Utente non trovato",
    backend_invalid_credentials: "Credenziali non valide",
    backend_email_already_registered: "Email già registrata",
    backend_report_not_found: "Segnalazione non trovata",
    backend_listing_not_found: "Annuncio non trovato",
    backend_event_not_found: "Evento non trovato",
    backend_project_not_found: "Progetto non trovato",
    backend_invalid_session: "Sessione non valida",
    backend_token_expired: "Token scaduto",
    backend_bad_request: "Richiesta non valida",
    backend_server_error: "Errore interno del server",
    backend_operation_completed: "Operazione completata",
    backend_saved: "Salvato",
    backend_updated: "Aggiornato",
    backend_deleted: "Eliminato",
    backend_published: "Pubblicato",
    backend_config_incomplete: "Configurazione non completata",
    backend_forbidden: "Permessi insufficienti",
    backend_file_too_large: "File troppo grande",
    backend_file_bad_format: "Formato file non supportato",
    backend_photo_required: "Foto obbligatoria",
    backend_location_required: "Posizione obbligatoria",
    backend_category_required: "Categoria obbligatoria",
    backend_title_required: "Titolo obbligatorio",
    backend_description_required: "Descrizione obbligatoria",
    backend_amount_invalid: "Importo non valido",
    backend_password_too_short: "Password troppo corta",
    backend_passwords_mismatch: "Password non corrispondenti",
    backend_email_invalid: "Email non valida",
    backend_too_many_attempts: "Troppi tentativi. Riprova più tardi.",
    admin_verified_entities: "Enti verificati",
    admin_verified_entities_super: "Enti verificati (Super Admin)",
    admin_management: "Gestione Admin",
    admin_management_super: "Gestione Admin (Super Admin)",
    admin_reset_super_password: "Reimposta password Super Admin",
    admin_content_pages: "Pagine di contenuto (Missione / Chi siamo)",
    admin_pec_config: "Configurazione PEC",
    admin_reforestation_manage: "Riforestazione — gestione progetti",
    admin_reject_dialog_title: "Motivazione rifiuto",
    admin_reject_reason_help: "La motivazione è obbligatoria. La nota è facoltativa e non sarà mostrata all'autore.",
    admin_scope_label: "Ambito",
    admin_reason_required: "Motivazione *",
    admin_internal_note: "Nota (interna, facoltativa)",
    admin_moderation_label: "Moderazione admin",
    admin_pec_required_msg: "Configurazione PEC necessaria. Puoi preparare e visualizzare l'anteprima, ma l'invio verrà bloccato finché il Super Admin non completa la configurazione.",
    admin_pec_locked_msg: "Configurazione PEC necessaria. Finché non compili tutti i campi, gli invii di PEC restano bloccati.",
    admin_no_auto_dispatch: "Nessun invio automatico",
    admin_certified_delivery: "Recapito certificato",
    admin_save_changes: "Salva modifiche",
    admin_cancel_dispatch: "Annulla preparazione",
    admin_declare_event_ended: "Dichiara evento concluso",
    admin_reforestation_new: "Nuovo progetto di riforestazione",
    admin_reforestation_update: "Aggiorna progetto",
    admin_content_edit_desc: "Modifica il testo di \"La nostra missione\" e \"Chi siamo\" senza toccare il codice. Se una pagina non è pubblicata, gli utenti vedono i contenuti predefiniti o un placeholder sobrio.",
    admin_password_reset_title: "Reimposta password",
    admin_new_password: "Nuova password",
    admin_repeat_password: "Ripeti password",
    admin_back_to_login: "Torna al login",
    admin_stop_following: "Smetti di seguire",
    admin_seller_actions: "Azioni venditore",
    admin_buyer_selected: "Sei stato selezionato come acquirente",
    admin_no_chat_yet: "Nessuna chat per questo annuncio",
    admin_publish_new_report: "Pubblica una nuova segnalazione o annuncio",
    admin_reset_province_filter: "Azzera filtro provincia",
    admin_reports_list: "Elenco segnalazioni",
    admin_country_province_place: "Paese, provincia o comune…",
    admin_content_placeholder_desc: "Un nome/ruolo per riga (es. Mario Rossi — Fondatore)",
    admin_content_placeholder_contact: "Email, PEC, indirizzo, social…",
  
    create: "Crea",
    confirm_conclusion: "Conferma conclusione",
    optional_note_followers: "Nota facoltativa (verrà mostrata ai follower)",
    admin_reset_super_password_confirm: "Generare un link di reimpostazione password per il tuo account Super Admin? Il link è monouso e scade tra 15 minuti. Verrai portato subito alla schermata di scelta password.",
  
    be_ai_not_configured: "AI not configured",
    be_account_sospeso_o_bannato: "Account sospeso o bannato",
    be_admin_only: "Admin only",
    be_admin_role_required: "Admin role required",
    be_alert_not_found: "Alert not found",
    be_almeno_un_tra_ritiro_e_spedizione_deve_essere_selezionato: "Almeno un tra ritiro e spedizione deve essere selezionato",
    be_amount_out_of_range_min_0_50_max_100000: "Amount out of range (min 0.50€, max 100000€)",
    be_cannot_report_yourself: "Cannot report yourself",
    be_duplicate_report_please_wait_before_re_reporting_the_same_co: "Duplicate report — please wait before re-reporting the same content.",
    be_duration_must_be_1_3_6_12_or_24_hours: "Duration must be 1, 3, 6, 12 or 24 hours",
    be_email_already_registered: "Email already registered",
    be_email_gi_in_uso: "Email già in uso",
    be_evento_non_attivo: "Evento non attivo",
    be_extension_not_found: "Extension not found",
    be_failed_to_upload_blurred_version: "Failed to upload blurred version",
    be_file_too_large_max_8mb: "File too large (max 8MB)",
    be_forbidden: "Forbidden",
    be_il_nome_della_ricerca_obbligatorio: "Il nome della ricerca è obbligatorio",
    be_il_prezzo_obbligatorio_per_vendo: "Il prezzo è obbligatorio per Vendo",
    be_invalid_action: "Invalid action",
    be_invalid_category: "Invalid category",
    be_invalid_credentials: "Invalid credentials",
    be_invalid_image: "Invalid image",
    be_invalid_reason: "Invalid reason",
    be_invalid_risk_level: "Invalid risk_level",
    be_invalid_role: "Invalid role",
    be_invalid_session: "Invalid session",
    be_invalid_status: "invalid status",
    be_la_nuova_password_deve_avere_almeno_6_caratteri: "La nuova password deve avere almeno 6 caratteri",
    be_la_nuova_password_deve_avere_almeno_8_caratteri: "La nuova password deve avere almeno 8 caratteri",
    be_la_password_deve_avere_almeno_6_caratteri: "La password deve avere almeno 6 caratteri",
    be_la_segnalazione_deve_essere_approvata_pubblicata_prima: "La segnalazione deve essere approvata/pubblicata prima",
    be_le_chat_non_sono_previste_per_gli_oggetti_riutilizzabili_tro: "Le chat non sono previste per gli oggetti riutilizzabili trovati",
    be_login_required_for_this_category: "Login required for this category",
    be_message_cannot_be_empty: "Message cannot be empty",
    be_message_not_found: "Message not found",
    be_messaggio_troppo_breve: "Messaggio troppo breve",
    be_motivazione_obbligatoria: "Motivazione obbligatoria",
    be_moderation_note_required: "Motivazione obbligatoria (min 10 caratteri).",
    ur_note_required_prompt: "Motivazione della misura (obbligatoria, min 10 caratteri):",
    ur_note_required_toast: "Motivazione obbligatoria (min 10 caratteri).",
    be_nessun_abbonamento_trovato_per_questo_utente: "Nessun abbonamento trovato per questo utente",
    be_nessuna_richiesta_di_conferma_attiva: "Nessuna richiesta di conferma attiva",
    be_non_annullabile_dispatch_gi_inviato: "Non annullabile: dispatch già inviato",
    be_non_modificabile_dispatch_gi_inviato: "Non modificabile: dispatch già inviato",
    be_non_puoi_rimuovere_il_tuo_ruolo_admin: "Non puoi rimuovere il tuo ruolo Admin",
    be_non_puoi_seguire_un_annuncio_di_cui_sei_il_proprietario: "Non puoi seguire un annuncio di cui sei il proprietario",
    be_not_a_reusable_item_report: "Not a reusable item report",
    be_not_authenticated: "Not authenticated",
    be_not_found: "Not found",
    be_notification_has_no_actionable_target: "Notification has no actionable target",
    be_notification_not_found: "Notification not found",
    be_only_admin: "Only admin",
    be_only_admin_can_apply_user_actions: "Only admin can apply user actions",
    be_only_admin_can_delete_reports: "Only admin can delete reports",
    be_only_admin_moderator: "Only admin/moderator",
    be_only_gift_subcategory_reports_support_this: "Only gift subcategory reports support this",
    be_only_moderators_can_update_reports: "Only moderators can update reports",
    be_only_owner_or_admin_can_set_this_status: "Only owner or admin can set this status",
    be_pagina_non_trovata: "Pagina non trovata",
    be_password_attuale_errata: "Password attuale errata",
    be_password_non_impostabile_per_questo_account_google: "Password non impostabile per questo account (Google)",
    be_photo_not_found: "Photo not found",
    be_puoi_salvare_al_massimo_20_ricerche_elimina_prima_una_vecchi: "Puoi salvare al massimo 20 ricerche. Elimina prima una vecchia.",
    be_recurring_donations_are_only_available_for_platform_and_refo: "Recurring donations are only available for platform and reforestation",
    be_report_not_found: "report not found",
    be_ricerca_non_trovata: "Ricerca non trovata",
    be_seleziona_prima_l: "Seleziona prima l",
    be_sign_in_required: "Sign in required",
    be_sign_in_required_to_view_marketplace: "Sign in required to view Marketplace",
    be_slug_non_valido: "Slug non valido",
    be_solo_super_admin: "Solo super-admin",
    be_solo_vendo: "Solo Vendo",
    be_solo_admin_o_ente_verificato: "Solo admin o ente verificato",
    be_solo_admin_moderator_o_ente_verificato: "Solo admin/moderator o ente verificato",
    be_solo_il_proprietario_pu_modificare: "Solo il proprietario può modificare",
    be_solo_il_venditore: "Solo il venditore",
    be_solo_l: "Solo l",
    be_solo_la_controparte_pu_confermare: "Solo la controparte può confermare",
    be_solo_la_controparte_pu_rifiutare: "Solo la controparte può rifiutare",
    be_solo_super_admin_pu_assegnare_o_revocare_admin: "Solo super-admin può assegnare o revocare Admin",
    be_source_photo_not_found: "Source photo not found",
    be_stato_non_valido: "Stato non valido",
    be_super_admin_only: "Super admin only",
    be_target_user_not_found: "Target user not found",
    be_token_non_valido_o_gi_usato: "Token non valido o già usato",
    be_token_non_valido_o_scaduto: "Token non valido o scaduto",
    be_token_scaduto: "Token scaduto",
    be_too_many_reports_in_a_short_time_try_again_later: "Too many reports in a short time — try again later.",
    be_transaction_not_found: "Transaction not found",
    be_translation_failed: "Translation failed",
    be_unsupported_file_type: "Unsupported file type",
    be_you_can_only_edit_your_own_messages: "You can only edit your own messages",
    be_already_moderated: "already moderated",
    be_annuncio_concluso_la_chat_chiusa: "annuncio è concluso: la chat è chiusa",
    be_categoria_non_valida: "categoria non valida",
    be_invalid_hours: "invalid hours",
    be_invalid_kind: "invalid kind",
    be_invalid_token: "invalid token",
    be_invalid_type: "invalid type",
    be_kind_must_be_one_of_resolved_in_progress_worse_undo: "kind must be one of: resolved, in_progress, worse, undo",
    be_new_path_not_found_in_files: "new_path not found in files",
    be_no_changes: "no changes",
    be_peer_id_richiesto_per_il_proprietario: "peer_id richiesto per il proprietario",
    be_photo_path_required: "photo path required",
    be_photo_index_out_of_range: "photo_index out of range",
    be_platform_must_be_ios_android_web: "platform must be ios|android|web",
    be_polygon_needs_at_least_3_points: "polygon needs at least 3 points",
    be_reason_required_min_5_chars: "reason required (min 5 chars)",
    be_regions_required: "regions required",
    be_role_must_be: "role must be",
    be_solo_vendo_ha_il_prezzo: "solo Vendo ha il prezzo",
    be_sottocategoria_non_valida: "sottocategoria non valida",
    be_text_required: "text required",
    be_tipo_specifico_non_valido: "tipo specifico non valido",
    be_token_required: "token required",
    be_utente_non_trovato: "utente non trovato",
    be_cosa_fare_ora_riservato_ad_admin_ed_enti_verificati: "«Cosa fare ora» riservato ad Admin ed enti verificati",
  
    menu_my_listings: "I miei annunci",
    menu_following: "Seguiti",
    menu_saved_searches: "Le mie ricerche",
    unread_messages: "messaggi non letti",
  
    mk_type_sale: "Vendo",
    mk_type_gift: "Regalo",
    mk_type_reusable: "Riutilizzabile trovato",
  
    mk_title_row: "Vendo · Regalo · Riutilizzabili",
    new_listing: "Nuovo annuncio",
    guest_login_sale: "Accedi per vedere gli annunci Vendo.",
    tab_all: "Tutti",
    mk_kicker: "MARKETPLACE",
    tip_mk_3cats: "Marketplace ha tre categorie ben distinte: 🟣 Vendo (con prezzo, ritiro/spedizione), 🔵 Regalo (gratuito, scelto dal proprietario in chat), 🟤 Riutilizzabile trovato (oggetto abbandonato: chi arriva prima lo prende).",
    tip_mk_guest: "Gli annunci Vendo sono visibili solo agli utenti registrati. Regalo e Riutilizzabile sono visibili a tutti nella mappa, ma per contattare o creare devi accedere.",
  
    event_new_proposal: "Nuova proposta",
    event_extraordinary_kicker: "Evento straordinario",
    event_intro_line: "Segnala un evento realmente in corso su area estesa (incendio, alluvione, frana, tempesta, ecc.).",
    event_intro_verified_pub: "La tua pubblicazione sarà immediata come ente verificato.",
    event_intro_review_pub: "La proposta verrà rivista da un Admin prima di essere pubblicata.",
    event_title_label: "Titolo",
    event_kind_label: "Categoria",
    event_whattodo_admin_only: "Cosa fare ora (solo Admin / enti verificati)",
    event_started_label: "Data e ora di inizio (facoltativo)",
    event_publish_btn: "Pubblica evento",
    event_send_proposal_btn: "Invia proposta",
    event_area_involved: "Area coinvolta",
    event_area_hint: "Cerca il territorio (facoltativo) e/o clicca sulla mappa per aggiungere i vertici del poligono. Servono almeno 3 punti.",
    event_territory_prefix: "Territorio",
    event_undo_last: "Annulla ultimo",
    event_clear_all: "Pulisci",
    event_draw_start: "Disegna area",
    event_draw_stop: "Ferma disegno",
    event_draw_active_hint: "Modalità disegno ATTIVA — tocca la mappa per aggiungere vertici. Servono almeno 3 punti.",
    event_polygon_hint_manual: "Attiva \"Disegna area\" e tocca almeno 3 punti sulla mappa. In alternativa usa \"Usa area corrente\" per un poligono automatico di 2 km.",
    event_use_current_area: "Usa area corrente (~2 km)",
    event_area_used_current: "Area di ~2 km generata attorno al centro mappa",
    event_points_count_suffix: "punti",
    event_title_required: "Titolo obbligatorio",
    event_polygon_required: "Disegna un'area di almeno 3 punti",
    event_published_ok: "Evento pubblicato",
    event_proposal_sent: "Proposta inviata alla revisione Admin",
    event_generic_error: "Errore",
    event_title_placeholder: "Es. Incendio boschivo — Costa nord",
    event_desc_placeholder: "Cosa sta succedendo, dove, da quanto tempo",
    event_whattodo_placeholder: "Es. Non avvicinarsi. Chiamare 115. Evacuare zona X.",
    event_photos_label: "Fotografie",
    add_photo_short: "Aggiungi",
    mkc_description_label: "Descrizione",
    mkc_choose_placeholder: "Scegli…",
    mkc_condition_label: "Condizione",
    mkc_color_label: "Colore",
    mkc_color_placeholder: "Es. blu, legno naturale",
    mkc_keywords_label: "Parole chiave",
    mkc_photos_label: "Fotografie",
    country_or_province: "Paese, provincia o comune…",
    reports_solved_kicker: "Segnalazioni risolte",
    in_progress_kicker: "In lavorazione",
    verified_users_kicker: "Utenti verificati",
    close_tips: "Chiudi consigli",
    what_are_you_selling: "Che cosa vendi?",
    what_are_you_giving: "Che cosa regali?",
    what_did_you_find: "Che cosa hai trovato?",
    change_type: "Cambia tipologia",
    publish_listing: "Pubblica annuncio",
    approximate_location: "Posizione approssimativa",
    category_first_short: "Prima la categoria",
    // --- MarketplaceCreate — mode-choice + form + errors ---
    mkc_new_listing_kicker: "Marketplace · Nuovo annuncio",
    mkc_what_type_heading: "Che tipo di annuncio vuoi pubblicare?",
    mkc_type_choice_desc: "Scegli una delle tre modalità. Ogni tipologia ha regole diverse (prezzo, chat, chiusura). Potrai modificare la scelta prima di pubblicare.",
    mkc_hint_sale: "Prezzo obbligatorio. L'annuncio è visibile solo agli utenti registrati. Chat privata con potenziali acquirenti; alla fine tu (venditore) e l'acquirente confermate la conclusione.",
    mkc_hint_gift: "Regali un oggetto a un altro utente. Nessun prezzo. Decidi liberamente in chat a chi consegnarlo.",
    mkc_hint_reusable: "Segnali un oggetto abbandonato o riutilizzabile che hai trovato. Nessun prezzo, nessuna assegnazione: chi arriva per primo lo prende. La chat è solo informativa.",
    mkc_subtitle_sale: "Pubblica un annuncio di vendita: prezzo obbligatorio, ritiro a mano o spedizione, chat privata con gli acquirenti.",
    mkc_subtitle_gift: "Regala un oggetto a un altro utente: scegli tu liberamente in chat a chi consegnarlo.",
    mkc_subtitle_reusable: "Segnala un oggetto riutilizzabile che hai trovato o abbandonato: chi arriva per primo lo prende. Chat solo informativa.",
    mkc_title_label: "Titolo",
    mkc_category_label: "Categoria",
    mkc_subcategory_label: "Sottocategoria",
    mkc_itemtype_label: "Tipo specifico",
    mkc_subcategory_first: "Prima la sottocategoria",
    mkc_condition_new: "Nuovo",
    mkc_condition_good: "Buono",
    mkc_condition_used: "Usato",
    mkc_keywords_placeholder: "ikea, doppio, 180cm (separate da virgola)",
    mkc_price_label: "Prezzo (€)",
    mkc_negotiable: "Trattabile",
    mkc_pickup: "Ritiro a mano",
    mkc_shipping: "Spedizione",
    mkc_position_label: "Posizione approssimativa",
    mkc_position_hint: "Cerca il territorio (facoltativo) e/o clicca sulla mappa. La posizione pubblica è approssimativa; l'indirizzo preciso lo condividerai in chat.",
    mkc_territory_prefix: "Territorio",
    mkc_err_title_required: "Titolo obbligatorio",
    mkc_err_taxonomy_required: "Categoria, sottocategoria e tipo specifico obbligatori",
    mkc_err_position_required: "Seleziona la posizione approssimativa sulla mappa",
    mkc_err_price_required: "Prezzo obbligatorio",
    mkc_success_published: "Annuncio pubblicato",
    mkc_err_generic: "Errore",
    mkc_upload_failed: "Caricamento fallito",
    map_reports_list_title: "Elenco segnalazioni",
    map_within_km: "entro {km} km",
    map_within_area: "in {area}",
    map_count_results: "risultati",
    map_count_reports: "segnalazioni",
    map_clear_area_filter: "Azzera filtro provincia",
    details_arrow: "Dettagli →",
    events_popup_state_prefix: "Stato",
    mk_popup_following: "✓ Seguito",
    mk_popup_follow: "🔔 Segui",
    events_history_kicker: "Storico eventi straordinari",
    events_history_count_suffix: "eventi",
    events_history_none: "Nessun evento trovato.",
    legal_kicker: "Documento legale",
    legal_placeholder_title: "Contenuto in fase di finalizzazione",
    legal_placeholder_body: "Il testo definitivo di questo documento sarà pubblicato a breve. Per informazioni contattaci a",
    legal_privacy_title: "Informativa sulla privacy",
    legal_terms_title: "Termini e Condizioni",
    legal_community_title: "Regole della community",
    legal_marketplace_title: "Regole del Marketplace",
    acct_del_kicker: "Cancellazione account",
    acct_del_title: "Cancella il tuo account ToClean",
    acct_del_intro: "Puoi richiedere la cancellazione del tuo account ToClean e dei dati personali associati in qualsiasi momento. La procedura è irreversibile.",
    acct_del_what_happens_title: "Cosa succede alla cancellazione",
    acct_del_what_1: "Il tuo account viene eliminato dal database.",
    acct_del_what_2: "I tuoi annunci Marketplace vengono rimossi.",
    acct_del_what_3: "I tuoi post e messaggi vengono anonimizzati (contenuto conservato, autore mostrato come «Utente eliminato»).",
    acct_del_what_4: "Le tue sessioni e token push vengono revocati immediatamente.",
    acct_del_what_5: "Segnalazioni pubbliche già inviate agli enti restano nel loro registro (obbligo di legge).",
    acct_del_how_signed_in_title: "Se sei collegato",
    acct_del_how_signed_in_body: "Vai in Impostazioni → «Elimina account». Riceverai una conferma prima dell'azione irreversibile.",
    acct_del_go_settings: "Apri Impostazioni",
    acct_del_how_email_title: "Se non hai accesso all'account",
    acct_del_how_email_body: "Scrivi a info@toclean.app dall'email associata all'account. Il team ToClean processerà la richiesta.",
  
    tip_event_scope: "Un evento straordinario riguarda emergenze su area estesa (incendio, alluvione, frana, tempesta, ecc.), non singoli oggetti o piccole segnalazioni.",
    tip_event_polygon: "Disegna l'area sulla mappa cliccando i vertici del poligono: servono almeno 3 punti. Usa «Annulla ultimo» o «Pulisci» per correggere.",
    tip_event_moderation: "Se non sei un ente verificato, la proposta viene inviata alla revisione di un Admin prima di diventare pubblica sulla mappa.",
    tip_map_colors: "I marker sono colorati per rischio: 🟢 Verde = ordinario, 🟡 Giallo = da monitorare, 🔴 Rosso = urgente. Il colore viene deciso dal breve questionario in fase di creazione della segnalazione.",
    tip_map_filters: "Usa i filtri per scegliere quali segnalazioni o oggetti visualizzare. La mappa, l'elenco e il numero dei risultati si aggiorneranno insieme.",
    tip_map_duplicates: "Prima di aprire una nuova segnalazione, controlla se ne esiste già una vicina: aiuta a non generare duplicati e a rafforzare i report esistenti.",
    tip_rc_wizard: "Le 4 domande del codice colore assegnano automaticamente Verde/Giallo/Rosso in base a rischio percepito, urgenza, entità e impatto. Non sono un giudizio: guidano solo la priorità della moderazione.",
    tip_rc_privacy: "Le tue foto vengono processate lato server: volti e targhe vengono automaticamente sfocati. La posizione pubblica è approssimativa: l'indirizzo preciso resta privato.",
    tip_rc_after_photo: "Per dichiarare risolta una segnalazione ordinaria, dovrai in seguito aggiungere una foto «dopo» dallo stesso luogo. Un solo click, ma indispensabile per confermare la risoluzione.",
  
    publish: "Pubblica",
    submit_for_review: "Invia per revisione",
    state_published: "Pubblicata",
    state_in_progress: "In lavorazione",
    state_pending: "In verifica",
    state_rejected: "Rifiutata",
    state_draft: "Bozza",
    state_resolved: "Risolta",
    state_closed: "Chiusa",
    state_active: "Attiva",
    risk_green: "Verde",
    risk_yellow: "Giallo",
    risk_red: "Rosso",
    stats_reports_solved: "Segnalazioni risolte",
    stats_reports_progress: "In lavorazione",
    stats_users_verified: "Utenti verificati",
  
    no_period_data: "Nessun dato per il periodo selezionato.",
    awaiting_counterpart: "In attesa che la controparte confermi.",
    no_messages_write_first: "Nessun messaggio: scrivi il primo.",
    no_chat_for_listing_msg: "Nessuna chat per questo annuncio",
    // Phase 3 — private chat (18+ only)
    nav_messages: "Messaggi",
    chat_title: "Messaggi",
    chat_tab_chats: "Chat",
    chat_tab_requests: "Richieste",
    chat_tab_invites: "Inviti",
    chat_tab_blocked: "Bloccati",
    chat_empty: "Nessuna chat ancora.",
    chat_no_requests: "Nessuna richiesta.",
    chat_no_invites: "Nessun invito.",
    chat_send: "Invia",
    chat_composer_placeholder: "Scrivi un messaggio…",
    chat_request_dialog_title: "Richiedi una chat privata",
    chat_request_dialog_desc: "Invia una richiesta per iniziare una chat privata. Il destinatario deve accettarla prima che la conversazione possa iniziare.",
    chat_request_send: "Invia richiesta",
    chat_request_sent: "Richiesta inviata",
    chat_message_optional_label: "Messaggio iniziale (opzionale)",
    chat_message_optional_ph: "Ad esempio: sono interessato all'annuncio…",
    chat_accept: "Accetta",
    chat_reject: "Rifiuta",
    chat_cancel_req: "Annulla richiesta",
    chat_incoming: "In arrivo",
    chat_outgoing: "Inviate",
    chat_pending_status: "In attesa",
    chat_group_create: "Crea gruppo",
    chat_group_title_label: "Titolo del gruppo",
    chat_group_desc_label: "Descrizione (opzionale)",
    chat_group_invitees_label: "Invita utenti (ID utente, separati da virgola)",
    chat_group_picker_label: "Invita utenti",
    chat_group_picker_placeholder: "Cerca per nome…",
    chat_group_picker_selected: "Selezionati",
    chat_group_picker_no_results: "Nessun utente trovato.",
    chat_group_picker_min_chars: "Digita almeno 2 caratteri.",
    chat_group_picker_add: "Aggiungi",
    chat_group_picker_remove: "Rimuovi",
    // Phase 4 — Social links
    social_links_title: "Link social e sito web",
    social_links_desc: "Facoltativi. I link saranno visibili nel tuo profilo pubblico. ToClean non verifica né approva i contenuti esterni.",
    social_links_add: "Aggiungi link",
    social_links_platform: "Piattaforma",
    social_links_url: "URL",
    social_links_label: "Etichetta (opzionale)",
    social_links_save: "Salva link",
    social_links_saved: "Link social salvati",
    social_links_url_scheme_err: "L'URL deve iniziare con http:// o https://",
    social_links_url_invalid_err: "URL non valido.",
    social_links_url_too_long_err: "URL troppo lungo.",
    social_links_adult_only: "Solo utenti di 18 anni o più possono aggiungere link esterni.",
    social_links_none: "Nessun link.",
    social_links_platform_website: "Sito web",
    social_links_platform_other: "Altro",
    social_links_disclaimer: "Link esterni non verificati.",
    // Phase 4 — Video upload
    video_upload_label: "Aggiungi video",
    video_upload_hint: "Formati supportati: MP4, MOV, M4V, WebM (H.264 o VP8/VP9). Massimo {mb} MB.",
    video_uploading: "Caricamento…",
    video_upload_progress: "{p}%",
    video_upload_ok: "Video caricato",
    video_upload_err_format: "Formato non supportato. Usa MP4, MOV o WebM.",
    video_upload_err_hevc: "Il video è in HEVC/H.265 e non è riproducibile su tutti i browser. Sull'iPhone, imposta Impostazioni → Fotocamera → Formati → \"Più compatibile\" e riprova.",
    hevc_help_title: "Compatibilità video iPhone",
    hevc_help_desc: "Il tuo iPhone ha registrato in HEVC/H.265. Segui questi passaggi per usare un formato compatibile con ToClean.",
    hevc_help_step1: "Apri Impostazioni",
    hevc_help_step2: "Vai su Fotocamera → Formati",
    hevc_help_step3: "Scegli \"Più compatibile\"",
    hevc_help_step4: "Registra un nuovo video e ricarica",
    hevc_help_note: "I video già in HEVC sul rullino restano invariati. Le nuove registrazioni useranno H.264/MP4, compatibile con ToClean e con la maggior parte dei dispositivi.",
    hevc_help_show: "Come si risolve?",
    video_upload_err_too_large: "Video troppo grande. Limite {mb} MB.",
    video_upload_err_generic: "Impossibile caricare il video.",
    video_delete: "Elimina video",
    video_delete_confirm: "Eliminare questo video?",
    video_privacy_notice: "Se il video mostra persone, targhe o dati personali direttamente collegati a un presunto comportamento illecito o dannoso, si applica lo stesso Privacy Prompt delle foto.",
    video_none: "Nessun video.",
    video_removed: "Video rimosso.",
    chat_group_leave: "Esci dal gruppo",
    chat_group_member: "Membro",
    chat_group_pending_label: "Invito in sospeso",
    chat_block_user: "Blocca utente",
    chat_unblock_user: "Sblocca",
    chat_blocked_list: "Utenti bloccati",
    chat_report_message: "Segnala messaggio",
    chat_adult_only: "Le chat private sono disponibili solo agli utenti di 18 anni o più.",
    chat_pending_invite_banner: "Devi accettare l'invito per vedere i messaggi del gruppo.",
    chat_open: "Apri",
    chat_leave: "Esci",
    chat_open_conversation: "Apri conversazione",
    chat_error_send: "Impossibile inviare il messaggio.",
    chat_group_created: "Gruppo creato",
    chat_group_leave_confirm: "Sicuro di voler uscire dal gruppo?",
    chat_from: "da",
    report_unavailable: "Segnalazione non disponibile",
    open_report_in_app: "Apri la segnalazione nell'app",
    content_removed: "Questo contenuto è stato rimosso o non è più accessibile.",
    no_pec_before_button: "Nessuna PEC viene inviata prima di questo bottone.",
    no_reports_for_filters: "Nessuna segnalazione per i filtri attuali.",
    reforestation_big_project: "Un progetto grande quanto il futuro che vogliamo costruire.",
    not_authorized_dot: "Non autorizzato.",
    support_reforestation: "Sostieni la riforestazione",
    my_searches_title: "Le mie ricerche",
    // Legal compliance (iter60+): DOB & consent
    signup_dob_label: "Data di nascita",
    signup_dob_help: "Serve solo per verificare che tu abbia almeno 14 anni. Non viene mostrata a nessuno.",
    signup_terms_prefix: "Ho letto e accetto i",
    signup_terms_link: "Termini di Servizio",
    signup_privacy_prefix: "Ho letto e accetto l'",
    signup_privacy_link: "Informativa sulla Privacy",
    signup_terms_required: "Devi accettare Termini e Privacy per registrarti.",
    signup_age_required: "Per usare ToClean devi avere almeno 14 anni.",
    signup_dob_invalid: "Data di nascita non valida.",
    complete_profile_title: "Completa il tuo profilo",
    complete_profile_desc: "Per continuare a usare ToClean confermaci la tua età e accetta le condizioni aggiornate. Nessun altro dato viene richiesto.",
    complete_profile_cta: "Conferma e continua",
    complete_profile_age_warning: "Se hai meno di 14 anni il tuo account verrà eliminato automaticamente, come richiesto dalle regole delle app store.",
    // Age gating labels in UI
    mk_adult_only_banner: "Il Marketplace è disponibile in sola lettura fino ai 18 anni. Puoi consultare gli annunci ma non pubblicare, contattare o seguire.",
    mk_adult_only_button_tip: "Disponibile dai 18 anni.",
    mk_new_disabled_minor: "Solo dai 18 anni",
    // Content report / block
    report_content_btn: "Segnala contenuto",
    report_content_title: "Segnala questo contenuto",
    report_content_desc: "Verrà notificato al team di moderazione. Non condividiamo la tua identità con la persona segnalata.",
    report_reason_harassment: "Molestie o minacce",
    report_reason_hate: "Incitamento all'odio",
    report_reason_sexual: "Contenuto sessuale non richiesto",
    report_reason_spam: "Spam o truffa",
    report_reason_privacy: "Violazione della privacy",
    report_reason_illegal: "Contenuto illegale",
    report_reason_impersonation: "Impersonificazione",
    report_reason_abuse: "Abuso della piattaforma",
    report_reason_other: "Altro",
    report_content_details: "Dettagli (opzionale)",
    report_content_send: "Invia segnalazione",
    report_content_sent: "Segnalazione inviata. Grazie.",
    block_user_btn: "Blocca utente",
    unblock_user_btn: "Sblocca utente",
    block_user_confirm_title: "Blocca questo utente?",
    block_user_confirm_desc: "Non riceverai più messaggi né vedrai i suoi contenuti. Puoi sbloccarlo in qualsiasi momento dalle Impostazioni.",
    block_user_ok: "Bloccato",
    unblock_user_ok: "Sbloccato",
    // Privacy Prompt (iter68 UI)
    pp_title: "Un momento prima di pubblicare",
    pp_question: "Stai rendendo riconoscibile una persona, una targa o altri dati personali collegandoli direttamente a un presunto comportamento illecito o dannoso?",
    pp_answer_no: "No",
    pp_answer_yes: "Sì",
    pp_warn_title: "Attenzione: privacy, reputazione e diritti delle persone",
    pp_warn_body: "Rendere una persona identificabile e collegarla pubblicamente a presunti illeciti può avere conseguenze legali per te e per la persona rappresentata: privacy, reputazione e diritti sono in gioco.\n\nPer questo motivo, il contenuto verrà inviato a ToClean per una verifica prima dell'eventuale pubblicazione.",
    pp_warn_body_review_only: "Rendere una persona identificabile e collegarla pubblicamente a presunti illeciti può avere conseguenze legali per te e per la persona rappresentata: privacy, reputazione e diritti sono in gioco.\n\nPer questo motivo, il contenuto verrà inviato a ToClean per una verifica prima dell'eventuale pubblicazione.",
    pp_send_review: "Invia in revisione a ToClean",
    pp_ack_label: "Confermo di essere responsabile dei contenuti e delle dichiarazioni che pubblico e di aver letto l'avviso relativo alla privacy, alla reputazione e ai diritti delle persone rappresentate.",
    pp_publish_anyway: "Pubblica comunque",
    pp_sent_review_toast: "Contenuto inviato in revisione. Ti aggiorneremo.",
    // Comments: like + sort (iter70)
    comment_like: "Mi piace",
    comment_unlike: "Rimuovi Mi piace",
    comment_likes_count_one: "1 Mi piace",
    comment_likes_count_many: "{n} Mi piace",
    comment_sort_label: "Ordina",
    comment_sort_relevant: "Più rilevanti",
    comment_sort_liked: "Più apprezzati",
    comment_sort_recent: "Più recenti",
    comment_sort_oldest: "Meno recenti",
    comment_report: "Segnala commento",
    // Admin content-reports section (iter62)
    admin_tab_content_reports: "Segnalazioni contenuti",
    admin_tab_events: "Eventi straordinari",
    what_to_do_now: "Cosa fare ora",
    reject_reason_prompt: "Motivazione (opzionale):",
    delete_event_confirm: "Eliminare definitivamente questo evento?",
    cr_no_items: "Nessuna segnalazione di contenuto per i filtri attuali.",
    cr_status_open: "Aperta",
    cr_status_in_review: "In revisione",
    cr_status_resolved: "Risolta",
    cr_status_dismissed: "Ignorata",
    cr_target_type: "Tipo",
    cr_target_report: "Segnalazione",
    cr_target_marketplace_listing: "Annuncio",
    cr_target_message: "Messaggio chat",
    cr_target_marketplace_message: "Messaggio Marketplace",
    cr_reported_by: "Segnalato da",
    cr_reporter_deleted: "utente eliminato",
    cr_content_author: "Autore contenuto",
    cr_open_target: "Apri contenuto segnalato",
    cr_action_review: "Prendi in carico",
    cr_action_resolve: "Segna come risolto",
    // Legal package (iter80)
    legal_info_title: "Informazioni Legali e Contatti",
    legal_privacy_title: "Privacy Policy",
    legal_terms_title: "Termini di Servizio",
    legal_community_title: "Regole Community",
    legal_marketplace_title: "Regole Marketplace",
    legal_deletion_title: "Cancellazione Account e Dati",
    footer_legal: "Documenti legali",
    footer_legal_info: "Informazioni legali",
    footer_privacy: "Privacy Policy",
    footer_terms: "Termini di Servizio",
    footer_community_rules: "Regole Community",
    footer_marketplace_rules: "Regole Marketplace",
    footer_account_deletion: "Cancellazione account",
    // Unified signup consent
    signup_consent_prefix: "Accetto i",
    signup_consent_and_the: "e le",
    signup_consent_privacy_note: "e dichiaro di aver letto la",
    signup_community_link: "Regole Community",
    // Marketplace Rules Gate
    mkt_rules_gate_title: "Regole Marketplace",
    mkt_rules_gate_kicker: "Prima operazione Marketplace",
    mkt_rules_gate_desc: "Per pubblicare un annuncio, modificarlo o contattare un altro utente devi prima accettare le Regole Marketplace nella versione corrente.",
    mkt_rules_gate_read: "Leggi le Regole Marketplace",
    mkt_rules_gate_checkbox: "Ho letto e accetto le Regole Marketplace.",
    mkt_rules_gate_accept: "Accetto e continuo",
    mkt_rules_gate_cancel: "Annulla",
    mkt_rules_gate_required: "Devi accettare le Regole Marketplace per procedere.",
    mkt_rules_gate_accepted_toast: "Regole Marketplace accettate.",
    mkt_rules_gate_error: "Impossibile registrare l'accettazione. Riprova.",
    // Profile photo (Settings)
    section_profile_photo: "Foto profilo",
    profile_photo_desc: "Aggiungi una foto profilo pubblica. È facoltativa e puoi rimuoverla in qualsiasi momento.",
    profile_photo_upload: "Carica foto",
    profile_photo_replace: "Sostituisci foto",
    profile_photo_remove: "Rimuovi foto",
    profile_photo_uploading: "Caricamento in corso…",
    profile_photo_removing: "Rimozione in corso…",
    profile_photo_updated: "Foto profilo aggiornata.",
    profile_photo_removed: "Foto profilo rimossa.",
    profile_photo_invalid_type: "Formato immagine non supportato. Usa JPG, PNG o WEBP.",
    profile_photo_too_large: "L'immagine è troppo grande. Dimensione massima: 5 MB.",
    profile_photo_error: "Impossibile aggiornare la foto profilo. Riprova.",
    profile_photo_hint: "JPG, PNG o WEBP · massimo 5 MB.",
    // Username / nickname (iter83)
    username_label: "Nome utente",
    username_placeholder: "es. mario.rossi",
    username_help: "3–30 caratteri, solo lettere, numeri, punto e underscore. Univoco e pubblico.",
    email_private_hint: "L'email resta privata: non viene mostrata ad altri utenti.",
    username_too_short: "Il nome utente deve avere almeno 3 caratteri.",
    username_too_long: "Il nome utente non può superare i 30 caratteri.",
    username_invalid_chars: "Il nome utente può contenere solo lettere, numeri, punto e underscore.",
    username_reserved: "Questo nome utente è riservato.",
    username_taken: "Questo nome utente è già in uso.",
    username_required: "Scegli un nome utente per continuare.",
    cr_action_dismiss: "Ignora",
  },
  en: {
    tagline: "Leave the world better than we found it.",
    hero_title: "Report. Verify. Clean up.",
    hero_subtitle: "ToClean is the global platform that turns a report into real action. Citizens, volunteers, NGOs and municipalities — together on one map.",
    cta_map: "Open the map",
    cta_report: "Create report",
    cta_signin: "Sign in",
    cta_signup: "Sign up",
    cta_google: "Continue with Google",
    cta_donate: "Donate",
    nav_map: "Map",
    nav_stories: "Positive stories",
    nav_leaderboard: "Leaderboard",
    nav_profile: "Profile",
    nav_admin: "Admin",
    nav_settings: "Settings",
    nav_admin_dashboard: "Admin Dashboard",
    stats_reports: "total reports",
    stats_resolved: "problems solved",
    stats_pending: "in progress",
    stats_users: "active members",
    filters: "Filters",
    category: "Category",
    all: "All",
    risk_level: "Risk",
    status: "Status",
    green: "Green", yellow: "Yellow", red: "Red",
    st_published: "Published",
    st_in_progress: "In progress",
    st_resolved: "Resolved",
    st_pending: "Pending",
    st_pending_moderation: "To approve",
    st_concluded: "Concluded",
    st_archived: "Archived",
    cat_waste: "Waste",
    cat_environment: "Environment",
    cat_animals: "Animals",
    cat_urban: "Urban decay",
    cat_vegetation: "Hazardous roadside vegetation",
    cat_reusable: "Reusable items",
    new_report: "New report",
    subcategory: "Subcategory",
    description: "Description",
    upload_photos: "Upload photos",
    submit: "Submit report",
    cancel: "Cancel",
    email: "Email",
    password: "Password",
    name: "Name",
    role: "Role",
    citizen: "Citizen",
    volunteer: "Volunteer",
    association: "NGO",
    company: "Company / Sponsor",
    municipality: "Municipality",
    operator: "Operator",
    already: "Already have an account?",
    new_here: "New to ToClean?",
    signin_now: "Sign in",
    signup_now: "Sign up",
    coordinate: "Coordinate the intervention",
    send_message: "Send",
    write_message: "Write a message…",
    confirm: "Confirm",
    confirm_still: "Problem still exists",
    confirm_worsened: "It got worse",
    confirm_resolved: "Looks resolved",
    confirm_not: "No longer present",
    take_item: "I took the item",
    interested: "I'm interested",
    logout: "Log out",
    reports_created: "Reports created",
    confirmations_made: "Confirmations",
    reputation: "Reputation",
    donation_title: "Support ToClean",
    donation_desc: "Your contribution funds verified interventions, volunteer rewards and platform development.",
    donation_amount: "Amount",
    donation_message: "Message (optional)",
    donate_now: "Donate now",
    donate_min_amount: "Minimum amount: €0.50. You can also donate without registering.",
    donate_min_error: "Minimum amount €0.50",
    donate_stripe_error: "Stripe error",
    donate_redirect: "Redirecting…",
    donate_message_placeholder: "A thought for the community…",
    donate_secure: "Secure payment via Stripe. Test card:",
    positive_title: "Positive stories from the community",
    positive_desc: "Every gray marker is a problem someone made invisible.",
    positive_empty: "No stories yet. Your confirmations and interventions can become the next one.",
    positive_solved: "Resolved",
    ai_analyze: "Analyze with AI",
    ai_suggested: "AI suggestion",
    emergency_notice: "For immediate emergencies (fires, life-threatening animal situations, hazardous substances) contact your local emergency services first.",
    footer_mission: "ToClean is a platform for environmental action. Every report matters.",
    footer_platform: "Platform",
    footer_platform_items: "Map · Reports · Chat · Rewards",
    footer_platform_lang: "Multi-language (IT · EN)",
    footer_platform_ai: "AI-assisted moderation (GPT-5.2)",
    footer_community: "Community",
    footer_made: "Made with volunteers, for the planet.",
    hero_slide1_title: "The planet is beautiful.",
    hero_slide1_sub: "Every tiny gesture decides whether it stays that way.",
    hero_slide2_title: "Together we can.",
    hero_slide2_sub: "Citizens, volunteers, NGOs, companies, municipalities — on the same map.",
    hero_slide3_title: "One action, one proof.",
    hero_slide3_sub: "Before/after photos, receipts, public history of every intervention.",
    hero_prev: "Previous",
    hero_next: "Next",
    hero_play: "Play",
    hero_pause: "Pause",
    hero_mute_on: "Unmute",
    hero_mute_off: "Mute",
    community_verified: "Community · verified",
    hero_action_leaves_mark: "Every action leaves a mark.",
    risk_green_low: "Green · Low",
    risk_green_desc: "Small litter, objects, non-hazardous materials.",
    risk_red_high: "Red · High",
    risk_red_desc: "Hazardous substances, animal abuse, sensitive evidence.",
    mission_kicker: "Mission & Purpose",
    mission_title: "A cleaner planet doesn't wait for anyone's permission.",
    mission_p1: "ToClean is an <b>independent</b> platform built to connect those who see a problem with those who can solve it. Citizens, volunteers, NGOs, companies and municipalities — on the same map, with the same tools, for the same goal.",
    mission_p2: "Not another social network. Not a petition. An operational tool: <b>photo, verification, coordination, proof of result.</b> Simple, transparent, verifiable.",
    // ---- MissionPage /missione (approved content, faithfully translated from IT)
    missionpage_kicker: "Mission",
    missionpage_title: "Our mission",
    missionpage_intro: "ToClean was created to make protecting the environment simpler, more tangible and more shared. We want to offer people a space where they can report environmental issues, follow what is happening in their area, collaborate with the community and give new life to items that are still usable.",
    missionpage_s1_title: "Environmental participation",
    missionpage_s1_body: "ToClean lets people contribute to caring for their area through environmental reports, updates, local initiatives and extraordinary events. Every contribution can help make problems more visible and foster action, collaboration and shared responsibility.",
    missionpage_s2_title: "Reuse and community",
    missionpage_s2_body: "Through the Sell, Give away and Reusable items found sections, ToClean aims to cut waste and make it easier to reuse what can still be useful. The goal is not only to build a Marketplace, but to nurture a more attentive, responsible community that is close to its area.",
    missionpage_s3_title: "Donations and growth of the project",
    missionpage_s3_body: "People will be able to support ToClean, environmental reports and reforestation projects through voluntary contributions. The resources collected may contribute to the development, running and growth of the project, in compliance with the rules and information that will be published.",
    missionpage_future_title: "Future vision: sponsors and rewards",
    missionpage_future_p1: "ToClean believes that those who dedicate time, energy and concrete effort to protecting the environment deserve to be recognised.",
    missionpage_future_p2: "As the community grows and with the future support of companies, organisations and sponsors, we want to develop a transparent programme of recognition and rewards for the most active volunteers and for the most meaningful environmental initiatives.",
    missionpage_future_p3: "Sponsors will be able to support the project, contribute to the rewards and gain a clearly recognisable sponsorship visibility. A share of the resources may also help cover the costs required to maintain and grow ToClean.",
    missionpage_rewards_title: "Possible future rewards",
    missionpage_rewards_1: "Vouchers or discounts provided by sponsors",
    missionpage_rewards_2: "Eco-friendly products",
    missionpage_rewards_3: "Participation in experiences or events",
    missionpage_rewards_4: "Digital badges and recognitions",
    missionpage_rewards_5: "Prizes linked to environmental initiatives",
    missionpage_rewards_6: "Concrete support for volunteer groups or projects",
    missionpage_disclaimer: "The rewards programme is not active yet. It represents a future vision of ToClean and can be rolled out gradually only when there is real community growth, available resources and concrete agreements with sponsors and partners. Criteria, rules, conditions and assignment methods will be published before activation.",
    missionpage_updated_at: "Last updated:",
    missionpage_back_home: "Back to Home",
    publish_chooser_title: "What do you want to publish?",
    publish_chooser_desc: "Pick the content type: an environmental report or a Marketplace listing.",
    publish_chooser_report_title: "Environmental report",
    publish_chooser_report_desc: "Waste, abuse, neglect: helps monitor and resolve everyday issues.",
    publish_chooser_sale_title: "Item for sale",
    publish_chooser_sale_desc: "Post a listing with a price. Private chat with potential buyers.",
    publish_chooser_gift_title: "Item to give away",
    publish_chooser_gift_desc: "No price. Decide freely in chat who to give it to.",
    publish_chooser_reusable_title: "Reusable item found",
    publish_chooser_reusable_desc: "Report an abandoned or reusable item. First come, first served.",
    listing_type_sale: "Sell",
    listing_type_gift: "Give away",
    listing_type_reusable: "Reusable found",
    pillar1_title: "Report what you see",
    pillar1_desc: "Waste, urban decay, animals in distress, fires, reusable items. A photo, GPS position, a risk level. That's it.",
    pillar2_title: "Verify with the community",
    pillar2_desc: "People nearby confirm, add photos, indicate if the problem got worse or was solved. Reliability grows with confirmations.",
    pillar3_title: "Coordinate people and resources",
    pillar3_desc: "Every report has its own chat. Volunteers, NGOs, municipalities and professional operators agree there, without getting lost in private DMs.",
    pillar4_title: "Support with donations and sponsors",
    pillar4_desc: "Companies and individuals can fund interventions, rewards and equipment. Every contribution is tracked and tied to a real result.",
    pillar5_title: "Reward those who contribute",
    pillar5_desc: "Vouchers, gifts, equipment, sponsor recognitions. You don't earn money with ToClean — but the time you donate is never forgotten.",
    pillar6_title: "Verifiable, transparent results",
    pillar6_desc: "Before and after photos, disposal receipts, public history of every intervention. The 'Positive stories' section shows what was made invisible.",
    how_kicker: "How it works",
    how_title: "Five steps. Zero bureaucracy.",
    how_sub: "From the photo on your phone to the public proof of the result.",
    how_step_1: "Report",
    how_step_1_desc: "Photo, GPS, category, perceived risk.",
    how_step_2: "Verify",
    how_step_2_desc: "The community confirms or denies.",
    how_step_3: "Coordinate",
    how_step_3_desc: "Dedicated chat for volunteers and operators.",
    how_step_4: "Act",
    how_step_4_desc: "Organize pickup, cleanup, recovery.",
    how_step_5: "Prove",
    how_step_5_desc: "Before/after photos, disposal receipts.",
    cat_kicker: "5 categories · reportable in seconds",
    cat_headline: "Waste, environment, animals, urban decay and reusable items.",
    gray_markers: "Gray markers: problems made invisible.",
    emergency_label: "Emergencies",
    support_chip: "Support ToClean",
    support_title_1: "We don't ask for a subscription.",
    support_title_2: "We ask for a",
    support_title_3: "voluntary gesture.",
    support_p1: "ToClean is an independent project. It doesn't belong to a fund, doesn't sell personal data, doesn't fill the interface with ad banners. It grows thanks to those who believe that <b>caring for the territory is everyone's responsibility</b> — and choose to do it with a small financial contribution too.",
    support_p2: "Every euro donated is completely <b>optional</b>. You don't receive premium features, you don't get priority lanes, you don't rank higher. You receive something more important: <b>the certainty that a platform for the common good stays free, open and useful to those who come after you.</b>",
    support_cta: "Support ToClean",
    support_discover: "Discover the mission",
    support_uses_title: "What a donation is used for",
    support_use_1_title: "Servers and infrastructure",
    support_use_1_desc: "Map, photos, chat: everything must stay fast and available 24/7.",
    support_use_2_title: "New features",
    support_use_2_desc: "AI duplicate detection, notifications, automatic rewards, native mobile app.",
    support_use_3_title: "Moderation",
    support_use_3_desc: "Sensitive content, animal welfare, clean chats: the invisible work that makes the app trustworthy.",
    support_use_4_title: "Expansion to new countries",
    support_use_4_desc: "Translations, regulatory adaptation, local partners.",
    support_use_5_title: "Environmental initiatives",
    support_use_5_desc: "Small funds for verified community interventions (equipment, materials).",
    support_use_6_title: "Continuous improvement",
    support_use_6_desc: "Listening to users, fixes, accessibility, performance.",
    support_footnote: "No donation is mandatory. You can use ToClean forever, for free. If one day you want to contribute, you'll find it within reach — never in the way.",
    final_kicker: "Start now",
    final_slogan: "ToClean is simple, free and respectful — just like the Earth. Help us help her.",
    final_desc: "Sign up and turn a simple photo into real change. Every report is a step.",
    feedback_kicker: "Feedback and improvement proposals",
    feedback_title: "Help us improve ToClean.",
    feedback_desc: "Your suggestion is worth more than ten internal roadmaps. Report a bug, propose a new feature, tell us what's not working. You can write to us without registering.",
    feedback_kind: "Type",
    feedback_kind_suggestion: "Suggestion",
    feedback_kind_bug: "Bug / Problem",
    feedback_kind_improvement: "Improvement proposal",
    feedback_email_label: "Email (optional)",
    feedback_email_placeholder: "Only if you want to be contacted back",
    feedback_message: "Message",
    feedback_message_placeholder: "What can we improve?",
    feedback_submit: "Send feedback",
    feedback_submitting: "Sending…",
    feedback_no_signup: "No registration required.",
    feedback_min_words: "Write at least a few words",
    feedback_thanks: "Thanks for your feedback!",
    feedback_error: "Error",
    support_title: "We don't ask for a subscription. We ask for a voluntary gesture.",
    open_details: "Open details",
    close: "Close",
    set_local_password: "Set local password",
    set_password_desc: "Add a local password to your Google account so you can also log in with email + password.",
    new_password: "New password",
    save: "Save",
    confirmations_short: "conf.",

    // MapHub
    map_locate_unsupported: "Your browser does not support geolocation.",
    map_geo_disabled: "Geolocation disabled in settings.",
    map_geo_denied: "GPS permission denied.",
    map_geo_failed: "Unable to obtain your location.",
    map_locate_title: "My location",
    map_locate_here: "Center here",
    geo_no_results_for_area: "No results for this area.",
    geo_search_error: "Search error",
    geo_temp_unavailable: "Search temporarily unavailable — please retry",
    map_hide_filters: "Hide filters",
    map_show_filters: "Show filters",
    map_std: "Map",
    map_satellite: "Satellite",
    map_tiles_error: "Unable to load map tiles.",
    map_tiles_check: "Check your connection and try again.",
    map_retry: "Retry",
    color: "Color",
    show_all: "Show all",
    reset: "Reset",
    all_subcategories: "All subcategories",
    legend: "Legend",
    legend_green_low: "Green · low",
    legend_yellow_med: "Yellow · medium",
    legend_red_high: "Red · high",
    legend_gray_resolved: "Gray · resolved",
    legend_blue_progress: "Blue · in progress",
    legend_purple_reusable: "Purple · reusable",
    st_active: "Active",
    st_taken: "Taken over",
    st_review: "In review",
    st_standby: "Standby",
    st_reopened: "Reopened",
    active_prefix: "Active:",
    fab_expand: "Show Create report button",
    fab_minimize: "Minimize",

    // AuthPage
    auth_home: "Home",
    auth_signin_kicker: "Sign in",
    auth_signup_kicker: "Create account",
    auth_signin_h: "Welcome back.",
    auth_signup_h: "Join the movement.",
    auth_slogan: "Every photo is a small change.",
    auth_or: "or",
    welcome_back: "Welcome back!",
    welcome_new: "Welcome to ToClean!",
    generic_error: "Error",
    forgot_password: "Forgot password?",
    signin_remember_me: "Remember me on this device",

    // PasswordReset
    reset_back_to_login: "Back to login",
    reset_title: "Reset password",
    reset_request_desc: "Enter your email. We'll send you a token to reset your password.",
    reset_confirm_desc: "Enter the token you received and your new password.",
    reset_send_link: "Send link",
    reset_update_pwd: "Update password",
    reset_updated: "Password updated! You can now sign in.",
    reset_dev_notice_b: "Demo environment:",
    reset_dev_notice: "token pre-filled. In production it arrives by email.",
    reset_min_chars: "Minimum 6 characters",
    token_label: "Token",

    // Settings
    settings_title: "Your account",
    settings_desc: "Manage profile, security, notifications and privacy.",
    section_profile: "Profile",
    section_password: "Password",
    section_notifications: "Notifications",
    section_language: "Language",
    section_geolocation: "Geolocation",
    section_privacy: "Privacy",
    section_feedback: "Feedback & suggestions",
    section_session: "Session",
    current_password: "Current password",
    new_password_min: "New password (min. 6)",
    change_password: "Change password",
    fill_both_fields: "Fill both fields",
    profile_updated: "Profile updated",
    password_updated: "Password updated",
    lang_updated: "Language updated",
    local_password_set: "Local password set!",
    notif_new_reports: "New reports in your area",
    notif_mentions: "Chat mentions",
    notif_status_changes: "Status updates",
    notif_rewards: "Rewards and vouchers available",
    geo_desc: "If enabled, ToClean can request browser GPS to center the map and pre-fill report location. You can revoke permission at any time from your browser settings.",
    geo_browser_denied: "The browser denied GPS. Enable it in your browser settings.",
    privacy_public_b: "Public profile.",
    privacy_public_desc: "Your name, reputation and reports are visible in the leaderboard and profile page. You can disable visibility here.",
    privacy_footnote: "Report photos are always public. Sensitive data (plates, faces) is hidden until moderator approval.",
    logout_label: "Logout",
    delete_account: "Delete account",
    delete_account_title: "Delete account permanently?",
    delete_account_desc: "Your profile will be deleted. Your reports remain visible anonymously to preserve historical integrity. This action is irreversible.",
    delete: "Delete",
    account_deleted: "Account deleted",

    // Profile
    loading: "Loading…",
    reputation_short: "reputation",

    // ReportCreate
    new_report_title: "Turn a photo into action.",
    new_report_desc: "Fill in the fields carefully. AI can help you categorize correctly.",
    add: "Add",
    latitude: "Latitude",
    longitude: "Longitude",
    detect: "Detect",
    position_on_map: "Position on map · tap to select",
    geo_denied_msg: "GPS permission denied. You can still select the location by tapping on the map or entering it manually.",
    tiles_not_loaded: "Tiles not loaded.",
    risk_green_label: "Green · low risk",
    risk_green_short_desc: "Small litter, non-hazardous items",
    risk_yellow_label: "Yellow · medium risk",
    risk_yellow_short_desc: "Many bags, glass, heavy materials",
    risk_red_label: "Red · high risk",
    risk_red_short_desc: "Hazardous substances, animals, sensitive content",
    ai_analyze_desc: "Analyze photo and description to suggest category, subcategory and risk level.",
    ai_analyze_action: "Analyze",
    ai_unavailable: "AI not available",
    ai_completed: "AI analysis completed",
    sensitive_content_b: "Sensitive content.",
    sensitive_content_desc: "The content includes faces, plates, minors, evidence or accusations. It will be reviewed by moderators before publication.",
    describe_placeholder: "What did you see? Size, context, materials…",
    photo_uploaded: "Photo uploaded",
    photo_upload_failed: "Upload failed",
    add_photo_or_desc: "Add at least a photo or description",
    gps_missing: "GPS position missing",
    select_subcategory: "Select subcategory",
    description_too_short: "Description too short",
    photo_required: "At least one photo is required",
    report_submitted: "Report submitted!",
    gps_updated: "GPS updated",
    gps_unavailable: "Geolocation not supported",
    gps_pick_manual: "Unable to get location — tap the map below to select it manually.",
    position_set: "Position set",

    // ReportDetail
    navigate: "Navigate",
    donate_short: "Donate",
    report_sent_b: "Report submitted!",
    report_sent_desc: "Thank you for your contribution. The community can confirm and coordinate below.",
    back_to_map: "Back to the map",
    risk_prefix: "risk",
    confirmations_label: "confirmations",
    still_exists: "Still exists",
    worsened: "Worsened",
    resolved_short: "Resolved",
    not_present: "Not present",
    reusable_not_available: "Likely no longer available",
    timeline: "Timeline",
    no_messages: "No messages. Start the conversation.",
    login_to_join: "Sign in to join",
    of_author: "by",
    fullscreen: "Fullscreen",
    edit_message: "Edit",
    message_edited: "edited",
    saved_confirmation: "Confirmation recorded",
    thanks: "Thanks!",
    donate_report_title: "Support this report",
    donate_report_desc_p1: "Funds will be used",
    donate_report_desc_b1: "primarily to solve this specific report",
    donate_report_desc_p2: ". If not possible, they'll be redirected to similar interventions",
    donate_report_desc_b2: "in the same municipality or territory",
    donate_report_desc_p3: ". You can donate",
    donate_report_desc_b3: "even without registering",
    donate_free_offer: "Free amount (min €0.50)",
    donate_report_placeholder: "A message for the community (optional)",
    not_authenticated: "Not authenticated",

    // AdminDashboard
    admin_dashboard_kicker: "Admin dashboard",
    admin_overview: "Moderation overview",
    admin_users: "Users",
    admin_reports: "Reports",
    admin_pending: "Pending",
    admin_red: "Red",
    admin_resolved: "Resolved",
    admin_donations: "Donations",
    tab_moderation: "Moderation",
    tab_all_reports: "All reports",
    tab_users: "Users",
    tab_donations: "Donations & Sponsors",
    tab_logs: "Logs",
    no_pending: "No pending reports.",
    no_reports: "No reports.",
    all_statuses: "All statuses",
    only_red_risk: "Red risk only",
    search_by_name_email: "Search by name or email…",
    admin_rep_short: "rep",
    admin_suspended: "suspended",
    admin_banned: "banned",
    admin_reactivate: "Reactivate",
    admin_suspend: "Suspend",
    admin_remove_ban: "Remove ban",
    admin_ban: "Ban",
    approve: "Approve",
    reject: "Reject",
    archive: "Archive",
    reopen: "Reopen",
    hide_evidence: "Hide",
    show_evidence: "Show evidence",
    sensitive_badge: "sensitive",
    proposed_label: "proposed:",
    author_line_by: "by",
    make_public: "Make public",
    mark_sensitive: "Mark sensitive",
    st_pub_visible: "Visible",
    st_hidden: "Hidden",
    st_archived: "Archived",
    st_rejected: "Rejected",
    change_state_title: "Change report status",
    current_status: "Current status:",
    reason_optional: "Reason (optional)",
    state_change_note: "Hiding, suspending or archiving",
    state_change_note_b: "does not delete",
    state_change_note_2: "the report. Photos, coordinates, author and history remain intact.",
    state_arrow: "Status →",
    color_short: "Color",
    admin_actions_title: "Admin actions",
    delete_report_confirm_title: "Delete this report?",
    delete_report_confirm_body: "The report will be permanently removed. This action cannot be undone.",
    change_color_title: "Change color (risk level)",
    current_color: "Current color:",
    color_reason_placeholder: "Why are you changing the color?",
    state_reason_placeholder: "Why are you changing the status?",
    color_change_note: "Changing color",
    color_change_note_b: "does not",
    color_change_note_2: "publish, hide, archive or delete the report — it only changes the risk level visible on the map and in filters. History logged.",
    apply: "Apply",
    delete_report_title: "Delete the report?",
    delete_report_desc: "This permanently removes the report, associated photos and chat. It cannot be undone.",
    load_error: "Load error",
    approved: "Approved",
    updated: "Updated",
    report_updated: "Report updated",
    role_updated: "Role updated",
    user_updated: "User updated",
    report_deleted: "Report deleted",
    report_reopened: "Report reopened",
    // Bulk selection (Lotto 3 #7/#8)
    bulk_select_all: "Select all",
    bulk_selected_of: "{n} of {total} selected",
    bulk_select_row: "Select this row",
    bulk_clear_selection: "Clear",
    bulk_delete_confirm_title: "Delete the selected items?",
    bulk_delete_confirm_body: "You are about to permanently delete {n} items. This action cannot be undone.",
    bulk_deleted_ok: "{n} items deleted",
    bulk_updated_ok: "{n} items updated",
    bulk_notif_mark_read: "Mark as read",
    bulk_notif_archive: "Archive",
    no_donations: "No donations recorded.",
    mod_logs: "Moderation logs",
    no_logs: "No logs available.",

    // Leaderboard
    leaderboard_h: "Who is leaving a mark.",
    leaderboard_empty: "No active members yet.",

    // PaymentResult
    thanks_donation: "Thank you from the bottom of our hearts!",
    donation_recorded: "Your donation of €{amount} has been recorded.",
    confirming: "Confirming…",
    waiting_stripe: "Waiting for Stripe confirmation.",
    payment_cancelled: "Payment cancelled",
    no_charge: "No charge has been made.",
    back_to_map_btn: "Back to the map",

    // Profile stats labels
    stat_reports_created: "Reports created",
    stat_confirmations_made: "Confirmations",
    stat_reputation: "Reputation",
    back: "Back",
    // Sub-categories (English)
    sub_small_pile: "Small pile",
    sub_bags: "Bags of waste",
    sub_plastic: "Plastic",
    sub_glass: "Glass",
    sub_paper: "Paper",
    sub_organic: "Organic",
    sub_tires: "Tires",
    sub_appliances: "Appliances",
    sub_furniture: "Furniture",
    sub_construction: "Construction debris",
    sub_industrial: "Industrial waste",
    sub_hazardous: "Hazardous waste",
    sub_asbestos: "Asbestos",
    sub_chemicals: "Chemicals",
    sub_oil: "Oils",
    sub_batteries: "Batteries",
    sub_illegal_dump: "Illegal dump",
    sub_marine: "Marine waste",
    sub_river: "River waste",
    sub_forest: "Forest waste",
    sub_sewage_spill: "Sewage spill",
    sub_medical_waste: "Medical waste",
    sub_explosive_flammable: "Explosive / flammable",
    sub_water_pollution: "Water pollution",
    sub_soil_pollution: "Soil pollution",
    sub_suspicious_discharge: "Suspicious discharge",
    sub_smoke_emissions: "Smoke emissions",
    sub_fire: "Fire",
    sub_fire_damage: "Fire damage",
    sub_damaged_trees: "Damaged trees",
    sub_degraded_green: "Degraded green area",
    sub_water_leak: "Water leak",
    sub_erosion: "Erosion",
    sub_contamination: "Contamination",
    sub_beach_coast_degradation: "Beach / coast degradation",
    sub_injured: "Injured animal",
    sub_abandoned: "Abandoned animal",
    sub_trapped: "Trapped animal",
    sub_in_danger: "Animal in danger",
    sub_suspected_mistreatment: "Suspected mistreatment",
    sub_poor_conditions: "Poor conditions",
    sub_wildlife_distress: "Wildlife distress",
    sub_broken_light: "Broken street light",
    sub_broken_bench: "Broken bench",
    sub_damaged_playground: "Damaged playground",
    sub_pothole: "Pothole",
    sub_architectural_barrier: "Architectural barrier",
    sub_dangerous_sidewalk: "Dangerous sidewalk",
    sub_broken_signage: "Broken signage",
    sub_abandoned_public: "Abandoned public building",
    sub_vandalism: "Vandalism",
    sub_other: "Other",
    sub_tall_grass: "Tall grass",
    sub_brambles: "Brambles",
    sub_dangerous_branches: "Dangerous branches",
    sub_obstructing_visibility: "Obstructing visibility",
    sub_fallen_tree: "Fallen tree",
    sub_invasive_plants: "Invasive plants",
    sub_road_encroachment: "Road encroachment",
    sub_bed: "Bed",
    sub_mattress: "Mattress",
    sub_table: "Table",
    sub_chair: "Chair",
    sub_wardrobe: "Wardrobe",
    sub_sofa: "Sofa",
    sub_home_decor: "Home decor",
    sub_appliance: "Appliance",
    sub_electronics: "Electronics",
    sub_computer: "Computer",
    sub_bicycle: "Bicycle",
    sub_tools: "Tools",
    sub_clothing: "Clothing",
    sub_toys: "Toys",
    sub_construction_materials: "Construction materials",
    sub_books: "Books",
    take_photo: "Take photo",
    from_gallery: "Choose from gallery",
    camera_permission_denied: "Camera permission denied. You can still choose a photo from the gallery.",
    suggested_color: "Suggested color",
    severity: "Severity",
    urgency: "Urgency",
    confidence: "Confidence",
    trust: "Trust",
    coherence: "Photo↔text",
    ai_action: "Suggested action",
    add_photo: "Add a photo",
    add_photo_desc: "Document worsening, changes, work progress or resolution.",
    add_photo_note: "Optional note",
    add_photo_note_placeholder: "e.g. got worse after rain, or almost resolved…",
    add_photo_confirm: "Add",
    add_photo_success: "Photo added",
    add_photo_pending: "Photo sent to admin review (content or coherence to verify)",
    add_photo_failed: "Add failed",
    additional_photos: "Additional photos",
    pending_review: "In review",
    // Urgent temporary alerts
    urgent_alert: "Urgent temporary alert",
    urgent_new: "New urgent alert",
    urgent_desc: "Report a temporary problem (suspicious baits, road obstacles, fallen branches, flooding, smoke, hazardous substance…).",
    urgent_duration: "Duration",
    urgent_1h: "1 hour", urgent_3h: "3 hours", urgent_6h: "6 hours", urgent_12h: "12 hours", urgent_24h: "24 hours",
    urgent_radius: "Radius (m)",
    urgent_other: "Other urgent alert",
    urgent_free_desc: "Describe freely what the problem is and why it is urgent and temporary",
    urgent_submit: "Publish alert",
    urgent_created: "Alert published",
    urgent_state_active: "Active",
    urgent_state_expired: "Expired — to verify",
    urgent_state_resolved: "Resolved",
    urgent_state_archived: "Archived",
    urgent_state_pending: "In review",
    urgent_still_present: "I confirm it is still there",
    urgent_not_present: "No longer present",
    urgent_time_remaining: "Time remaining",
    urgent_extend: "Extend",
    urgent_expired: "Expired",
    fab_urgent: "Urgent alert",
    urgent_alerts_list: "Active urgent alerts",
    no_urgent_alerts: "No active urgent alerts.",
    ai_panel_title: "AI moderation (GPT-5.2)",
    ai_problem: "Recognized problem",
    ai_reason: "Reason",
    urg_low: "Low", urg_medium: "Medium", urg_high: "High",
    ai_act_publish_auto: "Auto-publish",
    ai_act_review_admin: "Admin review",
    ai_act_reject: "Reject",
    legal_badge: "legal",
    filter_urgent_alerts: "Extraordinary events",
    filter_extraordinary_events: "Extraordinary events",
    extraordinary_event: "Extraordinary event",
    extraordinary_events: "Extraordinary events",
    fab_event: "New extraordinary event",
    event_kind_wildfire: "Wildfire",
    event_kind_flood: "Flood",
    event_kind_river_overflow: "River overflow",
    event_kind_landslide: "Landslide",
    event_kind_storm: "Exceptional storm",
    event_kind_hailstorm: "Exceptional hailstorm",
    event_kind_tornado: "Tornado",
    event_kind_heavy_snow: "Heavy snow",
    event_kind_avalanche: "Avalanche",
    event_kind_sea_storm: "Sea storm",
    event_kind_heatwave: "Heatwave",
    event_kind_coldwave: "Cold wave",
    urgent_pending_approval: "Pending approval",
    urgent_approved: "Alert approved",
    urgent_rejected: "Alert rejected",
    approve_urgent: "Approve alert",
    reject_urgent: "Reject alert",
    urgent_map_pick: "Move the map and tap to pick the point",
    urgent_center_me: "Center on my location",
    urgent_short_explanation: "Use this to report an urgent yet temporary problem. Set the issue, the position, the affected radius and choose how long the alert should last. After Admin approval, the alert becomes visible with a countdown until expiry.",
    notifications: "Notifications",
    notif_empty: "No notifications.",
    notif_gone: "Notification no longer available",
    notif_mark_read: "Mark as read",
    notif_mark_unread: "Mark as unread",
    notif_archive: "Archive",
    notif_delete: "Delete",
    notif_open: "Open",
    notif_all_read: "Mark all as read",
    notif_view_all: "View all notifications",
    notif_tab_all: "All", notif_tab_unread: "Unread", notif_tab_archived: "Archived",
    extensions_pending: "Extensions pending",
    no_extensions_pending: "No extension requests to review.",
    photos_pending: "Photos in review",
    admin_home_title: "Moderation overview",
    admin_home_desc: "Select a section to get started.",
    admin_card_red: "Red",
    admin_card_yellow: "Yellow",
    admin_card_green: "Green",
    admin_card_photos_review: "Admin moderation",
    admin_card_urgent: "Extraordinary events",
    admin_section_others: "Others",
    admin_others_desc: "Users · Feedback · Donations · Chat · Logs · Archive · Settings",
    admin_tab_users: "Users",
    admin_tab_feedback: "Feedback",
    admin_tab_donations: "Donations",
    admin_tab_logs: "Logs",
    admin_tab_archive: "Archive",
    admin_tab_settings: "Settings",
    admin_filter_status: "Filter by status",
    admin_st_in_progress: "In progress",
    admin_st_pending_approval: "Pending approval",
    admin_st_approved: "Approved",
    admin_st_archived: "Archived",
    admin_st_all: "All",
    admin_urgent_state_pending: "Pending approval",
    admin_urgent_state_active: "Active",
    admin_urgent_state_expired: "Expired — verify",
    admin_urgent_ext_pending: "Extensions pending",
    admin_urgent_state_archived: "Archived",
    admin_urgent_state_rejected: "Rejected",
    admin_urgent_state_all: "All",
    filters: "Filters",
    advanced_filters: "Advanced filters",
    filter_search_placeholder: "Search by title, description, author, place or ID",
    filter_ai_conf: "AI confidence",
    filter_sensitive: "Sensitive content",
    filter_legal: "Possible legal issues",
    photos_review_title: "Admin moderation",
    photos_review_empty: "No photos to review.",
    photos_review_source: "Source",
    photos_review_reason: "Reason",
    photos_review_priority: "Priority",
    src_new_report: "New report",
    src_added_photo: "Added photo",
    src_urgent: "Urgent alert",
    src_extension: "Extension request",
    reason_photo_incoherent: "Photo incoherent",
    reason_photo_text_incoherent: "Photo doesn't match description",
    reason_category_mismatch: "Wrong category",
    reason_subcategory_mismatch: "Wrong subcategory",
    reason_severity_higher: "Higher severity",
    reason_color_mismatch: "Color mismatch",
    reason_sensitive_content: "Sensitive content",
    reason_legal_issues: "Possible legal issue",
    reason_spam_or_irrelevant: "Spam or irrelevant",
    reason_low_ai_confidence: "Low AI confidence",
    reason_ai_suggests_review: "AI suggests review",
    reason_face_blur_failed: "Face blur failed",
    reason_face_blur_uncertain: "Face blur uncertain",
    reason_red_requires_approval: "Red: approval required",
    reason_sensitive_animal_category: "Sensitive animal subcategory",
    reason_possibly_criminal_content: "Possible crime scene",
    publish_as_green: "Publish as Green",
    publish_as_yellow: "Publish as Yellow",
    publish_as_red: "Publish as Red",
    photo_approved_as_color: "Photo approved and published as {color}",
    original_unavailable: "Original no longer available",
    original_unavailable_hint: "Original no longer available — you can still apply additional blurring on the current version.",
    admin_card_events: "Extraordinary events",
    total: "total",
    admin_card_marketplace: "Marketplace",
    mk_type_sale: "For sale",
    mk_type_gift: "Gift",
    mk_type_reusable: "Reusable found",
    mk_st_published: "Active",
    mk_st_archived: "Archived",
    mk_st_closed: "Concluded",
    mk_st_pending: "Pending confirmation",
    mk_search_placeholder: "Search title, author, province…",
    mk_empty: "No listings in this view",
    mk_admin_details: "Admin details",
    mk_found_checks_title: "User confirmations",
    mk_found_present: "Item present",
    mk_found_not_present: "Item not present",
    mk_found_present_short: "Present",
    mk_found_not_present_short: "Not present",
    mk_found_no_checks: "No confirmations yet.",
    mk_found_check_saved: "Thanks! Your confirmation has been saved.",
    mk_found_intro: "Have you been on-site? Help the community: report whether the item is still there.",
    mk_found_note_optional: "Note (optional)",
    delete_listing_title: "Delete listing",
    delete_listing_desc: "The listing will be permanently deleted. This action cannot be undone.",
    reactivate: "Reactivate",
    reactivated: "Reactivated",
    close: "Close",
    chat_translate: "Translate",
    chat_show_original: "Show original",
    chat_translated_badge: "auto-translation",
    chat_translating: "Translating…",
    chat_translate_error: "Translation failed",
    report_user: "Report user",
    report_user_title: "Report this user",
    report_user_reason: "Reason",
    ur_reason_spam: "Spam",
    ur_reason_offensive: "Offensive language",
    ur_reason_harassment: "Harassment or threats",
    ur_reason_misleading: "False or misleading content",
    ur_reason_bad_chat: "Inappropriate chat behavior",
    ur_reason_misuse: "App misuse",
    ur_reason_false_reports: "Repeatedly false reports",
    ur_reason_other: "Other reason",
    report_user_explanation: "Short explanation (optional)",
    report_user_send: "Send report",
    report_user_sent: "Report sent privately",
    report_user_privacy: "This report is private and will not be shown to the reported user.",
    admin_tab_user_reports: "User reports",
    ur_status_new: "New",
    ur_status_in_review: "In review",
    ur_status_resolved: "Resolved",
    ur_status_archived: "Archived",
    ur_status_rejected: "Rejected",
    ur_status_all: "All",
    ur_reports_count: "Prior",
    ur_action_warn: "Warning",
    ur_action_limit_chat: "Limit chat",
    ur_action_limit_publish: "Limit publishing",
    ur_action_suspend: "Temporarily suspend",
    ur_action_ban: "Ban account",
    ur_action_close: "Close without action",
    ur_action_hours: "Duration (hours)",
    ur_open_context: "Open context",
    ur_no_items: "No user reports.",
    confirm_choose_status: "Choose status",
    confirm_resolved: "Resolved",
    confirm_in_progress: "In progress",
    confirm_worse: "Worse",
    confirm_undo: "Undo confirmation",
    confirm_change_title: "Change confirmation",
    confirm_change_desc: "Change your confirmation from \"{from}\" to \"{to}\"?",
    confirm_change_ok: "Yes, change",
    confirm_your_current: "Your current confirmation",
    manual_blur: "Manual blur",
    manual_blur_title: "Blur editor",
    manual_blur_desc: "Draw rectangles over sensitive areas. Photos become public only after saving.",
    manual_blur_mode_blur: "Blur",
    manual_blur_mode_pixel: "Pixelate",
    manual_blur_undo: "Undo",
    manual_blur_redo: "Redo",
    manual_blur_clear: "Clear all",
    manual_blur_save: "Save blurred version",
    manual_blur_saved: "Blurred version saved",
    manual_blur_no_regions: "Add at least one region before saving.",
    manual_blur_hint: "Click & drag to draw. Drag edges to resize. Double-click a region to delete.",
    download_original: "Download original",
    upload_replacement: "Upload blurred version",
    replacement_uploaded: "Photo replaced",
    admin_only_action: "Admins only",
    sub_gift: "Object to give away",
    nav_reforestation: "Reforestation",
    share: "Share",
    deleted_user_label: "Deleted user",
    copy_link: "Copy link",
    copy_link_ok: "Link copied",
    copy_link_err: "Copy failed",
    filter_area: "Province / administrative area",
    notif_type_chat_message: "New chat message",
    notif_type_report_update: "Report update",
    notif_type_photo_approved: "Photo approved",
    notif_type_photo_rejected: "Photo rejected",
    notif_type_photo_review: "Photo in review",
    notif_type_urgent_approved: "Alert approved",
    notif_type_urgent_rejected: "Alert rejected",
    notif_type_urgent_expiring: "Alert expiring",
    notif_type_report_status: "Report status changed",
    notif_type_content_report_resolved: "Content report handled",
    notif_type_content_report_dismissed: "Content report reviewed",
    notif_type_new_feedback: "New feedback",
    notif_type_new_urgent: "New urgent alert to approve",
    notif_type_new_red: "New red report",
    notif_type_photo_pending: "Photo to review",
    notif_type_face_uncertain: "Faces to verify",
    notif_type_manual_mod: "Manual moderation required",
    notif_type_sensitive: "Sensitive content",
    notif_type_legal: "Possible legal issues",
    notif_type_severe: "Very severe report",
    tour_start: "Quick tour",
    tour_next: "Next",
    tour_prev: "Back",
    tour_skip: "Skip",
    tour_close: "Close tour",
    tour_dont_show: "Don't show again",
    tour_restart: "Restart tour",
    tour_step1_title: "Welcome to ToClean",
    tour_step1_desc: "We'll show you around in a few seconds. You can skip anytime.",
    tour_step2_title: "Create a report",
    tour_step2_desc: "Use the green button to report an environmental, urban or animal-welfare problem.",
    tour_step3_title: "Open a report",
    tour_step3_desc: "Tap any marker on the map to open the report details.",
    tour_step4_title: "Follow and join",
    tour_step4_desc: "In the report chat you can write messages, coordinate actions and receive updates.",
    tour_step5_title: "Marketplace",
    tour_step5_desc: "Sell, give away, or list reusable items you've found. Tap the Publish button and choose the type.",
    tour_step6_title: "Extraordinary events",
    tour_step6_desc: "Report large-scale emergencies such as fires, floods, or storms by drawing the area on the map. Publications follow the permissions and moderation defined by the user's role.",
    tour_step7_title: "Confirm or deny",
    tour_step7_desc: "If you're on the spot, confirm that the problem is still there or mark it as no longer present.",

    // HomeSwipe
    swipe_values_kicker: "Together we make a real change",
    swipe_values_title: "A small gesture, a real impact on the territory.",
    swipe_value_1_title: "Report an issue",
    swipe_value_1_desc: "Take a photo, add the location, publish: your report is geolocated and visible to everyone.",
    swipe_value_2_title: "Follow what happens in your area",
    swipe_value_2_desc: "Real-time map, urgent alerts and leaderboards of the most active areas.",
    swipe_value_3_title: "Contribute to the solution",
    swipe_value_3_desc: "Verify, confirm a fix, or donate to a real reforestation project.",
    swipe_cta_enter: "Enter ToClean",
    swipe_cta_hint: "You can explore the map without signing up.",

    // Compact status filter
    map_status_all: "All statuses",
    map_status_selected: "{n} statuses selected",
    map_legend_hint_in_filter: "Legend opens from the bottom-left button on the map.",
    apply: "Apply",
    cat_reusable_found: "Reusable items found",
    cat_gift: "Gift items",
    cat_sale: "Items for sale",

    // Public gating
    guest_gate_action: "To continue you need to sign in or sign up.",
    guest_gate_category_hidden: "To see this section you need to sign in or sign up.",
    guest_gate_marketplace: "To see this section you need to sign in or sign up.",
    guest_gate_title: "Sign in required",
    guest_gate_login: "Sign in",
    guest_gate_signup: "Sign up",

    // Guided color wizard
    cw_intro: "Answer a few questions: we'll suggest the right color.",
    cw_step_label: "Step {n}",
    cw_examples: "Examples",
    cw_yes: "Yes",
    cw_no: "No",
    cw_unsure: "Not sure",
    cw_restart: "Restart",
    cw_q1: "Is the situation, right now, putting the life or safety of people or animals in danger?",
    cw_q1_examples: "Active fire, trapped animal, landslide or flood with people involved.",
    cw_q1_reason: "Immediate danger to people or animals.",
    cw_q2: "Do you see a leak, dispersion or emission of hazardous substances into water, soil or air?",
    cw_q2_examples: "Fuels, oils, chemicals, toxic fumes, damaged asbestos, leaking drums, sudden fish or bird die-off, severe ecosystem damage even of unknown cause.",
    cw_q2_reason: "Serious, active or hard-to-repair environmental contamination.",
    cw_q3: "Is the problem large, likely to worsen, or does it require specialized intervention?",
    cw_q3_examples: "Large dump, unstable tree, e-waste, syringes, visibly polluted watercourse.",
    cw_q3_reason: "Serious, extended issue or requiring specialized staff.",
    cw_q4: "Is the problem localized, without evident risks and solvable with routine cleaning or maintenance?",
    cw_q4_examples: "Small litter, full bin, minor decay, abandoned non-dangerous item.",
    cw_q4_reason: "Ordinary, localized issue with no evident risks.",
    cw_unsure_reason: "When in doubt we apply a provisional yellow: it will be re-evaluated.",
    cw_result_red: "Red — Highest priority",
    cw_result_yellow: "Yellow — Medium priority",
    cw_result_green: "Green — Ordinary priority",
    cw_red_admin_note: "Red reports are always reviewed by an Admin before publication.",
    cw_required: "Complete the guide to determine the report color.",
  
    save_changes: "Save changes",
    all_categories: "All categories",
    all_types: "All types",
    reject_reason_title: "Rejection reason",
    only_photo: "Photo only",
    entire_report: "Entire report",
    location_placeholder: "City, province or municipality…",
    sort_by: "Sort by",
    sort_recent: "Most recent",
    sort_oldest: "Oldest",
    sort_price_asc: "Price ascending",
    sort_price_desc: "Price descending",
    condition_like_new: "Like new",
    condition_fair: "Fair",
    gift_delivered: "Delivered",
    gift_unavailable: "No longer available",
    gift_reopen: "Reopen as available",
    manage_subscriptions: "Manage subscriptions",
    one_time: "One time",
    reject_photo_placeholder: "E.g. Recognizable face not properly masked",
    admin_log_note: "Admin log note",
    repeat_password: "Repeat password",
    back_to_login: "Back to login",
    report_not_available: "Report not available",
    moderation_admin: "Admin moderation",
    no_auto_dispatch: "No auto dispatch",
    certified_delivery: "Certified delivery",
    cancel_dispatch: "Cancel preparation",
    personal_section: "Personal section",
    stop_following: "Stop following",
    classifications_title: "Rankings",
    concluded_events: "Concluded events",
    past_extraordinary_events_label: "Past extraordinary events",
    previous_label: "Previous",
    next_label: "Next",
    assistant_label: "Assistant",
    reforestation_new_title: "New reforestation project",
    reforestation_update_title: "Update project",
    no_chat_for_listing: "No chat for this listing",
    reports_list_label: "Reports list",
    reset_province_filter: "Reset province filter",
    remove_prox_filter: "Remove proximity filter",
    publish_new_tooltip: "Publish a new report or listing",
    seller_actions_label: "Seller actions",
    selected_as_buyer_label: "You've been selected as buyer",
    sort_by_field: "Sort by",
    search_placeholder_marketplace: "Title, description, category, province…",
    search_placeholder_map: "Title, description, province…",
    clear_search: "Clear search",
    tab_territories: "Territories",
    tab_generous: "Most generous provinces",
    most_generous_province_badge: "Most generous province",
    assistant_open_tips: "Assistant: open tips",
    page_tips_title: "Page tips",
    delete_label: "Delete",
    back_label: "Back",
    show_hide: "Show/hide",
  
    announcement_status: "Announcement status",
    in_agreement: "Agreed",
    closed_listing_note: "This announcement is closed. Chat history remains visible but new request messages aren't allowed.",
    reject_reason_help: "Reason is required. Note is optional and won't be shown to the author.",
    scope_label: "Scope",
    motivation_required: "Reason *",
    internal_note_optional: "Note (internal, optional)",
    reject_action: "Reject",
    confirm_reject: "Confirm rejection",
    chi_siamo: "About us",
    la_nostra_missione: "Our mission",
    search_marketplace_placeholder: "Title, description, category, province…",
    search_map_placeholder: "Title, description, province…",
    type_specific_label: "Specific type",
    reset_password: "Reset password",
    declare_event_ended_title: "Declare event ended",
    new_reforestation_project: "New reforestation project",
    update_reforestation_project: "Update project",
    no_chat_yet: "No chats for this announcement yet",
    extraordinary_events_history: "Extraordinary events history",
    province_label: "Province",
  
    category_first: "Category first",
    subcategory_first: "Subcategory first",
    no_active_subscriptions: "You don't have any active subscriptions yet.",
    monthly: "Monthly",
    near_me: "Near me",
    near_me_activate: "Near me (turn on location)",
    lb_subtitle: "Positive comparison — we focus on results and participation, not problems.",
    period_week: "Week",
    period_month: "Month",
    period_year: "Year",
    period_all: "Overall",
    assistant_status_on: "Assistant: On",
    assistant_status_off: "Assistant: Off",
    on: "On",
    off: "Off",
    reforestation_new_project_title: "New reforestation project",
    reforestation_update_project_title: "Update project",
    declare_event_ended_title_v2: "Mark event as ended",
    reject_motivation_title: "Reason for rejection",
    past_events_kicker: "Past special events",
    events_ended: "Ended events",
    search_by_word: "Search by word",
    category_marketplace: "Category · Marketplace",
    min_currency: "Min €",
    max_currency: "Max €",
    condition_all: "All",
    condition_new: "New",
    condition_good_v2: "Good",
    condition_used: "Used",
    condition_negotiable: "Negotiable",
    condition_label: "Condition",
    score_label: "Score",
    no_data_period: "No data for the selected period.",
    no_donations_period: "No donations recorded in the selected period.",
    sale_price_only: "Price (Selling only)",
    price_min_gt_max: "Min is higher than max: we'll apply the correct range anyway.",
    publish_new_report_tooltip: "Publish a new report or listing",
    show_hide_label: "Show/hide",
    activate_position_note: "turn on location",
  
    nav_marketplace: "Marketplace",
  
    backend_unauthorized: "Unauthorized",
    backend_user_not_found: "User not found",
    backend_invalid_credentials: "Invalid credentials",
    backend_email_already_registered: "Email already registered",
    backend_report_not_found: "Report not found",
    backend_listing_not_found: "Listing not found",
    backend_event_not_found: "Event not found",
    backend_project_not_found: "Project not found",
    backend_invalid_session: "Invalid session",
    backend_token_expired: "Token expired",
    backend_bad_request: "Invalid request",
    backend_server_error: "Internal server error",
    backend_operation_completed: "Operation completed",
    backend_saved: "Saved",
    backend_updated: "Updated",
    backend_deleted: "Deleted",
    backend_published: "Published",
    backend_config_incomplete: "Setup incomplete",
    backend_forbidden: "Insufficient permissions",
    backend_file_too_large: "File too large",
    backend_file_bad_format: "File format not supported",
    backend_photo_required: "Photo required",
    backend_location_required: "Location required",
    backend_category_required: "Category required",
    backend_title_required: "Title required",
    backend_description_required: "Description required",
    backend_amount_invalid: "Invalid amount",
    backend_password_too_short: "Password too short",
    backend_passwords_mismatch: "Passwords don't match",
    backend_email_invalid: "Invalid email",
    backend_too_many_attempts: "Too many attempts. Try again later.",
    admin_verified_entities: "Verified entities",
    admin_verified_entities_super: "Verified entities (Super Admin)",
    admin_management: "Admin management",
    admin_management_super: "Admin management (Super Admin)",
    admin_reset_super_password: "Reset Super Admin password",
    admin_content_pages: "Content pages (Mission / About us)",
    admin_pec_config: "PEC configuration",
    admin_reforestation_manage: "Reforestation — manage projects",
    admin_reject_dialog_title: "Rejection reason",
    admin_reject_reason_help: "The reason is required. The note is optional and won't be shown to the author.",
    admin_scope_label: "Scope",
    admin_reason_required: "Reason *",
    admin_internal_note: "Note (internal, optional)",
    admin_moderation_label: "Admin moderation",
    admin_pec_required_msg: "PEC configuration needed. You can prepare and preview, but sending will be blocked until the Super Admin completes the setup.",
    admin_pec_locked_msg: "PEC configuration needed. Until you fill in all fields, PEC sending remains blocked.",
    admin_no_auto_dispatch: "No automatic sending",
    admin_certified_delivery: "Certified delivery",
    admin_save_changes: "Save changes",
    admin_cancel_dispatch: "Cancel preparation",
    admin_declare_event_ended: "Declare event ended",
    admin_reforestation_new: "New reforestation project",
    admin_reforestation_update: "Update project",
    admin_content_edit_desc: "Edit the text of \"Our mission\" and \"About us\" without touching the code. If a page isn't published, users see default content or a simple placeholder.",
    admin_password_reset_title: "Reset password",
    admin_new_password: "New password",
    admin_repeat_password: "Repeat password",
    admin_back_to_login: "Back to login",
    admin_stop_following: "Stop following",
    admin_seller_actions: "Seller actions",
    admin_buyer_selected: "You've been selected as buyer",
    admin_no_chat_yet: "No chat for this listing yet",
    admin_publish_new_report: "Publish a new report or listing",
    admin_reset_province_filter: "Reset province filter",
    admin_reports_list: "Reports list",
    admin_country_province_place: "Country, province or town…",
    admin_content_placeholder_desc: "One name/role per line (e.g. Mario Rossi — Founder)",
    admin_content_placeholder_contact: "Email, PEC, address, socials…",
  
    create: "Create",
    confirm_conclusion: "Confirm conclusion",
    optional_note_followers: "Optional note (shown to followers)",
    admin_reset_super_password_confirm: "Generate a password-reset link for your Super Admin account? The link is single-use and expires in 15 minutes. You will be taken to the new-password screen right away.",
  
    be_ai_not_configured: "AI not configured",
    be_account_sospeso_o_bannato: "Account suspended or banned",
    be_admin_only: "Admin only",
    be_admin_role_required: "Admin role required",
    be_alert_not_found: "Alert not found",
    be_almeno_un_tra_ritiro_e_spedizione_deve_essere_selezionato: "Pick at least pickup or shipping",
    be_amount_out_of_range_min_0_50_max_100000: "Amount out of range (min €0.50, max €100,000)",
    be_cannot_report_yourself: "Can't report yourself",
    be_duplicate_report_please_wait_before_re_reporting_the_same_co: "Duplicate report — wait before reporting this again",
    be_duration_must_be_1_3_6_12_or_24_hours: "Duration must be 1, 3, 6, 12, or 24 hours",
    be_email_already_registered: "Email already registered",
    be_email_gi_in_uso: "Email already in use",
    be_evento_non_attivo: "Event not active",
    be_extension_not_found: "Extension not found",
    be_failed_to_upload_blurred_version: "Failed to upload blurred version",
    be_file_too_large_max_8mb: "File too large (max 8MB)",
    be_forbidden: "Forbidden",
    be_il_nome_della_ricerca_obbligatorio: "Search name is required",
    be_il_prezzo_obbligatorio_per_vendo: "Price is required for selling",
    be_invalid_action: "Invalid action",
    be_invalid_category: "Invalid category",
    be_invalid_credentials: "Invalid credentials",
    be_invalid_image: "Invalid image",
    be_invalid_reason: "Invalid reason",
    be_invalid_risk_level: "Invalid risk level",
    be_invalid_role: "Invalid role",
    be_invalid_session: "Invalid session",
    be_invalid_status: "Invalid status",
    be_la_nuova_password_deve_avere_almeno_6_caratteri: "New password must be at least 6 characters",
    be_la_nuova_password_deve_avere_almeno_8_caratteri: "New password must be at least 8 characters",
    be_la_password_deve_avere_almeno_6_caratteri: "Password must be at least 6 characters",
    be_la_segnalazione_deve_essere_approvata_pubblicata_prima: "Report must be approved/published first",
    be_le_chat_non_sono_previste_per_gli_oggetti_riutilizzabili_tro: "Chat not available for found reusable items",
    be_login_required_for_this_category: "Login required for this category",
    be_message_cannot_be_empty: "Message can't be empty",
    be_message_not_found: "Message not found",
    be_messaggio_troppo_breve: "Message too short",
    be_motivazione_obbligatoria: "Reason required",
    be_moderation_note_required: "Motivation required (min 10 characters).",
    ur_note_required_prompt: "Motivation for this action (required, min 10 chars):",
    ur_note_required_toast: "Motivation required (min 10 characters).",
    be_nessun_abbonamento_trovato_per_questo_utente: "No subscription found for this user",
    be_nessuna_richiesta_di_conferma_attiva: "No active confirmation request",
    be_non_annullabile_dispatch_gi_inviato: "Can't cancel: already dispatched",
    be_non_modificabile_dispatch_gi_inviato: "Can't edit: already dispatched",
    be_non_puoi_rimuovere_il_tuo_ruolo_admin: "You can't remove your own admin role",
    be_non_puoi_seguire_un_annuncio_di_cui_sei_il_proprietario: "You can't follow your own listing",
    be_not_a_reusable_item_report: "Not a reusable item report",
    be_not_authenticated: "Not authenticated",
    be_not_found: "Not found",
    be_notification_has_no_actionable_target: "Notification has no actionable target",
    be_notification_not_found: "Notification not found",
    be_only_admin: "Only admin",
    be_only_admin_can_apply_user_actions: "Only admin can apply user actions",
    be_only_admin_can_delete_reports: "Only admin can delete reports",
    be_only_admin_moderator: "Only admin/moderator",
    be_only_gift_subcategory_reports_support_this: "Only gift subcategory reports support this",
    be_only_moderators_can_update_reports: "Only moderators can update reports",
    be_only_owner_or_admin_can_set_this_status: "Only owner or admin can set this status",
    be_pagina_non_trovata: "Page not found",
    be_password_attuale_errata: "Current password incorrect",
    be_password_non_impostabile_per_questo_account_google: "Can't set password for this Google account",
    be_photo_not_found: "Photo not found",
    be_puoi_salvare_al_massimo_20_ricerche_elimina_prima_una_vecchi: "Max 20 saved searches. Delete an old one first.",
    be_recurring_donations_are_only_available_for_platform_and_refo: "Recurring donations only for platform and reforestation",
    be_report_not_found: "Report not found",
    be_ricerca_non_trovata: "Search not found",
    be_seleziona_prima_l: "Select first",
    be_sign_in_required: "Sign in required",
    be_sign_in_required_to_view_marketplace: "Sign in required to view Marketplace",
    be_slug_non_valido: "Invalid slug",
    be_solo_super_admin: "Super admin only",
    be_solo_vendo: "Selling only",
    be_solo_admin_o_ente_verificato: "Admin or verified organization only",
    be_solo_admin_moderator_o_ente_verificato: "Admin/moderator or verified organization only",
    be_solo_il_proprietario_pu_modificare: "Only the owner can edit",
    be_solo_il_venditore: "Seller only",
    be_solo_l: "Only",
    be_solo_la_controparte_pu_confermare: "Only the other party can confirm",
    be_solo_la_controparte_pu_rifiutare: "Only the other party can refuse",
    be_solo_super_admin_pu_assegnare_o_revocare_admin: "Only super admin can assign or revoke admin",
    be_source_photo_not_found: "Source photo not found",
    be_stato_non_valido: "Invalid status",
    be_super_admin_only: "Super admin only",
    be_target_user_not_found: "Target user not found",
    be_token_non_valido_o_gi_usato: "Invalid or already used token",
    be_token_non_valido_o_scaduto: "Invalid or expired token",
    be_token_scaduto: "Token expired",
    be_too_many_reports_in_a_short_time_try_again_later: "Too many reports in a short time — try again later",
    be_transaction_not_found: "Transaction not found",
    be_translation_failed: "Translation failed",
    be_unsupported_file_type: "Unsupported file type",
    be_you_can_only_edit_your_own_messages: "You can only edit your own messages",
    be_already_moderated: "Already moderated",
    be_annuncio_concluso_la_chat_chiusa: "Listing closed: chat is closed",
    be_categoria_non_valida: "Invalid category",
    be_invalid_hours: "Invalid hours",
    be_invalid_kind: "Invalid kind",
    be_invalid_token: "Invalid token",
    be_invalid_type: "Invalid type",
    be_kind_must_be_one_of_resolved_in_progress_worse_undo: "Kind must be: resolved, in_progress, worse, undo",
    be_new_path_not_found_in_files: "New path not found in files",
    be_no_changes: "No changes",
    be_peer_id_richiesto_per_il_proprietario: "Peer ID required for owner",
    be_photo_path_required: "Photo path required",
    be_photo_index_out_of_range: "Photo index out of range",
    be_platform_must_be_ios_android_web: "Platform must be ios|android|web",
    be_polygon_needs_at_least_3_points: "Polygon needs at least 3 points",
    be_reason_required_min_5_chars: "Reason required (min 5 chars)",
    be_regions_required: "Regions required",
    be_role_must_be: "Role must be",
    be_solo_vendo_ha_il_prezzo: "Only selling has a price",
    be_sottocategoria_non_valida: "Invalid subcategory",
    be_text_required: "Text required",
    be_tipo_specifico_non_valido: "Invalid specific type",
    be_token_required: "Token required",
    be_utente_non_trovato: "User not found",
    be_cosa_fare_ora_riservato_ad_admin_ed_enti_verificati: "\"What to do now\" reserved for admins and verified organizations",
  
    menu_my_listings: "My Listings",
    menu_following: "Following",
    menu_saved_searches: "Saved Searches",
    unread_messages: "unread messages",
  
    mk_type_sale: "For Sale",
    mk_type_gift: "Free Gift",
    mk_type_reusable: "Found Reusable",
  
    mk_title_row: "For Sale · Free · Reusables",
    new_listing: "New listing",
    guest_login_sale: "Sign in to see For Sale listings.",
    tab_all: "All",
    mk_kicker: "MARKETPLACE",
    tip_mk_3cats: "Marketplace has three distinct categories: 🟣 For Sale (with price, pickup/shipping), 🔵 Free Gift (free, chosen by owner in chat), 🟤 Found Reusable (abandoned item: first come, first served).",
    tip_mk_guest: "For Sale listings are visible only to registered users. Free gifts and Reusables are visible to everyone on the map, but to contact or create you need to sign in.",
  
    event_new_proposal: "New proposal",
    event_extraordinary_kicker: "Extraordinary event",
    event_intro_line: "Report an event actually underway over a large area (wildfire, flood, landslide, storm, etc.).",
    event_intro_verified_pub: "Your event will be published immediately as a verified entity.",
    event_intro_review_pub: "The proposal will be reviewed by an Admin before it is published.",
    event_title_label: "Title",
    event_kind_label: "Category",
    event_whattodo_admin_only: "What to do now (Admin / verified entities only)",
    event_started_label: "Start date and time (optional)",
    event_publish_btn: "Publish event",
    event_send_proposal_btn: "Send proposal",
    event_area_involved: "Area involved",
    event_area_hint: "Search the territory (optional) and/or click on the map to add the polygon vertices. At least 3 points are required.",
    event_territory_prefix: "Territory",
    event_undo_last: "Undo last",
    event_clear_all: "Clear",
    event_draw_start: "Draw area",
    event_draw_stop: "Stop drawing",
    event_draw_active_hint: "DRAW MODE ACTIVE — tap the map to add vertices. At least 3 points required.",
    event_polygon_hint_manual: "Turn on \"Draw area\" and tap at least 3 points on the map. Or use \"Use current area\" for a quick 2 km polygon.",
    event_use_current_area: "Use current area (~2 km)",
    event_area_used_current: "~2 km area generated around map centre",
    event_points_count_suffix: "points",
    event_title_required: "Title is required",
    event_polygon_required: "Draw an area with at least 3 points",
    event_published_ok: "Event published",
    event_proposal_sent: "Proposal sent to Admin review",
    event_generic_error: "Error",
    event_title_placeholder: "E.g. Forest fire — North coast",
    event_desc_placeholder: "What's happening, where, how long",
    event_whattodo_placeholder: "E.g. Don't approach. Call 115. Evacuate area X.",
    event_photos_label: "Photos",
    add_photo_short: "Add",
    mkc_description_label: "Description",
    mkc_choose_placeholder: "Choose…",
    mkc_condition_label: "Condition",
    mkc_color_label: "Color",
    mkc_color_placeholder: "E.g. blue, natural wood",
    mkc_keywords_label: "Keywords",
    mkc_photos_label: "Photos",
    country_or_province: "Country, province or city…",
    reports_solved_kicker: "Solved reports",
    in_progress_kicker: "In progress",
    verified_users_kicker: "Verified users",
    close_tips: "Close tips",
    what_are_you_selling: "What are you selling?",
    what_are_you_giving: "What are you giving away?",
    what_did_you_find: "What did you find?",
    change_type: "Change type",
    publish_listing: "Publish listing",
    approximate_location: "Approximate location",
    category_first_short: "Category first",
    mkc_new_listing_kicker: "Marketplace · New listing",
    mkc_what_type_heading: "What kind of listing do you want to publish?",
    mkc_type_choice_desc: "Pick one of the three modes. Each type has its own rules (price, chat, closing). You can change the choice before publishing.",
    mkc_hint_sale: "Price required. The listing is only visible to registered users. Private chat with potential buyers; at the end you (the seller) and the buyer confirm the closure.",
    mkc_hint_gift: "You're giving an item to another user. No price. Decide freely in chat who to give it to.",
    mkc_hint_reusable: "You're reporting an abandoned or reusable item you found. No price, no assignment: first come, first served. The chat is informational only.",
    mkc_subtitle_sale: "Publish a for-sale listing: price required, pickup or shipping, private chat with buyers.",
    mkc_subtitle_gift: "Give an item to another user: you choose freely in chat who to hand it over to.",
    mkc_subtitle_reusable: "Report a reusable item you found or that's been abandoned: first come, first served. Chat is informational only.",
    mkc_title_label: "Title",
    mkc_category_label: "Category",
    mkc_subcategory_label: "Subcategory",
    mkc_itemtype_label: "Specific type",
    mkc_subcategory_first: "Subcategory first",
    mkc_condition_new: "New",
    mkc_condition_good: "Good",
    mkc_condition_used: "Used",
    mkc_keywords_placeholder: "ikea, double, 180cm (comma-separated)",
    mkc_price_label: "Price (€)",
    mkc_negotiable: "Negotiable",
    mkc_pickup: "Pickup",
    mkc_shipping: "Shipping",
    mkc_position_label: "Approximate location",
    mkc_position_hint: "Search the territory (optional) and/or click on the map. The public location is approximate; you'll share the exact address in chat.",
    mkc_territory_prefix: "Territory",
    mkc_err_title_required: "Title is required",
    mkc_err_taxonomy_required: "Category, subcategory and specific type are required",
    mkc_err_position_required: "Pick the approximate location on the map",
    mkc_err_price_required: "Price is required",
    mkc_success_published: "Listing published",
    mkc_err_generic: "Error",
    mkc_upload_failed: "Upload failed",
    map_reports_list_title: "Reports list",
    map_within_km: "within {km} km",
    map_within_area: "in {area}",
    map_count_results: "results",
    map_count_reports: "reports",
    map_clear_area_filter: "Clear province filter",
    details_arrow: "Details →",
    events_popup_state_prefix: "State",
    mk_popup_following: "✓ Following",
    mk_popup_follow: "🔔 Follow",
    events_history_kicker: "Extraordinary events history",
    events_history_count_suffix: "events",
    events_history_none: "No events found.",
    legal_kicker: "Legal document",
    legal_placeholder_title: "Content being finalized",
    legal_placeholder_body: "The final text of this document will be published shortly. For information contact us at",
    legal_privacy_title: "Privacy Policy",
    legal_terms_title: "Terms & Conditions",
    legal_community_title: "Community rules",
    legal_marketplace_title: "Marketplace rules",
    acct_del_kicker: "Account deletion",
    acct_del_title: "Delete your ToClean account",
    acct_del_intro: "You can request deletion of your ToClean account and the associated personal data at any time. The action is irreversible.",
    acct_del_what_happens_title: "What happens on deletion",
    acct_del_what_1: "Your account is removed from the database.",
    acct_del_what_2: "Your Marketplace listings are removed.",
    acct_del_what_3: "Your posts and messages are anonymized (content preserved, author shown as \"Deleted user\").",
    acct_del_what_4: "Your sessions and push tokens are revoked immediately.",
    acct_del_what_5: "Public reports already sent to authorities remain on their record (legal obligation).",
    acct_del_how_signed_in_title: "If you are signed in",
    acct_del_how_signed_in_body: "Go to Settings → \"Delete account\". You will get a confirmation prompt before the irreversible action.",
    acct_del_go_settings: "Open Settings",
    acct_del_how_email_title: "If you have no access to your account",
    acct_del_how_email_body: "Write to info@toclean.app from the email tied to your account. The ToClean team will process the request.",
  
    tip_event_scope: "An extraordinary event concerns emergencies over a wide area (fire, flood, landslide, storm, etc.), not individual objects or small reports.",
    tip_event_polygon: "Draw the area on the map by clicking the polygon vertices: you need at least 3 points. Use «Undo last» or «Clear» to correct.",
    tip_event_moderation: "If you're not a verified organization, the proposal is sent to an Admin for review before going public on the map.",
    tip_map_colors: "Markers are colored by risk: 🟢 Green = ordinary, 🟡 Yellow = to monitor, 🔴 Red = urgent. The color is decided by the short questionnaire when creating the report.",
    tip_map_filters: "Use the filters to choose which reports or objects to display. The map, list, and number of results will update together.",
    tip_map_duplicates: "Before opening a new report, check if there's already one nearby: it helps avoid duplicates and strengthen existing reports.",
    tip_rc_wizard: "The 4 color-code questions automatically assign Green/Yellow/Red based on perceived risk, urgency, extent, and impact. They're not a judgment: they just guide moderation priority.",
    tip_rc_privacy: "Your photos are processed server-side: faces and license plates are automatically blurred. The public location is approximate: the exact address stays private.",
    tip_rc_after_photo: "To mark an ordinary report as resolved, you'll need to add an «after» photo from the same place later. Just one click, but essential to confirm resolution.",
  
    publish: "Publish",
    submit_for_review: "Submit for review",
    state_published: "Published",
    state_in_progress: "In progress",
    state_pending: "Pending review",
    state_rejected: "Rejected",
    state_draft: "Draft",
    state_resolved: "Resolved",
    state_closed: "Closed",
    state_active: "Active",
    risk_green: "Green",
    risk_yellow: "Yellow",
    risk_red: "Red",
    stats_reports_solved: "Reports solved",
    stats_reports_progress: "In progress",
    stats_users_verified: "Verified users",
  
    no_period_data: "No data for the selected period.",
    awaiting_counterpart: "Waiting for the other party to confirm.",
    no_messages_write_first: "No messages — write the first one.",
    no_chat_for_listing_msg: "No chat for this listing",
    // Phase 3 — private chat (18+ only)
    nav_messages: "Messages",
    chat_title: "Messages",
    chat_tab_chats: "Chats",
    chat_tab_requests: "Requests",
    chat_tab_invites: "Invites",
    chat_tab_blocked: "Blocked",
    chat_empty: "No chats yet.",
    chat_no_requests: "No requests.",
    chat_no_invites: "No invites.",
    chat_send: "Send",
    chat_composer_placeholder: "Write a message…",
    chat_request_dialog_title: "Request a private chat",
    chat_request_dialog_desc: "Send a request to start a private chat. The recipient must accept it before the conversation can start.",
    chat_request_send: "Send request",
    chat_request_sent: "Request sent",
    chat_message_optional_label: "Initial message (optional)",
    chat_message_optional_ph: "For example: I'm interested in your listing…",
    chat_accept: "Accept",
    chat_reject: "Decline",
    chat_cancel_req: "Cancel request",
    chat_incoming: "Incoming",
    chat_outgoing: "Sent",
    chat_pending_status: "Pending",
    chat_group_create: "Create group",
    chat_group_title_label: "Group title",
    chat_group_desc_label: "Description (optional)",
    chat_group_invitees_label: "Invite users (user IDs, comma-separated)",
    chat_group_picker_label: "Invite users",
    chat_group_picker_placeholder: "Search by name…",
    chat_group_picker_selected: "Selected",
    chat_group_picker_no_results: "No users found.",
    chat_group_picker_min_chars: "Type at least 2 characters.",
    chat_group_picker_add: "Add",
    chat_group_picker_remove: "Remove",
    // Phase 4 — Social links
    social_links_title: "Social links & website",
    social_links_desc: "Optional. Links are shown on your public profile. ToClean does not verify or endorse external content.",
    social_links_add: "Add link",
    social_links_platform: "Platform",
    social_links_url: "URL",
    social_links_label: "Label (optional)",
    social_links_save: "Save links",
    social_links_saved: "Social links saved",
    social_links_url_scheme_err: "URL must start with http:// or https://",
    social_links_url_invalid_err: "Invalid URL.",
    social_links_url_too_long_err: "URL too long.",
    social_links_adult_only: "Only users aged 18 or older can add external links.",
    social_links_none: "No links.",
    social_links_platform_website: "Website",
    social_links_platform_other: "Other",
    social_links_disclaimer: "External, unverified links.",
    // Phase 4 — Video upload
    video_upload_label: "Add video",
    video_upload_hint: "Supported formats: MP4, MOV, M4V, WebM (H.264 or VP8/VP9). Maximum {mb} MB.",
    video_uploading: "Uploading…",
    video_upload_progress: "{p}%",
    video_upload_ok: "Video uploaded",
    video_upload_err_format: "Unsupported format. Use MP4, MOV or WebM.",
    video_upload_err_hevc: "Your video is HEVC/H.265 and cannot play across all browsers. On iPhone go to Settings → Camera → Formats → \"Most Compatible\" and try again.",
    hevc_help_title: "iPhone video compatibility",
    hevc_help_desc: "Your iPhone recorded this clip in HEVC/H.265. Follow these steps to use a format that ToClean can play.",
    hevc_help_step1: "Open Settings",
    hevc_help_step2: "Go to Camera → Formats",
    hevc_help_step3: "Choose \"Most Compatible\"",
    hevc_help_step4: "Record a new video and upload again",
    hevc_help_note: "Existing HEVC clips in your camera roll stay unchanged. New recordings will use H.264/MP4 — compatible with ToClean and with most devices.",
    hevc_help_show: "How do I fix this?",
    video_upload_err_too_large: "Video too large. Limit {mb} MB.",
    video_upload_err_generic: "Video upload failed.",
    video_delete: "Delete video",
    video_delete_confirm: "Delete this video?",
    video_privacy_notice: "If the video shows people, license plates or personal data directly linked to an alleged illicit or harmful behaviour, the same Privacy Prompt as for photos applies.",
    video_none: "No videos.",
    video_removed: "Video removed.",
    chat_group_leave: "Leave group",
    chat_group_member: "Member",
    chat_group_pending_label: "Invite pending",
    chat_block_user: "Block user",
    chat_unblock_user: "Unblock",
    chat_blocked_list: "Blocked users",
    chat_report_message: "Report message",
    chat_adult_only: "Private chats are only available to users aged 18 or older.",
    chat_pending_invite_banner: "You must accept the invite to view group messages.",
    chat_open: "Open",
    chat_leave: "Leave",
    chat_open_conversation: "Open conversation",
    chat_error_send: "Unable to send message.",
    chat_group_created: "Group created",
    chat_group_leave_confirm: "Are you sure you want to leave the group?",
    chat_from: "from",
    report_unavailable: "Report unavailable",
    open_report_in_app: "Open the report in the app",
    content_removed: "This content has been removed or is no longer accessible.",
    no_pec_before_button: "No certified email is sent before pressing this button.",
    no_reports_for_filters: "No reports match the current filters.",
    reforestation_big_project: "A project as big as the future we want to build.",
    not_authorized_dot: "Not authorized.",
    support_reforestation: "Support reforestation",
    my_searches_title: "My searches",
    signup_dob_label: "Date of birth",
    signup_dob_help: "Used only to verify you are at least 14. Never shown to anyone.",
    signup_terms_prefix: "I have read and accept the",
    signup_terms_link: "Terms of Service",
    signup_privacy_prefix: "I have read and accept the",
    signup_privacy_link: "Privacy Policy",
    signup_terms_required: "You must accept the Terms and Privacy to register.",
    signup_age_required: "You must be at least 14 to use ToClean.",
    signup_dob_invalid: "Invalid date of birth.",
    complete_profile_title: "Complete your profile",
    complete_profile_desc: "To keep using ToClean confirm your age and accept the updated terms. No other data is required.",
    complete_profile_cta: "Confirm and continue",
    complete_profile_age_warning: "If you are under 14 your account will be removed automatically, as required by app-store rules.",
    mk_adult_only_banner: "The Marketplace is read-only until you are 18. You can browse listings but not publish, contact or follow.",
    mk_adult_only_button_tip: "Available from age 18.",
    mk_new_disabled_minor: "18+ only",
    report_content_btn: "Report content",
    report_content_title: "Report this content",
    report_content_desc: "Our moderation team will be notified. We never share your identity with the reported person.",
    report_reason_harassment: "Harassment or threats",
    report_reason_hate: "Hate speech",
    report_reason_sexual: "Unsolicited sexual content",
    report_reason_spam: "Spam or scam",
    report_reason_privacy: "Privacy violation",
    report_reason_illegal: "Illegal content",
    report_reason_impersonation: "Impersonation",
    report_reason_abuse: "Platform abuse",
    report_reason_other: "Other",
    report_content_details: "Details (optional)",
    report_content_send: "Send report",
    report_content_sent: "Report submitted. Thank you.",
    block_user_btn: "Block user",
    unblock_user_btn: "Unblock user",
    block_user_confirm_title: "Block this user?",
    block_user_confirm_desc: "You'll stop receiving their messages and content. You can unblock them anytime from Settings.",
    block_user_ok: "Blocked",
    unblock_user_ok: "Unblocked",
    pp_title: "One moment before publishing",
    pp_question: "Are you making a person, a licence plate or other personal data recognizable while directly linking them to an alleged illegal or harmful behavior?",
    pp_answer_no: "No",
    pp_answer_yes: "Yes",
    pp_warn_title: "Heads up: privacy, reputation and personal rights",
    pp_warn_body: "Making a person identifiable and publicly linking them to an alleged wrongdoing can have legal consequences for you and for the person portrayed: privacy, reputation and personal rights are at stake.\n\nFor this reason, the content will be sent to ToClean for review before it can be published.",
    pp_warn_body_review_only: "Making a person identifiable and publicly linking them to an alleged wrongdoing can have legal consequences for you and for the person portrayed: privacy, reputation and personal rights are at stake.\n\nFor this reason, the content will be sent to ToClean for review before it can be published.",
    pp_send_review: "Send for review to ToClean",
    pp_ack_label: "I confirm I am responsible for the content and statements I publish and that I have read the notice regarding privacy, reputation and personal rights of the people represented.",
    pp_publish_anyway: "Publish anyway",
    pp_sent_review_toast: "Content sent for review. We'll keep you posted.",
    comment_like: "Like",
    comment_unlike: "Unlike",
    comment_likes_count_one: "1 like",
    comment_likes_count_many: "{n} likes",
    comment_sort_label: "Sort",
    comment_sort_relevant: "Most relevant",
    comment_sort_liked: "Most liked",
    comment_sort_recent: "Most recent",
    comment_sort_oldest: "Oldest",
    comment_report: "Report comment",
    admin_tab_content_reports: "Content reports",
    admin_tab_events: "Extraordinary events",
    what_to_do_now: "What to do now",
    reject_reason_prompt: "Reason (optional):",
    delete_event_confirm: "Permanently delete this event?",
    cr_no_items: "No content reports for the current filters.",
    cr_status_open: "Open",
    cr_status_in_review: "In review",
    cr_status_resolved: "Resolved",
    cr_status_dismissed: "Dismissed",
    cr_target_type: "Type",
    cr_target_report: "Report",
    cr_target_marketplace_listing: "Listing",
    cr_target_message: "Chat message",
    cr_target_marketplace_message: "Marketplace message",
    cr_reported_by: "Reported by",
    cr_reporter_deleted: "deleted user",
    cr_content_author: "Content author",
    cr_open_target: "Open reported content",
    cr_action_review: "Take in review",
    cr_action_resolve: "Mark as resolved",
    legal_info_title: "Legal Information and Contacts",
    legal_privacy_title: "Privacy Policy",
    legal_terms_title: "Terms of Service",
    legal_community_title: "Community Rules",
    legal_marketplace_title: "Marketplace Rules",
    legal_deletion_title: "Account and Data Deletion",
    footer_legal: "Legal documents",
    footer_legal_info: "Legal information",
    footer_privacy: "Privacy Policy",
    footer_terms: "Terms of Service",
    footer_community_rules: "Community Rules",
    footer_marketplace_rules: "Marketplace Rules",
    footer_account_deletion: "Account deletion",
    signup_consent_prefix: "I accept the",
    signup_consent_and_the: "and the",
    signup_consent_privacy_note: "and I acknowledge that I have read the",
    signup_community_link: "Community Rules",
    mkt_rules_gate_title: "Marketplace Rules",
    mkt_rules_gate_kicker: "First Marketplace operation",
    mkt_rules_gate_desc: "To publish a listing, edit yours, or contact another user, you first need to accept the current version of the Marketplace Rules.",
    mkt_rules_gate_read: "Read the Marketplace Rules",
    mkt_rules_gate_checkbox: "I have read and accept the Marketplace Rules.",
    mkt_rules_gate_accept: "Accept and continue",
    mkt_rules_gate_cancel: "Cancel",
    mkt_rules_gate_required: "You must accept the Marketplace Rules to continue.",
    mkt_rules_gate_accepted_toast: "Marketplace Rules accepted.",
    mkt_rules_gate_error: "Could not record your acceptance. Please try again.",
    section_profile_photo: "Profile photo",
    profile_photo_desc: "Add a public profile photo. It is optional and can be removed at any time.",
    profile_photo_upload: "Upload photo",
    profile_photo_replace: "Replace photo",
    profile_photo_remove: "Remove photo",
    profile_photo_uploading: "Uploading…",
    profile_photo_removing: "Removing…",
    profile_photo_updated: "Profile photo updated.",
    profile_photo_removed: "Profile photo removed.",
    profile_photo_invalid_type: "Unsupported image format. Use JPG, PNG or WEBP.",
    profile_photo_too_large: "Image too large. Maximum size: 5 MB.",
    profile_photo_error: "Could not update your profile photo. Please try again.",
    profile_photo_hint: "JPG, PNG or WEBP · max 5 MB.",
    username_label: "Username",
    username_placeholder: "e.g. jane.doe",
    username_help: "3–30 characters, letters, digits, dot and underscore only. Unique and public.",
    email_private_hint: "Your email stays private and is never shown to other users.",
    username_too_short: "Username must be at least 3 characters.",
    username_too_long: "Username cannot exceed 30 characters.",
    username_invalid_chars: "Username can only contain letters, digits, dots and underscores.",
    username_reserved: "That username is reserved.",
    username_taken: "That username is already taken.",
    username_required: "Please choose a username to continue.",
    cr_action_dismiss: "Dismiss",
  },
  fr: {
    tagline: "Laisser le monde meilleur qu'on ne l'a trouvé.",
    hero_title: "Signale. Vérifie. Nettoie.",
    hero_subtitle: "ToClean est la plateforme mondiale pour transformer un signalement en action concrète. Citoyens, bénévoles, associations et communes, ensemble sur la même carte.",
    cta_map: "Ouvrir la carte",
    cta_report: "Créer un signalement",
    cta_signin: "Se connecter",
    cta_signup: "S'inscrire",
    cta_google: "Continuer avec Google",
    cta_donate: "Soutenir",
    nav_map: "Carte",
    nav_stories: "Histoires positives",
    nav_leaderboard: "Classement",
    nav_profile: "Profil",
    nav_admin: "Admin",
    nav_settings: "Paramètres",
    nav_admin_dashboard: "Tableau de bord Admin",
    stats_reports: "signalements totaux",
    stats_resolved: "problèmes résolus",
    stats_pending: "en cours",
    stats_users: "membres actifs",
    filters: "Filtres",
    category: "Catégorie",
    all: "Toutes",
    risk_level: "Risque",
    status: "Statut",
    st_published: "Publiée",
    st_in_progress: "En cours",
    st_resolved: "Résolue",
    st_pending: "En attente",
    st_pending_moderation: "À approuver",
    st_concluded: "Conclu",
    st_archived: "Archivé",
    cat_waste: "Déchets",
    cat_environment: "Environnement",
    cat_animals: "Animaux",
    cat_urban: "Dégradation urbaine",
    cat_vegetation: "Végétation dangereuse sur route",
    cat_reusable: "Objets réutilisables",
    new_report: "Nouveau signalement",
    subcategory: "Sous-catégorie",
    description: "Description",
    upload_photos: "Charger des photos",
    submit: "Envoyer le signalement",
    cancel: "Annuler",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    role: "Rôle",
    citizen: "Citoyen",
    volunteer: "Bénévole",
    association: "Association",
    company: "Entreprise / Sponsor",
    municipality: "Commune / Organisme",
    operator: "Opérateur",
    already: "Tu as déjà un compte ?",
    new_here: "Nouveau sur ToClean ?",
    signin_now: "Se connecter",
    signup_now: "S'inscrire",
    coordinate: "Coordonner l'intervention",
    send_message: "Envoyer",
    write_message: "Écris un message…",
    confirm: "Confirmer",
    confirm_still: "Le problème existe encore",
    confirm_worsened: "Ça s'est aggravé",
    confirm_resolved: "Résolue",
    confirm_not: "Ce n'est plus présent",
    take_item: "J'ai pris l'objet",
    interested: "Je suis intéressé",
    logout: "Se déconnecter",
    reports_created: "Signalements créés",
    confirmations_made: "Confirmations fournies",
    reputation: "Réputation",
    donation_title: "Soutenir ToClean",
    donation_desc: "Ta contribution finance des interventions vérifiées, des récompenses pour les bénévoles et le développement de la plateforme.",
    donation_amount: "Montant",
    donation_message: "Message (optionnel)",
    donate_now: "Faire un don",
    donate_min_amount: "Montant minimum : 0,50 €. Tu peux aussi faire un don sans t'inscrire.",
    donate_min_error: "Montant minimum 0,50 €",
    donate_stripe_error: "Erreur Stripe",
    donate_redirect: "Redirection…",
    donate_message_placeholder: "Une pensée pour la communauté…",
    donate_secure: "Paiement sécurisé via Stripe. Carte de test :",
    positive_title: "Histoires positives de la communauté",
    positive_desc: "Chaque marqueur gris est un problème que quelqu'un a rendu invisible.",
    positive_empty: "Aucune histoire pour l'instant. Tes confirmations et tes interventions peuvent devenir la prochaine.",
    positive_solved: "Résolu",
    ai_analyze: "Analyser avec l'IA",
    ai_suggested: "Suggestion IA",
    emergency_notice: "En cas d'urgence immédiate (incendies, animaux en danger de mort, substances dangereuses), contacte immédiatement les services d'urgence locaux.",
    footer_mission: "ToClean est une plateforme pour l'action environnementale. Chaque signalement compte.",
    footer_platform: "Plateforme",
    footer_platform_items: "Carte · Signalements · Chat · Récompenses",
    footer_platform_lang: "Multi-langue (IT · EN)",
    footer_platform_ai: "Modération IA (GPT-5.2)",
    footer_community: "Communauté",
    footer_made: "Créé avec les bénévoles, pour la planète.",
    hero_slide1_title: "La planète est magnifique.",
    hero_slide1_sub: "Chaque geste minuscule décide si elle le restera.",
    hero_slide2_title: "Ensemble, on peut.",
    hero_slide2_sub: "Citoyens, bénévoles, associations, entreprises, communes — sur la même carte.",
    hero_slide3_title: "Une action, une preuve.",
    hero_slide3_sub: "Photos avant et après, reçus, historique public de chaque intervention.",
    hero_prev: "Précédent",
    hero_next: "Suivant",
    hero_play: "Lecture",
    hero_pause: "Pause",
    hero_mute_on: "Activer le son",
    hero_mute_off: "Muet",
    community_verified: "Community · verified",
    hero_action_leaves_mark: "Chaque action laisse une trace.",
    risk_green_low: "Vert · Faible",
    risk_green_desc: "Petits déchets, objets, matériaux non dangereux.",
    risk_red_high: "Rouge · Élevé",
    risk_red_desc: "Substances dangereuses, maltraitance animale, preuves sensibles.",
    mission_kicker: "Mission & Objectif",
    mission_title: "Une planète plus propre n'attend l'autorisation de personne.",
    mission_p1: "ToClean est une plateforme <b>indépendante</b> créée pour mettre en contact ceux qui voient un problème avec ceux qui peuvent le résoudre. Citoyens, bénévoles, associations, entreprises et administrations — sur la même carte, avec les mêmes outils, pour le même objectif.",
    mission_p2: "Ce n'est pas un énième réseau social. Ce n'est pas une pétition. C'est un outil opérationnel : <b>photo, vérification, coordination, preuve du résultat.</b> Simple, transparent, vérifiable.",
    // ---- MissionPage /missione (contenu approuvé, traduit fidèlement depuis l'IT)
    missionpage_kicker: "Mission",
    missionpage_title: "Notre mission",
    missionpage_intro: "ToClean est né pour rendre la protection de l'environnement plus simple, plus concrète et plus partagée. Nous voulons offrir aux personnes un espace pour signaler les problèmes environnementaux, suivre ce qui se passe sur leur territoire, collaborer avec la communauté et donner une nouvelle vie aux objets encore utilisables.",
    missionpage_s1_title: "Participation environnementale",
    missionpage_s1_body: "ToClean permet aux personnes de contribuer à l'entretien du territoire grâce à des signalements environnementaux, des mises à jour, des initiatives locales et des événements extraordinaires. Chaque contribution peut aider à rendre les problèmes plus visibles et à favoriser interventions, collaboration et responsabilité partagée.",
    missionpage_s2_title: "Réutilisation et communauté",
    missionpage_s2_body: "À travers les sections Je vends, Je donne et Objets réutilisables trouvés, ToClean vise à réduire le gaspillage et à faciliter la réutilisation de ce qui peut encore servir. L'objectif n'est pas seulement de créer une Place de marché, mais d'encourager une communauté plus attentive, responsable et proche de son territoire.",
    missionpage_s3_title: "Dons et croissance du projet",
    missionpage_s3_body: "Les personnes pourront soutenir ToClean, les signalements environnementaux et les projets de reforestation par des contributions volontaires. Les ressources collectées pourront contribuer au développement, à la gestion et à la croissance du projet, dans le respect des règles et des informations qui seront rendues publiques.",
    missionpage_future_title: "Vision future : sponsors et récompenses",
    missionpage_future_p1: "ToClean estime que celles et ceux qui consacrent du temps, de l'énergie et un engagement concret à la protection de l'environnement méritent d'être valorisés.",
    missionpage_future_p2: "Avec la croissance de la communauté et le soutien futur d'entreprises, d'organismes et de sponsors, nous voulons développer un programme transparent de reconnaissance et de récompense pour les bénévoles les plus actifs et pour les initiatives environnementales les plus significatives.",
    missionpage_future_p3: "Les sponsors pourront soutenir le projet, contribuer aux récompenses et obtenir une visibilité clairement identifiable comme sponsoring. Une partie des ressources pourra également contribuer aux coûts nécessaires pour maintenir et faire croître ToClean.",
    missionpage_rewards_title: "Récompenses futures possibles",
    missionpage_rewards_1: "Bons ou remises mis à disposition par les sponsors",
    missionpage_rewards_2: "Produits éco-responsables",
    missionpage_rewards_3: "Participation à des expériences ou événements",
    missionpage_rewards_4: "Badges et reconnaissances numériques",
    missionpage_rewards_5: "Prix liés à des initiatives environnementales",
    missionpage_rewards_6: "Soutien concret à des groupes ou projets bénévoles",
    missionpage_disclaimer: "Le programme de récompenses n'est pas encore actif. Il représente une vision future de ToClean et pourra être mis en œuvre progressivement uniquement en présence d'une croissance réelle de la communauté, de ressources disponibles et d'accords concrets avec les sponsors et partenaires. Avant l'activation, les critères, règles, conditions et modalités d'attribution seront publiés.",
    missionpage_updated_at: "Dernière mise à jour :",
    missionpage_back_home: "Retour à l'accueil",
    publish_chooser_title: "Que veux-tu publier ?",
    publish_chooser_desc: "Choisis le type de contenu : un signalement environnemental ou une annonce de la Place de marché.",
    publish_chooser_report_title: "Signalement environnemental",
    publish_chooser_report_desc: "Déchets, abus, négligence : aide à surveiller et à résoudre les problèmes courants.",
    publish_chooser_sale_title: "Objet à vendre",
    publish_chooser_sale_desc: "Publie une annonce avec prix. Chat privé avec les acheteurs potentiels.",
    publish_chooser_gift_title: "Objet à donner",
    publish_chooser_gift_desc: "Aucun prix. Choisis librement en chat à qui le remettre.",
    publish_chooser_reusable_title: "Objet réutilisable trouvé",
    publish_chooser_reusable_desc: "Signale un objet abandonné ou réutilisable. Premier arrivé, premier servi.",
    listing_type_sale: "Je vends",
    listing_type_gift: "Je donne",
    listing_type_reusable: "Réutilisable trouvé",
    pillar1_title: "Signale ce que tu vois",
    pillar1_desc: "Déchets, dégradation urbaine, animaux en difficulté, incendies, objets réutilisables. Une photo, la position GPS, un niveau de risque. C'est tout.",
    pillar2_title: "Vérifie avec la communauté",
    pillar2_desc: "Ceux qui sont proches confirment, ajoutent des photos, indiquent si le problème s'est aggravé ou a été résolu. La fiabilité augmente avec les confirmations.",
    pillar3_title: "Coordonne personnes et moyens",
    pillar3_desc: "Chaque signalement a son propre chat. Bénévoles, associations, communes et opérateurs professionnels se mettent d'accord là, sans se perdre dans des DM privés.",
    pillar4_title: "Soutiens avec des dons et des sponsors",
    pillar4_desc: "Entreprises et particuliers peuvent financer des interventions, des récompenses et du matériel. Chaque contribution est tracée et reliée à un résultat réel.",
    pillar5_title: "Récompense ceux qui contribuent",
    pillar5_desc: "Bons d'achat, cadeaux, équipement, reconnaissances des sponsors. On ne gagne pas d'argent avec ToClean — mais le temps donné n'est jamais oublié.",
    pillar6_title: "Résultats vérifiables et transparents",
    pillar6_desc: "Photos avant et après, reçus de dépôt, historique public de chaque intervention. La section « Histoires positives » raconte ce qui a été rendu invisible.",
    how_kicker: "Comment ça marche",
    how_title: "Cinq étapes. Zéro bureaucratie.",
    how_sub: "De la photo sur le téléphone à la preuve publique du résultat.",
    how_step_1: "Signale",
    how_step_1_desc: "Photo, GPS, catégorie, risque perçu.",
    how_step_2: "Vérifie",
    how_step_2_desc: "La communauté confirme ou dément.",
    how_step_3: "Coordonne",
    how_step_3_desc: "Chat dédié pour bénévoles et opérateurs.",
    how_step_4: "Interviens",
    how_step_4_desc: "On organise le ramassage, le nettoyage, la récupération.",
    how_step_5: "Prouve",
    how_step_5_desc: "Photos avant/après, reçus de dépôt.",
    cat_kicker: "5 catégories · signalables en quelques secondes",
    cat_headline: "Déchets, environnement, animaux, dégradation urbaine et objets réutilisables.",
    gray_markers: "Marqueurs gris : problèmes rendus invisibles.",
    emergency_label: "Urgences",
    support_chip: "Soutenir ToClean",
    support_title_1: "On ne demande pas d'abonnement.",
    support_title_2: "On demande un",
    support_title_3: "geste volontaire.",
    support_p1: "ToClean est un projet indépendant. Il n'appartient pas à un fonds, ne vend pas de données personnelles, ne remplit pas l'interface de bannières publicitaires. Il grandit grâce à ceux qui croient que <b>prendre soin du territoire est la responsabilité de tous</b> — et choisissent de le faire aussi avec une petite contribution financière.",
    support_p2: "Chaque euro donné est complètement <b>facultatif</b>. Tu ne reçois pas de fonctionnalités premium, tu n'obtiens pas de files prioritaires, tu n'apparais pas plus haut dans le classement. Tu reçois quelque chose de plus important : <b>la certitude qu'une plateforme pour le bien commun reste libre, ouverte et utile à ceux qui viendront après toi.</b>",
    support_cta: "Soutenir ToClean",
    support_discover: "Découvrir la mission",
    support_uses_title: "À quoi sert un don",
    support_use_1_title: "Serveurs et infrastructure",
    support_use_1_desc: "Carte, photos, chat : tout doit rester rapide et disponible 24/7.",
    support_use_2_title: "Nouvelles fonctionnalités",
    support_use_2_desc: "Détection de doublons IA, notifications, récompenses automatiques, app mobile native.",
    support_use_3_title: "Modération",
    support_use_3_desc: "Contenus sensibles, protection animale, chats propres : le travail invisible qui rend l'app fiable.",
    support_use_4_title: "Expansion dans de nouveaux pays",
    support_use_4_desc: "Traductions, adaptation réglementaire, partenaires locaux.",
    support_use_5_title: "Initiatives environnementales",
    support_use_5_desc: "Petits fonds pour des interventions communautaires vérifiées (équipement, matériaux).",
    support_use_6_title: "Amélioration continue",
    support_use_6_desc: "Écoute des utilisateurs, corrections, accessibilité, performance.",
    support_footnote: "Aucun don n'est obligatoire. Tu peux utiliser ToClean pour toujours, gratuitement. Si un jour tu veux contribuer, tu le trouveras à portée de main — jamais au milieu.",
    final_kicker: "Commence maintenant",
    final_slogan: "ToClean est simple, gratuite et respectueuse comme la Terre. Aide-nous à l'aider.",
    final_desc: "Inscris-toi et transforme une simple photo en un changement réel. Chaque signalement est un pas.",
    feedback_kicker: "Retours et propositions d'amélioration",
    feedback_title: "Aide-nous à améliorer ToClean.",
    feedback_desc: "Ta suggestion vaut plus que dix roadmaps internes. Signale un bug, propose une nouvelle fonction, dis-nous ce qui ne va pas. Tu peux nous écrire même sans t'inscrire.",
    feedback_kind: "Type",
    feedback_kind_suggestion: "Suggestion",
    feedback_kind_bug: "Bug / Problème",
    feedback_kind_improvement: "Proposition d'amélioration",
    feedback_email_label: "Email (optionnel)",
    feedback_email_placeholder: "Seulement si tu veux être recontacté",
    feedback_message: "Message",
    feedback_message_placeholder: "Que pouvons-nous améliorer ?",
    feedback_submit: "Envoyer le retour",
    feedback_submitting: "Envoi…",
    feedback_no_signup: "Pas besoin de s'inscrire.",
    feedback_min_words: "Écris au moins quelques mots",
    feedback_thanks: "Merci pour ton retour !",
    feedback_error: "Erreur",
    support_title: "On ne demande pas d'abonnement. On demande un geste volontaire.",
    open_details: "Ouvrir les détails",
    close: "Fermer",
    set_local_password: "Définir un mot de passe local",
    set_password_desc: "Ajoute un mot de passe local à ton compte Google pour te connecter aussi via email + mot de passe.",
    new_password: "Nouveau mot de passe",
    save: "Enregistrer",
    confirmations_short: "conf.",
    map_locate_unsupported: "Ton navigateur ne prend pas en charge la géolocalisation.",
    map_geo_disabled: "Géolocalisation désactivée dans les paramètres.",
    map_geo_denied: "Permission GPS refusée.",
    map_geo_failed: "Impossible d'obtenir la position.",
    map_locate_title: "Ma position",
    map_locate_here: "Centrer ici",
    geo_no_results_for_area: "Aucun résultat pour cette zone.",
    geo_search_error: "Erreur de recherche",
    geo_temp_unavailable: "Recherche temporairement indisponible — réessaie",
    map_hide_filters: "Masquer les filtres",
    map_show_filters: "Afficher les filtres",
    map_std: "Carte",
    map_satellite: "Satellite",
    map_tiles_error: "Impossible de charger les tuiles de la carte.",
    map_tiles_check: "Vérifie ta connexion et réessaie.",
    map_retry: "Réessayer",
    color: "Couleur",
    show_all: "Tout afficher",
    reset: "Réinitialiser",
    all_subcategories: "Toutes les sous-catégories",
    legend: "Légende",
    legend_green_low: "Vert · faible",
    legend_yellow_med: "Jaune · moyen",
    legend_red_high: "Rouge · élevé",
    legend_gray_resolved: "Gris · résolu",
    legend_blue_progress: "Bleu · en cours",
    legend_purple_reusable: "Violet · réutilisable",
    st_active: "Active",
    st_taken: "Prise en charge",
    st_review: "En révision",
    st_standby: "En attente",
    st_reopened: "Rouverte",
    active_prefix: "Active :",
    fab_expand: "Afficher le bouton Créer un signalement",
    fab_minimize: "Réduire",
    auth_home: "Accueil",
    auth_signin_kicker: "Se connecter",
    auth_signup_kicker: "Créer un compte",
    auth_signin_h: "Ravi de te revoir.",
    auth_signup_h: "Rejoins le mouvement.",
    auth_slogan: "Chaque photo est un petit changement.",
    auth_or: "ou",
    welcome_back: "Ravi de te revoir !",
    welcome_new: "Bienvenue sur ToClean !",
    generic_error: "Erreur",
    forgot_password: "Mot de passe oublié ?",
    signin_remember_me: "Se souvenir de moi sur cet appareil",
    reset_back_to_login: "Retour à la connexion",
    reset_title: "Réinitialiser le mot de passe",
    reset_request_desc: "Saisis ton adresse e-mail. Nous t'enverrons un code pour réinitialiser ton mot de passe.",
    reset_confirm_desc: "Saisis le code reçu et ton nouveau mot de passe.",
    reset_send_link: "Envoyer le lien",
    reset_update_pwd: "Mettre à jour le mot de passe",
    reset_updated: "Mot de passe mis à jour ! Tu peux maintenant te connecter.",
    reset_dev_notice_b: "Environnement démo :",
    reset_dev_notice: "code pré-rempli. En production, il arrive par e-mail.",
    reset_min_chars: "6 caractères minimum",
    token_label: "Code",
    settings_title: "Ton compte",
    settings_desc: "Gère ton profil, sécurité, notifications et confidentialité.",
    section_profile: "Profil",
    section_password: "Mot de passe",
    section_notifications: "Notifications",
    section_language: "Langue",
    section_geolocation: "Géolocalisation",
    section_privacy: "Confidentialité",
    section_feedback: "Avis et Suggestions",
    section_session: "Session",
    current_password: "Mot de passe actuel",
    new_password_min: "Nouveau mot de passe (min. 6)",
    change_password: "Changer le mot de passe",
    fill_both_fields: "Remplis les deux champs",
    profile_updated: "Profil mis à jour",
    password_updated: "Mot de passe mis à jour",
    lang_updated: "Langue mise à jour",
    local_password_set: "Mot de passe local défini !",
    notif_new_reports: "Nouveaux signalements dans ta zone",
    notif_mentions: "Mentions dans les discussions",
    notif_status_changes: "Mises à jour de statut",
    notif_rewards: "Récompenses et bons disponibles",
    geo_desc: "Si activée, ToClean peut demander le GPS du navigateur pour centrer la carte et pré-remplir la position des signalements. Tu peux révoquer cette autorisation à tout moment dans les paramètres du navigateur.",
    geo_browser_denied: "Le navigateur a refusé le GPS. Active-le dans les paramètres du navigateur.",
    privacy_public_b: "Profil public.",
    privacy_public_desc: "Ton nom, ta réputation et tes signalements sont visibles dans le classement et sur ta page profil. Tu peux désactiver la visibilité ici.",
    privacy_footnote: "Les photos des signalements sont toujours publiques. Les données sensibles (plaques, visages) sont masquées jusqu'à approbation des modérateurs.",
    logout_label: "Déconnexion",
    delete_account: "Supprimer le compte",
    delete_account_title: "Supprimer définitivement le compte ?",
    delete_account_desc: "Ton profil sera effacé. Tes signalements resteront visibles de manière anonyme pour préserver l'intégrité de l'historique. Cette action est irréversible.",
    delete: "Supprimer",
    account_deleted: "Compte supprimé",
    loading: "Chargement…",
    reputation_short: "réputation",
    new_report_title: "Transforme la photo en action.",
    new_report_desc: "Remplis les champs avec soin. L'IA peut t'aider à catégoriser correctement.",
    add: "Ajouter",
    latitude: "Latitude",
    longitude: "Longitude",
    detect: "Détecter",
    position_on_map: "Position sur la carte · touche pour sélectionner",
    geo_denied_msg: "Autorisation GPS refusée. Tu peux quand même sélectionner la position en touchant la carte ou en la saisissant manuellement.",
    tiles_not_loaded: "Tuiles non chargées.",
    risk_green_label: "Vert · risque faible",
    risk_green_short_desc: "Petits déchets, objets non dangereux",
    risk_yellow_label: "Jaune · risque moyen",
    risk_yellow_short_desc: "Nombreux sacs, verres, matériaux lourds",
    risk_red_label: "Rouge · risque élevé",
    risk_red_short_desc: "Substances dangereuses, animaux, contenus sensibles",
    ai_analyze_desc: "Analyse la photo et la description pour suggérer catégorie, sous-catégorie et niveau de risque.",
    ai_analyze_action: "Analyser",
    ai_unavailable: "IA non disponible",
    ai_completed: "Analyse IA terminée",
    sensitive_content_b: "Contenu sensible.",
    sensitive_content_desc: "Le contenu inclut des visages, des plaques, des mineurs, des preuves ou des accusations. Il sera examiné par les modérateurs avant publication.",
    describe_placeholder: "Qu'as-tu vu ? Taille, contexte, matériaux…",
    photo_uploaded: "Photo téléchargée",
    photo_upload_failed: "Échec du téléchargement",
    add_photo_or_desc: "Ajoute au moins une photo ou une description",
    gps_missing: "Position GPS manquante",
    select_subcategory: "Sélectionne une sous-catégorie",
    description_too_short: "Description trop courte",
    photo_required: "Au moins une photo est obligatoire",
    report_submitted: "Signalement envoyé !",
    gps_updated: "GPS mis à jour",
    gps_unavailable: "Géolocalisation non supportée",
    gps_pick_manual: "Impossible d'obtenir la position — touche la carte ci-dessous pour la sélectionner manuellement.",
    position_set: "Position définie",
    navigate: "Naviguer",
    donate_short: "Donner",
    report_sent_b: "Signalement envoyé !",
    report_sent_desc: "Merci pour ta contribution. La communauté pourra confirmer et se coordonner ci-dessous.",
    back_to_map: "Retour à la carte",
    risk_prefix: "risque",
    confirmations_label: "confirmations",
    still_exists: "Existe encore",
    worsened: "Aggravé",
    resolved_short: "Résolu",
    not_present: "Absent",
    reusable_not_available: "Probablement plus disponible",
    timeline: "Chronologie",
    no_messages: "Aucun message. Lance la conversation.",
    login_to_join: "Connecte-toi pour participer",
    of_author: "de",
    fullscreen: "Plein écran",
    edit_message: "Modifier",
    message_edited: "modifié",
    saved_confirmation: "Confirmation enregistrée",
    thanks: "Merci !",
    donate_report_title: "Soutiens ce signalement",
    donate_report_desc_p1: "Les fonds seront utilisés",
    donate_report_desc_b1: "en priorité pour résoudre ce signalement",
    donate_report_desc_p2: ". Si cela n'était pas possible, ils seront destinés à des interventions similaires",
    donate_report_desc_b2: "dans la même commune ou territoire",
    donate_report_desc_p3: ". Tu peux donner",
    donate_report_desc_b3: "même sans t'inscrire",
    donate_free_offer: "Offre libre (min 0,50 €)",
    donate_report_placeholder: "Un message pour la communauté (optionnel)",
    not_authenticated: "Non authentifié",
    admin_dashboard_kicker: "Dashboard admin",
    admin_overview: "Aperçu modération",
    admin_users: "Utilisateurs",
    admin_reports: "Signalements",
    admin_pending: "En attente",
    admin_red: "Rouges",
    admin_resolved: "Résolus",
    admin_donations: "Dons",
    tab_moderation: "Modération",
    tab_all_reports: "Tous les signalements",
    tab_users: "Utilisateurs",
    tab_donations: "Dons & Sponsors",
    tab_logs: "Logs",
    no_pending: "Aucun signalement en attente.",
    no_reports: "Aucun signalement.",
    all_statuses: "Tous les statuts",
    only_red_risk: "Uniquement risque rouge",
    search_by_name_email: "Recherche par nom ou email…",
    admin_rep_short: "rép",
    admin_suspended: "suspendu",
    admin_banned: "banni",
    admin_reactivate: "Réactiver",
    admin_suspend: "Suspendre",
    admin_remove_ban: "Retirer le ban",
    admin_ban: "Bannir",
    approve: "Approuver",
    reject: "Rejeter",
    archive: "Archiver",
    reopen: "Rouvrir",
    hide_evidence: "Masquer",
    show_evidence: "Afficher preuves",
    sensitive_badge: "sensible",
    proposed_label: "proposé :",
    author_line_by: "de",
    make_public: "Rendre public",
    mark_sensitive: "Marquer sensible",
    st_pub_visible: "Visible",
    st_hidden: "Masqué",
    st_archived: "Archivé",
    st_rejected: "Rejeté",
    change_state_title: "Changer le statut du signalement",
    current_status: "Statut actuel :",
    reason_optional: "Motif (optionnel)",
    state_change_note: "Masquer, suspendre ou archiver",
    state_change_note_b: "ne supprime pas",
    state_change_note_2: "le signalement. Photos, coordonnées, auteur et chronologie restent inchangés.",
    state_arrow: "Statut →",
    color_short: "Couleur",
    admin_actions_title: "Actions administratives",
    delete_report_confirm_title: "Supprimer ce signalement ?",
    delete_report_confirm_body: "Le signalement sera supprimé définitivement. Cette action est irréversible.",
    change_color_title: "Changer la couleur (niveau de risque)",
    current_color: "Couleur actuelle :",
    color_reason_placeholder: "Pourquoi changes-tu la couleur ?",
    state_reason_placeholder: "Pourquoi changes-tu le statut ?",
    color_change_note: "La modification de la couleur",
    color_change_note_b: "ne",
    color_change_note_2: "publie pas, ne masque pas, n'archive pas et ne supprime pas le signalement — elle change seulement le niveau de risque visible sur la carte et dans les filtres. Historique enregistré.",
    apply: "Appliquer",
    delete_report_title: "Supprimer le signalement ?",
    delete_report_desc: "Cette action supprime définitivement le signalement, les photos et le chat associés. Elle ne peut pas être annulée.",
    load_error: "Erreur de chargement",
    approved: "Approuvé",
    updated: "Mis à jour",
    report_updated: "Signalement mis à jour",
    role_updated: "Rôle mis à jour",
    user_updated: "Utilisateur mis à jour",
    report_deleted: "Signalement supprimé",
    report_reopened: "Signalement réouvert",
    // Bulk selection (Lotto 3 #7/#8)
    bulk_select_all: "Tout sélectionner",
    bulk_selected_of: "{n} sur {total} sélectionnés",
    bulk_select_row: "Sélectionner cette ligne",
    bulk_clear_selection: "Désélectionner",
    bulk_delete_confirm_title: "Supprimer les éléments sélectionnés ?",
    bulk_delete_confirm_body: "Vous êtes sur le point de supprimer définitivement {n} éléments. L'action est irréversible.",
    bulk_deleted_ok: "{n} éléments supprimés",
    bulk_updated_ok: "{n} éléments mis à jour",
    bulk_notif_mark_read: "Marquer comme lues",
    bulk_notif_archive: "Archiver",
    no_donations: "Aucun don enregistré.",
    mod_logs: "Logs de modération",
    no_logs: "Aucun log disponible.",
    leaderboard_h: "Qui laisse sa marque.",
    leaderboard_empty: "Aucun membre actif pour l'instant.",
    thanks_donation: "Merci de tout cœur !",
    donation_recorded: "Ton don de {amount} € a été enregistré.",
    confirming: "Confirmation…",
    waiting_stripe: "Nous attendons la confirmation de Stripe.",
    payment_cancelled: "Paiement annulé",
    no_charge: "Aucun débit effectué.",
    back_to_map_btn: "Retour à la carte",
    stat_reports_created: "Signalements créés",
    stat_confirmations_made: "Confirmations fournies",
    stat_reputation: "Réputation",
    back: "Retour",
    sub_small_pile: "Petit tas",
    sub_bags: "Sacs de déchets",
    sub_plastic: "Plastique",
    sub_glass: "Verre",
    sub_paper: "Papier",
    sub_organic: "Organique",
    sub_tires: "Pneus",
    sub_appliances: "Électroménager",
    sub_furniture: "Meubles",
    sub_construction: "Matériaux de construction",
    sub_industrial: "Déchets industriels",
    sub_hazardous: "Déchets dangereux",
    sub_asbestos: "Amiante",
    sub_chemicals: "Produits chimiques",
    sub_oil: "Huiles",
    sub_batteries: "Piles",
    sub_illegal_dump: "Décharge sauvage",
    sub_marine: "Déchets marins",
    sub_river: "Déchets en rivière",
    sub_forest: "Déchets en forêt",
    sub_sewage_spill: "Déversement d'eaux usées",
    sub_medical_waste: "Déchets médicaux",
    sub_explosive_flammable: "Explosifs / inflammables",
    sub_water_pollution: "Pollution de l'eau",
    sub_soil_pollution: "Pollution du sol",
    sub_suspicious_discharge: "Rejet suspect",
    sub_smoke_emissions: "Émissions de fumée",
    sub_fire: "Incendie",
    sub_fire_damage: "Dégâts d'incendie",
    sub_damaged_trees: "Arbres endommagés",
    sub_degraded_green: "Espaces verts dégradés",
    sub_water_leak: "Fuite d'eau",
    sub_erosion: "Érosion",
    sub_contamination: "Contamination",
    sub_beach_coast_degradation: "Dégradation côtière",
    sub_injured: "Animal blessé",
    sub_abandoned: "Animal abandonné",
    sub_trapped: "Animal piégé",
    sub_in_danger: "Animal en danger",
    sub_suspected_mistreatment: "Suspicion de maltraitance",
    sub_poor_conditions: "Conditions précaires",
    sub_wildlife_distress: "Faune en détresse",
    sub_broken_light: "Lampadaire cassé",
    sub_broken_bench: "Banc cassé",
    sub_damaged_playground: "Aire de jeux endommagée",
    sub_pothole: "Nid-de-poule",
    sub_architectural_barrier: "Barrière architecturale",
    sub_dangerous_sidewalk: "Trottoir dangereux",
    sub_broken_signage: "Signalisation cassée",
    sub_abandoned_public: "Bâtiment public abandonné",
    sub_vandalism: "Vandalisme",
    sub_other: "Autre",
    sub_tall_grass: "Herbe haute",
    sub_brambles: "Ronces",
    sub_dangerous_branches: "Branches dangereuses",
    sub_obstructing_visibility: "Obstrue la visibilité",
    sub_fallen_tree: "Arbre tombé",
    sub_invasive_plants: "Plantes invasives",
    sub_road_encroachment: "Empiètement sur la chaussée",
    sub_bed: "Lit",
    sub_mattress: "Matelas",
    sub_table: "Table",
    sub_chair: "Chaise",
    sub_wardrobe: "Armoire",
    sub_sofa: "Canapé",
    sub_home_decor: "Objets de décoration",
    sub_appliance: "Électroménager",
    sub_electronics: "Électronique",
    sub_computer: "Ordinateur",
    sub_bicycle: "Vélo",
    sub_tools: "Outils",
    sub_clothing: "Vêtements",
    sub_toys: "Jouets",
    sub_construction_materials: "Matériaux de construction",
    sub_books: "Livres",
    take_photo: "Prendre une photo",
    from_gallery: "Choisir depuis la galerie",
    camera_permission_denied: "Permission caméra refusée. Tu peux quand même choisir une photo depuis la galerie.",
    suggested_color: "Couleur suggérée",
    severity: "Gravité",
    urgency: "Urgence",
    confidence: "Confiance",
    trust: "Fiabilité",
    coherence: "Photo↔texte",
    ai_action: "Action suggérée",
    add_photo: "Ajouter une photo",
    add_photo_desc: "Documente les dégradations, changements, avancement des travaux ou résolution.",
    add_photo_note: "Note optionnelle",
    add_photo_note_placeholder: "Ex. dégradé après la pluie, ou presque résolu…",
    add_photo_confirm: "Ajouter",
    add_photo_success: "Photo ajoutée",
    add_photo_pending: "Photo envoyée en révision admin (contenu ou cohérence à vérifier)",
    add_photo_failed: "Ajout échoué",
    additional_photos: "Photos supplémentaires",
    pending_review: "En révision",
    urgent_alert: "Alerte urgente temporaire",
    urgent_new: "Nouvelle alerte urgente",
    urgent_desc: "Signale un problème temporaire (appâts suspects, obstacles, branche tombée, inondation, fumée, substance dangereuse…).",
    urgent_duration: "Durée",
    urgent_radius: "Rayon (m)",
    urgent_other: "Autre alerte urgente",
    urgent_free_desc: "Décris librement le problème et pourquoi il est urgent et temporaire",
    urgent_submit: "Publier l'alerte",
    urgent_created: "Alerte publiée",
    urgent_state_active: "Active",
    urgent_state_expired: "Expirée — à vérifier",
    urgent_state_resolved: "Résolue",
    urgent_state_archived: "Archivée",
    urgent_state_pending: "En révision",
    urgent_still_present: "Je confirme que c'est encore présent",
    urgent_not_present: "Ce n'est plus présent",
    urgent_time_remaining: "Temps restant",
    urgent_extend: "Prolonger",
    urgent_expired: "Expirée",
    fab_urgent: "Événement extraordinaire",
    fab_event: "Nouvel événement extraordinaire",
    extraordinary_event: "Événement extraordinaire",
    extraordinary_events: "Événements extraordinaires",
    urgent_alerts_list: "Événements extraordinaires actifs",
    no_urgent_alerts: "Aucun événement extraordinaire actif.",
    ai_panel_title: "Analyse IA (GPT-5.2)",
    ai_problem: "Problème reconnu",
    ai_reason: "Motivation",
    ai_act_publish_auto: "Publication automatique",
    ai_act_review_admin: "Révision admin",
    ai_act_reject: "Refuser",
    legal_badge: "légal",
    filter_urgent_alerts: "Événements extraordinaires",
    filter_extraordinary_events: "Événements extraordinaires",
    event_kind_wildfire: "Feu de forêt",
    event_kind_flood: "Inondation",
    event_kind_river_overflow: "Débordement / crue",
    event_kind_landslide: "Glissement de terrain",
    event_kind_storm: "Tempête exceptionnelle",
    event_kind_hailstorm: "Grêle exceptionnelle",
    event_kind_tornado: "Tornade",
    event_kind_heavy_snow: "Forte chute de neige",
    event_kind_avalanche: "Avalanche",
    event_kind_sea_storm: "Tempête maritime",
    event_kind_heatwave: "Vague de chaleur",
    event_kind_coldwave: "Vague de froid",
    urgent_pending_approval: "En attente d'approbation",
    urgent_approved: "Alerte approuvée",
    urgent_rejected: "Alerte refusée",
    approve_urgent: "Approuver l'alerte",
    reject_urgent: "Refuser l'alerte",
    urgent_map_pick: "Déplace la carte et touche pour sélectionner le point",
    urgent_center_me: "Centrer sur ma position",
    urgent_short_explanation: "Utilise cette fonction pour signaler un problème urgent mais temporaire. Indique le problème, la position, le rayon de la zone concernée et choisis la durée de l'alerte. Après l'approbation de l'Admin, l'alerte sera visible avec un compte à rebours jusqu'à l'expiration.",
    notifications: "Notifications",
    notif_empty: "Aucune notification.",
    notif_gone: "Notification plus disponible",
    notif_mark_read: "Marquer comme lue",
    notif_mark_unread: "Marquer comme non lue",
    notif_archive: "Archiver",
    notif_delete: "Supprimer",
    notif_open: "Ouvrir",
    notif_all_read: "Tout marquer comme lu",
    notif_view_all: "Voir toutes les notifications",
    extensions_pending: "Prolongations en attente",
    no_extensions_pending: "Aucune prolongation à approuver.",
    photos_pending: "Photos en révision",
    admin_home_title: "Vue d'ensemble modération",
    admin_home_desc: "Sélectionne une section pour commencer.",
    admin_card_red: "Rouges",
    admin_card_yellow: "Jaunes",
    admin_card_green: "Vertes",
    admin_card_photos_review: "Modération admin",
    admin_card_urgent: "Événements extraordinaires",
    admin_section_others: "Autre",
    admin_others_desc: "Utilisateurs · Retours · Dons · Chat · Logs · Archive · Paramètres",
    admin_tab_users: "Utilisateurs",
    admin_tab_feedback: "Retours",
    admin_tab_donations: "Dons",
    admin_tab_logs: "Logs",
    admin_tab_archive: "Archive",
    admin_tab_settings: "Paramètres",
    admin_filter_status: "Filtrer par statut",
    admin_st_in_progress: "En cours",
    admin_st_pending_approval: "En attente d'approbation",
    admin_st_approved: "Approuvées",
    admin_st_archived: "Archivées",
    admin_st_all: "Toutes",
    admin_urgent_state_pending: "À approuver",
    admin_urgent_state_active: "Actifs",
    admin_urgent_state_expired: "Expirés — à vérifier",
    admin_urgent_ext_pending: "Prolongations en attente",
    admin_urgent_state_archived: "Archivés",
    admin_urgent_state_rejected: "Refusés",
    admin_urgent_state_all: "Tous",
    advanced_filters: "Filtres avancés",
    filter_search_placeholder: "Rechercher par titre, description, auteur, lieu ou ID",
    filter_ai_conf: "Confiance IA",
    filter_sensitive: "Contenus sensibles",
    filter_legal: "Problèmes juridiques possibles",
    photos_review_title: "Modération admin",
    photos_review_empty: "Aucune photo à réviser.",
    photos_review_source: "Provenance",
    photos_review_reason: "Motif",
    photos_review_priority: "Priorité",
    src_new_report: "Nouveau signalement",
    src_added_photo: "Photo ajoutée",
    src_urgent: "Alerte urgente",
    src_extension: "Demande de prolongation",
    reason_photo_incoherent: "Photo incohérente",
    reason_photo_text_incoherent: "Photo et description incohérentes",
    reason_category_mismatch: "Catégorie incorrecte",
    reason_subcategory_mismatch: "Sous-catégorie incorrecte",
    reason_severity_higher: "Gravité supérieure",
    reason_color_mismatch: "Couleur incohérente",
    reason_sensitive_content: "Contenu sensible",
    reason_legal_issues: "Problème juridique possible",
    reason_spam_or_irrelevant: "Spam ou non pertinent",
    reason_low_ai_confidence: "Faible confiance IA",
    reason_ai_suggests_review: "L'IA suggère une révision",
    reason_face_blur_failed: "Floutage des visages échoué",
    reason_face_blur_uncertain: "Floutage des visages incertain",
    reason_red_requires_approval: "Rouge : approbation requise",
    reason_sensitive_animal_category: "Sous-catégorie animale sensible",
    reason_possibly_criminal_content: "Possible scène de crime",
    publish_as_green: "Publier comme Verte",
    publish_as_yellow: "Publier comme Jaune",
    publish_as_red: "Publier comme Rouge",
    photo_approved_as_color: "Photo approuvée et publiée comme {color}",
    original_unavailable: "Original non disponible",
    original_unavailable_hint: "Original non disponible — vous pouvez tout de même appliquer un floutage supplémentaire sur la version actuelle.",
    admin_card_events: "Événements extraordinaires",
    total: "totaux",
    admin_card_marketplace: "Marketplace",
    mk_type_sale: "À vendre",
    mk_type_gift: "Don",
    mk_type_reusable: "Réutilisable trouvé",
    mk_st_published: "Actif",
    mk_st_archived: "Archivé",
    mk_st_closed: "Conclu",
    mk_st_pending: "En attente",
    mk_search_placeholder: "Rechercher titre, auteur, province…",
    mk_empty: "Aucune annonce dans cette vue",
    mk_admin_details: "Détails admin",
    mk_found_checks_title: "Confirmations utilisateurs",
    mk_found_present: "Objet présent",
    mk_found_not_present: "Objet non présent",
    mk_found_present_short: "Présent",
    mk_found_not_present_short: "Non présent",
    mk_found_no_checks: "Aucune confirmation pour le moment.",
    mk_found_check_saved: "Merci ! Votre confirmation a été enregistrée.",
    mk_found_intro: "Vous êtes allé sur place ? Aidez la communauté en signalant si l'objet est toujours là.",
    mk_found_note_optional: "Note (facultatif)",
    delete_listing_title: "Supprimer l'annonce",
    delete_listing_desc: "L'annonce sera supprimée définitivement. Cette action est irréversible.",
    reactivate: "Réactiver",
    reactivated: "Réactivé",
    close: "Fermer",
    chat_translate: "Traduire",
    chat_show_original: "Afficher l'original",
    chat_translated_badge: "traduction automatique",
    chat_translating: "Traduction en cours…",
    chat_translate_error: "Échec de la traduction",
    report_user: "Signaler l'utilisateur",
    report_user_title: "Signaler cet utilisateur",
    report_user_reason: "Motif",
    ur_reason_spam: "Spam",
    ur_reason_offensive: "Langage offensant",
    ur_reason_harassment: "Harcèlement ou menaces",
    ur_reason_misleading: "Contenus faux ou trompeurs",
    ur_reason_bad_chat: "Comportement inapproprié dans les chats",
    ur_reason_misuse: "Usage inapproprié de l'appli",
    ur_reason_false_reports: "Signalements répétés faux",
    ur_reason_other: "Autre motif",
    report_user_explanation: "Brève explication (facultatif)",
    report_user_send: "Envoyer le signalement",
    report_user_sent: "Signalement envoyé en privé",
    report_user_privacy: "Le signalement est privé et ne sera pas montré à l'utilisateur signalé.",
    admin_tab_user_reports: "Signalements d'utilisateurs",
    ur_status_new: "Nouveaux",
    ur_status_in_review: "En révision",
    ur_status_resolved: "Résolus",
    ur_status_archived: "Archivés",
    ur_status_rejected: "Refusés",
    ur_status_all: "Tous",
    ur_reports_count: "Précédents",
    ur_action_warn: "Avertissement",
    ur_action_limit_chat: "Limiter le chat",
    ur_action_limit_publish: "Limiter les publications",
    ur_action_suspend: "Suspendre temporairement",
    ur_action_ban: "Bloquer le compte",
    ur_action_close: "Archiver sans sanction",
    ur_action_hours: "Durée (heures)",
    ur_open_context: "Ouvrir le contexte",
    ur_no_items: "Aucun signalement d'utilisateur.",
    confirm_choose_status: "Choisis le statut",
    confirm_in_progress: "En cours",
    confirm_worse: "Dégradée",
    confirm_undo: "Annuler la confirmation",
    confirm_change_title: "Modifier la confirmation",
    confirm_change_desc: "Veux-tu modifier ta confirmation de \"{from}\" à \"{to}\" ?",
    confirm_change_ok: "Oui, modifier",
    confirm_your_current: "Ta confirmation actuelle",
    manual_blur: "Flouter manuellement",
    manual_blur_title: "Éditeur de floutage",
    manual_blur_desc: "Dessine des rectangles sur les zones sensibles. Les photos ne sont publiées qu'après l'enregistrement.",
    manual_blur_mode_blur: "Floutage",
    manual_blur_mode_pixel: "Pixelisation",
    manual_blur_undo: "Annuler",
    manual_blur_redo: "Rétablir",
    manual_blur_clear: "Tout effacer",
    manual_blur_save: "Enregistrer la version floutée",
    manual_blur_saved: "Version floutée enregistrée",
    manual_blur_no_regions: "Ajoute au moins une zone avant d'enregistrer.",
    manual_blur_hint: "Clique et fais glisser pour dessiner. Fais glisser le bord pour redimensionner. Double-clic pour supprimer.",
    download_original: "Télécharger l'original",
    upload_replacement: "Téléverser la version floutée",
    replacement_uploaded: "Version remplacée",
    admin_only_action: "Réservé aux admins autorisés",
    sub_gift: "Objet à offrir",
    nav_reforestation: "Reforestation",
    share: "Partager",
    deleted_user_label: "Utilisateur supprimé",
    copy_link: "Copier le lien",
    copy_link_ok: "Lien copié dans le presse-papiers",
    copy_link_err: "Copie impossible",
    filter_area: "Province / zone administrative",
    notif_type_chat_message: "Nouveau message en chat",
    notif_type_report_update: "Mise à jour du signalement",
    notif_type_photo_approved: "Photo approuvée",
    notif_type_photo_rejected: "Photo refusée",
    notif_type_photo_review: "Photo en révision",
    notif_type_urgent_approved: "Alerte approuvée",
    notif_type_urgent_rejected: "Alerte refusée",
    notif_type_urgent_expiring: "Alerte en fin de validité",
    notif_type_report_status: "Changement de statut du signalement",
    notif_type_content_report_resolved: "Signalement de contenu traité",
    notif_type_content_report_dismissed: "Signalement de contenu examiné",
    notif_type_new_feedback: "Nouveau retour",
    notif_type_new_urgent: "Nouvelle alerte urgente à approuver",
    notif_type_new_red: "Nouveau signalement rouge",
    notif_type_photo_pending: "Photo à réviser",
    notif_type_face_uncertain: "Visages à vérifier",
    notif_type_manual_mod: "Modération manuelle requise",
    notif_type_sensitive: "Contenu sensible",
    notif_type_legal: "Problèmes légaux possibles",
    notif_type_severe: "Signalement très grave",
    tour_start: "Guide rapide",
    tour_next: "Suivant",
    tour_prev: "Précédent",
    tour_skip: "Passer",
    tour_close: "Fermer le guide",
    tour_dont_show: "Ne plus afficher",
    tour_restart: "Redémarrer le guide",
    tour_step1_title: "Bienvenue sur ToClean",
    tour_step1_desc: "On te montre comment ça marche en quelques secondes. Tu peux passer à tout moment.",
    tour_step2_title: "Crée un signalement",
    tour_step2_desc: "Utilise le bouton vert pour signaler un problème environnemental, urbain ou lié aux animaux.",
    tour_step3_title: "Ouvre un signalement",
    tour_step3_desc: "Touche un marqueur sur la carte pour ouvrir la fiche du signalement.",
    tour_step4_title: "Suis et participe",
    tour_step4_desc: "Dans le chat du signalement, tu peux écrire des messages, coordonner des interventions et recevoir des mises à jour.",
    tour_step5_title: "Marketplace",
    tour_step5_desc: "Vends, offre ou signale des objets réutilisables trouvés. Appuie sur le bouton Publier et choisis la catégorie.",
    tour_step6_title: "Événements extraordinaires",
    tour_step6_desc: "Signale des urgences à grande échelle comme des incendies, inondations ou tempêtes en dessinant la zone sur la carte. Les publications suivent les permissions et la modération prévues par le rôle de l'utilisateur.",
    tour_step7_title: "Confirme ou dément",
    tour_step7_desc: "Si tu es sur place, tu peux confirmer que le problème est encore présent ou signaler sa résolution.",
    swipe_values_kicker: "Ensemble, on change vraiment",
    swipe_values_title: "Un petit geste, un impact réel sur le territoire.",
    swipe_value_1_title: "Signale un problème",
    swipe_value_1_desc: "Prends une photo, ajoute la position et publie : ton signalement est géolocalisé et visible par tous.",
    swipe_value_2_title: "Suis ce qui se passe sur ton territoire",
    swipe_value_2_desc: "Carte en temps réel, alertes urgentes et classements des zones les plus actives.",
    swipe_value_3_title: "Contribue à la solution",
    swipe_value_3_desc: "Vérifie, confirme la résolution ou fais un don à un vrai projet de reforestation.",
    swipe_cta_enter: "Entre dans ToClean",
    swipe_cta_hint: "Tu peux explorer la carte sans t'inscrire.",
    map_status_all: "Tous les statuts",
    map_status_selected: "{n} statuts sélectionnés",
    map_legend_hint_in_filter: "La légende s'ouvre depuis le bouton en bas à gauche de la carte.",
    cat_reusable_found: "Objets réutilisables trouvés",
    cat_gift: "Objets à offrir",
    cat_sale: "Objets en vente",
    guest_gate_action: "Pour continuer, tu dois te connecter ou t'inscrire.",
    guest_gate_category_hidden: "Pour voir cette section, tu dois te connecter ou t'inscrire.",
    guest_gate_marketplace: "Pour voir cette section, tu dois te connecter ou t'inscrire.",
    guest_gate_title: "Connexion requise",
    guest_gate_login: "Se connecter",
    guest_gate_signup: "S'inscrire",
    cw_intro: "Réponds à quelques questions : on te proposera la bonne couleur.",
    cw_step_label: "Étape {n}",
    cw_examples: "Exemples",
    cw_yes: "Oui",
    cw_no: "Non",
    cw_unsure: "Je ne suis pas sûr",
    cw_restart: "Refaire le test",
    cw_q1: "La situation met-elle en danger, en ce moment même, la vie ou la sécurité de personnes ou d'animaux ?",
    cw_q1_examples: "Incendie actif, animal piégé, glissement de terrain ou inondation avec des personnes impliquées.",
    cw_q1_reason: "Danger immédiat pour les personnes ou les animaux.",
    cw_q2: "Vois-tu une fuite, une dispersion ou une émission de substances dangereuses dans l'eau, le sol ou l'air ?",
    cw_q2_examples: "Carburants, huiles, produits chimiques, fumées toxiques, amiante endommagé, bidons qui fuient, mortalité soudaine de poissons ou d'oiseaux, dommage grave à l'écosystème même de cause inconnue.",
    cw_q2_reason: "Contamination environnementale grave, active ou difficile à réparer.",
    cw_q3: "Le problème est-il étendu, peut-il empirer ou nécessite-t-il une intervention spécialisée ?",
    cw_q3_examples: "Grande décharge, arbre menaçant, déchets électroniques, seringues, cours d'eau visiblement pollué.",
    cw_q3_reason: "Problème sérieux, étendu ou nécessitant du personnel spécialisé.",
    cw_q4: "Le problème est-il circonscrit, sans risques évidents et résoluble avec un nettoyage ou un entretien normal ?",
    cw_q4_examples: "Petits déchets, poubelle pleine, léger dégradé, objet abandonné non dangereux.",
    cw_q4_reason: "Problème ordinaire, circonscrit et sans risques évidents.",
    cw_unsure_reason: "En cas de doute, on applique un jaune provisoire : ce sera réévalué.",
    cw_result_red: "Rouge — Priorité maximale",
    cw_result_yellow: "Jaune — Priorité moyenne",
    cw_result_green: "Vert — Priorité ordinaire",
    cw_red_admin_note: "Les signalements rouges sont toujours vérifiés par un Admin avant publication.",
    cw_required: "Complète le guide pour établir la couleur du signalement.",
    green: "Vert",
    yellow: "Jaune",
    red: "Rouge",
    urgent_1h: "1 heure",
    urgent_3h: "3 heures",
    urgent_6h: "6 heures",
    urgent_12h: "12 heures",
    urgent_24h: "24 heures",
    urg_low: "Faible",
    urg_medium: "Moyenne",
    urg_high: "Élevée",
    notif_tab_all: "Toutes",
    notif_tab_unread: "Non lues",
    notif_tab_archived: "Archivées",
  
    save_changes: "Enregistrer les modifications",
    all_categories: "Toutes les catégories",
    all_types: "Tous les types",
    reject_reason_title: "Motif du refus",
    only_photo: "Photo uniquement",
    entire_report: "Signalement complet",
    location_placeholder: "Pays, province ou commune…",
    sort_by: "Trier par",
    sort_recent: "Plus récents",
    sort_oldest: "Moins récents",
    sort_price_asc: "Prix croissant",
    sort_price_desc: "Prix décroissant",
    condition_like_new: "Comme neuf",
    condition_fair: "Correct",
    gift_delivered: "Livré",
    gift_unavailable: "Plus disponible",
    gift_reopen: "Rouvrir comme disponible",
    manage_subscriptions: "Gérer les abonnements",
    one_time: "Ponctuel",
    reject_photo_placeholder: "Ex. Visage reconnaissable non masqué correctement",
    admin_log_note: "Note pour le log Admin",
    repeat_password: "Répète le mot de passe",
    back_to_login: "Retour à la connexion",
    report_not_available: "Signalement non disponible",
    moderation_admin: "Modération admin",
    no_auto_dispatch: "Pas d'envoi automatique",
    certified_delivery: "Livraison certifiée",
    cancel_dispatch: "Annuler la préparation",
    personal_section: "Section personnelle",
    stop_following: "Arrêter de suivre",
    classifications_title: "Classements",
    concluded_events: "Événements terminés",
    past_extraordinary_events_label: "Historique événements extraordinaires",
    previous_label: "Précédent",
    next_label: "Suivant",
    assistant_label: "Assistant",
    reforestation_new_title: "Nouveau projet de reforestation",
    reforestation_update_title: "Mettre à jour le projet",
    no_chat_for_listing: "Aucun chat pour cette annonce",
    reports_list_label: "Liste des signalements",
    reset_province_filter: "Réinitialiser le filtre province",
    remove_prox_filter: "Retirer le filtre proximité",
    publish_new_tooltip: "Publier un nouveau signalement ou annonce",
    seller_actions_label: "Actions vendeur",
    selected_as_buyer_label: "Tu as été sélectionné comme acheteur",
    sort_by_field: "Trier par",
    search_placeholder_marketplace: "Titre, description, catégorie, province…",
    search_placeholder_map: "Titre, description, province…",
    clear_search: "Effacer la recherche",
    tab_territories: "Territoires",
    tab_generous: "Provinces les plus généreuses",
    most_generous_province_badge: "Province la plus généreuse",
    assistant_open_tips: "Assistant : ouvrir les conseils",
    page_tips_title: "Conseils de la page",
    delete_label: "Supprimer",
    back_label: "Retour",
    show_hide: "Afficher/masquer",
  
    announcement_status: "Statut de l'annonce",
    in_agreement: "D'accord",
    closed_listing_note: "Cette annonce est fermée. L'historique du chat reste visible mais aucun nouveau message de demande n'est autorisé.",
    reject_reason_help: "La motivation est obligatoire. La note est facultative et ne sera pas montrée à l'auteur.",
    scope_label: "Portée",
    motivation_required: "Motivation *",
    internal_note_optional: "Note (interne, facultative)",
    reject_action: "Refuser",
    confirm_reject: "Confirmer le refus",
    chi_siamo: "Qui sommes-nous",
    la_nostra_missione: "Notre mission",
    search_marketplace_placeholder: "Titre, description, catégorie, province…",
    search_map_placeholder: "Titre, description, province…",
    type_specific_label: "Type spécifique",
    reset_password: "Réinitialiser le mot de passe",
    declare_event_ended_title: "Déclarer l'événement terminé",
    new_reforestation_project: "Nouveau projet de reboisement",
    update_reforestation_project: "Mettre à jour le projet",
    no_chat_yet: "Aucun chat pour cette annonce",
    extraordinary_events_history: "Historique des événements extraordinaires",
    province_label: "Province",
  
    category_first: "D'abord la catégorie",
    subcategory_first: "D'abord la sous-catégorie",
    no_active_subscriptions: "Tu n'as pas encore d'abonnements actifs.",
    monthly: "Mensuel",
    near_me: "Près de moi",
    near_me_activate: "Près de moi (active la localisation)",
    lb_subtitle: "Comparaison positive — on mise sur les résultats et la participation, pas sur les problèmes.",
    period_week: "Semaine",
    period_month: "Mois",
    period_year: "Année",
    period_all: "Général",
    assistant_status_on: "Assistant : Actif",
    assistant_status_off: "Assistant : Inactif",
    on: "Active",
    off: "Désactive",
    reforestation_new_project_title: "Nouveau projet de reforestation",
    reforestation_update_project_title: "Mettre à jour le projet",
    declare_event_ended_title_v2: "Déclarer l'événement terminé",
    reject_motivation_title: "Motif du refus",
    past_events_kicker: "Historique des événements extraordinaires",
    events_ended: "Événements terminés",
    search_by_word: "Chercher par mot",
    category_marketplace: "Catégorie · Marketplace",
    min_currency: "Min €",
    max_currency: "Max €",
    condition_all: "Toutes",
    condition_new: "Neuf",
    condition_good_v2: "Bon",
    condition_used: "Usagé",
    condition_negotiable: "Négociable",
    condition_label: "Condition",
    score_label: "Score",
    no_data_period: "Aucune donnée pour la période sélectionnée.",
    no_donations_period: "Aucun don enregistré dans la période sélectionnée.",
    sale_price_only: "Prix (seulement Vente)",
    price_min_gt_max: "Le minimum est supérieur au maximum : on applique quand même l'intervalle correct.",
    publish_new_report_tooltip: "Publier un nouveau signalement ou annonce",
    show_hide_label: "Afficher/masquer",
    activate_position_note: "active la localisation",
  
    nav_marketplace: "Marketplace",
  
    backend_unauthorized: "Non autorisé",
    backend_user_not_found: "Utilisateur introuvable",
    backend_invalid_credentials: "Identifiants invalides",
    backend_email_already_registered: "Email déjà enregistré",
    backend_report_not_found: "Signalement introuvable",
    backend_listing_not_found: "Annonce introuvable",
    backend_event_not_found: "Événement introuvable",
    backend_project_not_found: "Projet introuvable",
    backend_invalid_session: "Session invalide",
    backend_token_expired: "Token expiré",
    backend_bad_request: "Requête invalide",
    backend_server_error: "Erreur interne du serveur",
    backend_operation_completed: "Opération terminée",
    backend_saved: "Enregistré",
    backend_updated: "Mis à jour",
    backend_deleted: "Supprimé",
    backend_published: "Publié",
    backend_config_incomplete: "Configuration incomplète",
    backend_forbidden: "Permissions insuffisantes",
    backend_file_too_large: "Fichier trop volumineux",
    backend_file_bad_format: "Format de fichier non supporté",
    backend_photo_required: "Photo obligatoire",
    backend_location_required: "Position obligatoire",
    backend_category_required: "Catégorie obligatoire",
    backend_title_required: "Titre obligatoire",
    backend_description_required: "Description obligatoire",
    backend_amount_invalid: "Montant invalide",
    backend_password_too_short: "Mot de passe trop court",
    backend_passwords_mismatch: "Mots de passe non identiques",
    backend_email_invalid: "Email invalide",
    backend_too_many_attempts: "Trop de tentatives. Réessaie plus tard.",
    admin_verified_entities: "Organismes vérifiés",
    admin_verified_entities_super: "Organismes vérifiés (Super Admin)",
    admin_management: "Gestion Admin",
    admin_management_super: "Gestion Admin (Super Admin)",
    admin_reset_super_password: "Réinitialiser mot de passe Super Admin",
    admin_content_pages: "Pages de contenu (Mission / Qui sommes-nous)",
    admin_pec_config: "Configuration PEC",
    admin_reforestation_manage: "Reforestation — gestion des projets",
    admin_reject_dialog_title: "Motif du refus",
    admin_reject_reason_help: "Le motif est obligatoire. La note est facultative et ne sera pas montrée à l'auteur.",
    admin_scope_label: "Portée",
    admin_reason_required: "Motif *",
    admin_internal_note: "Note (interne, facultative)",
    admin_moderation_label: "Modération admin",
    admin_pec_required_msg: "Configuration PEC nécessaire. Tu peux préparer et visualiser l'aperçu, mais l'envoi sera bloqué tant que le Super Admin n'aura pas complété la configuration.",
    admin_pec_locked_msg: "Configuration PEC nécessaire. Tant que tu n'as pas rempli tous les champs, les envois de PEC restent bloqués.",
    admin_no_auto_dispatch: "Aucun envoi automatique",
    admin_certified_delivery: "Remise certifiée",
    admin_save_changes: "Enregistrer les modifications",
    admin_cancel_dispatch: "Annuler la préparation",
    admin_declare_event_ended: "Déclarer l'événement terminé",
    admin_reforestation_new: "Nouveau projet de reforestation",
    admin_reforestation_update: "Mettre à jour le projet",
    admin_content_edit_desc: "Modifie le texte de \"Notre mission\" et \"Qui sommes-nous\" sans toucher au code. Si une page n'est pas publiée, les utilisateurs voient les contenus par défaut ou un placeholder sobre.",
    admin_password_reset_title: "Réinitialiser le mot de passe",
    admin_new_password: "Nouveau mot de passe",
    admin_repeat_password: "Répéter le mot de passe",
    admin_back_to_login: "Retour à la connexion",
    admin_stop_following: "Arrêter de suivre",
    admin_seller_actions: "Actions vendeur",
    admin_buyer_selected: "Tu as été sélectionné comme acheteur",
    admin_no_chat_yet: "Aucun chat pour cette annonce",
    admin_publish_new_report: "Publier un nouveau signalement ou annonce",
    admin_reset_province_filter: "Réinitialiser le filtre province",
    admin_reports_list: "Liste des signalements",
    admin_country_province_place: "Pays, province ou commune…",
    admin_content_placeholder_desc: "Un nom/rôle par ligne (ex. Marie Dupont — Fondatrice)",
    admin_content_placeholder_contact: "Email, PEC, adresse, réseaux sociaux…",
  
    create: "Créer",
    confirm_conclusion: "Confirmer la clôture",
    optional_note_followers: "Note facultative (affichée aux abonnés)",
    admin_reset_super_password_confirm: "Générer un lien de réinitialisation de mot de passe pour ton compte Super Admin ? Le lien est à usage unique et expire dans 15 minutes. Tu seras redirigé immédiatement vers l'écran de choix du mot de passe.",
  
    be_ai_not_configured: "IA non configurée",
    be_account_sospeso_o_bannato: "Compte suspendu ou banni",
    be_admin_only: "Admins uniquement",
    be_admin_role_required: "Rôle admin requis",
    be_alert_not_found: "Alerte introuvable",
    be_almeno_un_tra_ritiro_e_spedizione_deve_essere_selezionato: "Sélectionne au moins retrait ou livraison",
    be_amount_out_of_range_min_0_50_max_100000: "Montant hors limite (min 0,50€, max 100000€)",
    be_cannot_report_yourself: "Tu ne peux pas te signaler toi-même",
    be_duplicate_report_please_wait_before_re_reporting_the_same_co: "Signalement en double — attends avant de signaler à nouveau",
    be_duration_must_be_1_3_6_12_or_24_hours: "La durée doit être 1, 3, 6, 12 ou 24 heures",
    be_email_already_registered: "Email déjà enregistré",
    be_email_gi_in_uso: "Email déjà utilisé",
    be_evento_non_attivo: "Événement inactif",
    be_extension_not_found: "Extension introuvable",
    be_failed_to_upload_blurred_version: "Échec de l'envoi de la version floutée",
    be_file_too_large_max_8mb: "Fichier trop lourd (max 8 Mo)",
    be_forbidden: "Interdit",
    be_il_nome_della_ricerca_obbligatorio: "Le nom de la recherche est obligatoire",
    be_il_prezzo_obbligatorio_per_vendo: "Le prix est obligatoire pour Vends",
    be_invalid_action: "Action invalide",
    be_invalid_category: "Catégorie invalide",
    be_invalid_credentials: "Identifiants invalides",
    be_invalid_image: "Image invalide",
    be_invalid_reason: "Raison invalide",
    be_invalid_risk_level: "Niveau de risque invalide",
    be_invalid_role: "Rôle invalide",
    be_invalid_session: "Session invalide",
    be_invalid_status: "Statut invalide",
    be_la_nuova_password_deve_avere_almeno_6_caratteri: "Le nouveau mot de passe doit avoir au moins 6 caractères",
    be_la_nuova_password_deve_avere_almeno_8_caratteri: "Le nouveau mot de passe doit avoir au moins 8 caractères",
    be_la_password_deve_avere_almeno_6_caratteri: "Le mot de passe doit avoir au moins 6 caractères",
    be_la_segnalazione_deve_essere_approvata_pubblicata_prima: "Le signalement doit d'abord être approuvé/publié",
    be_le_chat_non_sono_previste_per_gli_oggetti_riutilizzabili_tro: "Pas de chat pour les objets réutilisables trouvés",
    be_login_required_for_this_category: "Connexion requise pour cette catégorie",
    be_message_cannot_be_empty: "Le message ne peut pas être vide",
    be_message_not_found: "Message introuvable",
    be_messaggio_troppo_breve: "Message trop court",
    be_motivazione_obbligatoria: "Justification obligatoire",
    be_moderation_note_required: "Motivation obligatoire (min 10 caractères).",
    ur_note_required_prompt: "Motivation de la mesure (obligatoire, min 10 caractères) :",
    ur_note_required_toast: "Motivation obligatoire (min 10 caractères).",
    be_nessun_abbonamento_trovato_per_questo_utente: "Aucun abonnement trouvé pour cet utilisateur",
    be_nessuna_richiesta_di_conferma_attiva: "Aucune demande de confirmation active",
    be_non_annullabile_dispatch_gi_inviato: "Non annulable : envoi déjà effectué",
    be_non_modificabile_dispatch_gi_inviato: "Non modifiable : envoi déjà effectué",
    be_non_puoi_rimuovere_il_tuo_ruolo_admin: "Tu ne peux pas retirer ton rôle Admin",
    be_non_puoi_seguire_un_annuncio_di_cui_sei_il_proprietario: "Tu ne peux pas suivre ta propre annonce",
    be_not_a_reusable_item_report: "Ce n'est pas un signalement d'objet réutilisable",
    be_not_authenticated: "Non authentifié",
    be_not_found: "Introuvable",
    be_notification_has_no_actionable_target: "Cette notification n'a pas de cible actionnable",
    be_notification_not_found: "Notification introuvable",
    be_only_admin: "Admins uniquement",
    be_only_admin_can_apply_user_actions: "Seuls les admins peuvent appliquer des actions utilisateur",
    be_only_admin_can_delete_reports: "Seuls les admins peuvent supprimer des signalements",
    be_only_admin_moderator: "Admins/modérateurs uniquement",
    be_only_gift_subcategory_reports_support_this: "Seuls les signalements de sous-catégorie Don supportent ça",
    be_only_moderators_can_update_reports: "Seuls les modérateurs peuvent modifier des signalements",
    be_only_owner_or_admin_can_set_this_status: "Seul le propriétaire ou un admin peut définir ce statut",
    be_pagina_non_trovata: "Page introuvable",
    be_password_attuale_errata: "Mot de passe actuel incorrect",
    be_password_non_impostabile_per_questo_account_google: "Mot de passe non paramétrable pour ce compte (Google)",
    be_photo_not_found: "Photo introuvable",
    be_puoi_salvare_al_massimo_20_ricerche_elimina_prima_una_vecchi: "Max 20 recherches sauvegardées. Supprime-en une ancienne d'abord",
    be_recurring_donations_are_only_available_for_platform_and_refo: "Les dons récurrents sont disponibles uniquement pour la plateforme et la reforestation",
    be_report_not_found: "Signalement introuvable",
    be_ricerca_non_trovata: "Recherche introuvable",
    be_seleziona_prima_l: "Sélectionne d'abord l",
    be_sign_in_required: "Connexion requise",
    be_sign_in_required_to_view_marketplace: "Connexion requise pour voir le Marché",
    be_slug_non_valido: "Slug invalide",
    be_solo_super_admin: "Super-admins uniquement",
    be_solo_vendo: "Vends uniquement",
    be_solo_admin_o_ente_verificato: "Admins ou organismes vérifiés uniquement",
    be_solo_admin_moderator_o_ente_verificato: "Admins/modérateurs ou organismes vérifiés uniquement",
    be_solo_il_proprietario_pu_modificare: "Seul le propriétaire peut modifier",
    be_solo_il_venditore: "Vendeur uniquement",
    be_solo_l: "Uniquement l",
    be_solo_la_controparte_pu_confermare: "Seule la contrepartie peut confirmer",
    be_solo_la_controparte_pu_rifiutare: "Seule la contrepartie peut refuser",
    be_solo_super_admin_pu_assegnare_o_revocare_admin: "Seul le super-admin peut attribuer ou révoquer Admin",
    be_source_photo_not_found: "Photo source introuvable",
    be_stato_non_valido: "Statut invalide",
    be_super_admin_only: "Super-admins uniquement",
    be_target_user_not_found: "Utilisateur cible introuvable",
    be_token_non_valido_o_gi_usato: "Token invalide ou déjà utilisé",
    be_token_non_valido_o_scaduto: "Token invalide ou expiré",
    be_token_scaduto: "Token expiré",
    be_too_many_reports_in_a_short_time_try_again_later: "Trop de signalements en peu de temps — réessaie plus tard",
    be_transaction_not_found: "Transaction introuvable",
    be_translation_failed: "Échec de la traduction",
    be_unsupported_file_type: "Type de fichier non supporté",
    be_you_can_only_edit_your_own_messages: "Tu ne peux modifier que tes propres messages",
    be_already_moderated: "Déjà modéré",
    be_annuncio_concluso_la_chat_chiusa: "Annonce terminée : le chat est fermé",
    be_categoria_non_valida: "Catégorie invalide",
    be_invalid_hours: "Heures invalides",
    be_invalid_kind: "Type invalide",
    be_invalid_token: "Token invalide",
    be_invalid_type: "Type invalide",
    be_kind_must_be_one_of_resolved_in_progress_worse_undo: "Le type doit être : resolved, in_progress, worse, undo",
    be_new_path_not_found_in_files: "new_path introuvable dans les fichiers",
    be_no_changes: "Aucun changement",
    be_peer_id_richiesto_per_il_proprietario: "peer_id requis pour le propriétaire",
    be_photo_path_required: "Chemin de photo requis",
    be_photo_index_out_of_range: "Index de photo hors limites",
    be_platform_must_be_ios_android_web: "La plateforme doit être ios|android|web",
    be_polygon_needs_at_least_3_points: "Le polygone nécessite au moins 3 points",
    be_reason_required_min_5_chars: "Raison requise (min 5 caractères)",
    be_regions_required: "Régions requises",
    be_role_must_be: "Le rôle doit être",
    be_solo_vendo_ha_il_prezzo: "Seul Vends a le prix",
    be_sottocategoria_non_valida: "Sous-catégorie invalide",
    be_text_required: "Texte requis",
    be_tipo_specifico_non_valido: "Type spécifique invalide",
    be_token_required: "Token requis",
    be_utente_non_trovato: "Utilisateur introuvable",
    be_cosa_fare_ora_riservato_ad_admin_ed_enti_verificati: "« Que faire maintenant » réservé aux admins et organismes vérifiés",
  
    menu_my_listings: "Mes annonces",
    menu_following: "Suivis",
    menu_saved_searches: "Mes recherches",
    unread_messages: "messages non lus",
  
    mk_type_sale: "À vendre",
    mk_type_gift: "Don gratuit",
    mk_type_reusable: "Réutilisable trouvé",
  
    mk_title_row: "À vendre · Don · Réutilisables",
    new_listing: "Nouvelle annonce",
    guest_login_sale: "Connecte-toi pour voir les annonces à vendre.",
    tab_all: "Tout",
    mk_kicker: "MARKETPLACE",
    tip_mk_3cats: "Marketplace a trois catégories distinctes : 🟣 À vendre (avec prix, retrait/livraison), 🔵 Don gratuit (choisi par le propriétaire dans le chat), 🟤 Réutilisable trouvé (objet abandonné : premier arrivé, premier servi).",
    tip_mk_guest: "Les annonces à vendre sont visibles uniquement aux utilisateurs inscrits. Les dons et réutilisables sont visibles à tous sur la carte, mais pour contacter ou créer tu dois te connecter.",
  
    event_new_proposal: "Nouvelle proposition",
    event_extraordinary_kicker: "Événement extraordinaire",
    event_intro_line: "Signale un événement en cours sur une zone étendue (incendie, inondation, glissement, tempête, etc.).",
    event_intro_verified_pub: "Ta publication sera immédiate en tant qu'entité vérifiée.",
    event_intro_review_pub: "La proposition sera examinée par un Admin avant publication.",
    event_title_label: "Titre",
    event_kind_label: "Catégorie",
    event_whattodo_admin_only: "Que faire maintenant (Admin / entités vérifiées uniquement)",
    event_started_label: "Date et heure de début (facultatif)",
    event_publish_btn: "Publier l'événement",
    event_send_proposal_btn: "Envoyer la proposition",
    event_area_involved: "Zone concernée",
    event_area_hint: "Recherche le territoire (facultatif) et/ou clique sur la carte pour ajouter les sommets du polygone. Au moins 3 points sont requis.",
    event_territory_prefix: "Territoire",
    event_undo_last: "Annuler le dernier",
    event_clear_all: "Effacer",
    event_points_count_suffix: "points",
    event_title_required: "Le titre est obligatoire",
    event_polygon_required: "Dessine une zone d'au moins 3 points",
    event_published_ok: "Événement publié",
    event_proposal_sent: "Proposition envoyée à la revue Admin",
    event_generic_error: "Erreur",
    event_title_placeholder: "Ex. Incendie de forêt — Côte nord",
    event_desc_placeholder: "Quoi, où, depuis combien de temps",
    event_whattodo_placeholder: "Ex. Ne pas approcher. Appeler le 18. Évacuer zone X.",
    event_photos_label: "Photographies",
    add_photo_short: "Ajouter",
    mkc_description_label: "Description",
    mkc_choose_placeholder: "Choisis…",
    mkc_condition_label: "État",
    mkc_color_label: "Couleur",
    mkc_color_placeholder: "Ex. bleu, bois naturel",
    mkc_keywords_label: "Mots-clés",
    mkc_photos_label: "Photographies",
    country_or_province: "Pays, région ou commune…",
    reports_solved_kicker: "Signalements résolus",
    in_progress_kicker: "En cours",
    verified_users_kicker: "Utilisateurs vérifiés",
    close_tips: "Fermer conseils",
    what_are_you_selling: "Tu vends quoi ?",
    what_are_you_giving: "Tu donnes quoi ?",
    what_did_you_find: "T'as trouvé quoi ?",
    change_type: "Changer le type",
    publish_listing: "Publier l'annonce",
    approximate_location: "Position approximative",
    category_first_short: "D'abord la catégorie",
    mkc_new_listing_kicker: "Place de marché · Nouvelle annonce",
    mkc_what_type_heading: "Quel type d'annonce veux-tu publier ?",
    mkc_type_choice_desc: "Choisis l'une des trois modes. Chaque type a ses propres règles (prix, chat, clôture). Tu pourras modifier le choix avant de publier.",
    mkc_hint_sale: "Prix obligatoire. L'annonce n'est visible que par les utilisateurs enregistrés. Chat privé avec les acheteurs potentiels ; à la fin, toi (vendeur) et l'acheteur confirmez la conclusion.",
    mkc_hint_gift: "Tu donnes un objet à un autre utilisateur. Pas de prix. Choisis librement en chat à qui le remettre.",
    mkc_hint_reusable: "Tu signales un objet abandonné ou réutilisable que tu as trouvé. Pas de prix, pas d'attribution : premier arrivé, premier servi. Le chat est uniquement informatif.",
    mkc_subtitle_sale: "Publie une annonce de vente : prix obligatoire, retrait en main propre ou expédition, chat privé avec les acheteurs.",
    mkc_subtitle_gift: "Offre un objet à un autre utilisateur : choisis librement en chat à qui le remettre.",
    mkc_subtitle_reusable: "Signale un objet réutilisable trouvé ou abandonné : premier arrivé, premier servi. Chat uniquement informatif.",
    mkc_title_label: "Titre",
    mkc_category_label: "Catégorie",
    mkc_subcategory_label: "Sous-catégorie",
    mkc_itemtype_label: "Type spécifique",
    mkc_subcategory_first: "D'abord la sous-catégorie",
    mkc_condition_new: "Neuf",
    mkc_condition_good: "Bon",
    mkc_condition_used: "Utilisé",
    mkc_keywords_placeholder: "ikea, double, 180cm (séparés par des virgules)",
    mkc_price_label: "Prix (€)",
    mkc_negotiable: "Négociable",
    mkc_pickup: "Retrait en main propre",
    mkc_shipping: "Expédition",
    mkc_position_label: "Position approximative",
    mkc_position_hint: "Cherche le territoire (facultatif) et/ou clique sur la carte. La position publique est approximative ; l'adresse précise sera partagée en chat.",
    mkc_territory_prefix: "Territoire",
    mkc_err_title_required: "Le titre est obligatoire",
    mkc_err_taxonomy_required: "Catégorie, sous-catégorie et type spécifique sont obligatoires",
    mkc_err_position_required: "Sélectionne la position approximative sur la carte",
    mkc_err_price_required: "Le prix est obligatoire",
    mkc_success_published: "Annonce publiée",
    mkc_err_generic: "Erreur",
    mkc_upload_failed: "Envoi échoué",
    map_reports_list_title: "Liste des signalements",
    map_within_km: "dans un rayon de {km} km",
    map_within_area: "à {area}",
    map_count_results: "résultats",
    map_count_reports: "signalements",
    map_clear_area_filter: "Réinitialiser le filtre province",
    details_arrow: "Détails →",
    events_popup_state_prefix: "État",
    mk_popup_following: "✓ Suivi",
    mk_popup_follow: "🔔 Suivre",
    events_history_kicker: "Historique des événements extraordinaires",
    events_history_count_suffix: "événements",
    events_history_none: "Aucun événement trouvé.",
    legal_kicker: "Document légal",
    legal_placeholder_title: "Contenu en cours de finalisation",
    legal_placeholder_body: "Le texte définitif de ce document sera publié prochainement. Pour toute information contactez-nous à",
    legal_privacy_title: "Politique de confidentialité",
    legal_terms_title: "Conditions générales",
    legal_community_title: "Règles de la communauté",
    legal_marketplace_title: "Règles de la Place de marché",
    acct_del_kicker: "Suppression du compte",
    acct_del_title: "Supprime ton compte ToClean",
    acct_del_intro: "Tu peux demander la suppression de ton compte ToClean et des données personnelles associées à tout moment. L'action est irréversible.",
    acct_del_what_happens_title: "Ce qui se passe à la suppression",
    acct_del_what_1: "Ton compte est supprimé de la base de données.",
    acct_del_what_2: "Tes annonces de la Place de marché sont supprimées.",
    acct_del_what_3: "Tes publications et messages sont anonymisés (contenu conservé, auteur affiché comme «Utilisateur supprimé»).",
    acct_del_what_4: "Tes sessions et jetons push sont révoqués immédiatement.",
    acct_del_what_5: "Les signalements publics déjà envoyés aux autorités restent dans leur registre (obligation légale).",
    acct_del_how_signed_in_title: "Si tu es connecté",
    acct_del_how_signed_in_body: "Va dans Paramètres → «Supprimer le compte». Tu recevras une confirmation avant l'action irréversible.",
    acct_del_go_settings: "Ouvrir les paramètres",
    acct_del_how_email_title: "Si tu n'as plus accès au compte",
    acct_del_how_email_body: "Écris à info@toclean.app depuis l'email associé au compte. L'équipe ToClean traitera la demande.",
  
    tip_event_scope: "Un événement extraordinaire concerne des urgences sur une zone étendue (incendie, inondation, glissement de terrain, tempête, etc.), pas des objets isolés ou de petits signalements.",
    tip_event_polygon: "Dessine la zone sur la carte en cliquant sur les sommets du polygone : il faut au moins 3 points. Utilise «Annuler dernier» ou «Effacer» pour corriger.",
    tip_event_moderation: "Si tu n'es pas un organisme vérifié, la proposition est envoyée à la révision d'un Admin avant de devenir publique sur la carte.",
    tip_map_colors: "Les marqueurs sont colorés par risque : 🟢 Vert = ordinaire, 🟡 Jaune = à surveiller, 🔴 Rouge = urgent. La couleur est décidée par le court questionnaire lors de la création du signalement.",
    tip_map_filters: "Utilise les filtres pour choisir quels signalements ou objets afficher. La carte, la liste et le nombre de résultats se mettront à jour ensemble.",
    tip_map_duplicates: "Avant d'ouvrir un nouveau signalement, vérifie s'il en existe déjà un à proximité : ça aide à éviter les doublons et à renforcer les signalements existants.",
    tip_rc_wizard: "Les 4 questions du code couleur attribuent automatiquement Vert/Jaune/Rouge selon le risque perçu, l'urgence, l'ampleur et l'impact. Ce n'est pas un jugement : elles guident seulement la priorité de la modération.",
    tip_rc_privacy: "Tes photos sont traitées côté serveur : les visages et plaques d'immatriculation sont automatiquement floutés. La position publique est approximative : l'adresse précise reste privée.",
    tip_rc_after_photo: "Pour déclarer résolu un signalement ordinaire, tu devras par la suite ajouter une photo «après» depuis le même endroit. Un seul clic, mais indispensable pour confirmer la résolution.",
  
    publish: "Publier",
    submit_for_review: "Envoyer en révision",
    state_published: "Publiée",
    state_in_progress: "En cours",
    state_pending: "En attente",
    state_rejected: "Rejetée",
    state_draft: "Brouillon",
    state_resolved: "Résolue",
    state_closed: "Fermée",
    state_active: "Active",
    risk_green: "Vert",
    risk_yellow: "Jaune",
    risk_red: "Rouge",
    stats_reports_solved: "Signalements résolus",
    stats_reports_progress: "En cours",
    stats_users_verified: "Utilisateurs vérifiés",
  
    no_period_data: "Aucune donnée pour la période sélectionnée.",
    awaiting_counterpart: "En attente de confirmation de l'autre partie.",
    no_messages_write_first: "Aucun message : écris le premier.",
    no_chat_for_listing_msg: "Aucun chat pour cette annonce",
    // Phase 3 — chat privé (18+ uniquement)
    nav_messages: "Messages",
    chat_title: "Messages",
    chat_tab_chats: "Chats",
    chat_tab_requests: "Demandes",
    chat_tab_invites: "Invitations",
    chat_tab_blocked: "Bloqués",
    chat_empty: "Aucun chat pour l'instant.",
    chat_no_requests: "Aucune demande.",
    chat_no_invites: "Aucune invitation.",
    chat_send: "Envoyer",
    chat_composer_placeholder: "Écris un message…",
    chat_request_dialog_title: "Demander un chat privé",
    chat_request_dialog_desc: "Envoie une demande pour démarrer un chat privé. Le destinataire doit l'accepter avant que la conversation puisse commencer.",
    chat_request_send: "Envoyer la demande",
    chat_request_sent: "Demande envoyée",
    chat_message_optional_label: "Message initial (facultatif)",
    chat_message_optional_ph: "Par exemple : je suis intéressé par ton annonce…",
    chat_accept: "Accepter",
    chat_reject: "Refuser",
    chat_cancel_req: "Annuler la demande",
    chat_incoming: "Reçues",
    chat_outgoing: "Envoyées",
    chat_pending_status: "En attente",
    chat_group_create: "Créer un groupe",
    chat_group_title_label: "Titre du groupe",
    chat_group_desc_label: "Description (facultatif)",
    chat_group_invitees_label: "Inviter des utilisateurs (IDs séparés par des virgules)",
    chat_group_picker_label: "Inviter des utilisateurs",
    chat_group_picker_placeholder: "Rechercher par nom…",
    chat_group_picker_selected: "Sélectionnés",
    chat_group_picker_no_results: "Aucun utilisateur trouvé.",
    chat_group_picker_min_chars: "Saisis au moins 2 caractères.",
    chat_group_picker_add: "Ajouter",
    chat_group_picker_remove: "Retirer",
    // Phase 4 — Liens sociaux
    social_links_title: "Liens sociaux et site web",
    social_links_desc: "Facultatifs. Les liens s'afficheront sur ton profil public. ToClean ne vérifie ni ne valide les contenus externes.",
    social_links_add: "Ajouter un lien",
    social_links_platform: "Plateforme",
    social_links_url: "URL",
    social_links_label: "Étiquette (facultatif)",
    social_links_save: "Enregistrer les liens",
    social_links_saved: "Liens sociaux enregistrés",
    social_links_url_scheme_err: "L'URL doit commencer par http:// ou https://",
    social_links_url_invalid_err: "URL non valide.",
    social_links_url_too_long_err: "URL trop long.",
    social_links_adult_only: "Seuls les utilisateurs de 18 ans ou plus peuvent ajouter des liens externes.",
    social_links_none: "Aucun lien.",
    social_links_platform_website: "Site web",
    social_links_platform_other: "Autre",
    social_links_disclaimer: "Liens externes non vérifiés.",
    // Phase 4 — Vidéo
    video_upload_label: "Ajouter une vidéo",
    video_upload_hint: "Formats pris en charge : MP4, MOV, M4V, WebM (H.264 ou VP8/VP9). Maximum {mb} Mo.",
    video_uploading: "Téléversement…",
    video_upload_progress: "{p}%",
    video_upload_ok: "Vidéo téléversée",
    video_upload_err_format: "Format non pris en charge. Utilise MP4, MOV ou WebM.",
    video_upload_err_hevc: "Ta vidéo est en HEVC/H.265 et n'est pas lisible sur tous les navigateurs. Sur iPhone : Réglages → Appareil photo → Formats → \"Plus compatible\", puis réessaye.",
    hevc_help_title: "Compatibilité vidéo iPhone",
    hevc_help_desc: "Ton iPhone a enregistré cette vidéo en HEVC/H.265. Suis ces étapes pour utiliser un format compatible avec ToClean.",
    hevc_help_step1: "Ouvre Réglages",
    hevc_help_step2: "Va dans Appareil photo → Formats",
    hevc_help_step3: "Choisis \"Plus compatible\"",
    hevc_help_step4: "Enregistre une nouvelle vidéo et téléverse à nouveau",
    hevc_help_note: "Les vidéos HEVC déjà dans ta pellicule restent inchangées. Les prochaines seront en H.264/MP4 — compatibles avec ToClean et la plupart des appareils.",
    hevc_help_show: "Comment résoudre ?",
    video_upload_err_too_large: "Vidéo trop volumineuse. Limite {mb} Mo.",
    video_upload_err_generic: "Impossible de téléverser la vidéo.",
    video_delete: "Supprimer la vidéo",
    video_delete_confirm: "Supprimer cette vidéo ?",
    video_privacy_notice: "Si la vidéo montre des personnes, des plaques ou des données personnelles directement liées à un comportement présumé illicite ou nuisible, le même Privacy Prompt que pour les photos s'applique.",
    video_none: "Aucune vidéo.",
    video_removed: "Vidéo supprimée.",
    chat_group_leave: "Quitter le groupe",
    chat_group_member: "Membre",
    chat_group_pending_label: "Invitation en attente",
    chat_block_user: "Bloquer l'utilisateur",
    chat_unblock_user: "Débloquer",
    chat_blocked_list: "Utilisateurs bloqués",
    chat_report_message: "Signaler le message",
    chat_adult_only: "Les chats privés sont réservés aux utilisateurs de 18 ans ou plus.",
    chat_pending_invite_banner: "Tu dois accepter l'invitation pour voir les messages du groupe.",
    chat_open: "Ouvrir",
    chat_leave: "Quitter",
    chat_open_conversation: "Ouvrir la conversation",
    chat_error_send: "Impossible d'envoyer le message.",
    chat_group_created: "Groupe créé",
    chat_group_leave_confirm: "Es-tu sûr de vouloir quitter le groupe ?",
    chat_from: "de",
    report_unavailable: "Signalement indisponible",
    open_report_in_app: "Ouvrir le signalement dans l'app",
    content_removed: "Ce contenu a été supprimé ou n'est plus accessible.",
    no_pec_before_button: "Aucun courriel certifié n\\u2019est envoyé avant ce bouton.",
    no_reports_for_filters: "Aucun signalement ne correspond aux filtres.",
    reforestation_big_project: "Un projet aussi grand que l'avenir que nous voulons bâtir.",
    not_authorized_dot: "Non autorisé.",
    support_reforestation: "Soutiens la reforestation",
    my_searches_title: "Mes recherches",
    signup_dob_label: "Date de naissance",
    signup_dob_help: "Utilisée uniquement pour vérifier que tu as au moins 14 ans. Jamais affichée.",
    signup_terms_prefix: "J'ai lu et j'accepte les",
    signup_terms_link: "Conditions d'utilisation",
    signup_privacy_prefix: "J'ai lu et j'accepte la",
    signup_privacy_link: "Politique de confidentialité",
    signup_terms_required: "Tu dois accepter les Conditions et la Confidentialité pour t'inscrire.",
    signup_age_required: "Il faut avoir au moins 14 ans pour utiliser ToClean.",
    signup_dob_invalid: "Date de naissance invalide.",
    complete_profile_title: "Complète ton profil",
    complete_profile_desc: "Pour continuer sur ToClean confirme ton âge et accepte les conditions mises à jour. Aucune autre donnée n'est demandée.",
    complete_profile_cta: "Confirmer et continuer",
    complete_profile_age_warning: "Si tu as moins de 14 ans ton compte sera supprimé automatiquement, conformément aux règles des app stores.",
    mk_adult_only_banner: "Le Marketplace est en lecture seule avant 18 ans. Tu peux consulter les annonces mais pas publier, contacter ou suivre.",
    mk_adult_only_button_tip: "Disponible à partir de 18 ans.",
    mk_new_disabled_minor: "18 ans et +",
    report_content_btn: "Signaler",
    report_content_title: "Signaler ce contenu",
    report_content_desc: "Notre équipe de modération sera notifiée. Ton identité n'est jamais partagée avec la personne signalée.",
    report_reason_harassment: "Harcèlement ou menaces",
    report_reason_hate: "Propos haineux",
    report_reason_sexual: "Contenu sexuel non sollicité",
    report_reason_spam: "Spam ou arnaque",
    report_reason_privacy: "Violation de la vie privée",
    report_reason_illegal: "Contenu illégal",
    report_reason_impersonation: "Usurpation d'identité",
    report_reason_abuse: "Abus de la plateforme",
    report_reason_other: "Autre",
    report_content_details: "Détails (facultatif)",
    report_content_send: "Envoyer le signalement",
    report_content_sent: "Signalement envoyé. Merci.",
    block_user_btn: "Bloquer l'utilisateur",
    unblock_user_btn: "Débloquer l'utilisateur",
    block_user_confirm_title: "Bloquer cet utilisateur ?",
    block_user_confirm_desc: "Tu ne recevras plus ses messages ni son contenu. Tu peux le débloquer à tout moment depuis les Paramètres.",
    block_user_ok: "Bloqué",
    unblock_user_ok: "Débloqué",
    pp_title: "Un instant avant de publier",
    pp_question: "Rends-tu reconnaissable une personne, une plaque d'immatriculation ou d'autres données personnelles en les liant directement à un comportement présumé illicite ou nuisible ?",
    pp_answer_no: "Non",
    pp_answer_yes: "Oui",
    pp_warn_title: "Attention : vie privée, réputation et droits des personnes",
    pp_warn_body: "Rendre une personne identifiable et l'associer publiquement à des faits présumés illicites peut avoir des conséquences juridiques pour toi et pour la personne représentée : vie privée, réputation et droits personnels sont en jeu.\n\nPour cette raison, le contenu sera envoyé à ToClean pour vérification avant toute publication éventuelle.",
    pp_warn_body_review_only: "Rendre une personne identifiable et l'associer publiquement à des faits présumés illicites peut avoir des conséquences juridiques pour toi et pour la personne représentée : vie privée, réputation et droits personnels sont en jeu.\n\nPour cette raison, le contenu sera envoyé à ToClean pour vérification avant toute publication éventuelle.",
    pp_send_review: "Envoyer en révision à ToClean",
    pp_ack_label: "Je confirme être responsable des contenus et des déclarations que je publie et avoir lu l'avis concernant la vie privée, la réputation et les droits des personnes représentées.",
    pp_publish_anyway: "Publier quand même",
    pp_sent_review_toast: "Contenu envoyé en révision. On te tient au courant.",
    comment_like: "J'aime",
    comment_unlike: "Retirer J'aime",
    comment_likes_count_one: "1 j'aime",
    comment_likes_count_many: "{n} j'aime",
    comment_sort_label: "Trier",
    comment_sort_relevant: "Plus pertinents",
    comment_sort_liked: "Plus appréciés",
    comment_sort_recent: "Plus récents",
    comment_sort_oldest: "Plus anciens",
    comment_report: "Signaler le commentaire",
    admin_tab_content_reports: "Signalements de contenu",
    admin_tab_events: "Événements extraordinaires",
    what_to_do_now: "Que faire maintenant",
    reject_reason_prompt: "Motif (facultatif) :",
    delete_event_confirm: "Supprimer définitivement cet événement ?",
    cr_no_items: "Aucun signalement de contenu pour ces filtres.",
    cr_status_open: "Ouvert",
    cr_status_in_review: "En revue",
    cr_status_resolved: "Résolu",
    cr_status_dismissed: "Rejeté",
    cr_target_type: "Type",
    cr_target_report: "Signalement",
    cr_target_marketplace_listing: "Annonce",
    cr_target_message: "Message de chat",
    cr_target_marketplace_message: "Message Marketplace",
    cr_reported_by: "Signalé par",
    cr_reporter_deleted: "utilisateur supprimé",
    cr_content_author: "Auteur du contenu",
    cr_open_target: "Ouvrir le contenu signalé",
    cr_action_review: "Prendre en charge",
    cr_action_resolve: "Marquer comme résolu",
    legal_info_title: "Informations Légales et Contacts",
    legal_privacy_title: "Politique de Confidentialité",
    legal_terms_title: "Conditions d'Utilisation",
    legal_community_title: "Règles de la Communauté",
    legal_marketplace_title: "Règles du Marketplace",
    legal_deletion_title: "Suppression du Compte et des Données",
    footer_legal: "Documents légaux",
    footer_legal_info: "Informations légales",
    footer_privacy: "Politique de confidentialité",
    footer_terms: "Conditions d'utilisation",
    footer_community_rules: "Règles de la communauté",
    footer_marketplace_rules: "Règles du Marketplace",
    footer_account_deletion: "Suppression du compte",
    signup_consent_prefix: "J'accepte les",
    signup_consent_and_the: "et les",
    signup_consent_privacy_note: "et je déclare avoir lu la",
    signup_community_link: "Règles de la communauté",
    mkt_rules_gate_title: "Règles du Marketplace",
    mkt_rules_gate_kicker: "Première opération sur le Marketplace",
    mkt_rules_gate_desc: "Pour publier une annonce, la modifier ou contacter un autre utilisateur, vous devez d'abord accepter la version en vigueur des Règles du Marketplace.",
    mkt_rules_gate_read: "Lire les Règles du Marketplace",
    mkt_rules_gate_checkbox: "J'ai lu et j'accepte les Règles du Marketplace.",
    mkt_rules_gate_accept: "Accepter et continuer",
    mkt_rules_gate_cancel: "Annuler",
    mkt_rules_gate_required: "Vous devez accepter les Règles du Marketplace pour continuer.",
    mkt_rules_gate_accepted_toast: "Règles du Marketplace acceptées.",
    mkt_rules_gate_error: "Impossible d'enregistrer votre acceptation. Veuillez réessayer.",
    section_profile_photo: "Photo de profil",
    profile_photo_desc: "Ajoutez une photo de profil publique. Elle est facultative et peut être retirée à tout moment.",
    profile_photo_upload: "Ajouter une photo",
    profile_photo_replace: "Remplacer la photo",
    profile_photo_remove: "Supprimer la photo",
    profile_photo_uploading: "Envoi en cours…",
    profile_photo_removing: "Suppression en cours…",
    profile_photo_updated: "Photo de profil mise à jour.",
    profile_photo_removed: "Photo de profil supprimée.",
    profile_photo_invalid_type: "Format d'image non pris en charge. Utilisez JPG, PNG ou WEBP.",
    profile_photo_too_large: "Image trop volumineuse. Taille maximale : 5 Mo.",
    profile_photo_error: "Impossible de mettre à jour la photo de profil. Veuillez réessayer.",
    profile_photo_hint: "JPG, PNG ou WEBP · 5 Mo max.",
    username_label: "Nom d'utilisateur",
    username_placeholder: "ex. jeanne.dupont",
    username_help: "3–30 caractères, lettres, chiffres, point et tiret bas. Unique et public.",
    email_private_hint: "Votre email reste privé : il n'est jamais affiché aux autres utilisateurs.",
    username_too_short: "Le nom d'utilisateur doit contenir au moins 3 caractères.",
    username_too_long: "Le nom d'utilisateur ne peut pas dépasser 30 caractères.",
    username_invalid_chars: "Le nom d'utilisateur ne peut contenir que des lettres, chiffres, points et tirets bas.",
    username_reserved: "Ce nom d'utilisateur est réservé.",
    username_taken: "Ce nom d'utilisateur est déjà pris.",
    username_required: "Veuillez choisir un nom d'utilisateur pour continuer.",
    cr_action_dismiss: "Rejeter",
  },
  de: {
    tagline: "Die Welt besser hinterlassen, als wir sie vorgefunden haben.",
    hero_title: "Melden. Prüfen. Aufräumen.",
    hero_subtitle: "ToClean ist die globale Plattform, um aus einer Meldung eine konkrete Aktion zu machen. Bürger, Freiwillige, Vereine und Gemeinden, gemeinsam auf derselben Karte.",
    cta_map: "Karte öffnen",
    cta_report: "Meldung erstellen",
    cta_signin: "Anmelden",
    cta_signup: "Registrieren",
    cta_google: "Mit Google fortfahren",
    cta_donate: "Unterstützen",
    nav_map: "Karte",
    nav_stories: "Erfolgsgeschichten",
    nav_leaderboard: "Rangliste",
    nav_profile: "Profil",
    nav_admin: "Admin",
    nav_settings: "Einstellungen",
    nav_admin_dashboard: "Admin-Dashboard",
    stats_reports: "Meldungen insgesamt",
    stats_resolved: "gelöste Probleme",
    stats_pending: "in Bearbeitung",
    stats_users: "aktive Mitglieder",
    filters: "Filter",
    category: "Kategorie",
    all: "Alle",
    risk_level: "Risiko",
    status: "Status",
    st_published: "Veröffentlicht",
    st_in_progress: "In Arbeit",
    st_resolved: "Gelöst",
    st_pending: "Ausstehend",
    st_pending_moderation: "Zu genehmigen",
    st_concluded: "Abgeschlossen",
    st_archived: "Archiviert",
    cat_waste: "Müll",
    cat_environment: "Umwelt",
    cat_animals: "Tiere",
    cat_urban: "Städtischer Verfall",
    cat_vegetation: "Gefährliche Vegetation auf Straße",
    cat_reusable: "Wiederverwendbare Gegenstände",
    new_report: "Neue Meldung",
    subcategory: "Unterkategorie",
    description: "Beschreibung",
    upload_photos: "Fotos hochladen",
    submit: "Meldung absenden",
    cancel: "Abbrechen",
    email: "E-Mail",
    password: "Passwort",
    name: "Name",
    role: "Rolle",
    citizen: "Bürger",
    volunteer: "Freiwilliger",
    association: "Verein",
    company: "Unternehmen / Sponsor",
    municipality: "Gemeinde / Behörde",
    operator: "Betreiber",
    already: "Hast du bereits ein Konto?",
    new_here: "Neu bei ToClean?",
    signin_now: "Anmelden",
    signup_now: "Registrieren",
    coordinate: "Einsatz koordinieren",
    send_message: "Senden",
    write_message: "Schreib eine Nachricht…",
    confirm: "Bestätigen",
    confirm_still: "Das Problem besteht noch",
    confirm_worsened: "Hat sich verschlimmert",
    confirm_resolved: "Gelöst",
    confirm_not: "Nicht mehr vorhanden",
    take_item: "Ich habe den Gegenstand genommen",
    interested: "Ich bin interessiert",
    logout: "Abmelden",
    reports_created: "Erstellte Meldungen",
    confirmations_made: "Abgegebene Bestätigungen",
    reputation: "Reputation",
    donation_title: "Unterstütze ToClean",
    donation_desc: "Dein Beitrag finanziert verifizierte Einsätze, Belohnungen für Freiwillige und die Weiterentwicklung der Plattform.",
    donation_amount: "Betrag",
    donation_message: "Nachricht (optional)",
    donate_now: "Jetzt spenden",
    donate_min_amount: "Mindestbetrag: 0,50 €. Du kannst auch ohne Registrierung spenden.",
    donate_min_error: "Mindestbetrag 0,50 €",
    donate_stripe_error: "Stripe-Fehler",
    donate_redirect: "Weiterleitung…",
    donate_message_placeholder: "Ein Gedanke für die Community…",
    donate_secure: "Sichere Zahlung über Stripe. Testkarte:",
    positive_title: "Erfolgsgeschichten aus der Community",
    positive_desc: "Jeder graue Marker ist ein Problem, das jemand unsichtbar gemacht hat.",
    positive_empty: "Noch keine Geschichten. Deine Bestätigungen und Einsätze können die nächsten werden.",
    positive_solved: "Gelöst",
    ai_analyze: "Mit KI analysieren",
    ai_suggested: "KI-Vorschlag",
    emergency_notice: "Bei unmittelbaren Notfällen (Brände, Tiere in Lebensgefahr, gefährliche Substanzen) kontaktiere sofort die örtlichen Notdienste.",
    footer_mission: "ToClean ist eine Plattform für Umweltaktionen. Jede Meldung zählt.",
    footer_platform: "Plattform",
    footer_platform_items: "Karte · Meldungen · Chat · Belohnungen",
    footer_platform_lang: "Mehrsprachig (IT · EN)",
    footer_platform_ai: "KI-Moderation (GPT-5.2)",
    footer_community: "Community",
    footer_made: "Erstellt mit Freiwilligen, für den Planeten.",
    hero_slide1_title: "Der Planet ist wunderschön.",
    hero_slide1_sub: "Jede winzige Geste entscheidet, ob er es bleibt.",
    hero_slide2_title: "Gemeinsam geht's.",
    hero_slide2_sub: "Bürger, Freiwillige, Vereine, Unternehmen, Gemeinden — auf derselben Karte.",
    hero_slide3_title: "Eine Aktion, ein Nachweis.",
    hero_slide3_sub: "Fotos vorher und nachher, Belege, öffentliche Chronik jedes Einsatzes.",
    hero_prev: "Zurück",
    hero_next: "Weiter",
    hero_play: "Abspielen",
    hero_pause: "Pause",
    hero_mute_on: "Ton einschalten",
    hero_mute_off: "Stumm",
    community_verified: "Community · verifiziert",
    hero_action_leaves_mark: "Jede Handlung hinterlässt eine Spur.",
    risk_green_low: "Grün · Niedrig",
    risk_green_desc: "Kleinere Abfälle, Gegenstände, ungefährliche Materialien.",
    risk_red_high: "Rot · Hoch",
    risk_red_desc: "Gefährliche Stoffe, Tiermisshandlung, sensible Beweise.",
    mission_kicker: "Mission & Zweck",
    mission_title: "Ein saubererer Planet wartet auf niemandes Erlaubnis.",
    mission_p1: "ToClean ist eine <b>unabhängige</b> Plattform, die Menschen, die ein Problem sehen, mit denen verbindet, die es lösen können. Bürger, Freiwillige, Vereine, Unternehmen und Verwaltungen — auf derselben Karte, mit denselben Werkzeugen, für dasselbe Ziel.",
    mission_p2: "Das ist kein weiteres soziales Netzwerk. Keine Petition. Es ist ein operatives Werkzeug: <b>Foto, Verifizierung, Koordination, Nachweis des Ergebnisses.</b> Einfach, transparent, nachvollziehbar.",
    // ---- MissionPage /missione (freigegebener Inhalt, treu aus dem Italienischen übersetzt)
    missionpage_kicker: "Mission",
    missionpage_title: "Unsere Mission",
    missionpage_intro: "ToClean wurde gegründet, um den Umweltschutz einfacher, konkreter und geteilt zu machen. Wir wollen den Menschen einen Raum bieten, in dem sie Umweltprobleme melden, verfolgen können, was in ihrer Region geschieht, mit der Community zusammenarbeiten und noch nutzbaren Gegenständen ein neues Leben geben.",
    missionpage_s1_title: "Umweltbeteiligung",
    missionpage_s1_body: "ToClean ermöglicht es den Menschen, durch Umweltmeldungen, Updates, lokale Initiativen und außergewöhnliche Ereignisse zur Pflege des Gebiets beizutragen. Jeder Beitrag kann helfen, Probleme sichtbarer zu machen und Maßnahmen, Zusammenarbeit und geteilte Verantwortung zu fördern.",
    missionpage_s2_title: "Wiederverwendung und Community",
    missionpage_s2_body: "Über die Bereiche Verkaufen, Verschenken und Gefundene wiederverwendbare Gegenstände will ToClean Verschwendung reduzieren und die Wiederverwendung dessen erleichtern, was noch nützlich sein kann. Ziel ist es nicht nur, einen Marktplatz zu schaffen, sondern eine aufmerksamere, verantwortungsbewusste und ortsnahe Community zu fördern.",
    missionpage_s3_title: "Spenden und Wachstum des Projekts",
    missionpage_s3_body: "Menschen werden ToClean, Umweltmeldungen und Aufforstungsprojekte durch freiwillige Beiträge unterstützen können. Die gesammelten Mittel können zur Entwicklung, Verwaltung und zum Wachstum des Projekts beitragen — unter Einhaltung der Regeln und Informationen, die veröffentlicht werden.",
    missionpage_future_title: "Zukunftsvision: Sponsoren und Belohnungen",
    missionpage_future_p1: "ToClean ist überzeugt, dass alle, die Zeit, Energie und konkretes Engagement dem Umweltschutz widmen, wertgeschätzt werden sollten.",
    missionpage_future_p2: "Mit dem Wachstum der Community und der zukünftigen Unterstützung von Unternehmen, Einrichtungen und Sponsoren wollen wir ein transparentes Programm zur Anerkennung und Belohnung der aktivsten Freiwilligen und der bedeutendsten Umweltinitiativen entwickeln.",
    missionpage_future_p3: "Sponsoren können das Projekt unterstützen, zu den Belohnungen beitragen und eine klar als Sponsoring erkennbare Sichtbarkeit erhalten. Ein Teil der Mittel kann außerdem zu den Kosten beitragen, die zum Erhalt und Wachstum von ToClean notwendig sind.",
    missionpage_rewards_title: "Mögliche zukünftige Belohnungen",
    missionpage_rewards_1: "Gutscheine oder Rabatte von Sponsoren",
    missionpage_rewards_2: "Nachhaltige Produkte",
    missionpage_rewards_3: "Teilnahme an Erlebnissen oder Veranstaltungen",
    missionpage_rewards_4: "Digitale Abzeichen und Auszeichnungen",
    missionpage_rewards_5: "Preise im Zusammenhang mit Umweltinitiativen",
    missionpage_rewards_6: "Konkrete Unterstützung für Freiwilligengruppen oder -projekte",
    missionpage_disclaimer: "Das Belohnungsprogramm ist noch nicht aktiv. Es stellt eine Zukunftsvision von ToClean dar und kann nur schrittweise realisiert werden, wenn ein echtes Community-Wachstum, verfügbare Ressourcen und konkrete Vereinbarungen mit Sponsoren und Partnern vorliegen. Vor der Aktivierung werden Kriterien, Regeln, Bedingungen und Vergabemodalitäten veröffentlicht.",
    missionpage_updated_at: "Letzte Aktualisierung:",
    missionpage_back_home: "Zurück zur Startseite",
    publish_chooser_title: "Was möchtest du veröffentlichen?",
    publish_chooser_desc: "Wähle den Inhaltstyp: eine Umweltmeldung oder eine Marktplatz-Anzeige.",
    publish_chooser_report_title: "Umweltmeldung",
    publish_chooser_report_desc: "Abfall, Missbrauch, Vernachlässigung: hilft, alltägliche Probleme zu überwachen und zu lösen.",
    publish_chooser_sale_title: "Zu verkaufender Gegenstand",
    publish_chooser_sale_desc: "Veröffentliche eine Anzeige mit Preis. Privater Chat mit potenziellen Käufern.",
    publish_chooser_gift_title: "Zu verschenkender Gegenstand",
    publish_chooser_gift_desc: "Kein Preis. Entscheide frei im Chat, wem du ihn übergibst.",
    publish_chooser_reusable_title: "Gefundener wiederverwendbarer Gegenstand",
    publish_chooser_reusable_desc: "Melde einen zurückgelassenen oder wiederverwendbaren Gegenstand. Wer zuerst kommt, nimmt ihn mit.",
    listing_type_sale: "Verkaufen",
    listing_type_gift: "Verschenken",
    listing_type_reusable: "Gefundener wiederverwendbarer",
    pillar1_title: "Melde, was du siehst",
    pillar1_desc: "Müll, städtischer Verfall, Tiere in Not, Brände, wiederverwendbare Gegenstände. Ein Foto, die GPS-Position, eine Risikostufe. Das war's.",
    pillar2_title: "Verifiziere mit der Community",
    pillar2_desc: "Wer in der Nähe ist, bestätigt, fügt Fotos hinzu, zeigt an, ob das Problem schlimmer geworden oder gelöst wurde. Die Zuverlässigkeit steigt mit den Bestätigungen.",
    pillar3_title: "Koordiniere Menschen und Mittel",
    pillar3_desc: "Jede Meldung hat ihren eigenen Chat. Freiwillige, Vereine, Gemeinden und professionelle Akteure organisieren sich dort, ohne sich in privaten DMs zu verlieren.",
    pillar4_title: "Unterstütze mit Spenden und Sponsoren",
    pillar4_desc: "Unternehmen und Privatpersonen können Einsätze, Belohnungen und Ausrüstung finanzieren. Jeder Beitrag wird nachverfolgt und mit einem echten Ergebnis verknüpft.",
    pillar5_title: "Belohne, wer beiträgt",
    pillar5_desc: "Gutscheine, Bons, Ausrüstung, Anerkennungen von Sponsoren. Mit ToClean verdient man nichts — aber die gespendete Zeit wird nie vergessen.",
    pillar6_title: "Nachweisbare und transparente Ergebnisse",
    pillar6_desc: "Vorher-Nachher-Fotos, Entsorgungsbelege, öffentliche Chronik jedes Einsatzes. Der Bereich „Positive Geschichten",
    how_kicker: "So funktioniert's",
    how_title: "Fünf Schritte. Null Bürokratie.",
    how_sub: "Vom Handyfoto zum öffentlichen Nachweis des Ergebnisses.",
    how_step_1: "Melden",
    how_step_1_desc: "Foto, GPS, Kategorie, wahrgenommenes Risiko.",
    how_step_2: "Verifizieren",
    how_step_2_desc: "Die Community bestätigt oder widerlegt.",
    how_step_3: "Koordinieren",
    how_step_3_desc: "Eigener Chat für Freiwillige und Akteure.",
    how_step_4: "Handeln",
    how_step_4_desc: "Abholung, Reinigung, Bergung wird organisiert.",
    how_step_5: "Nachweisen",
    how_step_5_desc: "Vorher-Nachher-Fotos, Entsorgungsbelege.",
    cat_kicker: "5 Kategorien · in Sekunden meldbar",
    cat_headline: "Müll, Umwelt, Tiere, städtischer Verfall und wiederverwendbare Gegenstände.",
    gray_markers: "Graue Marker: unsichtbar gemachte Probleme.",
    emergency_label: "Notfälle",
    support_chip: "ToClean unterstützen",
    support_title_1: "Wir verlangen kein Abo.",
    support_title_2: "Wir bitten um eine",
    support_title_3: "freiwillige Geste.",
    support_p1: "ToClean ist ein unabhängiges Projekt. Es gehört keinem Fonds, verkauft keine persönlichen Daten, vollstopft die Oberfläche nicht mit Werbebannern. Es wächst dank derer, die glauben, dass <b>die Pflege des Territoriums eine Verantwortung aller ist</b> — und sich entscheiden, dies auch mit einem kleinen finanziellen Beitrag zu tun.",
    support_p2: "Jeder gespendete Euro ist völlig <b>freiwillig</b>. Du erhältst keine Premium-Funktionen, keine Überholspuren, du erscheinst nicht weiter oben im Ranking. Du erhältst etwas Wichtigeres: <b>die Gewissheit, dass eine Plattform für das Gemeinwohl frei, offen und nützlich für die bleibt, die nach dir kommen.</b>",
    support_cta: "ToClean unterstützen",
    support_discover: "Mission entdecken",
    support_uses_title: "Wofür eine Spende verwendet wird",
    support_use_1_title: "Server und Infrastruktur",
    support_use_1_desc: "Karte, Fotos, Chat: Alles muss schnell und rund um die Uhr verfügbar bleiben.",
    support_use_2_title: "Neue Funktionen",
    support_use_2_desc: "KI-Duplikaterkennung, Benachrichtigungen, automatische Belohnungen, native Mobile-App.",
    support_use_3_title: "Moderation",
    support_use_3_desc: "Sensible Inhalte, Tierschutz, saubere Chats: die unsichtbare Arbeit, die die App zuverlässig macht.",
    support_use_4_title: "Expansion in neue Länder",
    support_use_4_desc: "Übersetzungen, rechtliche Anpassung, lokale Partner.",
    support_use_5_title: "Umweltinitiativen",
    support_use_5_desc: "Kleine Mittel für verifizierte Community-Einsätze (Ausrüstung, Materialien).",
    support_use_6_title: "Kontinuierliche Verbesserung",
    support_use_6_desc: "User-Feedback, Korrekturen, Barrierefreiheit, Performance.",
    support_footnote: "Keine Spende ist verpflichtend. Du kannst ToClean für immer kostenlos nutzen. Wenn du eines Tages beitragen möchtest, findest du es griffbereit — nie im Weg.",
    final_kicker: "Jetzt loslegen",
    final_slogan: "ToClean ist einfach, kostenlos und respektvoll wie die Erde. Hilf uns, ihr zu helfen.",
    final_desc: "Registriere dich und verwandle ein einfaches Foto in echte Veränderung. Jede Meldung ist ein Schritt.",
    feedback_kicker: "Feedback und Verbesserungsvorschläge",
    feedback_title: "Hilf uns, ToClean zu verbessern.",
    feedback_desc: "Dein Vorschlag ist mehr wert als zehn interne Roadmaps. Melde einen Fehler, schlage eine neue Funktion vor, sag uns, was nicht passt. Du kannst uns auch ohne Registrierung schreiben.",
    feedback_kind: "Art",
    feedback_kind_suggestion: "Vorschlag",
    feedback_kind_bug: "Fehler / Problem",
    feedback_kind_improvement: "Verbesserungsvorschlag",
    feedback_email_label: "E-Mail (optional)",
    feedback_email_placeholder: "Nur wenn du kontaktiert werden möchtest",
    feedback_message: "Nachricht",
    feedback_message_placeholder: "Was können wir verbessern?",
    feedback_submit: "Feedback senden",
    feedback_submitting: "Wird gesendet…",
    feedback_no_signup: "Keine Registrierung erforderlich.",
    feedback_min_words: "Schreib bitte ein paar Worte",
    feedback_thanks: "Danke für dein Feedback!",
    feedback_error: "Fehler",
    support_title: "Wir verlangen kein Abo. Wir bitten um eine freiwillige Geste.",
    open_details: "Details öffnen",
    close: "Schließen",
    set_local_password: "Lokales Passwort festlegen",
    set_password_desc: "Füge deinem Google-Konto ein lokales Passwort hinzu, um dich auch per E-Mail + Passwort anmelden zu können.",
    new_password: "Neues Passwort",
    save: "Speichern",
    confirmations_short: "Best.",
    map_locate_unsupported: "Dein Browser unterstützt keine Geolokalisierung.",
    map_geo_disabled: "Geolokalisierung in den Einstellungen deaktiviert.",
    map_geo_denied: "GPS-Berechtigung verweigert.",
    map_geo_failed: "Position konnte nicht ermittelt werden.",
    map_locate_title: "Mein Standort",
    map_locate_here: "Hier zentrieren",
    geo_no_results_for_area: "Keine Ergebnisse für dieses Gebiet.",
    geo_search_error: "Suchfehler",
    geo_temp_unavailable: "Suche vorübergehend nicht verfügbar — bitte erneut versuchen",
    map_hide_filters: "Filter ausblenden",
    map_show_filters: "Filter anzeigen",
    map_std: "Karte",
    map_satellite: "Satellit",
    map_tiles_error: "Kartenkacheln konnten nicht geladen werden.",
    map_tiles_check: "Überprüfe die Verbindung und versuche es erneut.",
    map_retry: "Erneut versuchen",
    color: "Farbe",
    show_all: "Alle anzeigen",
    reset: "Zurücksetzen",
    all_subcategories: "Alle Unterkategorien",
    legend: "Legende",
    legend_green_low: "Grün · niedrig",
    legend_yellow_med: "Gelb · mittel",
    legend_red_high: "Rot · hoch",
    legend_gray_resolved: "Grau · gelöst",
    legend_blue_progress: "Blau · in Bearbeitung",
    legend_purple_reusable: "Lila · wiederverwendbar",
    st_active: "Aktiv",
    st_taken: "Übernommen",
    st_review: "In Überprüfung",
    st_standby: "Im Standby",
    st_reopened: "Wiedereröffnet",
    active_prefix: "Aktiv:",
    fab_expand: "Schaltfläche Meldung erstellen anzeigen",
    fab_minimize: "Minimieren",
    auth_home: "Home",
    auth_signin_kicker: "Anmelden",
    auth_signup_kicker: "Account erstellen",
    auth_signin_h: "Willkommen zurück.",
    auth_signup_h: "Werde Teil der Bewegung.",
    auth_slogan: "Jedes Foto ist ein kleiner Wandel.",
    auth_or: "oder",
    welcome_back: "Willkommen zurück!",
    welcome_new: "Willkommen bei ToClean!",
    generic_error: "Fehler",
    forgot_password: "Passwort vergessen?",
    signin_remember_me: "Auf diesem Gerät angemeldet bleiben",
    reset_back_to_login: "Zurück zum Login",
    reset_title: "Passwort zurücksetzen",
    reset_request_desc: "Gib deine E-Mail ein. Wir senden dir einen Token zum Zurücksetzen des Passworts.",
    reset_confirm_desc: "Gib den erhaltenen Token und das neue Passwort ein.",
    reset_send_link: "Link senden",
    reset_update_pwd: "Passwort aktualisieren",
    reset_updated: "Passwort aktualisiert! Du kannst dich jetzt anmelden.",
    reset_dev_notice_b: "Demo-Umgebung:",
    reset_dev_notice: "Token vorausgefüllt. In Produktion wird er per E-Mail gesendet.",
    reset_min_chars: "Mindestens 6 Zeichen",
    token_label: "Token",
    settings_title: "Dein Account",
    settings_desc: "Verwalte Profil, Sicherheit, Benachrichtigungen und Privatsphäre.",
    section_profile: "Profil",
    section_password: "Passwort",
    section_notifications: "Benachrichtigungen",
    section_language: "Sprache",
    section_geolocation: "Geolokalisierung",
    section_privacy: "Privatsphäre",
    section_feedback: "Feedback und Vorschläge",
    section_session: "Sitzung",
    current_password: "Aktuelles Passwort",
    new_password_min: "Neues Passwort (mind. 6)",
    change_password: "Passwort ändern",
    fill_both_fields: "Fülle beide Felder aus",
    profile_updated: "Profil aktualisiert",
    password_updated: "Passwort aktualisiert",
    lang_updated: "Sprache aktualisiert",
    local_password_set: "Lokales Passwort gesetzt!",
    notif_new_reports: "Neue Meldungen in deiner Umgebung",
    notif_mentions: "Erwähnungen in Chats",
    notif_status_changes: "Status-Updates",
    notif_rewards: "Verfügbare Prämien und Gutscheine",
    geo_desc: "Wenn aktiviert, kann ToClean das GPS des Browsers anfordern, um die Karte zu zentrieren und den Standort von Meldungen vorauszufüllen. Du kannst die Berechtigung jederzeit in den Browser-Einstellungen widerrufen.",
    geo_browser_denied: "Der Browser hat GPS verweigert. Aktiviere es in den Browser-Einstellungen.",
    privacy_public_b: "Öffentliches Profil.",
    privacy_public_desc: "Dein Name, deine Reputation und deine Meldungen sind in der Rangliste und auf der Profilseite sichtbar. Du kannst die Sichtbarkeit hier deaktivieren.",
    privacy_footnote: "Fotos von Meldungen sind immer öffentlich. Sensible Daten (Kennzeichen, Gesichter) werden bis zur Freigabe durch Moderatoren verborgen.",
    logout_label: "Abmelden",
    delete_account: "Account löschen",
    delete_account_title: "Account endgültig löschen?",
    delete_account_desc: "Dein Profil wird gelöscht. Deine Meldungen bleiben in anonymer Form sichtbar, um die Integrität der Historie zu bewahren. Diese Aktion ist unwiderruflich.",
    delete: "Löschen",
    account_deleted: "Account gelöscht",
    loading: "Lädt…",
    reputation_short: "Reputation",
    new_report_title: "Verwandle das Foto in eine Aktion.",
    new_report_desc: "Fülle die Felder sorgfältig aus. Die KI kann dir helfen, korrekt zu kategorisieren.",
    add: "Hinzufügen",
    latitude: "Breitengrad",
    longitude: "Längengrad",
    detect: "Erkennen",
    position_on_map: "Position auf der Karte · tippe zum Auswählen",
    geo_denied_msg: "GPS-Berechtigung verweigert. Du kannst die Position dennoch auswählen, indem du auf die Karte tippst oder sie manuell eingibst.",
    tiles_not_loaded: "Kacheln nicht geladen.",
    risk_green_label: "Grün · geringes Risiko",
    risk_green_short_desc: "Kleiner Müll, ungefährliche Objekte",
    risk_yellow_label: "Gelb · mittleres Risiko",
    risk_yellow_short_desc: "Viele Säcke, Glas, schwere Materialien",
    risk_red_label: "Rot · hohes Risiko",
    risk_red_short_desc: "Gefährliche Stoffe, Tiere, sensible Inhalte",
    ai_analyze_desc: "Analysiere Foto und Beschreibung, um Kategorie, Unterkategorie und Risikolevel vorzuschlagen.",
    ai_analyze_action: "Analysieren",
    ai_unavailable: "KI nicht verfügbar",
    ai_completed: "KI-Analyse abgeschlossen",
    sensitive_content_b: "Sensibler Inhalt.",
    sensitive_content_desc: "Der Inhalt enthält Gesichter, Kennzeichen, Minderjährige, Beweise oder Anschuldigungen. Er wird vor der Veröffentlichung von den Moderatoren überprüft.",
    describe_placeholder: "Was hast du gesehen? Größe, Kontext, Materialien…",
    photo_uploaded: "Foto hochgeladen",
    photo_upload_failed: "Upload fehlgeschlagen",
    add_photo_or_desc: "Füge mindestens ein Foto oder eine Beschreibung hinzu",
    gps_missing: "GPS-Position fehlt",
    select_subcategory: "Unterkategorie auswählen",
    description_too_short: "Beschreibung zu kurz",
    photo_required: "Mindestens ein Foto ist erforderlich",
    report_submitted: "Meldung gesendet!",
    gps_updated: "GPS aktualisiert",
    gps_unavailable: "Geolokalisierung nicht unterstützt",
    gps_pick_manual: "Position konnte nicht ermittelt werden — tippe unten auf die Karte, um sie manuell auszuwählen.",
    position_set: "Position festgelegt",
    navigate: "Navigieren",
    donate_short: "Spenden",
    report_sent_b: "Meldung gesendet!",
    report_sent_desc: "Danke für deinen Beitrag. Die Community kann hier unten bestätigen und sich koordinieren.",
    back_to_map: "Zurück zur Karte",
    risk_prefix: "Risiko",
    confirmations_label: "Bestätigungen",
    still_exists: "Existiert noch",
    worsened: "Verschlimmert",
    resolved_short: "Gelöst",
    not_present: "Nicht vorhanden",
    reusable_not_available: "Wahrscheinlich nicht mehr verfügbar",
    timeline: "Chronik",
    no_messages: "Keine Nachrichten. Starte die Unterhaltung.",
    login_to_join: "Melde dich an, um teilzunehmen",
    of_author: "von",
    fullscreen: "Vollbild",
    edit_message: "Bearbeiten",
    message_edited: "bearbeitet",
    saved_confirmation: "Bestätigung gespeichert",
    thanks: "Danke!",
    donate_report_title: "Unterstütze diese Meldung",
    donate_report_desc_p1: "Die Mittel werden verwendet",
    donate_report_desc_b1: "vorrangig zur Lösung dieser Meldung",
    donate_report_desc_p2: ". Falls dies nicht möglich ist, werden sie für ähnliche Maßnahmen verwendet",
    donate_report_desc_b2: "in derselben Gemeinde oder Region",
    donate_report_desc_p3: ". Du kannst spenden",
    donate_report_desc_b3: "auch ohne Registrierung",
    donate_free_offer: "Freier Betrag (min. 0,50 €)",
    donate_report_placeholder: "Eine Nachricht an die Community (optional)",
    not_authenticated: "Nicht authentifiziert",
    admin_dashboard_kicker: "Admin-Dashboard",
    admin_overview: "Moderationsübersicht",
    admin_users: "Nutzer",
    admin_reports: "Meldungen",
    admin_pending: "Ausstehend",
    admin_red: "Rote",
    admin_resolved: "Gelöst",
    admin_donations: "Spenden",
    tab_moderation: "Moderation",
    tab_all_reports: "Alle Meldungen",
    tab_users: "Nutzer",
    tab_donations: "Spenden & Sponsoren",
    tab_logs: "Logs",
    no_pending: "Keine ausstehenden Meldungen.",
    no_reports: "Keine Meldungen.",
    all_statuses: "Alle Status",
    only_red_risk: "Nur rotes Risiko",
    search_by_name_email: "Nach Name oder E-Mail suchen…",
    admin_rep_short: "Rep",
    admin_suspended: "suspendiert",
    admin_banned: "gebannt",
    admin_reactivate: "Reaktivieren",
    admin_suspend: "Suspendieren",
    admin_remove_ban: "Bann aufheben",
    admin_ban: "Bannen",
    approve: "Genehmigen",
    reject: "Ablehnen",
    archive: "Archivieren",
    reopen: "Wieder öffnen",
    hide_evidence: "Ausblenden",
    show_evidence: "Beweise zeigen",
    sensitive_badge: "sensibel",
    proposed_label: "vorgeschlagen:",
    author_line_by: "von",
    make_public: "Öffentlich machen",
    mark_sensitive: "Als sensibel markieren",
    st_pub_visible: "Sichtbar",
    st_hidden: "Verborgen",
    st_archived: "Archiviert",
    st_rejected: "Abgelehnt",
    change_state_title: "Meldungsstatus ändern",
    current_status: "Aktueller Status:",
    reason_optional: "Begründung (optional)",
    state_change_note: "Verbergen, Suspendieren oder Archivieren",
    state_change_note_b: "löscht nicht",
    state_change_note_2: "die Meldung. Fotos, Koordinaten, Autor und Chronik bleiben unverändert.",
    state_arrow: "Status →",
    color_short: "Farbe",
    admin_actions_title: "Admin-Aktionen",
    delete_report_confirm_title: "Diese Meldung löschen?",
    delete_report_confirm_body: "Die Meldung wird endgültig entfernt. Diese Aktion kann nicht rückgängig gemacht werden.",
    change_color_title: "Farbe ändern (Risikoniveau)",
    current_color: "Aktuelle Farbe:",
    color_reason_placeholder: "Warum änderst du die Farbe?",
    state_reason_placeholder: "Warum änderst du den Status?",
    color_change_note: "Die Farbänderung",
    color_change_note_b: "veröffentlicht nicht",
    color_change_note_2: ", verbirgt nicht, archiviert nicht und löscht die Meldung nicht — sie ändert nur die auf der Karte und in den Filtern sichtbare Risikostufe. Verlauf gespeichert.",
    apply: "Anwenden",
    delete_report_title: "Meldung löschen?",
    delete_report_desc: "Diese Aktion löscht die Meldung, Fotos und den zugehörigen Chat endgültig. Sie kann nicht rückgängig gemacht werden.",
    load_error: "Ladefehler",
    approved: "Genehmigt",
    updated: "Aktualisiert",
    report_updated: "Meldung aktualisiert",
    role_updated: "Rolle aktualisiert",
    user_updated: "Nutzer aktualisiert",
    report_deleted: "Meldung gelöscht",
    report_reopened: "Meldung wiedereröffnet",
    // Bulk selection (Lotto 3 #7/#8)
    bulk_select_all: "Alle auswählen",
    bulk_selected_of: "{n} von {total} ausgewählt",
    bulk_select_row: "Diese Zeile auswählen",
    bulk_clear_selection: "Auswahl aufheben",
    bulk_delete_confirm_title: "Ausgewählte Einträge löschen?",
    bulk_delete_confirm_body: "Sie sind dabei, {n} Einträge endgültig zu löschen. Die Aktion kann nicht rückgängig gemacht werden.",
    bulk_deleted_ok: "{n} Einträge gelöscht",
    bulk_updated_ok: "{n} Einträge aktualisiert",
    bulk_notif_mark_read: "Als gelesen markieren",
    bulk_notif_archive: "Archivieren",
    no_donations: "Keine Spenden registriert.",
    mod_logs: "Moderationsprotokoll",
    no_logs: "Keine Protokolle verfügbar.",
    leaderboard_h: "Wer hinterlässt Spuren.",
    leaderboard_empty: "Noch keine aktiven Mitglieder.",
    thanks_donation: "Herzlichen Dank!",
    donation_recorded: "Deine Spende von €{amount} wurde registriert.",
    confirming: "Bestätige…",
    waiting_stripe: "Wir warten auf die Bestätigung von Stripe.",
    payment_cancelled: "Zahlung abgebrochen",
    no_charge: "Keine Abbuchung erfolgt.",
    back_to_map_btn: "Zurück zur Karte",
    stat_reports_created: "Meldungen erstellt",
    stat_confirmations_made: "Bestätigungen abgegeben",
    stat_reputation: "Reputation",
    back: "Zurück",
    sub_small_pile: "Kleiner Haufen",
    sub_bags: "Müllsäcke",
    sub_plastic: "Plastik",
    sub_glass: "Glas",
    sub_paper: "Papier",
    sub_organic: "Biomüll",
    sub_tires: "Reifen",
    sub_appliances: "Elektrogeräte",
    sub_furniture: "Möbel",
    sub_construction: "Baumaterialien",
    sub_industrial: "Industrieabfall",
    sub_hazardous: "Gefährliche Abfälle",
    sub_asbestos: "Asbest",
    sub_chemicals: "Chemikalien",
    sub_oil: "Öle",
    sub_batteries: "Batterien",
    sub_illegal_dump: "Illegale Müllkippe",
    sub_marine: "Meeresmüll",
    sub_river: "Flussmüll",
    sub_forest: "Waldmüll",
    sub_sewage_spill: "Abwasseraustritt",
    sub_medical_waste: "Medizinische Abfälle",
    sub_explosive_flammable: "Explosive / entzündliche Stoffe",
    sub_water_pollution: "Wasserverschmutzung",
    sub_soil_pollution: "Bodenverschmutzung",
    sub_suspicious_discharge: "Verdächtige Einleitung",
    sub_smoke_emissions: "Rauchemissionen",
    sub_fire: "Brand",
    sub_fire_damage: "Brandschaden",
    sub_damaged_trees: "Beschädigte Bäume",
    sub_degraded_green: "Verwahrloste Grünfläche",
    sub_water_leak: "Wasserleck",
    sub_erosion: "Erosion",
    sub_contamination: "Kontamination",
    sub_beach_coast_degradation: "Küstendegradation",
    sub_injured: "Verletztes Tier",
    sub_abandoned: "Ausgesetztes Tier",
    sub_trapped: "Eingeschlossenes Tier",
    sub_in_danger: "Tier in Gefahr",
    sub_suspected_mistreatment: "Verdacht auf Misshandlung",
    sub_poor_conditions: "Schlechte Haltungsbedingungen",
    sub_wildlife_distress: "Wildtier in Not",
    sub_broken_light: "Kaputte Straßenlaterne",
    sub_broken_bench: "Kaputte Bank",
    sub_damaged_playground: "Beschädigter Spielplatz",
    sub_pothole: "Schlagloch",
    sub_architectural_barrier: "Bauliche Barriere",
    sub_dangerous_sidewalk: "Gefährlicher Gehweg",
    sub_broken_signage: "Kaputte Beschilderung",
    sub_abandoned_public: "Verlassenes öffentliches Gebäude",
    sub_vandalism: "Vandalismus",
    sub_other: "Sonstiges",
    sub_tall_grass: "Hohes Gras",
    sub_brambles: "Dornengestrüpp",
    sub_dangerous_branches: "Gefährliche Äste",
    sub_obstructing_visibility: "Sichtbehinderung",
    sub_fallen_tree: "Umgestürzter Baum",
    sub_invasive_plants: "Invasive Pflanzen",
    sub_road_encroachment: "Straßeneinengung",
    sub_bed: "Bett",
    sub_mattress: "Matratze",
    sub_table: "Tisch",
    sub_chair: "Stuhl",
    sub_wardrobe: "Schrank",
    sub_sofa: "Sofa",
    sub_home_decor: "Wohnaccessoires",
    sub_appliance: "Haushaltsgerät",
    sub_electronics: "Elektronik",
    sub_computer: "Computer",
    sub_bicycle: "Fahrrad",
    sub_tools: "Werkzeuge",
    sub_clothing: "Kleidung",
    sub_toys: "Spielzeug",
    sub_construction_materials: "Baumaterialien",
    sub_books: "Bücher",
    take_photo: "Foto aufnehmen",
    from_gallery: "Aus Galerie wählen",
    camera_permission_denied: "Kamerazugriff verweigert. Du kannst trotzdem ein Foto aus der Galerie wählen.",
    suggested_color: "Vorgeschlagene Farbe",
    severity: "Schwere",
    urgency: "Dringlichkeit",
    confidence: "Vertrauen",
    trust: "Zuverlässigkeit",
    coherence: "Foto↔Text",
    ai_action: "Vorgeschlagene Aktion",
    add_photo: "Foto hinzufügen",
    add_photo_desc: "Dokumentiere Verschlechterungen, Veränderungen, Baufortschritte oder Lösungen.",
    add_photo_note: "Optionale Notiz",
    add_photo_note_placeholder: "Z.B. nach Regen verschlechtert oder fast gelöst…",
    add_photo_confirm: "Hinzufügen",
    add_photo_success: "Foto hinzugefügt",
    add_photo_pending: "Foto zur Admin-Prüfung gesendet (Inhalt oder Kohärenz muss überprüft werden)",
    add_photo_failed: "Hinzufügen fehlgeschlagen",
    additional_photos: "Zusätzliche Fotos",
    pending_review: "In Prüfung",
    urgent_alert: "Temporäre Dringlichkeitsmeldung",
    urgent_new: "Neue Dringlichkeitsmeldung",
    urgent_desc: "Melde ein vorübergehendes Problem (verdächtige Köder, Hindernisse, umgestürzter Ast, Überschwemmung, Rauch, Gefahrstoff…).",
    urgent_duration: "Dauer",
    urgent_radius: "Radius (m)",
    urgent_other: "Andere Dringlichkeitsmeldung",
    urgent_free_desc: "Beschreibe frei das Problem und warum es dringend und vorübergehend ist",
    urgent_submit: "Meldung veröffentlichen",
    urgent_created: "Meldung veröffentlicht",
    urgent_state_active: "Aktiv",
    urgent_state_expired: "Abgelaufen — zu überprüfen",
    urgent_state_resolved: "Gelöst",
    urgent_state_archived: "Archiviert",
    urgent_state_pending: "In Prüfung",
    urgent_still_present: "Ich bestätige, dass es noch vorhanden ist",
    urgent_not_present: "Nicht mehr vorhanden",
    urgent_time_remaining: "Verbleibende Zeit",
    urgent_extend: "Verlängern",
    urgent_expired: "Abgelaufen",
    fab_urgent: "Außergewöhnliches Ereignis",
    fab_event: "Neues außergewöhnliches Ereignis",
    extraordinary_event: "Außergewöhnliches Ereignis",
    extraordinary_events: "Außergewöhnliche Ereignisse",
    urgent_alerts_list: "Aktive außergewöhnliche Ereignisse",
    no_urgent_alerts: "Keine aktiven außergewöhnlichen Ereignisse.",
    ai_panel_title: "KI-Analyse (GPT-5.2)",
    ai_problem: "Erkanntes Problem",
    ai_reason: "Begründung",
    ai_act_publish_auto: "Automatische Veröffentlichung",
    ai_act_review_admin: "Admin-Prüfung",
    ai_act_reject: "Ablehnen",
    legal_badge: "rechtlich",
    filter_urgent_alerts: "Außergewöhnliche Ereignisse",
    filter_extraordinary_events: "Außergewöhnliche Ereignisse",
    event_kind_wildfire: "Waldbrand",
    event_kind_flood: "Hochwasser",
    event_kind_river_overflow: "Flussüberschwemmung / Hochwasser",
    event_kind_landslide: "Erdrutsch / Hangrutsch",
    event_kind_storm: "Außergewöhnlicher Sturm",
    event_kind_hailstorm: "Außergewöhnlicher Hagelsturm",
    event_kind_tornado: "Tornado",
    event_kind_heavy_snow: "Starker Schneefall",
    event_kind_avalanche: "Lawine",
    event_kind_sea_storm: "Seesturm",
    event_kind_heatwave: "Hitzewelle",
    event_kind_coldwave: "Kältewelle",
    urgent_pending_approval: "Wartet auf Genehmigung",
    urgent_approved: "Meldung genehmigt",
    urgent_rejected: "Meldung abgelehnt",
    approve_urgent: "Meldung genehmigen",
    reject_urgent: "Meldung ablehnen",
    urgent_map_pick: "Verschiebe die Karte und tippe, um den Punkt auszuwählen",
    urgent_center_me: "Auf meinen Standort zentrieren",
    urgent_short_explanation: "Nutze diese Funktion, um ein dringendes, aber vorübergehendes Problem zu melden. Gib das Problem, den Standort, den Radius des betroffenen Bereichs an und wähle, wie lange die Meldung aktiv bleiben soll. Nach Admin-Genehmigung wird die Meldung mit einem Countdown bis zum Ablauf angezeigt.",
    notifications: "Benachrichtigungen",
    notif_empty: "Keine Benachrichtigungen.",
    notif_gone: "Benachrichtigung nicht mehr verfügbar",
    notif_mark_read: "Als gelesen markieren",
    notif_mark_unread: "Als ungelesen markieren",
    notif_archive: "Archivieren",
    notif_delete: "Löschen",
    notif_open: "Öffnen",
    notif_all_read: "Alles als gelesen markieren",
    notif_view_all: "Alle Benachrichtigungen anzeigen",
    extensions_pending: "Ausstehende Verlängerungen",
    no_extensions_pending: "Keine Verlängerungen zu genehmigen.",
    photos_pending: "Fotos in Prüfung",
    admin_home_title: "Moderationsübersicht",
    admin_home_desc: "Wähle einen Bereich, um zu beginnen.",
    admin_card_red: "Rote",
    admin_card_yellow: "Gelbe",
    admin_card_green: "Grüne",
    admin_card_photos_review: "Admin-Moderation",
    admin_card_urgent: "Außergewöhnliche Ereignisse",
    admin_section_others: "Sonstiges",
    admin_others_desc: "Benutzer · Feedback · Spenden · Chat · Protokoll · Archiv · Einstellungen",
    admin_tab_users: "Benutzer",
    admin_tab_feedback: "Feedback",
    admin_tab_donations: "Spenden",
    admin_tab_logs: "Protokoll",
    admin_tab_archive: "Archiv",
    admin_tab_settings: "Einstellungen",
    admin_filter_status: "Nach Status filtern",
    admin_st_in_progress: "In Bearbeitung",
    admin_st_pending_approval: "Genehmigung ausstehend",
    admin_st_approved: "Genehmigt",
    admin_st_archived: "Archiviert",
    admin_st_all: "Alle",
    admin_urgent_state_pending: "Zu genehmigen",
    admin_urgent_state_active: "Aktiv",
    admin_urgent_state_expired: "Abgelaufen — zu überprüfen",
    admin_urgent_ext_pending: "Verlängerungen ausstehend",
    admin_urgent_state_archived: "Archiviert",
    admin_urgent_state_rejected: "Abgelehnt",
    admin_urgent_state_all: "Alle",
    advanced_filters: "Erweiterte Filter",
    filter_search_placeholder: "Suche nach Titel, Beschreibung, Autor, Ort oder ID",
    filter_ai_conf: "KI-Konfidenz",
    filter_sensitive: "Sensible Inhalte",
    filter_legal: "Mögliche rechtliche Probleme",
    photos_review_title: "Admin-Moderation",
    photos_review_empty: "Keine Fotos zu überprüfen.",
    photos_review_source: "Herkunft",
    photos_review_reason: "Grund",
    photos_review_priority: "Priorität",
    src_new_report: "Neue Meldung",
    src_added_photo: "Foto hinzugefügt",
    src_urgent: "Dringende Warnung",
    src_extension: "Verlängerungsantrag",
    reason_photo_incoherent: "Inkohärentes Foto",
    reason_photo_text_incoherent: "Foto und Beschreibung nicht kohärent",
    reason_category_mismatch: "Falsche Kategorie",
    reason_subcategory_mismatch: "Falsche Unterkategorie",
    reason_severity_higher: "Höherer Schweregrad",
    reason_color_mismatch: "Farbe nicht kohärent",
    reason_sensitive_content: "Sensibler Inhalt",
    reason_legal_issues: "Mögliches rechtliches Problem",
    reason_spam_or_irrelevant: "Spam oder irrelevant",
    reason_low_ai_confidence: "Niedrige KI-Konfidenz",
    reason_ai_suggests_review: "KI empfiehlt Überprüfung",
    reason_face_blur_failed: "Gesichtsverpixelung fehlgeschlagen",
    reason_face_blur_uncertain: "Gesichtsverpixelung unsicher",
    reason_red_requires_approval: "Rot: Genehmigung erforderlich",
    reason_sensitive_animal_category: "Sensible Tier-Unterkategorie",
    reason_possibly_criminal_content: "Möglicher Tatort",
    publish_as_green: "Als Grün veröffentlichen",
    publish_as_yellow: "Als Gelb veröffentlichen",
    publish_as_red: "Als Rot veröffentlichen",
    photo_approved_as_color: "Foto genehmigt und als {color} veröffentlicht",
    original_unavailable: "Original nicht mehr verfügbar",
    original_unavailable_hint: "Original nicht mehr verfügbar — du kannst dennoch eine zusätzliche Verpixelung auf die aktuelle Version anwenden.",
    admin_card_events: "Außerordentliche Ereignisse",
    total: "gesamt",
    admin_card_marketplace: "Marketplace",
    mk_type_sale: "Verkauf",
    mk_type_gift: "Geschenk",
    mk_type_reusable: "Wiederverwendbar gefunden",
    mk_st_published: "Aktiv",
    mk_st_archived: "Archiviert",
    mk_st_closed: "Abgeschlossen",
    mk_st_pending: "Zur Bestätigung",
    mk_search_placeholder: "Titel, Autor, Provinz suchen…",
    mk_empty: "Keine Einträge in dieser Ansicht",
    mk_admin_details: "Admin-Details",
    mk_found_checks_title: "Nutzerbestätigungen",
    mk_found_present: "Objekt vorhanden",
    mk_found_not_present: "Objekt nicht vorhanden",
    mk_found_present_short: "Vorhanden",
    mk_found_not_present_short: "Nicht vorhanden",
    mk_found_no_checks: "Noch keine Bestätigungen.",
    mk_found_check_saved: "Danke! Ihre Bestätigung wurde gespeichert.",
    mk_found_intro: "Waren Sie vor Ort? Helfen Sie der Community: melden Sie, ob das Objekt noch dort ist.",
    mk_found_note_optional: "Notiz (optional)",
    delete_listing_title: "Eintrag löschen",
    delete_listing_desc: "Der Eintrag wird endgültig gelöscht. Diese Aktion ist nicht umkehrbar.",
    reactivate: "Reaktivieren",
    reactivated: "Reaktiviert",
    close: "Schließen",
    chat_translate: "Übersetzen",
    chat_show_original: "Original anzeigen",
    chat_translated_badge: "automatische Übersetzung",
    chat_translating: "Übersetzung läuft…",
    chat_translate_error: "Übersetzung fehlgeschlagen",
    report_user: "Benutzer melden",
    report_user_title: "Diesen Benutzer melden",
    report_user_reason: "Grund",
    ur_reason_spam: "Spam",
    ur_reason_offensive: "Beleidigende Sprache",
    ur_reason_harassment: "Belästigung oder Drohungen",
    ur_reason_misleading: "Falsche oder irreführende Inhalte",
    ur_reason_bad_chat: "Unangemessenes Verhalten im Chat",
    ur_reason_misuse: "Unsachgemäße Nutzung der App",
    ur_reason_false_reports: "Wiederholt falsche Meldungen",
    ur_reason_other: "Anderer Grund",
    report_user_explanation: "Kurze Erklärung (optional)",
    report_user_send: "Meldung senden",
    report_user_sent: "Meldung privat gesendet",
    report_user_privacy: "Die Meldung ist privat und wird dem gemeldeten Benutzer nicht angezeigt.",
    admin_tab_user_reports: "Benutzermeldungen",
    ur_status_new: "Neu",
    ur_status_in_review: "In Prüfung",
    ur_status_resolved: "Erledigt",
    ur_status_archived: "Archiviert",
    ur_status_rejected: "Abgelehnt",
    ur_status_all: "Alle",
    ur_reports_count: "Frühere",
    ur_action_warn: "Verwarnung",
    ur_action_limit_chat: "Chat einschränken",
    ur_action_limit_publish: "Veröffentlichungen einschränken",
    ur_action_suspend: "Vorübergehend sperren",
    ur_action_ban: "Account sperren",
    ur_action_close: "Archivieren ohne Sanktionen",
    ur_action_hours: "Dauer (Stunden)",
    ur_open_context: "Kontext öffnen",
    ur_no_items: "Keine Benutzermeldungen.",
    confirm_choose_status: "Status wählen",
    confirm_in_progress: "In Bearbeitung",
    confirm_worse: "Verschlechtert",
    confirm_undo: "Bestätigung rückgängig",
    confirm_change_title: "Bestätigung ändern",
    confirm_change_desc: "Möchtest du deine Bestätigung von \"{from}\" zu \"{to}\" ändern?",
    confirm_change_ok: "Ja, ändern",
    confirm_your_current: "Deine aktuelle Bestätigung",
    manual_blur: "Manuell verpixeln",
    manual_blur_title: "Verpixelungs-Editor",
    manual_blur_desc: "Zeichne Rechtecke über sensible Bereiche. Die Fotos werden erst nach dem Speichern veröffentlicht.",
    manual_blur_mode_blur: "Unschärfe",
    manual_blur_mode_pixel: "Pixelung",
    manual_blur_undo: "Rückgängig",
    manual_blur_redo: "Wiederherstellen",
    manual_blur_clear: "Alles löschen",
    manual_blur_save: "Verpixelte Version speichern",
    manual_blur_saved: "Verpixelte Version gespeichert",
    manual_blur_no_regions: "Füge mindestens einen Bereich hinzu, bevor du speicherst.",
    manual_blur_hint: "Klicke und ziehe, um zu zeichnen. Ziehe den Rand, um die Größe zu ändern. Doppelklick zum Löschen.",
    download_original: "Original herunterladen",
    upload_replacement: "Verpixelte Version hochladen",
    replacement_uploaded: "Version ersetzt",
    admin_only_action: "Nur für autorisierte Admins",
    sub_gift: "Zu verschenken",
    nav_reforestation: "Aufforstung",
    share: "Teilen",
    deleted_user_label: "Gelöschter Nutzer",
    copy_link: "Link kopieren",
    copy_link_ok: "Link in Zwischenablage kopiert",
    copy_link_err: "Kopieren fehlgeschlagen",
    filter_area: "Provinz / Verwaltungsgebiet",
    notif_type_chat_message: "Neue Chat-Nachricht",
    notif_type_report_update: "Meldung aktualisiert",
    notif_type_photo_approved: "Foto genehmigt",
    notif_type_photo_rejected: "Foto abgelehnt",
    notif_type_photo_review: "Foto wird geprüft",
    notif_type_urgent_approved: "Hinweis genehmigt",
    notif_type_urgent_rejected: "Hinweis abgelehnt",
    notif_type_urgent_expiring: "Hinweis läuft ab",
    notif_type_report_status: "Status der Meldung geändert",
    notif_type_content_report_resolved: "Inhalts-Meldung bearbeitet",
    notif_type_content_report_dismissed: "Inhalts-Meldung geprüft",
    notif_type_new_feedback: "Neues Feedback",
    notif_type_new_urgent: "Neuer dringender Hinweis zur Genehmigung",
    notif_type_new_red: "Neue rote Meldung",
    notif_type_photo_pending: "Foto zu prüfen",
    notif_type_face_uncertain: "Gesichter zu überprüfen",
    notif_type_manual_mod: "Manuelle Moderation erforderlich",
    notif_type_sensitive: "Sensibler Inhalt",
    notif_type_legal: "Mögliche rechtliche Probleme",
    notif_type_severe: "Sehr schwerwiegende Meldung",
    tour_start: "Schnelleinführung",
    tour_next: "Weiter",
    tour_prev: "Zurück",
    tour_skip: "Überspringen",
    tour_close: "Einführung schließen",
    tour_dont_show: "Nicht mehr anzeigen",
    tour_restart: "Einführung neu starten",
    tour_step1_title: "Willkommen bei ToClean",
    tour_step1_desc: "Wir zeigen dir in wenigen Sekunden, wie es funktioniert. Du kannst jederzeit überspringen.",
    tour_step2_title: "Erstelle eine Meldung",
    tour_step2_desc: "Nutze den grünen Button, um ein Umwelt-, Stadt- oder Tierschutzproblem zu melden.",
    tour_step3_title: "Öffne eine Meldung",
    tour_step3_desc: "Tippe auf einen Marker auf der Karte, um die Details der Meldung zu öffnen.",
    tour_step4_title: "Folgen und mitmachen",
    tour_step4_desc: "Im Chat der Meldung kannst du Nachrichten schreiben, Maßnahmen koordinieren und Updates erhalten.",
    tour_step5_title: "Marketplace",
    tour_step5_desc: "Verkaufe, verschenke oder melde gefundene wiederverwendbare Gegenstände. Tippe auf die Schaltfläche Veröffentlichen und wähle die Kategorie.",
    tour_step6_title: "Außergewöhnliche Ereignisse",
    tour_step6_desc: "Melde großflächige Notlagen wie Brände, Überschwemmungen oder Stürme, indem du das Gebiet auf der Karte einzeichnest. Veröffentlichungen folgen den Berechtigungen und der Moderation gemäß der Rolle des Nutzers.",
    tour_step7_title: "Bestätigen oder widerlegen",
    tour_step7_desc: "Wenn du vor Ort bist, kannst du bestätigen, dass das Problem noch besteht, oder seine Behebung melden.",
    swipe_values_kicker: "Gemeinsam verändern wir wirklich etwas",
    swipe_values_title: "Eine kleine Geste, eine echte Wirkung vor Ort.",
    swipe_value_1_title: "Melde ein Problem",
    swipe_value_1_desc: "Fotografiere, füge den Standort hinzu und veröffentliche: Deine Meldung ist georeferenziert und für alle sichtbar.",
    swipe_value_2_title: "Verfolge, was in deiner Region passiert",
    swipe_value_2_desc: "Echtzeit-Karte, dringende Hinweise und Ranglisten der aktivsten Gebiete.",
    swipe_value_3_title: "Trage zur Lösung bei",
    swipe_value_3_desc: "Überprüfe, bestätige die Lösung oder spende für ein echtes Aufforstungsprojekt.",
    swipe_cta_enter: "ToClean betreten",
    swipe_cta_hint: "Du kannst die Karte ohne Registrierung erkunden.",
    map_status_all: "Alle Status",
    map_status_selected: "{n} Status ausgewählt",
    map_legend_hint_in_filter: "Die Legende öffnet sich über den Button unten links auf der Karte.",
    cat_reusable_found: "Wiederverwendbare Objekte gefunden",
    cat_gift: "Objekte zu verschenken",
    cat_sale: "Objekte zu verkaufen",
    guest_gate_action: "Um fortzufahren, musst du dich anmelden oder registrieren.",
    guest_gate_category_hidden: "Um diesen Bereich zu sehen, musst du dich anmelden oder registrieren.",
    guest_gate_marketplace: "Um diesen Bereich zu sehen, musst du dich anmelden oder registrieren.",
    guest_gate_title: "Anmeldung erforderlich",
    guest_gate_login: "Anmelden",
    guest_gate_signup: "Registrieren",
    cw_intro: "Beantworte ein paar Fragen: Wir schlagen dir die richtige Farbe vor.",
    cw_step_label: "Schritt {n}",
    cw_examples: "Beispiele",
    cw_yes: "Ja",
    cw_no: "Nein",
    cw_unsure: "Ich bin nicht sicher",
    cw_restart: "Test wiederholen",
    cw_q1: "Gefährdet die Situation gerade jetzt das Leben oder die Unversehrtheit von Menschen oder Tieren?",
    cw_q1_examples: "Aktiver Brand, eingeklemmtes Tier, Erdrutsch oder Überschwemmung mit betroffenen Personen.",
    cw_q1_reason: "Unmittelbare Gefahr für Menschen oder Tiere.",
    cw_q2: "Siehst du ein Austreten, eine Ausbreitung oder Emission von gefährlichen Stoffen ins Wasser, in den Boden oder in die Luft?",
    cw_q2_examples: "Kraftstoffe, Öle, Chemikalien, giftige Dämpfe, beschädigtes Asbest, auslaufende Fässer, plötzliches Fisch- oder Vogelsterben, schwerer Schaden am Ökosystem auch unbekannter Ursache.",
    cw_q2_reason: "Schwere Umweltverschmutzung, aktiv oder schwer zu beheben.",
    cw_q3: "Ist das Problem großflächig, kann es sich verschlimmern oder erfordert es einen Facheinsatz?",
    cw_q3_examples: "Große Mülldeponie, gefährlich wankender Baum, Elektroschrott, Spritzen, sichtbar verschmutzter Wasserlauf.",
    cw_q3_reason: "Ernstes, ausgedehntes Problem oder erfordert Fachpersonal.",
    cw_q4: "Ist das Problem begrenzt, ohne offensichtliche Risiken und mit normaler Reinigung oder Wartung lösbar?",
    cw_q4_examples: "Kleiner Müll, voller Mülleimer, leichte Verwahrlosung, ungefährlich zurückgelassenes Objekt.",
    cw_q4_reason: "Gewöhnliches, begrenztes Problem ohne offensichtliche Risiken.",
    cw_unsure_reason: "Im Zweifelsfall vergeben wir vorläufig Gelb: Es wird neu bewertet.",
    cw_result_red: "Rot — Höchste Priorität",
    cw_result_yellow: "Gelb — Mittlere Priorität",
    cw_result_green: "Grün — Normale Priorität",
    cw_red_admin_note: "Rote Meldungen werden immer von einem Admin vor der Veröffentlichung geprüft.",
    cw_required: "Vervollständige die Anleitung, um die Farbe der Meldung festzulegen.",
    green: "Grün",
    yellow: "Gelb",
    red: "Rot",
    urgent_1h: "1 Stunde",
    urgent_3h: "3 Stunden",
    urgent_6h: "6 Stunden",
    urgent_12h: "12 Stunden",
    urgent_24h: "24 Stunden",
    urg_low: "Niedrig",
    urg_medium: "Mittel",
    urg_high: "Hoch",
    notif_tab_all: "Alle",
    notif_tab_unread: "Ungelesen",
    notif_tab_archived: "Archiviert",
  
    save_changes: "Änderungen speichern",
    all_categories: "Alle Kategorien",
    all_types: "Alle Typen",
    reject_reason_title: "Ablehnungsgrund",
    only_photo: "Nur Foto",
    entire_report: "Gesamte Meldung",
    location_placeholder: "Land, Provinz oder Gemeinde…",
    sort_by: "Sortieren nach",
    sort_recent: "Neueste",
    sort_oldest: "Älteste",
    sort_price_asc: "Preis aufsteigend",
    sort_price_desc: "Preis absteigend",
    condition_like_new: "Wie neu",
    condition_fair: "Akzeptabel",
    gift_delivered: "Übergeben",
    gift_unavailable: "Nicht mehr verfügbar",
    gift_reopen: "Als verfügbar wieder öffnen",
    manage_subscriptions: "Abos verwalten",
    one_time: "Einmalig",
    reject_photo_placeholder: "z.B. Erkennbares Gesicht nicht korrekt verpixelt",
    admin_log_note: "Notiz fürs Admin-Log",
    repeat_password: "Passwort wiederholen",
    back_to_login: "Zurück zum Login",
    report_not_available: "Meldung nicht verfügbar",
    moderation_admin: "Admin-Moderation",
    no_auto_dispatch: "Kein automatischer Versand",
    certified_delivery: "Zertifizierte Zustellung",
    cancel_dispatch: "Vorbereitung abbrechen",
    personal_section: "Persönlicher Bereich",
    stop_following: "Nicht mehr folgen",
    classifications_title: "Ranglisten",
    concluded_events: "Abgeschlossene Events",
    past_extraordinary_events_label: "Verlauf außerordentlicher Events",
    previous_label: "Zurück",
    next_label: "Weiter",
    assistant_label: "Assistent",
    reforestation_new_title: "Neues Aufforstungsprojekt",
    reforestation_update_title: "Projekt aktualisieren",
    no_chat_for_listing: "Kein Chat für diese Anzeige",
    reports_list_label: "Meldungsliste",
    reset_province_filter: "Provinzfilter zurücksetzen",
    remove_prox_filter: "Umkreisfilter entfernen",
    publish_new_tooltip: "Neue Meldung oder Anzeige veröffentlichen",
    seller_actions_label: "Verkäufer-Aktionen",
    selected_as_buyer_label: "Du wurdest als Käufer ausgewählt",
    sort_by_field: "Sortieren nach",
    search_placeholder_marketplace: "Titel, Beschreibung, Kategorie, Provinz…",
    search_placeholder_map: "Titel, Beschreibung, Provinz…",
    clear_search: "Suche löschen",
    tab_territories: "Gebiete",
    tab_generous: "Großzügigste Provinzen",
    most_generous_province_badge: "Großzügigste Provinz",
    assistant_open_tips: "Assistent: Tipps öffnen",
    page_tips_title: "Tipps zur Seite",
    delete_label: "Löschen",
    back_label: "Zurück",
    show_hide: "Einblenden/Ausblenden",
  
    announcement_status: "Anzeigenstatus",
    in_agreement: "Einverstanden",
    closed_listing_note: "Diese Anzeige ist geschlossen. Der Chat-Verlauf bleibt sichtbar, aber neue Anfragen sind nicht mehr möglich.",
    reject_reason_help: "Die Begründung ist erforderlich. Die Notiz ist optional und wird dem Autor nicht angezeigt.",
    scope_label: "Bereich",
    motivation_required: "Begründung *",
    internal_note_optional: "Notiz (intern, optional)",
    reject_action: "Ablehnen",
    confirm_reject: "Ablehnung bestätigen",
    chi_siamo: "Über uns",
    la_nostra_missione: "Unsere Mission",
    search_marketplace_placeholder: "Titel, Beschreibung, Kategorie, Provinz…",
    search_map_placeholder: "Titel, Beschreibung, Provinz…",
    type_specific_label: "Spezifischer Typ",
    reset_password: "Passwort zurücksetzen",
    declare_event_ended_title: "Ereignis als beendet erklären",
    new_reforestation_project: "Neues Aufforstungsprojekt",
    update_reforestation_project: "Projekt aktualisieren",
    no_chat_yet: "Noch kein Chat für diese Anzeige",
    extraordinary_events_history: "Verlauf außergewöhnlicher Ereignisse",
    province_label: "Provinz",
  
    category_first: "Zuerst Kategorie",
    subcategory_first: "Zuerst Unterkategorie",
    no_active_subscriptions: "Du hast noch keine aktiven Abos.",
    monthly: "Monatlich",
    near_me: "In meiner Nähe",
    near_me_activate: "In meiner Nähe (Standort aktivieren)",
    lb_subtitle: "Positiver Vergleich — wir setzen auf Ergebnisse und Beteiligung, nicht auf Probleme.",
    period_week: "Woche",
    period_month: "Monat",
    period_year: "Jahr",
    period_all: "Gesamt",
    assistant_status_on: "Assistent: Aktiv",
    assistant_status_off: "Assistent: Inaktiv",
    on: "Aktivieren",
    off: "Deaktivieren",
    reforestation_new_project_title: "Neues Aufforstungsprojekt",
    reforestation_update_project_title: "Projekt aktualisieren",
    declare_event_ended_title_v2: "Event als beendet melden",
    reject_motivation_title: "Ablehnungsgrund",
    past_events_kicker: "Frühere Sonderevents",
    events_ended: "Beendete Events",
    search_by_word: "Nach Wort suchen",
    category_marketplace: "Kategorie · Marktplatz",
    min_currency: "Min €",
    max_currency: "Max €",
    condition_all: "Alle",
    condition_new: "Neu",
    condition_good_v2: "Gut",
    condition_used: "Gebraucht",
    condition_negotiable: "Verhandelbar",
    condition_label: "Zustand",
    score_label: "Score",
    no_data_period: "Keine Daten für den gewählten Zeitraum.",
    no_donations_period: "Keine Spenden im gewählten Zeitraum erfasst.",
    sale_price_only: "Preis (nur Verkauf)",
    price_min_gt_max: "Minimum ist größer als Maximum: wir wenden trotzdem den korrekten Bereich an.",
    publish_new_report_tooltip: "Neue Meldung oder Anzeige veröffentlichen",
    show_hide_label: "Anzeigen/Ausblenden",
    activate_position_note: "Standort aktivieren",
  
    nav_marketplace: "Marketplace",
  
    backend_unauthorized: "Nicht autorisiert",
    backend_user_not_found: "Benutzer nicht gefunden",
    backend_invalid_credentials: "Ungültige Zugangsdaten",
    backend_email_already_registered: "E-Mail bereits registriert",
    backend_report_not_found: "Meldung nicht gefunden",
    backend_listing_not_found: "Anzeige nicht gefunden",
    backend_event_not_found: "Event nicht gefunden",
    backend_project_not_found: "Projekt nicht gefunden",
    backend_invalid_session: "Ungültige Sitzung",
    backend_token_expired: "Token abgelaufen",
    backend_bad_request: "Ungültige Anfrage",
    backend_server_error: "Interner Serverfehler",
    backend_operation_completed: "Vorgang abgeschlossen",
    backend_saved: "Gespeichert",
    backend_updated: "Aktualisiert",
    backend_deleted: "Gelöscht",
    backend_published: "Veröffentlicht",
    backend_config_incomplete: "Konfiguration nicht abgeschlossen",
    backend_forbidden: "Unzureichende Berechtigungen",
    backend_file_too_large: "Datei zu groß",
    backend_file_bad_format: "Dateiformat nicht unterstützt",
    backend_photo_required: "Foto erforderlich",
    backend_location_required: "Standort erforderlich",
    backend_category_required: "Kategorie erforderlich",
    backend_title_required: "Titel erforderlich",
    backend_description_required: "Beschreibung erforderlich",
    backend_amount_invalid: "Betrag ungültig",
    backend_password_too_short: "Passwort zu kurz",
    backend_passwords_mismatch: "Passwörter stimmen nicht überein",
    backend_email_invalid: "E-Mail ungültig",
    backend_too_many_attempts: "Zu viele Versuche. Versuch's später nochmal.",
    admin_verified_entities: "Verifizierte Einrichtungen",
    admin_verified_entities_super: "Verifizierte Einrichtungen (Super-Admin)",
    admin_management: "Admin-Verwaltung",
    admin_management_super: "Admin-Verwaltung (Super-Admin)",
    admin_reset_super_password: "Super-Admin-Passwort zurücksetzen",
    admin_content_pages: "Inhaltsseiten (Mission / Über uns)",
    admin_pec_config: "PEC-Konfiguration",
    admin_reforestation_manage: "Aufforstung — Projektverwaltung",
    admin_reject_dialog_title: "Ablehnungsgrund",
    admin_reject_reason_help: "Der Grund ist Pflicht. Die Notiz ist optional und wird dem Autor nicht angezeigt.",
    admin_scope_label: "Bereich",
    admin_reason_required: "Grund *",
    admin_internal_note: "Notiz (intern, optional)",
    admin_moderation_label: "Admin-Moderation",
    admin_pec_required_msg: "PEC-Konfiguration erforderlich. Du kannst vorbereiten und die Vorschau anzeigen, aber der Versand wird blockiert, bis der Super-Admin die Konfiguration abschließt.",
    admin_pec_locked_msg: "PEC-Konfiguration erforderlich. Solange du nicht alle Felder ausfüllst, bleibt der PEC-Versand blockiert.",
    admin_no_auto_dispatch: "Kein automatischer Versand",
    admin_certified_delivery: "Zertifizierte Zustellung",
    admin_save_changes: "Änderungen speichern",
    admin_cancel_dispatch: "Vorbereitung abbrechen",
    admin_declare_event_ended: "Event als beendet erklären",
    admin_reforestation_new: "Neues Aufforstungsprojekt",
    admin_reforestation_update: "Projekt aktualisieren",
    admin_content_edit_desc: "Bearbeite den Text von \"Unsere Mission\" und \"Über uns\", ohne den Code anzufassen. Wenn eine Seite nicht veröffentlicht ist, sehen Nutzer die Standardinhalte oder einen schlichten Platzhalter.",
    admin_password_reset_title: "Passwort zurücksetzen",
    admin_new_password: "Neues Passwort",
    admin_repeat_password: "Passwort wiederholen",
    admin_back_to_login: "Zurück zum Login",
    admin_stop_following: "Nicht mehr folgen",
    admin_seller_actions: "Verkäuferaktionen",
    admin_buyer_selected: "Du wurdest als Käufer ausgewählt",
    admin_no_chat_yet: "Noch kein Chat für diese Anzeige",
    admin_publish_new_report: "Neue Meldung oder Anzeige veröffentlichen",
    admin_reset_province_filter: "Provinzfilter zurücksetzen",
    admin_reports_list: "Meldungsliste",
    admin_country_province_place: "Land, Provinz oder Gemeinde…",
    admin_content_placeholder_desc: "Ein Name/Rolle pro Zeile (z. B. Max Mustermann — Gründer)",
    admin_content_placeholder_contact: "E-Mail, PEC, Adresse, Social…",
  
    create: "Erstellen",
    confirm_conclusion: "Abschluss bestätigen",
    optional_note_followers: "Optionale Notiz (wird Followern angezeigt)",
    admin_reset_super_password_confirm: "Einen Passwort-Zurücksetz-Link für dein Super-Admin-Konto erstellen? Der Link ist einmalig und läuft in 15 Minuten ab. Du wirst sofort zum Passwort-Auswahlbildschirm weitergeleitet.",
  
    be_ai_not_configured: "KI nicht konfiguriert",
    be_account_sospeso_o_bannato: "Account gesperrt oder gebannt",
    be_admin_only: "Nur Admin",
    be_admin_role_required: "Admin-Rolle erforderlich",
    be_alert_not_found: "Alarm nicht gefunden",
    be_almeno_un_tra_ritiro_e_spedizione_deve_essere_selezionato: "Abholung oder Versand muss ausgewählt sein",
    be_amount_out_of_range_min_0_50_max_100000: "Betrag außerhalb des Bereichs (min 0,50 €, max 100.000 €)",
    be_cannot_report_yourself: "Du kannst dich nicht selbst melden",
    be_duplicate_report_please_wait_before_re_reporting_the_same_co: "Doppelte Meldung – warte kurz, bevor du denselben Inhalt erneut meldest",
    be_duration_must_be_1_3_6_12_or_24_hours: "Dauer muss 1, 3, 6, 12 oder 24 Stunden sein",
    be_email_already_registered: "E-Mail bereits registriert",
    be_email_gi_in_uso: "E-Mail bereits verwendet",
    be_evento_non_attivo: "Event nicht aktiv",
    be_extension_not_found: "Erweiterung nicht gefunden",
    be_failed_to_upload_blurred_version: "Upload der verpixelten Version fehlgeschlagen",
    be_file_too_large_max_8mb: "Datei zu groß (max. 8 MB)",
    be_forbidden: "Nicht erlaubt",
    be_il_nome_della_ricerca_obbligatorio: "Name der Suche ist erforderlich",
    be_il_prezzo_obbligatorio_per_vendo: "Preis ist erforderlich für Verkaufen",
    be_invalid_action: "Ungültige Aktion",
    be_invalid_category: "Ungültige Kategorie",
    be_invalid_credentials: "Ungültige Anmeldedaten",
    be_invalid_image: "Ungültiges Bild",
    be_invalid_reason: "Ungültiger Grund",
    be_invalid_risk_level: "Ungültige Risikostufe",
    be_invalid_role: "Ungültige Rolle",
    be_invalid_session: "Ungültige Sitzung",
    be_invalid_status: "Ungültiger Status",
    be_la_nuova_password_deve_avere_almeno_6_caratteri: "Neues Passwort muss mindestens 6 Zeichen haben",
    be_la_nuova_password_deve_avere_almeno_8_caratteri: "Neues Passwort muss mindestens 8 Zeichen haben",
    be_la_password_deve_avere_almeno_6_caratteri: "Passwort muss mindestens 6 Zeichen haben",
    be_la_segnalazione_deve_essere_approvata_pubblicata_prima: "Meldung muss zuerst genehmigt/veröffentlicht werden",
    be_le_chat_non_sono_previste_per_gli_oggetti_riutilizzabili_tro: "Keine Chats für gefundene wiederverwendbare Objekte",
    be_login_required_for_this_category: "Login für diese Kategorie erforderlich",
    be_message_cannot_be_empty: "Nachricht darf nicht leer sein",
    be_message_not_found: "Nachricht nicht gefunden",
    be_messaggio_troppo_breve: "Nachricht zu kurz",
    be_motivazione_obbligatoria: "Begründung erforderlich",
    be_moderation_note_required: "Begründung erforderlich (min. 10 Zeichen).",
    ur_note_required_prompt: "Begründung der Maßnahme (erforderlich, min. 10 Zeichen):",
    ur_note_required_toast: "Begründung erforderlich (min. 10 Zeichen).",
    be_nessun_abbonamento_trovato_per_questo_utente: "Kein Abo für diesen User gefunden",
    be_nessuna_richiesta_di_conferma_attiva: "Keine aktive Bestätigungsanfrage",
    be_non_annullabile_dispatch_gi_inviato: "Nicht stornierbar: Versand bereits erfolgt",
    be_non_modificabile_dispatch_gi_inviato: "Nicht änderbar: Versand bereits erfolgt",
    be_non_puoi_rimuovere_il_tuo_ruolo_admin: "Du kannst deine Admin-Rolle nicht entfernen",
    be_non_puoi_seguire_un_annuncio_di_cui_sei_il_proprietario: "Du kannst deine eigene Anzeige nicht folgen",
    be_not_a_reusable_item_report: "Keine Meldung für wiederverwendbare Objekte",
    be_not_authenticated: "Nicht authentifiziert",
    be_not_found: "Nicht gefunden",
    be_notification_has_no_actionable_target: "Benachrichtigung hat kein Aktionsziel",
    be_notification_not_found: "Benachrichtigung nicht gefunden",
    be_only_admin: "Nur Admin",
    be_only_admin_can_apply_user_actions: "Nur Admin kann Benutzeraktionen durchführen",
    be_only_admin_can_delete_reports: "Nur Admin kann Meldungen löschen",
    be_only_admin_moderator: "Nur Admin/Moderator",
    be_only_gift_subcategory_reports_support_this: "Nur Meldungen der Unterkategorie Geschenk unterstützen dies",
    be_only_moderators_can_update_reports: "Nur Moderatoren können Meldungen aktualisieren",
    be_only_owner_or_admin_can_set_this_status: "Nur Eigentümer oder Admin kann diesen Status setzen",
    be_pagina_non_trovata: "Seite nicht gefunden",
    be_password_attuale_errata: "Aktuelles Passwort falsch",
    be_password_non_impostabile_per_questo_account_google: "Passwort kann für diesen Account nicht gesetzt werden (Google)",
    be_photo_not_found: "Foto nicht gefunden",
    be_puoi_salvare_al_massimo_20_ricerche_elimina_prima_una_vecchi: "Max. 20 Suchen speicherbar. Lösche zuerst eine alte",
    be_recurring_donations_are_only_available_for_platform_and_refo: "Wiederkehrende Spenden nur für Plattform und Aufforstung verfügbar",
    be_report_not_found: "Meldung nicht gefunden",
    be_ricerca_non_trovata: "Suche nicht gefunden",
    be_seleziona_prima_l: "Wähle zuerst aus",
    be_sign_in_required: "Anmeldung erforderlich",
    be_sign_in_required_to_view_marketplace: "Anmeldung erforderlich für Marktplatz",
    be_slug_non_valido: "Ungültiger Slug",
    be_solo_super_admin: "Nur Super-Admin",
    be_solo_vendo: "Nur Verkaufen",
    be_solo_admin_o_ente_verificato: "Nur Admin oder verifizierte Organisation",
    be_solo_admin_moderator_o_ente_verificato: "Nur Admin/Moderator oder verifizierte Organisation",
    be_solo_il_proprietario_pu_modificare: "Nur Eigentümer kann bearbeiten",
    be_solo_il_venditore: "Nur Verkäufer",
    be_solo_l: "Nur",
    be_solo_la_controparte_pu_confermare: "Nur Gegenpartei kann bestätigen",
    be_solo_la_controparte_pu_rifiutare: "Nur Gegenpartei kann ablehnen",
    be_solo_super_admin_pu_assegnare_o_revocare_admin: "Nur Super-Admin kann Admin zuweisen oder entfernen",
    be_source_photo_not_found: "Quellfoto nicht gefunden",
    be_stato_non_valido: "Ungültiger Status",
    be_super_admin_only: "Nur Super-Admin",
    be_target_user_not_found: "Zielbenutzer nicht gefunden",
    be_token_non_valido_o_gi_usato: "Token ungültig oder bereits verwendet",
    be_token_non_valido_o_scaduto: "Token ungültig oder abgelaufen",
    be_token_scaduto: "Token abgelaufen",
    be_too_many_reports_in_a_short_time_try_again_later: "Zu viele Meldungen in kurzer Zeit – versuch's später nochmal",
    be_transaction_not_found: "Transaktion nicht gefunden",
    be_translation_failed: "Übersetzung fehlgeschlagen",
    be_unsupported_file_type: "Nicht unterstützter Dateityp",
    be_you_can_only_edit_your_own_messages: "Du kannst nur deine eigenen Nachrichten bearbeiten",
    be_already_moderated: "bereits moderiert",
    be_annuncio_concluso_la_chat_chiusa: "Anzeige abgeschlossen: Chat geschlossen",
    be_categoria_non_valida: "Ungültige Kategorie",
    be_invalid_hours: "Ungültige Stunden",
    be_invalid_kind: "Ungültiger Typ",
    be_invalid_token: "Ungültiger Token",
    be_invalid_type: "Ungültiger Typ",
    be_kind_must_be_one_of_resolved_in_progress_worse_undo: "Typ muss sein: resolved, in_progress, worse, undo",
    be_new_path_not_found_in_files: "Neuer Pfad nicht in Dateien gefunden",
    be_no_changes: "Keine Änderungen",
    be_peer_id_richiesto_per_il_proprietario: "Peer-ID für Eigentümer erforderlich",
    be_photo_path_required: "Fotopfad erforderlich",
    be_photo_index_out_of_range: "Fotoindex außerhalb des Bereichs",
    be_platform_must_be_ios_android_web: "Plattform muss sein: ios|android|web",
    be_polygon_needs_at_least_3_points: "Polygon braucht mindestens 3 Punkte",
    be_reason_required_min_5_chars: "Grund erforderlich (mind. 5 Zeichen)",
    be_regions_required: "Regionen erforderlich",
    be_role_must_be: "Rolle muss sein",
    be_solo_vendo_ha_il_prezzo: "Nur Verkaufen hat Preis",
    be_sottocategoria_non_valida: "Ungültige Unterkategorie",
    be_text_required: "Text erforderlich",
    be_tipo_specifico_non_valido: "Ungültiger spezifischer Typ",
    be_token_required: "Token erforderlich",
    be_utente_non_trovato: "Benutzer nicht gefunden",
    be_cosa_fare_ora_riservato_ad_admin_ed_enti_verificati: "\"Was jetzt tun\" nur für Admin und verifizierte Organisationen",
  
    menu_my_listings: "Meine Anzeigen",
    menu_following: "Beobachtet",
    menu_saved_searches: "Gespeicherte Suchen",
    unread_messages: "ungelesene Nachrichten",
  
    mk_type_sale: "Verkauf",
    mk_type_gift: "Verschenken",
    mk_type_reusable: "Wiederverwendbar gefunden",
  
    mk_title_row: "Verkauf · Verschenken · Wiederverwendbar",
    new_listing: "Neue Anzeige",
    guest_login_sale: "Melde dich an, um Verkaufsanzeigen zu sehen.",
    tab_all: "Alle",
    mk_kicker: "MARKETPLACE",
    tip_mk_3cats: "Marketplace hat drei klare Kategorien: 🟣 Verkauf (mit Preis, Abholung/Versand), 🔵 Verschenken (gratis, vom Besitzer per Chat gewählt), 🟤 Wiederverwendbar gefunden (verlassener Gegenstand: wer zuerst kommt, mahlt zuerst).",
    tip_mk_guest: "Verkaufsanzeigen sind nur für registrierte Nutzer sichtbar. Verschenken und Wiederverwendbar sind für alle auf der Karte sichtbar, aber zum Kontaktieren oder Erstellen musst du dich anmelden.",
  
    event_new_proposal: "Neuer Vorschlag",
    event_extraordinary_kicker: "Außergewöhnliches Ereignis",
    event_intro_line: "Melde ein tatsächlich laufendes Ereignis in einem großen Gebiet (Waldbrand, Überschwemmung, Erdrutsch, Sturm usw.).",
    event_intro_verified_pub: "Deine Veröffentlichung erfolgt sofort als verifizierte Einrichtung.",
    event_intro_review_pub: "Der Vorschlag wird vor der Veröffentlichung von einem Admin geprüft.",
    event_title_label: "Titel",
    event_kind_label: "Kategorie",
    event_whattodo_admin_only: "Was jetzt zu tun ist (nur Admin / verifizierte Einrichtungen)",
    event_started_label: "Startdatum und -uhrzeit (optional)",
    event_publish_btn: "Ereignis veröffentlichen",
    event_send_proposal_btn: "Vorschlag senden",
    event_area_involved: "Betroffenes Gebiet",
    event_area_hint: "Suche das Gebiet (optional) und/oder klicke auf die Karte, um die Polygonpunkte hinzuzufügen. Mindestens 3 Punkte sind erforderlich.",
    event_territory_prefix: "Gebiet",
    event_undo_last: "Letzten rückgängig",
    event_clear_all: "Leeren",
    event_points_count_suffix: "Punkte",
    event_title_required: "Titel ist erforderlich",
    event_polygon_required: "Zeichne ein Gebiet mit mindestens 3 Punkten",
    event_published_ok: "Ereignis veröffentlicht",
    event_proposal_sent: "Vorschlag zur Admin-Prüfung gesendet",
    event_generic_error: "Fehler",
    event_title_placeholder: "Z.B. Waldbrand — Nordküste",
    event_desc_placeholder: "Was passiert, wo, seit wann",
    event_whattodo_placeholder: "Z.B. Nicht nähern. 112 anrufen. Zone X räumen.",
    event_photos_label: "Fotos",
    add_photo_short: "Hinzufügen",
    mkc_description_label: "Beschreibung",
    mkc_choose_placeholder: "Wähle…",
    mkc_condition_label: "Zustand",
    mkc_color_label: "Farbe",
    mkc_color_placeholder: "Z.B. blau, Naturholz",
    mkc_keywords_label: "Schlagwörter",
    mkc_photos_label: "Fotos",
    country_or_province: "Land, Bundesland oder Gemeinde…",
    reports_solved_kicker: "Gelöste Meldungen",
    in_progress_kicker: "In Bearbeitung",
    verified_users_kicker: "Verifizierte Nutzer",
    close_tips: "Tipps schließen",
    what_are_you_selling: "Was verkaufst du?",
    what_are_you_giving: "Was verschenkst du?",
    what_did_you_find: "Was hast du gefunden?",
    change_type: "Typ ändern",
    publish_listing: "Anzeige veröffentlichen",
    approximate_location: "Ungefährer Standort",
    category_first_short: "Erst Kategorie",
    mkc_new_listing_kicker: "Marktplatz · Neue Anzeige",
    mkc_what_type_heading: "Welche Art von Anzeige möchtest du veröffentlichen?",
    mkc_type_choice_desc: "Wähle einen der drei Modi. Jeder Typ hat eigene Regeln (Preis, Chat, Abschluss). Du kannst die Wahl vor der Veröffentlichung ändern.",
    mkc_hint_sale: "Preis erforderlich. Die Anzeige ist nur für registrierte Nutzer sichtbar. Privater Chat mit potenziellen Käufern; am Ende bestätigst du (Verkäufer) und der Käufer den Abschluss.",
    mkc_hint_gift: "Du verschenkst einen Gegenstand an einen anderen Nutzer. Kein Preis. Entscheide frei im Chat, wem du ihn gibst.",
    mkc_hint_reusable: "Du meldest einen zurückgelassenen oder wiederverwendbaren Gegenstand, den du gefunden hast. Kein Preis, keine Zuweisung: wer zuerst kommt, nimmt ihn. Der Chat ist nur informativ.",
    mkc_subtitle_sale: "Veröffentliche eine Verkaufsanzeige: Preis erforderlich, Abholung oder Versand, privater Chat mit den Käufern.",
    mkc_subtitle_gift: "Verschenke einen Gegenstand an einen anderen Nutzer: entscheide frei im Chat, wem du ihn gibst.",
    mkc_subtitle_reusable: "Melde einen wiederverwendbaren, gefundenen oder zurückgelassenen Gegenstand: wer zuerst kommt, nimmt ihn. Chat nur informativ.",
    mkc_title_label: "Titel",
    mkc_category_label: "Kategorie",
    mkc_subcategory_label: "Unterkategorie",
    mkc_itemtype_label: "Spezifischer Typ",
    mkc_subcategory_first: "Erst Unterkategorie",
    mkc_condition_new: "Neu",
    mkc_condition_good: "Gut",
    mkc_condition_used: "Gebraucht",
    mkc_keywords_placeholder: "ikea, doppel, 180cm (durch Kommas getrennt)",
    mkc_price_label: "Preis (€)",
    mkc_negotiable: "Verhandelbar",
    mkc_pickup: "Abholung",
    mkc_shipping: "Versand",
    mkc_position_label: "Ungefährer Standort",
    mkc_position_hint: "Suche das Gebiet (optional) und/oder klicke auf die Karte. Der öffentliche Standort ist ungefähr; die genaue Adresse teilst du im Chat.",
    mkc_territory_prefix: "Gebiet",
    mkc_err_title_required: "Titel ist erforderlich",
    mkc_err_taxonomy_required: "Kategorie, Unterkategorie und spezifischer Typ sind erforderlich",
    mkc_err_position_required: "Wähle den ungefähren Standort auf der Karte",
    mkc_err_price_required: "Preis ist erforderlich",
    mkc_success_published: "Anzeige veröffentlicht",
    mkc_err_generic: "Fehler",
    mkc_upload_failed: "Upload fehlgeschlagen",
    map_reports_list_title: "Liste der Meldungen",
    map_within_km: "im Umkreis von {km} km",
    map_within_area: "in {area}",
    map_count_results: "Ergebnisse",
    map_count_reports: "Meldungen",
    map_clear_area_filter: "Provinzfilter zurücksetzen",
    details_arrow: "Details →",
    events_popup_state_prefix: "Status",
    mk_popup_following: "✓ Gefolgt",
    mk_popup_follow: "🔔 Folgen",
    events_history_kicker: "Verlauf außerordentlicher Ereignisse",
    events_history_count_suffix: "Ereignisse",
    events_history_none: "Keine Ereignisse gefunden.",
    legal_kicker: "Rechtliches Dokument",
    legal_placeholder_title: "Inhalt in Finalisierung",
    legal_placeholder_body: "Der endgültige Text dieses Dokuments wird in Kürze veröffentlicht. Für Informationen kontaktiere uns unter",
    legal_privacy_title: "Datenschutzerklärung",
    legal_terms_title: "AGB",
    legal_community_title: "Community-Regeln",
    legal_marketplace_title: "Marktplatz-Regeln",
    acct_del_kicker: "Kontolöschung",
    acct_del_title: "Lösche dein ToClean-Konto",
    acct_del_intro: "Du kannst jederzeit die Löschung deines ToClean-Kontos und der zugehörigen personenbezogenen Daten anfordern. Die Aktion ist unwiderruflich.",
    acct_del_what_happens_title: "Was bei der Löschung passiert",
    acct_del_what_1: "Dein Konto wird aus der Datenbank entfernt.",
    acct_del_what_2: "Deine Marktplatz-Anzeigen werden entfernt.",
    acct_del_what_3: "Deine Beiträge und Nachrichten werden anonymisiert (Inhalt erhalten, Autor als „Gelöschter Nutzer\" angezeigt).",
    acct_del_what_4: "Deine Sitzungen und Push-Tokens werden sofort widerrufen.",
    acct_del_what_5: "Bereits an Behörden gesendete öffentliche Meldungen bleiben in deren Register (gesetzliche Pflicht).",
    acct_del_how_signed_in_title: "Wenn du angemeldet bist",
    acct_del_how_signed_in_body: "Gehe zu Einstellungen → „Konto löschen\". Du erhältst eine Bestätigungsabfrage vor der unwiderruflichen Aktion.",
    acct_del_go_settings: "Einstellungen öffnen",
    acct_del_how_email_title: "Wenn du keinen Zugang mehr hast",
    acct_del_how_email_body: "Schreibe an info@toclean.app von der mit deinem Konto verknüpften E-Mail. Das ToClean-Team bearbeitet die Anfrage.",
  
    tip_event_scope: "Ein außerordentliches Ereignis betrifft Notfälle auf ausgedehntem Gebiet (Brand, Überschwemmung, Erdrutsch, Sturm usw.), nicht einzelne Objekte oder kleine Meldungen.",
    tip_event_polygon: "Zeichne das Gebiet auf der Karte, indem du die Eckpunkte des Polygons anklickst: mindestens 3 Punkte sind nötig. Benutze «Letzten rückgängig» oder «Löschen», um zu korrigieren.",
    tip_event_moderation: "Wenn du keine verifizierte Einrichtung bist, wird der Vorschlag zur Überprüfung an einen Admin gesendet, bevor er öffentlich auf der Karte erscheint.",
    tip_map_colors: "Die Marker sind nach Risiko eingefärbt: 🟢 Grün = normal, 🟡 Gelb = zu beobachten, 🔴 Rot = dringend. Die Farbe wird durch den kurzen Fragebogen beim Erstellen der Meldung festgelegt.",
    tip_map_filters: "Benutze die Filter, um auszuwählen, welche Meldungen oder Objekte angezeigt werden sollen. Die Karte, die Liste und die Anzahl der Ergebnisse werden sich gemeinsam aktualisieren.",
    tip_map_duplicates: "Bevor du eine neue Meldung eröffnest, prüfe, ob bereits eine in der Nähe existiert: das hilft, Duplikate zu vermeiden und bestehende Reports zu verstärken.",
    tip_rc_wizard: "Die 4 Fragen des Farbcodes weisen automatisch Grün/Gelb/Rot zu, basierend auf wahrgenommenem Risiko, Dringlichkeit, Ausmaß und Auswirkung. Sie sind kein Urteil: sie leiten nur die Priorität der Moderation.",
    tip_rc_privacy: "Deine Fotos werden serverseitig verarbeitet: Gesichter und Kennzeichen werden automatisch unscharf gemacht. Die öffentliche Position ist ungefähr: die genaue Adresse bleibt privat.",
    tip_rc_after_photo: "Um eine normale Meldung als gelöst zu erklären, musst du später ein «Nachher»-Foto vom selben Ort hinzufügen. Nur ein Klick, aber unerlässlich, um die Lösung zu bestätigen.",
  
    publish: "Veröffentlichen",
    submit_for_review: "Zur Prüfung senden",
    state_published: "Veröffentlicht",
    state_in_progress: "In Bearbeitung",
    state_pending: "In Prüfung",
    state_rejected: "Abgelehnt",
    state_draft: "Entwurf",
    state_resolved: "Gelöst",
    state_closed: "Geschlossen",
    state_active: "Aktiv",
    risk_green: "Grün",
    risk_yellow: "Gelb",
    risk_red: "Rot",
    stats_reports_solved: "Gelöste Meldungen",
    stats_reports_progress: "In Bearbeitung",
    stats_users_verified: "Verifizierte Nutzer",
  
    no_period_data: "Keine Daten für den ausgewählten Zeitraum.",
    awaiting_counterpart: "Warten auf Bestätigung der Gegenseite.",
    no_messages_write_first: "Noch keine Nachrichten — schreibe die erste.",
    no_chat_for_listing_msg: "Kein Chat für diese Anzeige",
    // Phase 3 — privater Chat (nur 18+)
    nav_messages: "Nachrichten",
    chat_title: "Nachrichten",
    chat_tab_chats: "Chats",
    chat_tab_requests: "Anfragen",
    chat_tab_invites: "Einladungen",
    chat_tab_blocked: "Blockiert",
    chat_empty: "Noch keine Chats.",
    chat_no_requests: "Keine Anfragen.",
    chat_no_invites: "Keine Einladungen.",
    chat_send: "Senden",
    chat_composer_placeholder: "Nachricht schreiben…",
    chat_request_dialog_title: "Privaten Chat anfragen",
    chat_request_dialog_desc: "Sende eine Anfrage, um einen privaten Chat zu starten. Der Empfänger muss sie annehmen, bevor das Gespräch beginnen kann.",
    chat_request_send: "Anfrage senden",
    chat_request_sent: "Anfrage gesendet",
    chat_message_optional_label: "Initiale Nachricht (optional)",
    chat_message_optional_ph: "Zum Beispiel: Ich habe Interesse an deiner Anzeige…",
    chat_accept: "Annehmen",
    chat_reject: "Ablehnen",
    chat_cancel_req: "Anfrage abbrechen",
    chat_incoming: "Eingehend",
    chat_outgoing: "Gesendet",
    chat_pending_status: "Ausstehend",
    chat_group_create: "Gruppe erstellen",
    chat_group_title_label: "Gruppentitel",
    chat_group_desc_label: "Beschreibung (optional)",
    chat_group_invitees_label: "Nutzer einladen (User-IDs, komma-getrennt)",
    chat_group_picker_label: "Nutzer einladen",
    chat_group_picker_placeholder: "Nach Name suchen…",
    chat_group_picker_selected: "Ausgewählt",
    chat_group_picker_no_results: "Keine Nutzer gefunden.",
    chat_group_picker_min_chars: "Bitte mindestens 2 Zeichen eingeben.",
    chat_group_picker_add: "Hinzufügen",
    chat_group_picker_remove: "Entfernen",
    // Phase 4 — Soziale Links
    social_links_title: "Soziale Links & Website",
    social_links_desc: "Optional. Die Links werden in deinem öffentlichen Profil angezeigt. ToClean prüft oder billigt externe Inhalte nicht.",
    social_links_add: "Link hinzufügen",
    social_links_platform: "Plattform",
    social_links_url: "URL",
    social_links_label: "Bezeichnung (optional)",
    social_links_save: "Links speichern",
    social_links_saved: "Soziale Links gespeichert",
    social_links_url_scheme_err: "Die URL muss mit http:// oder https:// beginnen",
    social_links_url_invalid_err: "Ungültige URL.",
    social_links_url_too_long_err: "URL zu lang.",
    social_links_adult_only: "Nur Nutzer ab 18 Jahren können externe Links hinzufügen.",
    social_links_none: "Keine Links.",
    social_links_platform_website: "Website",
    social_links_platform_other: "Sonstiges",
    social_links_disclaimer: "Externe, nicht verifizierte Links.",
    // Phase 4 — Video
    video_upload_label: "Video hinzufügen",
    video_upload_hint: "Unterstützte Formate: MP4, MOV, M4V, WebM (H.264 oder VP8/VP9). Maximal {mb} MB.",
    video_uploading: "Hochladen…",
    video_upload_progress: "{p}%",
    video_upload_ok: "Video hochgeladen",
    video_upload_err_format: "Nicht unterstütztes Format. Verwende MP4, MOV oder WebM.",
    video_upload_err_hevc: "Dein Video ist in HEVC/H.265 und lässt sich nicht in allen Browsern abspielen. Am iPhone: Einstellungen → Kamera → Formate → „Kompatibel“ und erneut versuchen.",
    hevc_help_title: "iPhone Video-Kompatibilität",
    hevc_help_desc: "Dein iPhone hat diesen Clip in HEVC/H.265 aufgenommen. Folge diesen Schritten für ein ToClean-kompatibles Format.",
    hevc_help_step1: "Öffne Einstellungen",
    hevc_help_step2: "Gehe zu Kamera → Formate",
    hevc_help_step3: "Wähle „Kompatibel“",
    hevc_help_step4: "Nimm ein neues Video auf und lade es hoch",
    hevc_help_note: "Bereits vorhandene HEVC-Aufnahmen im Album bleiben unverändert. Neue Aufnahmen sind H.264/MP4 — kompatibel mit ToClean und den meisten Geräten.",
    hevc_help_show: "Wie behebe ich das?",
    video_upload_err_too_large: "Video zu groß. Grenze {mb} MB.",
    video_upload_err_generic: "Video-Upload fehlgeschlagen.",
    video_delete: "Video löschen",
    video_delete_confirm: "Dieses Video löschen?",
    video_privacy_notice: "Wenn im Video Personen, Kennzeichen oder personenbezogene Daten in direktem Zusammenhang mit einem mutmaßlich rechtswidrigen oder schädlichen Verhalten gezeigt werden, gilt derselbe Privacy Prompt wie für Fotos.",
    video_none: "Keine Videos.",
    video_removed: "Video entfernt.",
    chat_group_leave: "Gruppe verlassen",
    chat_group_member: "Mitglied",
    chat_group_pending_label: "Einladung ausstehend",
    chat_block_user: "Nutzer blockieren",
    chat_unblock_user: "Entsperren",
    chat_blocked_list: "Blockierte Nutzer",
    chat_report_message: "Nachricht melden",
    chat_adult_only: "Private Chats sind nur für Nutzer ab 18 Jahren verfügbar.",
    chat_pending_invite_banner: "Du musst die Einladung annehmen, um Gruppennachrichten zu sehen.",
    chat_open: "Öffnen",
    chat_leave: "Verlassen",
    chat_open_conversation: "Konversation öffnen",
    chat_error_send: "Nachricht konnte nicht gesendet werden.",
    chat_group_created: "Gruppe erstellt",
    chat_group_leave_confirm: "Möchtest du die Gruppe wirklich verlassen?",
    chat_from: "von",
    report_unavailable: "Meldung nicht verfügbar",
    open_report_in_app: "Meldung in der App öffnen",
    content_removed: "Dieser Inhalt wurde entfernt oder ist nicht mehr verfügbar.",
    no_pec_before_button: "Vor diesem Button wird keine zertifizierte E-Mail versendet.",
    no_reports_for_filters: "Keine Meldungen für die aktuellen Filter.",
    reforestation_big_project: "Ein Projekt so groß wie die Zukunft, die wir bauen wollen.",
    not_authorized_dot: "Nicht autorisiert.",
    support_reforestation: "Unterstütze die Aufforstung",
    my_searches_title: "Meine Suchen",
    signup_dob_label: "Geburtsdatum",
    signup_dob_help: "Wird nur verwendet, um zu prüfen ob du mindestens 14 bist. Wird nie angezeigt.",
    signup_terms_prefix: "Ich habe die",
    signup_terms_link: "Nutzungsbedingungen",
    signup_privacy_prefix: "Ich habe die",
    signup_privacy_link: "Datenschutzerklärung",
    signup_terms_required: "Du musst die Bedingungen und den Datenschutz akzeptieren, um dich zu registrieren.",
    signup_age_required: "Du musst mindestens 14 sein, um ToClean zu benutzen.",
    signup_dob_invalid: "Ungültiges Geburtsdatum.",
    complete_profile_title: "Vervollständige dein Profil",
    complete_profile_desc: "Um ToClean weiter zu nutzen bestätige dein Alter und akzeptiere die aktualisierten Bedingungen. Keine weiteren Daten nötig.",
    complete_profile_cta: "Bestätigen und fortfahren",
    complete_profile_age_warning: "Falls du unter 14 bist, wird dein Konto automatisch entfernt, wie es die App-Store-Regeln verlangen.",
    mk_adult_only_banner: "Der Marketplace ist bis 18 nur lesbar. Du kannst Anzeigen ansehen, aber nicht veröffentlichen, kontaktieren oder folgen.",
    mk_adult_only_button_tip: "Verfügbar ab 18 Jahren.",
    mk_new_disabled_minor: "Ab 18",
    report_content_btn: "Inhalt melden",
    report_content_title: "Diesen Inhalt melden",
    report_content_desc: "Unser Moderationsteam wird benachrichtigt. Deine Identität wird nie mit der gemeldeten Person geteilt.",
    report_reason_harassment: "Belästigung oder Bedrohungen",
    report_reason_hate: "Hassrede",
    report_reason_sexual: "Unerwünschter sexueller Inhalt",
    report_reason_spam: "Spam oder Betrug",
    report_reason_privacy: "Datenschutzverletzung",
    report_reason_illegal: "Illegaler Inhalt",
    report_reason_impersonation: "Identitätsdiebstahl",
    report_reason_abuse: "Missbrauch der Plattform",
    report_reason_other: "Sonstiges",
    report_content_details: "Details (optional)",
    report_content_send: "Meldung senden",
    report_content_sent: "Meldung gesendet. Danke.",
    block_user_btn: "Nutzer blockieren",
    unblock_user_btn: "Nutzer entsperren",
    block_user_confirm_title: "Diesen Nutzer blockieren?",
    block_user_confirm_desc: "Du erhältst keine Nachrichten und siehst keine Inhalte mehr von diesem Nutzer. In den Einstellungen kannst du ihn jederzeit entsperren.",
    block_user_ok: "Blockiert",
    unblock_user_ok: "Entsperrt",
    pp_title: "Einen Moment vor dem Veröffentlichen",
    pp_question: "Machst du eine Person, ein Kennzeichen oder andere personenbezogene Daten erkennbar und verknüpfst sie direkt mit einem mutmaßlich rechtswidrigen oder schädigenden Verhalten?",
    pp_answer_no: "Nein",
    pp_answer_yes: "Ja",
    pp_warn_title: "Achtung: Privatsphäre, Ruf und Persönlichkeitsrechte",
    pp_warn_body: "Eine Person erkennbar zu machen und öffentlich mit mutmaßlichen Verfehlungen in Verbindung zu bringen kann rechtliche Folgen für dich und die dargestellte Person haben: Privatsphäre, Ruf und Persönlichkeitsrechte stehen auf dem Spiel.\n\nAus diesem Grund wird der Inhalt zur Prüfung an ToClean gesendet, bevor er ggf. veröffentlicht werden kann.",
    pp_warn_body_review_only: "Eine Person erkennbar zu machen und öffentlich mit mutmaßlichen Verfehlungen in Verbindung zu bringen kann rechtliche Folgen für dich und die dargestellte Person haben: Privatsphäre, Ruf und Persönlichkeitsrechte stehen auf dem Spiel.\n\nAus diesem Grund wird der Inhalt zur Prüfung an ToClean gesendet, bevor er ggf. veröffentlicht werden kann.",
    pp_send_review: "An ToClean zur Prüfung senden",
    pp_ack_label: "Ich bestätige, dass ich für die von mir veröffentlichten Inhalte und Aussagen verantwortlich bin und den Hinweis zu Privatsphäre, Ruf und Persönlichkeitsrechten der dargestellten Personen gelesen habe.",
    pp_publish_anyway: "Trotzdem veröffentlichen",
    pp_sent_review_toast: "Inhalt zur Prüfung gesendet. Wir halten dich auf dem Laufenden.",
    comment_like: "Gefällt mir",
    comment_unlike: "Gefällt mir entfernen",
    comment_likes_count_one: "1 Gefällt mir",
    comment_likes_count_many: "{n} Gefällt mir",
    comment_sort_label: "Sortieren",
    comment_sort_relevant: "Am relevantesten",
    comment_sort_liked: "Am beliebtesten",
    comment_sort_recent: "Neueste",
    comment_sort_oldest: "Älteste",
    comment_report: "Kommentar melden",
    admin_tab_content_reports: "Inhalts-Meldungen",
    admin_tab_events: "Außergewöhnliche Ereignisse",
    what_to_do_now: "Was jetzt zu tun ist",
    reject_reason_prompt: "Grund (optional):",
    delete_event_confirm: "Dieses Ereignis endgültig löschen?",
    cr_no_items: "Keine Inhalts-Meldungen für die aktuellen Filter.",
    cr_status_open: "Offen",
    cr_status_in_review: "In Bearbeitung",
    cr_status_resolved: "Gelöst",
    cr_status_dismissed: "Verworfen",
    cr_target_type: "Typ",
    cr_target_report: "Meldung",
    cr_target_marketplace_listing: "Anzeige",
    cr_target_message: "Chat-Nachricht",
    cr_target_marketplace_message: "Marketplace-Nachricht",
    cr_reported_by: "Gemeldet von",
    cr_reporter_deleted: "gelöschter Nutzer",
    cr_content_author: "Inhalts-Autor",
    cr_open_target: "Gemeldeten Inhalt öffnen",
    cr_action_review: "In Bearbeitung nehmen",
    cr_action_resolve: "Als gelöst markieren",
    legal_info_title: "Rechtliche Informationen und Kontakte",
    legal_privacy_title: "Datenschutzerklärung",
    legal_terms_title: "Nutzungsbedingungen",
    legal_community_title: "Community-Regeln",
    legal_marketplace_title: "Marketplace-Regeln",
    legal_deletion_title: "Konto- und Datenlöschung",
    footer_legal: "Rechtliche Dokumente",
    footer_legal_info: "Rechtliche Informationen",
    footer_privacy: "Datenschutzerklärung",
    footer_terms: "Nutzungsbedingungen",
    footer_community_rules: "Community-Regeln",
    footer_marketplace_rules: "Marketplace-Regeln",
    footer_account_deletion: "Kontolöschung",
    signup_consent_prefix: "Ich akzeptiere die",
    signup_consent_and_the: "und die",
    signup_consent_privacy_note: "und bestätige, dass ich die",
    signup_community_link: "Community-Regeln",
    mkt_rules_gate_title: "Marketplace-Regeln",
    mkt_rules_gate_kicker: "Erste Marketplace-Aktion",
    mkt_rules_gate_desc: "Um ein Inserat zu veröffentlichen, dein Inserat zu bearbeiten oder eine andere Nutzerin bzw. einen anderen Nutzer zu kontaktieren, musst du zuerst die aktuelle Version der Marketplace-Regeln akzeptieren.",
    mkt_rules_gate_read: "Marketplace-Regeln lesen",
    mkt_rules_gate_checkbox: "Ich habe die Marketplace-Regeln gelesen und akzeptiere sie.",
    mkt_rules_gate_accept: "Akzeptieren und fortfahren",
    mkt_rules_gate_cancel: "Abbrechen",
    mkt_rules_gate_required: "Du musst die Marketplace-Regeln akzeptieren, um fortzufahren.",
    mkt_rules_gate_accepted_toast: "Marketplace-Regeln akzeptiert.",
    mkt_rules_gate_error: "Deine Zustimmung konnte nicht gespeichert werden. Bitte versuche es erneut.",
    section_profile_photo: "Profilbild",
    profile_photo_desc: "Füge ein öffentliches Profilbild hinzu. Es ist optional und kann jederzeit entfernt werden.",
    profile_photo_upload: "Foto hochladen",
    profile_photo_replace: "Foto ersetzen",
    profile_photo_remove: "Foto entfernen",
    profile_photo_uploading: "Wird hochgeladen…",
    profile_photo_removing: "Wird entfernt…",
    profile_photo_updated: "Profilbild aktualisiert.",
    profile_photo_removed: "Profilbild entfernt.",
    profile_photo_invalid_type: "Nicht unterstütztes Bildformat. Verwende JPG, PNG oder WEBP.",
    profile_photo_too_large: "Bild zu groß. Maximale Größe: 5 MB.",
    profile_photo_error: "Profilbild konnte nicht aktualisiert werden. Bitte versuche es erneut.",
    profile_photo_hint: "JPG, PNG oder WEBP · max. 5 MB.",
    username_label: "Benutzername",
    username_placeholder: "z. B. max.mustermann",
    username_help: "3–30 Zeichen, nur Buchstaben, Ziffern, Punkt und Unterstrich. Eindeutig und öffentlich.",
    email_private_hint: "Deine E-Mail bleibt privat und wird anderen Nutzenden nie angezeigt.",
    username_too_short: "Der Benutzername muss mindestens 3 Zeichen lang sein.",
    username_too_long: "Der Benutzername darf höchstens 30 Zeichen haben.",
    username_invalid_chars: "Der Benutzername darf nur Buchstaben, Ziffern, Punkt und Unterstrich enthalten.",
    username_reserved: "Dieser Benutzername ist reserviert.",
    username_taken: "Dieser Benutzername ist bereits vergeben.",
    username_required: "Bitte wähle einen Benutzernamen, um fortzufahren.",
    cr_action_dismiss: "Verwerfen",
  },
  es: {
    tagline: "Dejar el mundo mejor de como lo encontramos.",
    hero_title: "Reporta. Verifica. Limpia.",
    hero_subtitle: "ToClean es la plataforma global para transformar un reporte en una acción concreta. Ciudadanos, voluntarios, asociaciones y municipios, juntos en el mismo mapa.",
    cta_map: "Abrir el mapa",
    cta_report: "Crear reporte",
    cta_signin: "Iniciar sesión",
    cta_signup: "Registrarse",
    cta_google: "Continuar con Google",
    cta_donate: "Apoyar",
    nav_map: "Mapa",
    nav_stories: "Historias positivas",
    nav_leaderboard: "Clasificación",
    nav_profile: "Perfil",
    nav_admin: "Admin",
    nav_settings: "Configuración",
    nav_admin_dashboard: "Panel Admin",
    stats_reports: "reportes totales",
    stats_resolved: "problemas resueltos",
    stats_pending: "en proceso",
    stats_users: "miembros activos",
    filters: "Filtros",
    category: "Categoría",
    all: "Todas",
    risk_level: "Riesgo",
    status: "Estado",
    st_published: "Publicada",
    st_in_progress: "En curso",
    st_resolved: "Resuelta",
    st_pending: "En espera",
    st_pending_moderation: "Por aprobar",
    st_concluded: "Concluido",
    st_archived: "Archivado",
    cat_waste: "Residuos",
    cat_environment: "Ambiente",
    cat_animals: "Animales",
    cat_urban: "Deterioro urbano",
    cat_vegetation: "Vegetación peligrosa en vía",
    cat_reusable: "Objetos reutilizables",
    new_report: "Nuevo reporte",
    subcategory: "Subcategoría",
    description: "Descripción",
    upload_photos: "Subir fotos",
    submit: "Enviar reporte",
    cancel: "Cancelar",
    email: "Email",
    password: "Contraseña",
    name: "Nombre",
    role: "Rol",
    citizen: "Ciudadano",
    volunteer: "Voluntario",
    association: "Asociación",
    company: "Empresa / Patrocinador",
    municipality: "Municipio / Ente",
    operator: "Operador",
    already: "¿Ya tienes una cuenta?",
    new_here: "¿Nuevo en ToClean?",
    signin_now: "Iniciar sesión",
    signup_now: "Registrarse",
    coordinate: "Coordinar la intervención",
    send_message: "Enviar",
    write_message: "Escribe un mensaje…",
    confirm: "Confirmar",
    confirm_still: "El problema sigue existiendo",
    confirm_worsened: "Ha empeorado",
    confirm_resolved: "Resuelta",
    confirm_not: "Ya no está presente",
    take_item: "He tomado el objeto",
    interested: "Estoy interesado",
    logout: "Salir",
    reports_created: "Reportes creados",
    confirmations_made: "Confirmaciones proporcionadas",
    reputation: "Reputación",
    donation_title: "Apoya ToClean",
    donation_desc: "Tu contribución financia intervenciones verificadas, recompensas para los voluntarios y el desarrollo de la plataforma.",
    donation_amount: "Importe",
    donation_message: "Mensaje (opcional)",
    donate_now: "Donar ahora",
    donate_min_amount: "Importe mínimo: 0,50 €. También puedes donar sin registrarte.",
    donate_min_error: "Importe mínimo 0,50 €",
    donate_stripe_error: "Error Stripe",
    donate_redirect: "Redirigiendo…",
    donate_message_placeholder: "Un pensamiento para la comunidad…",
    donate_secure: "Pago seguro vía Stripe. Tarjeta de prueba:",
    positive_title: "Historias positivas de la comunidad",
    positive_desc: "Cada marcador gris es un problema que alguien ha vuelto invisible.",
    positive_empty: "Ninguna historia todavía. Tus confirmaciones y tus intervenciones pueden convertirse en la próxima.",
    positive_solved: "Resuelto",
    ai_analyze: "Analizar con IA",
    ai_suggested: "Sugerencia IA",
    emergency_notice: "En emergencias inmediatas (incendios, animales en peligro de muerte, sustancias peligrosas) contacta de inmediato a los servicios de emergencia locales.",
    footer_mission: "ToClean es una plataforma para la acción ambiental. Cada reporte cuenta.",
    footer_platform: "Plataforma",
    footer_platform_items: "Mapa · Reportes · Chat · Recompensas",
    footer_platform_lang: "Multi-idioma (IT · EN)",
    footer_platform_ai: "Moderación IA (GPT-5.2)",
    footer_community: "Comunidad",
    footer_made: "Creado con los voluntarios, para el planeta.",
    hero_slide1_title: "El planeta es hermoso.",
    hero_slide1_sub: "Cada gesto minúsculo decide si lo seguirá siendo.",
    hero_slide2_title: "Juntos se puede.",
    hero_slide2_sub: "Ciudadanos, voluntarios, asociaciones, empresas, municipios — en el mismo mapa.",
    hero_slide3_title: "Una acción, una prueba.",
    hero_slide3_sub: "Fotos antes y después, recibos, cronología pública de cada intervención.",
    hero_prev: "Anterior",
    hero_next: "Siguiente",
    hero_play: "Reproducir",
    hero_pause: "Pausa",
    hero_mute_on: "Activar audio",
    hero_mute_off: "Silenciar",
    community_verified: "Comunidad · verificado",
    hero_action_leaves_mark: "Cada acción deja huella.",
    risk_green_low: "Verde · Bajo",
    risk_green_desc: "Pequeños residuos, objetos, materiales no peligrosos.",
    risk_red_high: "Rojo · Alto",
    risk_red_desc: "Sustancias peligrosas, maltrato animal, evidencias sensibles.",
    mission_kicker: "Misión y Propósito",
    mission_title: "Un planeta más limpio no espera el permiso de nadie.",
    mission_p1: "ToClean es una plataforma <b>independiente</b> creada para conectar a quien ve un problema con quien puede resolverlo. Ciudadanos, voluntarios, asociaciones, empresas y administraciones — en el mismo mapa, con las mismas herramientas, por el mismo objetivo.",
    mission_p2: "No es otra red social. No es una petición. Es una herramienta operativa: <b>foto, verificación, coordinación, prueba del resultado.</b> Simple, transparente, verificable.",
    // ---- MissionPage /missione (contenido aprobado, traducido fielmente del italiano)
    missionpage_kicker: "Misión",
    missionpage_title: "Nuestra misión",
    missionpage_intro: "ToClean nace para hacer que la protección del medio ambiente sea más simple, concreta y compartida. Queremos ofrecer a las personas un espacio donde reportar problemas ambientales, seguir lo que ocurre en su territorio, colaborar con la comunidad y dar nueva vida a los objetos aún utilizables.",
    missionpage_s1_title: "Participación ambiental",
    missionpage_s1_body: "ToClean permite a las personas contribuir al cuidado del territorio mediante reportes ambientales, actualizaciones, iniciativas locales y eventos extraordinarios. Cada contribución puede ayudar a hacer más visibles los problemas y a favorecer intervenciones, colaboración y responsabilidad compartida.",
    missionpage_s2_title: "Reutilización y comunidad",
    missionpage_s2_body: "A través de las secciones Vendo, Regalo y Objetos reutilizables encontrados, ToClean busca reducir los residuos y facilitar la reutilización de lo que aún puede ser útil. El objetivo no es solo crear un Marketplace, sino promover una comunidad más atenta, responsable y cercana al territorio.",
    missionpage_s3_title: "Donaciones y crecimiento del proyecto",
    missionpage_s3_body: "Las personas podrán apoyar ToClean, los reportes ambientales y los proyectos de reforestación mediante contribuciones voluntarias. Los recursos recaudados podrán contribuir al desarrollo, gestión y crecimiento del proyecto, respetando las reglas y la información que se harán públicas.",
    missionpage_future_title: "Visión futura: patrocinadores y recompensas",
    missionpage_future_p1: "ToClean cree que quienes dedican tiempo, energía y compromiso concreto a la protección del medio ambiente merecen ser reconocidos.",
    missionpage_future_p2: "Con el crecimiento de la comunidad y el futuro apoyo de empresas, entidades y patrocinadores, queremos desarrollar un programa transparente de reconocimiento y recompensa para los voluntarios más activos y las iniciativas ambientales más significativas.",
    missionpage_future_p3: "Los patrocinadores podrán apoyar el proyecto, contribuir a las recompensas y obtener una visibilidad claramente identificable como patrocinio. Una parte de los recursos podrá además contribuir a los costes necesarios para mantener y hacer crecer ToClean.",
    missionpage_rewards_title: "Posibles recompensas futuras",
    missionpage_rewards_1: "Vales o descuentos ofrecidos por los patrocinadores",
    missionpage_rewards_2: "Productos ecosostenibles",
    missionpage_rewards_3: "Participación en experiencias o eventos",
    missionpage_rewards_4: "Insignias y reconocimientos digitales",
    missionpage_rewards_5: "Premios ligados a iniciativas ambientales",
    missionpage_rewards_6: "Apoyo concreto a grupos o proyectos de voluntariado",
    missionpage_disclaimer: "El programa de recompensas todavía no está activo. Representa una visión futura de ToClean y podrá realizarse gradualmente solo con un crecimiento real de la comunidad, recursos disponibles y acuerdos concretos con patrocinadores y socios. Antes de la activación se publicarán los criterios, reglas, condiciones y modalidades de asignación.",
    missionpage_updated_at: "Última actualización:",
    missionpage_back_home: "Volver al inicio",
    publish_chooser_title: "¿Qué quieres publicar?",
    publish_chooser_desc: "Elige el tipo de contenido: un reporte ambiental o un anuncio del Marketplace.",
    publish_chooser_report_title: "Reporte ambiental",
    publish_chooser_report_desc: "Residuos, abusos, abandono: ayuda a monitorear y resolver problemas ordinarios.",
    publish_chooser_sale_title: "Objeto en venta",
    publish_chooser_sale_desc: "Publica un anuncio con precio. Chat privado con posibles compradores.",
    publish_chooser_gift_title: "Objeto para regalar",
    publish_chooser_gift_desc: "Sin precio. Decide libremente en el chat a quién entregarlo.",
    publish_chooser_reusable_title: "Reutilizable encontrado",
    publish_chooser_reusable_desc: "Reporta un objeto abandonado o reutilizable. El primero en llegar se lo lleva.",
    listing_type_sale: "Vendo",
    listing_type_gift: "Regalo",
    listing_type_reusable: "Reutilizable encontrado",
    pillar1_title: "Reporta lo que ves",
    pillar1_desc: "Residuos, deterioro urbano, animales en dificultad, incendios, objetos reutilizables. Una foto, la posición GPS, un nivel de riesgo. Ya está.",
    pillar2_title: "Verifica con la comunidad",
    pillar2_desc: "Quien está cerca confirma, añade fotos, indica si el problema ha empeorado o se ha resuelto. La fiabilidad crece con las confirmaciones.",
    pillar3_title: "Coordina personas y medios",
    pillar3_desc: "Cada reporte tiene su chat. Voluntarios, asociaciones, ayuntamientos y operadores profesionales se ponen de acuerdo ahí, sin perderse en mensajes privados.",
    pillar4_title: "Apoya con donaciones y patrocinios",
    pillar4_desc: "Empresas y particulares pueden financiar intervenciones, premios y equipamiento. Cada contribución se rastrea y vincula a un resultado real.",
    pillar5_title: "Premia a quien contribuye",
    pillar5_desc: "Vales, bonos, equipamiento, reconocimientos de los patrocinadores. No se gana dinero con ToClean — pero el tiempo donado nunca se olvida.",
    pillar6_title: "Resultados verificables y transparentes",
    pillar6_desc: "Fotos antes y después, recibos de entrega, historial público de cada intervención. La sección 'Historias positivas' cuenta lo que se ha hecho invisible.",
    how_kicker: "Cómo funciona",
    how_title: "Cinco pasos. Cero burocracia.",
    how_sub: "Desde la foto en el móvil hasta la prueba pública del resultado.",
    how_step_1: "Reporta",
    how_step_1_desc: "Foto, GPS, categoría, riesgo percibido.",
    how_step_2: "Verifica",
    how_step_2_desc: "La comunidad confirma o desmiente.",
    how_step_3: "Coordina",
    how_step_3_desc: "Chat dedicado para voluntarios y operadores.",
    how_step_4: "Intervén",
    how_step_4_desc: "Se organiza la recogida, la limpieza, la recuperación.",
    how_step_5: "Demuestra",
    how_step_5_desc: "Fotos antes/después, recibos de entrega.",
    cat_kicker: "5 categorías · reportables en segundos",
    cat_headline: "Residuos, medio ambiente, animales, deterioro urbano y objetos reutilizables.",
    gray_markers: "Marcadores grises: problemas hechos invisibles.",
    emergency_label: "Emergencias",
    support_chip: "Apoya a ToClean",
    support_title_1: "No pedimos una suscripción.",
    support_title_2: "Pedimos un",
    support_title_3: "gesto voluntario.",
    support_p1: "ToClean es un proyecto independiente. No pertenece a un fondo, no vende datos personales, no llena la interfaz de banners publicitarios. Crece gracias a quienes creen que <b>cuidar el territorio es responsabilidad de todos</b> — y eligen hacerlo también con una pequeña contribución económica.",
    support_p2: "Cada euro donado es completamente <b>opcional</b>. No recibes funciones premium, no obtienes carriles preferenciales, no apareces más arriba en el ranking. Recibes algo más importante: <b>la certeza de que una plataforma para el bien común siga siendo libre, abierta y útil para quienes vengan después de ti.</b>",
    support_cta: "Apoya a ToClean",
    support_discover: "Descubre la misión",
    support_uses_title: "Para qué sirve una donación",
    support_use_1_title: "Servidores e infraestructura",
    support_use_1_desc: "Mapa, fotos, chat: todo debe seguir siendo rápido y disponible 24/7.",
    support_use_2_title: "Nuevas funcionalidades",
    support_use_2_desc: "Detección de duplicados con IA, notificaciones, premios automáticos, app móvil nativa.",
    support_use_3_title: "Moderación",
    support_use_3_desc: "Contenidos sensibles, protección animal, chats limpios: el trabajo invisible que hace la app fiable.",
    support_use_4_title: "Expansión a nuevos países",
    support_use_4_desc: "Traducciones, adaptación normativa, socios locales.",
    support_use_5_title: "Iniciativas ambientales",
    support_use_5_desc: "Pequeños fondos para intervenciones comunitarias verificadas (equipamiento, materiales).",
    support_use_6_title: "Mejora continua",
    support_use_6_desc: "Escucha de usuarios, correcciones, accesibilidad, rendimiento.",
    support_footnote: "Ninguna donación es obligatoria. Puedes usar ToClean para siempre, gratis. Si algún día quieres contribuir, lo encontrarás a mano — nunca en medio.",
    final_kicker: "Empieza ahora",
    final_slogan: "ToClean es simple, gratuita y respetuosa como la Tierra. Ayúdanos a ayudarla.",
    final_desc: "Regístrate y transforma una simple foto en un cambio real. Cada reporte es un paso.",
    feedback_kicker: "Feedback y propuestas de mejora",
    feedback_title: "Ayúdanos a mejorar ToClean.",
    feedback_desc: "Tu sugerencia vale más que diez hojas de ruta internas. Reporta un bug, propón una nueva función, dinos qué no funciona. Puedes escribirnos incluso sin registrarte.",
    feedback_kind: "Tipo",
    feedback_kind_suggestion: "Sugerencia",
    feedback_kind_bug: "Bug / Problema",
    feedback_kind_improvement: "Propuesta de mejora",
    feedback_email_label: "Email (opcional)",
    feedback_email_placeholder: "Solo si quieres que te contactemos",
    feedback_message: "Mensaje",
    feedback_message_placeholder: "¿Qué podemos mejorar?",
    feedback_submit: "Enviar feedback",
    feedback_submitting: "Enviando…",
    feedback_no_signup: "No hace falta registrarse.",
    feedback_min_words: "Escribe al menos algunas palabras",
    feedback_thanks: "¡Gracias por tu feedback!",
    feedback_error: "Error",
    support_title: "No pedimos una suscripción. Pedimos un gesto voluntario.",
    open_details: "Abrir detalles",
    close: "Cerrar",
    set_local_password: "Establece contraseña local",
    set_password_desc: "Añade una contraseña local a tu cuenta de Google para acceder también por email + contraseña.",
    new_password: "Nueva contraseña",
    save: "Guardar",
    confirmations_short: "conf.",
    map_locate_unsupported: "Tu navegador no soporta geolocalización.",
    map_geo_disabled: "Geolocalización desactivada en la configuración.",
    map_geo_denied: "Permiso GPS denegado.",
    map_geo_failed: "Imposible obtener la posición.",
    map_locate_title: "Mi posición",
    map_locate_here: "Centrar aquí",
    geo_no_results_for_area: "Sin resultados para esta área.",
    geo_search_error: "Error de búsqueda",
    geo_temp_unavailable: "Búsqueda temporalmente no disponible — vuelve a intentarlo",
    map_hide_filters: "Ocultar filtros",
    map_show_filters: "Mostrar filtros",
    map_std: "Mapa",
    map_satellite: "Satélite",
    map_tiles_error: "No se pueden cargar las teselas del mapa.",
    map_tiles_check: "Verifica la conexión e inténtalo de nuevo.",
    map_retry: "Reintentar",
    color: "Color",
    show_all: "Mostrar todos",
    reset: "Restablecer",
    all_subcategories: "Todas las subcategorías",
    legend: "Leyenda",
    legend_green_low: "Verde · bajo",
    legend_yellow_med: "Amarillo · medio",
    legend_red_high: "Rojo · alto",
    legend_gray_resolved: "Gris · resuelto",
    legend_blue_progress: "Azul · en curso",
    legend_purple_reusable: "Morado · reutilizable",
    st_active: "Activo",
    st_taken: "En proceso",
    st_review: "En revisión",
    st_standby: "En espera",
    st_reopened: "Reabierto",
    active_prefix: "Activo:",
    fab_expand: "Mostrar botón Crear reporte",
    fab_minimize: "Minimizar",
    auth_home: "Inicio",
    auth_signin_kicker: "Iniciar sesión",
    auth_signup_kicker: "Crear cuenta",
    auth_signin_h: "Bienvenido de nuevo.",
    auth_signup_h: "Únete al movimiento.",
    auth_slogan: "Cada foto es un pequeño cambio.",
    auth_or: "o",
    welcome_back: "¡Bienvenido de nuevo!",
    welcome_new: "¡Bienvenido a ToClean!",
    generic_error: "Error",
    forgot_password: "¿Olvidaste tu contraseña?",
    signin_remember_me: "Recuérdame en este dispositivo",
    reset_back_to_login: "Volver al inicio de sesión",
    reset_title: "Restablecer contraseña",
    reset_request_desc: "Ingresa tu correo electrónico. Te enviaremos un código para restablecer la contraseña.",
    reset_confirm_desc: "Ingresa el código recibido y la nueva contraseña.",
    reset_send_link: "Enviar enlace",
    reset_update_pwd: "Actualizar contraseña",
    reset_updated: "¡Contraseña actualizada! Ahora puedes iniciar sesión.",
    reset_dev_notice_b: "Entorno demo:",
    reset_dev_notice: "código prellenado. En producción llega por correo.",
    reset_min_chars: "Mínimo 6 caracteres",
    token_label: "Código",
    settings_title: "Tu cuenta",
    settings_desc: "Gestiona perfil, seguridad, notificaciones y privacidad.",
    section_profile: "Perfil",
    section_password: "Contraseña",
    section_notifications: "Notificaciones",
    section_language: "Idioma",
    section_geolocation: "Geolocalización",
    section_privacy: "Privacidad",
    section_feedback: "Comentarios y Sugerencias",
    section_session: "Sesión",
    current_password: "Contraseña actual",
    new_password_min: "Nueva contraseña (mín. 6)",
    change_password: "Cambiar contraseña",
    fill_both_fields: "Completa ambos campos",
    profile_updated: "Perfil actualizado",
    password_updated: "Contraseña actualizada",
    lang_updated: "Idioma actualizado",
    local_password_set: "¡Contraseña local establecida!",
    notif_new_reports: "Nuevos reportes en tu zona",
    notif_mentions: "Menciones en los chats",
    notif_status_changes: "Actualizaciones de estado",
    notif_rewards: "Premios y cupones disponibles",
    geo_desc: "Si está activa, ToClean puede solicitar el GPS del navegador para centrar el mapa y precompletar la posición de los reportes. Puedes revocar el permiso en cualquier momento desde la configuración del navegador.",
    geo_browser_denied: "El navegador denegó el GPS. Actívalo en la configuración del navegador.",
    privacy_public_b: "Perfil público.",
    privacy_public_desc: "Tu nombre, la reputación y tus reportes son visibles en el ranking y en la página de perfil. Puedes desactivar la visibilidad aquí.",
    privacy_footnote: "Las fotos de los reportes son siempre públicas. Los datos sensibles (matrículas, rostros) se ocultan hasta la aprobación de los moderadores.",
    logout_label: "Cerrar sesión",
    delete_account: "Eliminar cuenta",
    delete_account_title: "¿Eliminar la cuenta definitivamente?",
    delete_account_desc: "Tu perfil será eliminado. Tus reportes permanecerán visibles de forma anónima para preservar la integridad del historial. Esta acción es irreversible.",
    delete: "Eliminar",
    account_deleted: "Cuenta eliminada",
    loading: "Cargando…",
    reputation_short: "reputación",
    new_report_title: "Transforma la foto en una acción.",
    new_report_desc: "Completa los campos con cuidado. La IA puede ayudarte a categorizar correctamente.",
    add: "Agregar",
    latitude: "Latitud",
    longitude: "Longitud",
    detect: "Detectar",
    position_on_map: "Posición en el mapa · toca para seleccionar",
    geo_denied_msg: "Permiso GPS denegado. Aún puedes seleccionar la posición tocando el mapa o ingresándola manualmente.",
    tiles_not_loaded: "Teselas no cargadas.",
    risk_green_label: "Verde · riesgo bajo",
    risk_green_short_desc: "Residuos pequeños, objetos no peligrosos",
    risk_yellow_label: "Amarillo · riesgo medio",
    risk_yellow_short_desc: "Muchas bolsas, vidrios, materiales pesados",
    risk_red_label: "Rojo · riesgo alto",
    risk_red_short_desc: "Sustancias peligrosas, animales, contenido sensible",
    ai_analyze_desc: "Analiza foto y descripción para sugerir categoría, subcategoría y nivel de riesgo.",
    ai_analyze_action: "Analizar",
    ai_unavailable: "IA no disponible",
    ai_completed: "Análisis IA completado",
    sensitive_content_b: "Contenido sensible.",
    sensitive_content_desc: "El contenido incluye rostros, matrículas, menores, pruebas o acusaciones. Será revisado por moderadores antes de su publicación.",
    describe_placeholder: "¿Qué has visto? Tamaño, contexto, materiales…",
    photo_uploaded: "Foto subida",
    photo_upload_failed: "Subida fallida",
    add_photo_or_desc: "Añade al menos una foto o descripción",
    gps_missing: "Posición GPS faltante",
    select_subcategory: "Selecciona subcategoría",
    description_too_short: "Descripción demasiado corta",
    photo_required: "Al menos una foto es obligatoria",
    report_submitted: "¡Reporte enviado!",
    gps_updated: "GPS actualizado",
    gps_unavailable: "Geolocalización no soportada",
    gps_pick_manual: "Imposible obtener la posición — toca el mapa debajo para seleccionarla manualmente.",
    position_set: "Posición establecida",
    navigate: "Navegar",
    donate_short: "Donar",
    report_sent_b: "¡Reporte enviado!",
    report_sent_desc: "Gracias por tu contribución. La comunidad podrá confirmar y coordinarse aquí debajo.",
    back_to_map: "Volver al mapa",
    risk_prefix: "riesgo",
    confirmations_label: "confirmaciones",
    still_exists: "Sigue existiendo",
    worsened: "Empeorado",
    resolved_short: "Resuelto",
    not_present: "No presente",
    reusable_not_available: "Probablemente ya no disponible",
    timeline: "Cronología",
    no_messages: "Ningún mensaje. Inicia la conversación.",
    login_to_join: "Inicia sesión para participar",
    of_author: "de",
    fullscreen: "Pantalla completa",
    edit_message: "Editar",
    message_edited: "editado",
    saved_confirmation: "Confirmación registrada",
    thanks: "¡Gracias!",
    donate_report_title: "Apoya este reporte",
    donate_report_desc_p1: "Los fondos serán usados",
    donate_report_desc_b1: "prioritariamente para resolver este reporte",
    donate_report_desc_p2: ". Si no fuera posible, se destinarán a intervenciones similares",
    donate_report_desc_b2: "en el mismo Municipio o territorio",
    donate_report_desc_p3: ". Puedes donar",
    donate_report_desc_b3: "incluso sin registrarte",
    donate_free_offer: "Donación libre (mín 0,50 €)",
    donate_report_placeholder: "Un mensaje para la comunidad (opcional)",
    not_authenticated: "No autenticado",
    admin_dashboard_kicker: "Panel de administración",
    admin_overview: "Resumen de moderación",
    admin_users: "Usuarios",
    admin_reports: "Reportes",
    admin_pending: "Pendientes",
    admin_red: "Rojos",
    admin_resolved: "Resueltos",
    admin_donations: "Donaciones",
    tab_moderation: "Moderación",
    tab_all_reports: "Todos los reportes",
    tab_users: "Usuarios",
    tab_donations: "Donaciones y Patrocinios",
    tab_logs: "Registros",
    no_pending: "Ningún reporte pendiente.",
    no_reports: "Ningún reporte.",
    all_statuses: "Todos los estados",
    only_red_risk: "Solo riesgo rojo",
    search_by_name_email: "Buscar por nombre o email…",
    admin_rep_short: "rep",
    admin_suspended: "suspendido",
    admin_banned: "baneado",
    admin_reactivate: "Reactivar",
    admin_suspend: "Suspender",
    admin_remove_ban: "Quitar baneo",
    admin_ban: "Banear",
    approve: "Aprobar",
    reject: "Rechazar",
    archive: "Archivar",
    reopen: "Reabrir",
    hide_evidence: "Ocultar",
    show_evidence: "Mostrar pruebas",
    sensitive_badge: "sensible",
    proposed_label: "propuesto:",
    author_line_by: "de",
    make_public: "Hacer público",
    mark_sensitive: "Marcar como sensible",
    st_pub_visible: "Visible",
    st_hidden: "Oculto",
    st_archived: "Archivado",
    st_rejected: "Rechazado",
    change_state_title: "Cambiar estado del reporte",
    current_status: "Estado actual:",
    reason_optional: "Motivo (opcional)",
    state_change_note: "Ocultar, suspender o archivar",
    state_change_note_b: "no elimina",
    state_change_note_2: "el reporte. Fotos, coordenadas, autor y cronología permanecen sin cambios.",
    state_arrow: "Estado →",
    color_short: "Color",
    admin_actions_title: "Acciones administrativas",
    delete_report_confirm_title: "¿Eliminar este reporte?",
    delete_report_confirm_body: "El reporte se eliminará de forma permanente. Esta acción no se puede deshacer.",
    change_color_title: "Cambiar color (nivel de riesgo)",
    current_color: "Color actual:",
    color_reason_placeholder: "¿Por qué estás cambiando el color?",
    state_reason_placeholder: "¿Por qué estás cambiando el estado?",
    color_change_note: "El cambio de color",
    color_change_note_b: "no",
    color_change_note_2: "publica, oculta, archiva ni elimina el reporte — solo cambia el nivel de riesgo visible en el mapa y los filtros. Historial registrado.",
    apply: "Aplicar",
    delete_report_title: "¿Eliminar el reporte?",
    delete_report_desc: "Esta acción borra definitivamente el reporte, las fotos y el chat asociados. No se puede deshacer.",
    load_error: "Error de carga",
    approved: "Aprobado",
    updated: "Actualizado",
    report_updated: "Reporte actualizado",
    role_updated: "Rol actualizado",
    user_updated: "Usuario actualizado",
    report_deleted: "Reporte eliminado",
    report_reopened: "Reporte reabierto",
    // Bulk selection (Lotto 3 #7/#8)
    bulk_select_all: "Seleccionar todos",
    bulk_selected_of: "{n} de {total} seleccionados",
    bulk_select_row: "Seleccionar esta fila",
    bulk_clear_selection: "Deseleccionar",
    bulk_delete_confirm_title: "¿Eliminar los elementos seleccionados?",
    bulk_delete_confirm_body: "Estás a punto de eliminar permanentemente {n} elementos. Esta acción no se puede deshacer.",
    bulk_deleted_ok: "{n} elementos eliminados",
    bulk_updated_ok: "{n} elementos actualizados",
    bulk_notif_mark_read: "Marcar como leídas",
    bulk_notif_archive: "Archivar",
    no_donations: "No hay donaciones registradas.",
    mod_logs: "Logs de moderación",
    no_logs: "No hay logs disponibles.",
    leaderboard_h: "Quiénes están dejando huella.",
    leaderboard_empty: "Aún no hay miembros activos.",
    thanks_donation: "¡Muchas gracias!",
    donation_recorded: "Tu donación de €{amount} ha sido registrada.",
    confirming: "Confirmando…",
    waiting_stripe: "Esperamos la confirmación de Stripe.",
    payment_cancelled: "Pago cancelado",
    no_charge: "No se realizó ningún cargo.",
    back_to_map_btn: "Volver al mapa",
    stat_reports_created: "Reportes creados",
    stat_confirmations_made: "Confirmaciones realizadas",
    stat_reputation: "Reputación",
    back: "Atrás",
    sub_small_pile: "Montón pequeño",
    sub_bags: "Bolsas de basura",
    sub_plastic: "Plástico",
    sub_glass: "Vidrio",
    sub_paper: "Papel",
    sub_organic: "Orgánico",
    sub_tires: "Neumáticos",
    sub_appliances: "Electrodomésticos",
    sub_furniture: "Muebles",
    sub_construction: "Materiales de construcción",
    sub_industrial: "Residuos industriales",
    sub_hazardous: "Residuos peligrosos",
    sub_asbestos: "Amianto",
    sub_chemicals: "Sustancias químicas",
    sub_oil: "Aceites",
    sub_batteries: "Baterías",
    sub_illegal_dump: "Vertedero ilegal",
    sub_marine: "Residuos en el mar",
    sub_river: "Residuos en el río",
    sub_forest: "Residuos en el bosque",
    sub_sewage_spill: "Vertido de aguas residuales",
    sub_medical_waste: "Residuos sanitarios",
    sub_explosive_flammable: "Explosivos / inflamables",
    sub_water_pollution: "Contaminación del agua",
    sub_soil_pollution: "Contaminación del suelo",
    sub_suspicious_discharge: "Descarga sospechosa",
    sub_smoke_emissions: "Emisiones de humo",
    sub_fire: "Incendio",
    sub_fire_damage: "Daños por incendio",
    sub_damaged_trees: "Árboles dañados",
    sub_degraded_green: "Zonas verdes degradadas",
    sub_water_leak: "Fuga de agua",
    sub_erosion: "Erosión",
    sub_contamination: "Contaminación",
    sub_beach_coast_degradation: "Degradación costera",
    sub_injured: "Animal herido",
    sub_abandoned: "Animal abandonado",
    sub_trapped: "Animal atrapado",
    sub_in_danger: "Animal en peligro",
    sub_suspected_mistreatment: "Sospecha de maltrato",
    sub_poor_conditions: "Condiciones precarias",
    sub_wildlife_distress: "Fauna en dificultad",
    sub_broken_light: "Farola rota",
    sub_broken_bench: "Banco roto",
    sub_damaged_playground: "Parque infantil dañado",
    sub_pothole: "Bache",
    sub_architectural_barrier: "Barrera arquitectónica",
    sub_dangerous_sidewalk: "Acera peligrosa",
    sub_broken_signage: "Señalización rota",
    sub_abandoned_public: "Edificio público abandonado",
    sub_vandalism: "Vandalismo",
    sub_other: "Otro",
    sub_tall_grass: "Hierba alta",
    sub_brambles: "Zarzas",
    sub_dangerous_branches: "Ramas peligrosas",
    sub_obstructing_visibility: "Obstruye la visibilidad",
    sub_fallen_tree: "Árbol caído",
    sub_invasive_plants: "Plantas invasoras",
    sub_road_encroachment: "Invasión de la calzada",
    sub_bed: "Cama",
    sub_mattress: "Colchón",
    sub_table: "Mesa",
    sub_chair: "Silla",
    sub_wardrobe: "Armario",
    sub_sofa: "Sofá",
    sub_home_decor: "Complementos de decoración",
    sub_appliance: "Electrodoméstico",
    sub_electronics: "Electrónica",
    sub_computer: "Ordenador",
    sub_bicycle: "Bicicleta",
    sub_tools: "Herramientas",
    sub_clothing: "Ropa",
    sub_toys: "Juguetes",
    sub_construction_materials: "Materiales de construcción",
    sub_books: "Libros",
    take_photo: "Tomar foto",
    from_gallery: "Elegir de la galería",
    camera_permission_denied: "Permiso de cámara denegado. Aún puedes elegir una foto de la galería.",
    suggested_color: "Color sugerido",
    severity: "Gravedad",
    urgency: "Urgencia",
    confidence: "Confianza",
    trust: "Confiabilidad",
    coherence: "Foto↔texto",
    ai_action: "Acción sugerida",
    add_photo: "Añadir una foto",
    add_photo_desc: "Documenta empeoramientos, cambios, avance de obras o resolución.",
    add_photo_note: "Nota opcional",
    add_photo_note_placeholder: "Ej. empeoró después de la lluvia, o casi resuelto…",
    add_photo_confirm: "Añadir",
    add_photo_success: "Foto añadida",
    add_photo_pending: "Foto enviada a revisión admin (contenido o coherencia por verificar)",
    add_photo_failed: "Error al añadir",
    additional_photos: "Fotos adicionales",
    pending_review: "En revisión",
    urgent_alert: "Aviso urgente temporal",
    urgent_new: "Nuevo aviso urgente",
    urgent_desc: "Reporta un problema temporal (cebos sospechosos, obstáculos, rama caída, inundación, humo, sustancia peligrosa…).",
    urgent_duration: "Duración",
    urgent_radius: "Radio (m)",
    urgent_other: "Otro aviso urgente",
    urgent_free_desc: "Describe libremente el problema y por qué es urgente y temporal",
    urgent_submit: "Publicar aviso",
    urgent_created: "Aviso publicado",
    urgent_state_active: "Activo",
    urgent_state_expired: "Caducado — por verificar",
    urgent_state_resolved: "Resuelto",
    urgent_state_archived: "Archivado",
    urgent_state_pending: "En revisión",
    urgent_still_present: "Confirmo que aún está presente",
    urgent_not_present: "Ya no está presente",
    urgent_time_remaining: "Tiempo restante",
    urgent_extend: "Prórroga",
    urgent_expired: "Caducado",
    fab_urgent: "Evento extraordinario",
    fab_event: "Nuevo evento extraordinario",
    extraordinary_event: "Evento extraordinario",
    extraordinary_events: "Eventos extraordinarios",
    urgent_alerts_list: "Eventos extraordinarios activos",
    no_urgent_alerts: "Ningún evento extraordinario activo.",
    ai_panel_title: "Análisis IA (GPT-5.2)",
    ai_problem: "Problema reconocido",
    ai_reason: "Motivación",
    ai_act_publish_auto: "Publicación automática",
    ai_act_review_admin: "Revisión admin",
    ai_act_reject: "Rechazar",
    legal_badge: "legal",
    filter_urgent_alerts: "Eventos extraordinarios",
    filter_extraordinary_events: "Eventos extraordinarios",
    event_kind_wildfire: "Incendio forestal",
    event_kind_flood: "Inundación",
    event_kind_river_overflow: "Desbordamiento / crecida",
    event_kind_landslide: "Deslizamiento / desprendimiento",
    event_kind_storm: "Tormenta excepcional",
    event_kind_hailstorm: "Granizada excepcional",
    event_kind_tornado: "Tornado",
    event_kind_heavy_snow: "Nevada intensa",
    event_kind_avalanche: "Avalancha",
    event_kind_sea_storm: "Temporal marítimo",
    event_kind_heatwave: "Ola de calor",
    event_kind_coldwave: "Ola de frío",
    urgent_pending_approval: "Pendiente de aprobación",
    urgent_approved: "Aviso aprobado",
    urgent_rejected: "Aviso rechazado",
    approve_urgent: "Aprobar aviso",
    reject_urgent: "Rechazar aviso",
    urgent_map_pick: "Mueve el mapa y toca para seleccionar el punto",
    urgent_center_me: "Centrar en mi ubicación",
    urgent_short_explanation: "Usa esta función para reportar un problema urgente pero temporal. Indica el problema, la ubicación, el radio del área afectada y elige cuánto debe durar el aviso. Después de la aprobación del Admin, el aviso será visible con una cuenta regresiva hasta su caducidad.",
    notifications: "Notificaciones",
    notif_empty: "Ninguna notificación.",
    notif_gone: "Notificación no disponible",
    notif_mark_read: "Marcar como leída",
    notif_mark_unread: "Marcar como no leída",
    notif_archive: "Archivar",
    notif_delete: "Eliminar",
    notif_open: "Abrir",
    notif_all_read: "Marcar todo como leído",
    notif_view_all: "Ver todas las notificaciones",
    extensions_pending: "Prórrogas pendientes",
    no_extensions_pending: "Ninguna prórroga por aprobar.",
    photos_pending: "Fotos en revisión",
    admin_home_title: "Panel de moderación",
    admin_home_desc: "Selecciona una sección para comenzar.",
    admin_card_red: "Rojas",
    admin_card_yellow: "Amarillas",
    admin_card_green: "Verdes",
    admin_card_photos_review: "Moderación Admin",
    admin_card_urgent: "Eventos extraordinarios",
    admin_section_others: "Otro",
    admin_others_desc: "Usuarios · Feedback · Donaciones · Chat · Registro · Archivo · Ajustes",
    admin_tab_users: "Usuarios",
    admin_tab_feedback: "Feedback",
    admin_tab_donations: "Donaciones",
    admin_tab_logs: "Registro",
    admin_tab_archive: "Archivo",
    admin_tab_settings: "Ajustes",
    admin_filter_status: "Filtrar por estado",
    admin_st_in_progress: "En curso",
    admin_st_pending_approval: "Pendiente de aprobación",
    admin_st_approved: "Aprobadas",
    admin_st_archived: "Archivadas",
    admin_st_all: "Todas",
    admin_urgent_state_pending: "Por aprobar",
    admin_urgent_state_active: "Activos",
    admin_urgent_state_expired: "Caducados — por verificar",
    admin_urgent_ext_pending: "Prórrogas en espera",
    admin_urgent_state_archived: "Archivados",
    admin_urgent_state_rejected: "Rechazados",
    admin_urgent_state_all: "Todos",
    advanced_filters: "Filtros avanzados",
    filter_search_placeholder: "Busca por título, descripción, autor, lugar o ID",
    filter_ai_conf: "Confianza IA",
    filter_sensitive: "Contenidos sensibles",
    filter_legal: "Posibles problemas legales",
    photos_review_title: "Moderación Admin",
    photos_review_empty: "No hay fotos por revisar.",
    photos_review_source: "Procedencia",
    photos_review_reason: "Motivo",
    photos_review_priority: "Prioridad",
    src_new_report: "Nuevo reporte",
    src_added_photo: "Foto añadida",
    src_urgent: "Aviso urgente",
    src_extension: "Solicitud de prórroga",
    reason_photo_incoherent: "Foto incoherente",
    reason_photo_text_incoherent: "Foto y descripción no coherentes",
    reason_category_mismatch: "Categoría incorrecta",
    reason_subcategory_mismatch: "Subcategoría incorrecta",
    reason_severity_higher: "Gravedad superior",
    reason_color_mismatch: "Color no coherente",
    reason_sensitive_content: "Contenido sensible",
    reason_legal_issues: "Posible problema legal",
    reason_spam_or_irrelevant: "Spam o irrelevante",
    reason_low_ai_confidence: "Baja confianza IA",
    reason_ai_suggests_review: "IA sugiere revisión",
    reason_face_blur_failed: "Desenfocar rostros falló",
    reason_face_blur_uncertain: "Desenfocar rostros incierto",
    reason_red_requires_approval: "Roja: aprobación requerida",
    reason_sensitive_animal_category: "Subcategoría animal sensible",
    reason_possibly_criminal_content: "Posible escena de delito",
    publish_as_green: "Publicar como Verde",
    publish_as_yellow: "Publicar como Amarilla",
    publish_as_red: "Publicar como Roja",
    photo_approved_as_color: "Foto aprobada y publicada como {color}",
    original_unavailable: "Original ya no disponible",
    original_unavailable_hint: "Original ya no disponible — aún puedes aplicar un desenfoque adicional sobre la versión actual.",
    admin_card_events: "Eventos extraordinarios",
    total: "totales",
    admin_card_marketplace: "Marketplace",
    mk_type_sale: "Vendo",
    mk_type_gift: "Regalo",
    mk_type_reusable: "Reutilizable encontrado",
    mk_st_published: "Activo",
    mk_st_archived: "Archivado",
    mk_st_closed: "Concluido",
    mk_st_pending: "Pendiente de confirmación",
    mk_search_placeholder: "Buscar título, autor, provincia…",
    mk_empty: "No hay anuncios en esta vista",
    mk_admin_details: "Detalles admin",
    mk_found_checks_title: "Confirmaciones de usuarios",
    mk_found_present: "Objeto presente",
    mk_found_not_present: "Objeto no presente",
    mk_found_present_short: "Presente",
    mk_found_not_present_short: "No presente",
    mk_found_no_checks: "Sin confirmaciones aún.",
    mk_found_check_saved: "¡Gracias! Tu confirmación se ha guardado.",
    mk_found_intro: "¿Has ido al lugar? Ayuda a la comunidad: indica si el objeto sigue allí.",
    mk_found_note_optional: "Nota (opcional)",
    delete_listing_title: "Eliminar anuncio",
    delete_listing_desc: "El anuncio se eliminará permanentemente. Esta acción no se puede deshacer.",
    reactivate: "Reactivar",
    reactivated: "Reactivado",
    close: "Cerrar",
    chat_translate: "Traducir",
    chat_show_original: "Mostrar original",
    chat_translated_badge: "traducción automática",
    chat_translating: "Traduciendo…",
    chat_translate_error: "Traducción fallida",
    report_user: "Reportar usuario",
    report_user_title: "Reportar a este usuario",
    report_user_reason: "Motivo",
    ur_reason_spam: "Spam",
    ur_reason_offensive: "Lenguaje ofensivo",
    ur_reason_harassment: "Acoso o amenazas",
    ur_reason_misleading: "Contenidos falsos o engañosos",
    ur_reason_bad_chat: "Comportamiento incorrecto en los chats",
    ur_reason_misuse: "Uso indebido de la app",
    ur_reason_false_reports: "Reportes repetidamente falsos",
    ur_reason_other: "Otro motivo",
    report_user_explanation: "Breve explicación (opcional)",
    report_user_send: "Enviar reporte",
    report_user_sent: "Reporte enviado de forma privada",
    report_user_privacy: "El reporte es privado y no se mostrará al usuario reportado.",
    admin_tab_user_reports: "Reportes de usuarios",
    ur_status_new: "Nuevos",
    ur_status_in_review: "En revisión",
    ur_status_resolved: "Resueltos",
    ur_status_archived: "Archivados",
    ur_status_rejected: "Rechazados",
    ur_status_all: "Todos",
    ur_reports_count: "Previos",
    ur_action_warn: "Advertencia",
    ur_action_limit_chat: "Limitar chat",
    ur_action_limit_publish: "Limitar publicaciones",
    ur_action_suspend: "Suspender temporalmente",
    ur_action_ban: "Bloquear cuenta",
    ur_action_close: "Archivar sin sanciones",
    ur_action_hours: "Duración (horas)",
    ur_open_context: "Abrir contexto",
    ur_no_items: "No hay reportes de usuarios.",
    confirm_choose_status: "Elige el estado",
    confirm_in_progress: "En curso",
    confirm_worse: "Empeorada",
    confirm_undo: "Cancelar confirmación",
    confirm_change_title: "Modificar confirmación",
    confirm_change_desc: "¿Quieres modificar tu confirmación de \"{from}\" a \"{to}\"?",
    confirm_change_ok: "Sí, modificar",
    confirm_your_current: "Tu confirmación actual",
    manual_blur: "Desenfocar manualmente",
    manual_blur_title: "Editor de desenfoque",
    manual_blur_desc: "Dibuja rectángulos sobre las áreas sensibles. Las fotos se publican solo después de guardar.",
    manual_blur_mode_blur: "Desenfoque",
    manual_blur_mode_pixel: "Pixelado",
    manual_blur_undo: "Deshacer",
    manual_blur_redo: "Rehacer",
    manual_blur_clear: "Borrar todo",
    manual_blur_save: "Guardar versión difuminada",
    manual_blur_saved: "Versión difuminada guardada",
    manual_blur_no_regions: "Añade al menos un área antes de guardar.",
    manual_blur_hint: "Haz clic y arrastra para dibujar. Arrastra el borde para redimensionar. Doble clic para eliminar.",
    download_original: "Descargar original",
    upload_replacement: "Subir versión difuminada",
    replacement_uploaded: "Versión reemplazada",
    admin_only_action: "Reservado para Admins autorizados",
    sub_gift: "Objeto para regalar",
    nav_reforestation: "Reforestación",
    share: "Compartir",
    deleted_user_label: "Usuario eliminado",
    copy_link: "Copiar enlace",
    copy_link_ok: "Enlace copiado al portapapeles",
    copy_link_err: "No se pudo copiar",
    filter_area: "Provincia / área administrativa",
    notif_type_chat_message: "Nuevo mensaje en chat",
    notif_type_report_update: "Actualización de reporte",
    notif_type_photo_approved: "Foto aprobada",
    notif_type_photo_rejected: "Foto rechazada",
    notif_type_photo_review: "Foto en revisión",
    notif_type_urgent_approved: "Aviso aprobado",
    notif_type_urgent_rejected: "Aviso rechazado",
    notif_type_urgent_expiring: "Aviso por expirar",
    notif_type_report_status: "Cambio de estado del reporte",
    notif_type_content_report_resolved: "Reporte de contenido gestionado",
    notif_type_content_report_dismissed: "Reporte de contenido revisado",
    notif_type_new_feedback: "Nuevo comentario",
    notif_type_new_urgent: "Nuevo aviso urgente por aprobar",
    notif_type_new_red: "Nuevo reporte rojo",
    notif_type_photo_pending: "Foto por revisar",
    notif_type_face_uncertain: "Rostros por verificar",
    notif_type_manual_mod: "Moderación manual requerida",
    notif_type_sensitive: "Contenido sensible",
    notif_type_legal: "Posibles problemas legales",
    notif_type_severe: "Reporte muy grave",
    tour_start: "Guía rápida",
    tour_next: "Siguiente",
    tour_prev: "Atrás",
    tour_skip: "Saltar",
    tour_close: "Cerrar guía",
    tour_dont_show: "No mostrar más",
    tour_restart: "Reiniciar guía",
    tour_step1_title: "Bienvenido a ToClean",
    tour_step1_desc: "Te mostramos cómo funciona en pocos segundos. Puedes saltar en cualquier momento.",
    tour_step2_title: "Crea un reporte",
    tour_step2_desc: "Usa el botón verde para reportar un problema ambiental, urbano o relacionado con animales.",
    tour_step3_title: "Abre un reporte",
    tour_step3_desc: "Toca un marcador en el mapa para abrir la ficha del reporte.",
    tour_step4_title: "Sigue y participa",
    tour_step4_desc: "En el chat del reporte puedes escribir mensajes, coordinar acciones y recibir actualizaciones.",
    tour_step5_title: "Marketplace",
    tour_step5_desc: "Vende, regala o publica objetos reutilizables encontrados. Toca el botón Publicar y elige la tipología.",
    tour_step6_title: "Eventos extraordinarios",
    tour_step6_desc: "Reporta emergencias de gran alcance como incendios, inundaciones o tormentas dibujando el área en el mapa. Las publicaciones siguen los permisos y la moderación previstos por el rol del usuario.",
    tour_step7_title: "Confirma o desmiente",
    tour_step7_desc: "Si estás en el lugar, puedes confirmar que el problema sigue presente o reportar su resolución.",
    swipe_values_kicker: "Juntos cambiamos de verdad",
    swipe_values_title: "Un gesto pequeño, un impacto real en el territorio.",
    swipe_value_1_title: "Reporta un problema",
    swipe_value_1_desc: "Toma una foto, añade la ubicación y publica: tu reporte queda geolocalizado y visible para todos.",
    swipe_value_2_title: "Sigue lo que pasa en tu territorio",
    swipe_value_2_desc: "Mapa en tiempo real, avisos urgentes y rankings de las zonas más activas.",
    swipe_value_3_title: "Contribuye a la solución",
    swipe_value_3_desc: "Verifica, confirma la resolución o dona a un proyecto real de reforestación.",
    swipe_cta_enter: "Entrar a ToClean",
    swipe_cta_hint: "Puedes explorar el mapa sin registrarte.",
    map_status_all: "Todos los estados",
    map_status_selected: "{n} estados seleccionados",
    map_legend_hint_in_filter: "La leyenda se abre desde el botón abajo a la izquierda del mapa.",
    cat_reusable_found: "Objetos reutilizables encontrados",
    cat_gift: "Objetos de regalo",
    cat_sale: "Objetos en venta",
    guest_gate_action: "Para continuar debes iniciar sesión o registrarte.",
    guest_gate_category_hidden: "Para ver esta sección debes iniciar sesión o registrarte.",
    guest_gate_marketplace: "Para ver esta sección debes iniciar sesión o registrarte.",
    guest_gate_title: "Acceso requerido",
    guest_gate_login: "Iniciar sesión",
    guest_gate_signup: "Registrarse",
    cw_intro: "Responde a pocas preguntas: te sugeriremos el color adecuado.",
    cw_step_label: "Paso {n}",
    cw_examples: "Ejemplos",
    cw_yes: "Sí",
    cw_no: "No",
    cw_unsure: "No estoy seguro",
    cw_restart: "Repetir la prueba",
    cw_q1: "¿La situación está poniendo en peligro, en este momento, la vida o la integridad de personas o animales?",
    cw_q1_examples: "Incendio activo, animal atrapado, derrumbe o inundación con personas involucradas.",
    cw_q1_reason: "Peligro inmediato para personas o animales.",
    cw_q2: "¿Ves una fuga, dispersión o emisión de sustancias peligrosas en el agua, el suelo o el aire?",
    cw_q2_examples: "Combustibles, aceites, sustancias químicas, humos tóxicos, asbesto dañado, bidones con fugas, mortandad repentina de peces o aves, daño grave al ecosistema incluso de causa desconocida.",
    cw_q2_reason: "Contaminación ambiental grave, activa o difícil de reparar.",
    cw_q3: "¿El problema es extenso, puede empeorar o requiere una intervención especializada?",
    cw_q3_examples: "Basurero grande, árbol en riesgo de caída, residuos electrónicos, jeringas, curso de agua visiblemente contaminado.",
    cw_q3_reason: "Problema serio, extenso o que requiere personal especializado.",
    cw_q4: "¿El problema es limitado, sin riesgos evidentes y resoluble con limpieza o mantenimiento normal?",
    cw_q4_examples: "Basura pequeña, basurero lleno, deterioro leve, objeto abandonado no peligroso.",
    cw_q4_reason: "Problema ordinario, limitado y sin riesgos evidentes.",
    cw_unsure_reason: "En caso de duda, aplicamos un amarillo provisional: será reevaluado.",
    cw_result_red: "Rojo — Prioridad máxima",
    cw_result_yellow: "Amarillo — Prioridad media",
    cw_result_green: "Verde — Prioridad ordinaria",
    cw_red_admin_note: "Las denuncias rojas siempre son verificadas por un Admin antes de su publicación.",
    cw_required: "Completa la guía para establecer el color de la denuncia.",
    green: "Verde",
    yellow: "Amarillo",
    red: "Rojo",
    urgent_1h: "1 hora",
    urgent_3h: "3 horas",
    urgent_6h: "6 horas",
    urgent_12h: "12 horas",
    urgent_24h: "24 horas",
    urg_low: "Baja",
    urg_medium: "Media",
    urg_high: "Alta",
    notif_tab_all: "Todas",
    notif_tab_unread: "No leídas",
    notif_tab_archived: "Archivadas",
  
    save_changes: "Guardar cambios",
    all_categories: "Todas las categorías",
    all_types: "Todos los tipos",
    reject_reason_title: "Motivo de rechazo",
    only_photo: "Solo foto",
    entire_report: "Reporte completo",
    location_placeholder: "País, provincia o municipio…",
    sort_by: "Ordenar por",
    sort_recent: "Más recientes",
    sort_oldest: "Menos recientes",
    sort_price_asc: "Precio ascendente",
    sort_price_desc: "Precio descendente",
    condition_like_new: "Como nuevo",
    condition_fair: "Aceptable",
    gift_delivered: "Entregado",
    gift_unavailable: "No disponible",
    gift_reopen: "Reabrir como disponible",
    manage_subscriptions: "Gestionar suscripciones",
    one_time: "Una vez",
    reject_photo_placeholder: "Ej. Rostro reconocible no enmascarado correctamente",
    admin_log_note: "Nota para el log Admin",
    repeat_password: "Repetir contraseña",
    back_to_login: "Volver al login",
    report_not_available: "Reporte no disponible",
    moderation_admin: "Moderación admin",
    no_auto_dispatch: "Sin envío automático",
    certified_delivery: "Entrega certificada",
    cancel_dispatch: "Cancelar preparación",
    personal_section: "Sección personal",
    stop_following: "Dejar de seguir",
    classifications_title: "Clasificaciones",
    concluded_events: "Eventos concluidos",
    past_extraordinary_events_label: "Historial eventos extraordinarios",
    previous_label: "Anterior",
    next_label: "Siguiente",
    assistant_label: "Asistente",
    reforestation_new_title: "Nuevo proyecto de reforestación",
    reforestation_update_title: "Actualizar proyecto",
    no_chat_for_listing: "Sin chat para este anuncio",
    reports_list_label: "Lista de reportes",
    reset_province_filter: "Restablecer filtro provincia",
    remove_prox_filter: "Quitar filtro proximidad",
    publish_new_tooltip: "Publica un nuevo reporte o anuncio",
    seller_actions_label: "Acciones vendedor",
    selected_as_buyer_label: "Has sido seleccionado como comprador",
    sort_by_field: "Ordenar por",
    search_placeholder_marketplace: "Título, descripción, categoría, provincia…",
    search_placeholder_map: "Título, descripción, provincia…",
    clear_search: "Borrar búsqueda",
    tab_territories: "Territorios",
    tab_generous: "Provincias más generosas",
    most_generous_province_badge: "Provincia más generosa",
    assistant_open_tips: "Asistente: abrir consejos",
    page_tips_title: "Consejos de la página",
    delete_label: "Eliminar",
    back_label: "Atrás",
    show_hide: "Mostrar/ocultar",
  
    announcement_status: "Estado del anuncio",
    in_agreement: "De acuerdo",
    closed_listing_note: "Este anuncio está cerrado. El historial del chat sigue visible pero no se admiten nuevos mensajes de solicitud.",
    reject_reason_help: "La motivación es obligatoria. La nota es opcional y no se mostrará al autor.",
    scope_label: "Ámbito",
    motivation_required: "Motivación *",
    internal_note_optional: "Nota (interna, opcional)",
    reject_action: "Rechazar",
    confirm_reject: "Confirmar rechazo",
    chi_siamo: "Quiénes somos",
    la_nostra_missione: "Nuestra misión",
    search_marketplace_placeholder: "Título, descripción, categoría, provincia…",
    search_map_placeholder: "Título, descripción, provincia…",
    type_specific_label: "Tipo específico",
    reset_password: "Restablecer contraseña",
    declare_event_ended_title: "Declarar evento finalizado",
    new_reforestation_project: "Nuevo proyecto de reforestación",
    update_reforestation_project: "Actualizar proyecto",
    no_chat_yet: "Aún no hay chat para este anuncio",
    extraordinary_events_history: "Historial de eventos extraordinarios",
    province_label: "Provincia",
  
    category_first: "Primero la categoría",
    subcategory_first: "Primero la subcategoría",
    no_active_subscriptions: "Aún no tienes suscripciones activas.",
    monthly: "Mensual",
    near_me: "Cerca de mí",
    near_me_activate: "Cerca de mí (activa la ubicación)",
    lb_subtitle: "Comparación positiva — apostamos por resultados y participación, no por problemas.",
    period_week: "Semana",
    period_month: "Mes",
    period_year: "Año",
    period_all: "General",
    assistant_status_on: "Asistente: Activo",
    assistant_status_off: "Asistente: Inactivo",
    on: "Activa",
    off: "Desactiva",
    reforestation_new_project_title: "Nuevo proyecto de reforestación",
    reforestation_update_project_title: "Actualizar proyecto",
    declare_event_ended_title_v2: "Declarar evento finalizado",
    reject_motivation_title: "Motivo de rechazo",
    past_events_kicker: "Historial de eventos extraordinarios",
    events_ended: "Eventos finalizados",
    search_by_word: "Buscar por palabra",
    category_marketplace: "Categoría · Marketplace",
    min_currency: "Mín €",
    max_currency: "Máx €",
    condition_all: "Todas",
    condition_new: "Nuevo",
    condition_good_v2: "Bueno",
    condition_used: "Usado",
    condition_negotiable: "Negociable",
    condition_label: "Condición",
    score_label: "Puntuación",
    no_data_period: "No hay datos para el periodo seleccionado.",
    no_donations_period: "No hay donaciones registradas en el periodo seleccionado.",
    sale_price_only: "Precio (solo Vendo)",
    price_min_gt_max: "El mínimo es mayor que el máximo: aplicamos el intervalo correcto de todas formas.",
    publish_new_report_tooltip: "Publica un nuevo reporte o anuncio",
    show_hide_label: "Mostrar/ocultar",
    activate_position_note: "activa la ubicación",
  
    nav_marketplace: "Marketplace",
  
    backend_unauthorized: "No autorizado",
    backend_user_not_found: "Usuario no encontrado",
    backend_invalid_credentials: "Credenciales inválidas",
    backend_email_already_registered: "Email ya registrado",
    backend_report_not_found: "Reporte no encontrado",
    backend_listing_not_found: "Anuncio no encontrado",
    backend_event_not_found: "Evento no encontrado",
    backend_project_not_found: "Proyecto no encontrado",
    backend_invalid_session: "Sesión inválida",
    backend_token_expired: "Token vencido",
    backend_bad_request: "Solicitud inválida",
    backend_server_error: "Error interno del servidor",
    backend_operation_completed: "Operación completada",
    backend_saved: "Guardado",
    backend_updated: "Actualizado",
    backend_deleted: "Eliminado",
    backend_published: "Publicado",
    backend_config_incomplete: "Configuración incompleta",
    backend_forbidden: "Permisos insuficientes",
    backend_file_too_large: "Archivo demasiado grande",
    backend_file_bad_format: "Formato de archivo no soportado",
    backend_photo_required: "Foto obligatoria",
    backend_location_required: "Ubicación obligatoria",
    backend_category_required: "Categoría obligatoria",
    backend_title_required: "Título obligatorio",
    backend_description_required: "Descripción obligatoria",
    backend_amount_invalid: "Monto inválido",
    backend_password_too_short: "Contraseña demasiado corta",
    backend_passwords_mismatch: "Las contraseñas no coinciden",
    backend_email_invalid: "Email inválido",
    backend_too_many_attempts: "Demasiados intentos. Intenta más tarde.",
    admin_verified_entities: "Entidades verificadas",
    admin_verified_entities_super: "Entidades verificadas (Super Admin)",
    admin_management: "Gestión Admin",
    admin_management_super: "Gestión Admin (Super Admin)",
    admin_reset_super_password: "Restablecer contraseña Super Admin",
    admin_content_pages: "Páginas de contenido (Misión / Quiénes somos)",
    admin_pec_config: "Configuración PEC",
    admin_reforestation_manage: "Reforestación — gestión de proyectos",
    admin_reject_dialog_title: "Motivo del rechazo",
    admin_reject_reason_help: "El motivo es obligatorio. La nota es opcional y no se mostrará al autor.",
    admin_scope_label: "Ámbito",
    admin_reason_required: "Motivo *",
    admin_internal_note: "Nota (interna, opcional)",
    admin_moderation_label: "Moderación admin",
    admin_pec_required_msg: "Se necesita configuración PEC. Puedes preparar y ver la vista previa, pero el envío será bloqueado hasta que el Super Admin complete la configuración.",
    admin_pec_locked_msg: "Se necesita configuración PEC. Hasta que completes todos los campos, los envíos de PEC quedan bloqueados.",
    admin_no_auto_dispatch: "Sin envío automático",
    admin_certified_delivery: "Entrega certificada",
    admin_save_changes: "Guardar cambios",
    admin_cancel_dispatch: "Cancelar preparación",
    admin_declare_event_ended: "Declarar evento finalizado",
    admin_reforestation_new: "Nuevo proyecto de reforestación",
    admin_reforestation_update: "Actualizar proyecto",
    admin_content_edit_desc: "Edita el texto de \"Nuestra misión\" y \"Quiénes somos\" sin tocar el código. Si una página no está publicada, los usuarios ven los contenidos predeterminados o un placeholder sobrio.",
    admin_password_reset_title: "Restablecer contraseña",
    admin_new_password: "Nueva contraseña",
    admin_repeat_password: "Repite contraseña",
    admin_back_to_login: "Volver al login",
    admin_stop_following: "Dejar de seguir",
    admin_seller_actions: "Acciones vendedor",
    admin_buyer_selected: "Has sido seleccionado como comprador",
    admin_no_chat_yet: "Aún no hay chat para este anuncio",
    admin_publish_new_report: "Publicar un nuevo reporte o anuncio",
    admin_reset_province_filter: "Resetear filtro de provincia",
    admin_reports_list: "Lista de reportes",
    admin_country_province_place: "País, provincia o municipio…",
    admin_content_placeholder_desc: "Un nombre/rol por línea (ej. Juan Pérez — Fundador)",
    admin_content_placeholder_contact: "Email, PEC, dirección, redes sociales…",
  
    create: "Crear",
    confirm_conclusion: "Confirmar conclusión",
    optional_note_followers: "Nota opcional (visible para los seguidores)",
    admin_reset_super_password_confirm: "¿Generar un enlace de restablecimiento de contraseña para tu cuenta de Super Admin? El enlace es de un solo uso y caduca en 15 minutos. Te llevaremos directamente a la pantalla de elección de contraseña.",
  
    be_ai_not_configured: "IA no configurada",
    be_account_sospeso_o_bannato: "Cuenta suspendida o baneada",
    be_admin_only: "Solo admin",
    be_admin_role_required: "Rol de admin requerido",
    be_alert_not_found: "Alerta no encontrada",
    be_almeno_un_tra_ritiro_e_spedizione_deve_essere_selezionato: "Debes seleccionar al menos recogida o envío",
    be_amount_out_of_range_min_0_50_max_100000: "Monto fuera de rango (mín. 0.50€, máx. 100000€)",
    be_cannot_report_yourself: "No puedes reportarte a ti mismo",
    be_duplicate_report_please_wait_before_re_reporting_the_same_co: "Reporte duplicado. Espera antes de reportar el mismo contenido.",
    be_duration_must_be_1_3_6_12_or_24_hours: "La duración debe ser 1, 3, 6, 12 o 24 horas",
    be_email_already_registered: "Email ya registrado",
    be_email_gi_in_uso: "Email ya en uso",
    be_evento_non_attivo: "Evento no activo",
    be_extension_not_found: "Extensión no encontrada",
    be_failed_to_upload_blurred_version: "Error al subir versión difuminada",
    be_file_too_large_max_8mb: "Archivo demasiado grande (máx. 8MB)",
    be_forbidden: "Prohibido",
    be_il_nome_della_ricerca_obbligatorio: "El nombre de búsqueda es obligatorio",
    be_il_prezzo_obbligatorio_per_vendo: "El precio es obligatorio para Vendo",
    be_invalid_action: "Acción no válida",
    be_invalid_category: "Categoría no válida",
    be_invalid_credentials: "Credenciales no válidas",
    be_invalid_image: "Imagen no válida",
    be_invalid_reason: "Motivo no válido",
    be_invalid_risk_level: "Nivel de riesgo no válido",
    be_invalid_role: "Rol no válido",
    be_invalid_session: "Sesión no válida",
    be_invalid_status: "Estado no válido",
    be_la_nuova_password_deve_avere_almeno_6_caratteri: "La nueva contraseña debe tener al menos 6 caracteres",
    be_la_nuova_password_deve_avere_almeno_8_caratteri: "La nueva contraseña debe tener al menos 8 caracteres",
    be_la_password_deve_avere_almeno_6_caratteri: "La contraseña debe tener al menos 6 caracteres",
    be_la_segnalazione_deve_essere_approvata_pubblicata_prima: "El reporte debe ser aprobado/publicado primero",
    be_le_chat_non_sono_previste_per_gli_oggetti_riutilizzabili_tro: "No hay chat para objetos reutilizables encontrados",
    be_login_required_for_this_category: "Inicia sesión para esta categoría",
    be_message_cannot_be_empty: "El mensaje no puede estar vacío",
    be_message_not_found: "Mensaje no encontrado",
    be_messaggio_troppo_breve: "Mensaje demasiado corto",
    be_motivazione_obbligatoria: "Motivo obligatorio",
    be_moderation_note_required: "Motivación obligatoria (mín. 10 caracteres).",
    ur_note_required_prompt: "Motivación de la medida (obligatoria, mín. 10 caracteres):",
    ur_note_required_toast: "Motivación obligatoria (mín. 10 caracteres).",
    be_nessun_abbonamento_trovato_per_questo_utente: "No se encontró suscripción para este usuario",
    be_nessuna_richiesta_di_conferma_attiva: "No hay solicitud de confirmación activa",
    be_non_annullabile_dispatch_gi_inviato: "No se puede cancelar: envío ya realizado",
    be_non_modificabile_dispatch_gi_inviato: "No se puede modificar: envío ya realizado",
    be_non_puoi_rimuovere_il_tuo_ruolo_admin: "No puedes quitar tu propio rol de Admin",
    be_non_puoi_seguire_un_annuncio_di_cui_sei_il_proprietario: "No puedes seguir un anuncio del que eres propietario",
    be_not_a_reusable_item_report: "No es un reporte de objeto reutilizable",
    be_not_authenticated: "No autenticado",
    be_not_found: "No encontrado",
    be_notification_has_no_actionable_target: "La notificación no tiene objetivo accionable",
    be_notification_not_found: "Notificación no encontrada",
    be_only_admin: "Solo admin",
    be_only_admin_can_apply_user_actions: "Solo admin puede aplicar acciones de usuario",
    be_only_admin_can_delete_reports: "Solo admin puede eliminar reportes",
    be_only_admin_moderator: "Solo admin/moderador",
    be_only_gift_subcategory_reports_support_this: "Solo reportes de subcategoría Regalo admiten esto",
    be_only_moderators_can_update_reports: "Solo moderadores pueden actualizar reportes",
    be_only_owner_or_admin_can_set_this_status: "Solo propietario o admin puede establecer este estado",
    be_pagina_non_trovata: "Página no encontrada",
    be_password_attuale_errata: "Contraseña actual incorrecta",
    be_password_non_impostabile_per_questo_account_google: "No se puede establecer contraseña para esta cuenta (Google)",
    be_photo_not_found: "Foto no encontrada",
    be_puoi_salvare_al_massimo_20_ricerche_elimina_prima_una_vecchi: "Máximo 20 búsquedas guardadas. Elimina una antigua primero.",
    be_recurring_donations_are_only_available_for_platform_and_refo: "Las donaciones recurrentes solo están disponibles para plataforma y reforestación",
    be_report_not_found: "Reporte no encontrado",
    be_ricerca_non_trovata: "Búsqueda no encontrada",
    be_seleziona_prima_l: "Selecciona primero el",
    be_sign_in_required: "Inicio de sesión requerido",
    be_sign_in_required_to_view_marketplace: "Inicia sesión para ver el Marketplace",
    be_slug_non_valido: "Slug no válido",
    be_solo_super_admin: "Solo super-admin",
    be_solo_vendo: "Solo Vendo",
    be_solo_admin_o_ente_verificato: "Solo admin o entidad verificada",
    be_solo_admin_moderator_o_ente_verificato: "Solo admin/moderador o entidad verificada",
    be_solo_il_proprietario_pu_modificare: "Solo el propietario puede modificar",
    be_solo_il_venditore: "Solo el vendedor",
    be_solo_l: "Solo el",
    be_solo_la_controparte_pu_confermare: "Solo la contraparte puede confirmar",
    be_solo_la_controparte_pu_rifiutare: "Solo la contraparte puede rechazar",
    be_solo_super_admin_pu_assegnare_o_revocare_admin: "Solo super-admin puede asignar o revocar Admin",
    be_source_photo_not_found: "Foto de origen no encontrada",
    be_stato_non_valido: "Estado no válido",
    be_super_admin_only: "Solo super admin",
    be_target_user_not_found: "Usuario objetivo no encontrado",
    be_token_non_valido_o_gi_usato: "Token no válido o ya usado",
    be_token_non_valido_o_scaduto: "Token no válido o expirado",
    be_token_scaduto: "Token expirado",
    be_too_many_reports_in_a_short_time_try_again_later: "Demasiados reportes en poco tiempo. Intenta más tarde.",
    be_transaction_not_found: "Transacción no encontrada",
    be_translation_failed: "Traducción fallida",
    be_unsupported_file_type: "Tipo de archivo no compatible",
    be_you_can_only_edit_your_own_messages: "Solo puedes editar tus propios mensajes",
    be_already_moderated: "Ya moderado",
    be_annuncio_concluso_la_chat_chiusa: "Anuncio concluido: el chat está cerrado",
    be_categoria_non_valida: "Categoría no válida",
    be_invalid_hours: "Horas no válidas",
    be_invalid_kind: "Tipo no válido",
    be_invalid_token: "Token no válido",
    be_invalid_type: "Tipo no válido",
    be_kind_must_be_one_of_resolved_in_progress_worse_undo: "El tipo debe ser: resuelto, en progreso, peor, deshacer",
    be_new_path_not_found_in_files: "new_path no encontrado en archivos",
    be_no_changes: "Sin cambios",
    be_peer_id_richiesto_per_il_proprietario: "peer_id requerido para el propietario",
    be_photo_path_required: "Ruta de foto requerida",
    be_photo_index_out_of_range: "Índice de foto fuera de rango",
    be_platform_must_be_ios_android_web: "La plataforma debe ser ios|android|web",
    be_polygon_needs_at_least_3_points: "El polígono necesita al menos 3 puntos",
    be_reason_required_min_5_chars: "Motivo requerido (mín. 5 caracteres)",
    be_regions_required: "Regiones requeridas",
    be_role_must_be: "El rol debe ser",
    be_solo_vendo_ha_il_prezzo: "Solo Vendo tiene precio",
    be_sottocategoria_non_valida: "Subcategoría no válida",
    be_text_required: "Texto requerido",
    be_tipo_specifico_non_valido: "Tipo específico no válido",
    be_token_required: "Token requerido",
    be_utente_non_trovato: "Usuario no encontrado",
    be_cosa_fare_ora_riservato_ad_admin_ed_enti_verificati: "«Qué hacer ahora» reservado a Admin y entidades verificadas",
  
    menu_my_listings: "Mis anuncios",
    menu_following: "Seguidos",
    menu_saved_searches: "Mis búsquedas",
    unread_messages: "mensajes no leídos",
  
    mk_type_sale: "Vendo",
    mk_type_gift: "Regalo",
    mk_type_reusable: "Reutilizable encontrado",
  
    mk_title_row: "Vendo · Regalo · Reutilizables",
    new_listing: "Nuevo anuncio",
    guest_login_sale: "Inicia sesión para ver los anuncios de venta.",
    tab_all: "Todos",
    mk_kicker: "MARKETPLACE",
    tip_mk_3cats: "Marketplace tiene tres categorías bien diferenciadas: 🟣 Vendo (con precio, recogida/envío), 🔵 Regalo (gratis, elegido por el propietario en el chat), 🟤 Reutilizable encontrado (objeto abandonado: quien llega primero se lo lleva).",
    tip_mk_guest: "Los anuncios de venta solo son visibles para los usuarios registrados. Los regalos y reutilizables son visibles para todos en el mapa, pero para contactar o crear debes iniciar sesión.",
  
    event_new_proposal: "Nueva propuesta",
    event_extraordinary_kicker: "Evento extraordinario",
    event_intro_line: "Reporta un evento realmente en curso sobre un área extensa (incendio, inundación, deslizamiento, tormenta, etc.).",
    event_intro_verified_pub: "Tu publicación será inmediata como entidad verificada.",
    event_intro_review_pub: "La propuesta será revisada por un Admin antes de publicarse.",
    event_title_label: "Título",
    event_kind_label: "Categoría",
    event_whattodo_admin_only: "Qué hacer ahora (solo Admin / entidades verificadas)",
    event_started_label: "Fecha y hora de inicio (opcional)",
    event_publish_btn: "Publicar evento",
    event_send_proposal_btn: "Enviar propuesta",
    event_area_involved: "Área implicada",
    event_area_hint: "Busca el territorio (opcional) y/o haz clic en el mapa para agregar los vértices del polígono. Se requieren al menos 3 puntos.",
    event_territory_prefix: "Territorio",
    event_undo_last: "Deshacer último",
    event_clear_all: "Limpiar",
    event_points_count_suffix: "puntos",
    event_title_required: "El título es obligatorio",
    event_polygon_required: "Dibuja un área de al menos 3 puntos",
    event_published_ok: "Evento publicado",
    event_proposal_sent: "Propuesta enviada a revisión Admin",
    event_generic_error: "Error",
    event_title_placeholder: "Ej. Incendio forestal — Costa norte",
    event_desc_placeholder: "Qué está pasando, dónde, desde cuándo",
    event_whattodo_placeholder: "Ej. No acercarse. Llamar al 115. Evacuar zona X.",
    event_photos_label: "Fotografías",
    add_photo_short: "Añadir",
    mkc_description_label: "Descripción",
    mkc_choose_placeholder: "Elige…",
    mkc_condition_label: "Condición",
    mkc_color_label: "Color",
    mkc_color_placeholder: "Ej. azul, madera natural",
    mkc_keywords_label: "Palabras clave",
    mkc_photos_label: "Fotografías",
    country_or_province: "País, provincia o municipio…",
    reports_solved_kicker: "Reportes resueltos",
    in_progress_kicker: "En proceso",
    verified_users_kicker: "Usuarios verificados",
    close_tips: "Cerrar consejos",
    what_are_you_selling: "¿Qué vendes?",
    what_are_you_giving: "¿Qué regalas?",
    what_did_you_find: "¿Qué encontraste?",
    change_type: "Cambiar tipo",
    publish_listing: "Publicar anuncio",
    approximate_location: "Ubicación aproximada",
    category_first_short: "Primero la categoría",
    mkc_new_listing_kicker: "Marketplace · Nuevo anuncio",
    mkc_what_type_heading: "¿Qué tipo de anuncio quieres publicar?",
    mkc_type_choice_desc: "Elige una de las tres modalidades. Cada tipo tiene sus propias reglas (precio, chat, cierre). Podrás modificar la elección antes de publicar.",
    mkc_hint_sale: "Precio obligatorio. El anuncio solo es visible para usuarios registrados. Chat privado con compradores potenciales; al final tú (vendedor) y el comprador confirmáis la conclusión.",
    mkc_hint_gift: "Regalas un objeto a otro usuario. Sin precio. Decide libremente en el chat a quién entregarlo.",
    mkc_hint_reusable: "Reportas un objeto abandonado o reutilizable que has encontrado. Sin precio, sin asignación: el primero en llegar se lo lleva. El chat es solo informativo.",
    mkc_subtitle_sale: "Publica un anuncio de venta: precio obligatorio, recogida en mano o envío, chat privado con los compradores.",
    mkc_subtitle_gift: "Regala un objeto a otro usuario: eliges libremente en el chat a quién entregarlo.",
    mkc_subtitle_reusable: "Reporta un objeto reutilizable que has encontrado o abandonado: el primero en llegar se lo lleva. Chat solo informativo.",
    mkc_title_label: "Título",
    mkc_category_label: "Categoría",
    mkc_subcategory_label: "Subcategoría",
    mkc_itemtype_label: "Tipo específico",
    mkc_subcategory_first: "Primero la subcategoría",
    mkc_condition_new: "Nuevo",
    mkc_condition_good: "Bueno",
    mkc_condition_used: "Usado",
    mkc_keywords_placeholder: "ikea, doble, 180cm (separados por comas)",
    mkc_price_label: "Precio (€)",
    mkc_negotiable: "Negociable",
    mkc_pickup: "Recogida en mano",
    mkc_shipping: "Envío",
    mkc_position_label: "Posición aproximada",
    mkc_position_hint: "Busca el territorio (opcional) y/o haz clic en el mapa. La posición pública es aproximada; compartirás la dirección exacta en el chat.",
    mkc_territory_prefix: "Territorio",
    mkc_err_title_required: "El título es obligatorio",
    mkc_err_taxonomy_required: "Categoría, subcategoría y tipo específico son obligatorios",
    mkc_err_position_required: "Selecciona la posición aproximada en el mapa",
    mkc_err_price_required: "El precio es obligatorio",
    mkc_success_published: "Anuncio publicado",
    mkc_err_generic: "Error",
    mkc_upload_failed: "Carga fallida",
    map_reports_list_title: "Lista de reportes",
    map_within_km: "en un radio de {km} km",
    map_within_area: "en {area}",
    map_count_results: "resultados",
    map_count_reports: "reportes",
    map_clear_area_filter: "Restablecer filtro provincia",
    details_arrow: "Detalles →",
    events_popup_state_prefix: "Estado",
    mk_popup_following: "✓ Siguiendo",
    mk_popup_follow: "🔔 Seguir",
    events_history_kicker: "Historial de eventos extraordinarios",
    events_history_count_suffix: "eventos",
    events_history_none: "Ningún evento encontrado.",
    legal_kicker: "Documento legal",
    legal_placeholder_title: "Contenido en fase de finalización",
    legal_placeholder_body: "El texto definitivo de este documento se publicará pronto. Para información escríbenos a",
    legal_privacy_title: "Política de privacidad",
    legal_terms_title: "Términos y Condiciones",
    legal_community_title: "Reglas de la comunidad",
    legal_marketplace_title: "Reglas del Marketplace",
    acct_del_kicker: "Cancelación de cuenta",
    acct_del_title: "Elimina tu cuenta ToClean",
    acct_del_intro: "Puedes solicitar la eliminación de tu cuenta ToClean y de los datos personales asociados en cualquier momento. La acción es irreversible.",
    acct_del_what_happens_title: "Qué sucede al eliminar",
    acct_del_what_1: "Tu cuenta se elimina de la base de datos.",
    acct_del_what_2: "Tus anuncios del Marketplace se eliminan.",
    acct_del_what_3: "Tus publicaciones y mensajes se anonimizan (contenido conservado, autor mostrado como «Usuario eliminado»).",
    acct_del_what_4: "Tus sesiones y tokens push se revocan inmediatamente.",
    acct_del_what_5: "Los reportes públicos ya enviados a las autoridades permanecen en su registro (obligación legal).",
    acct_del_how_signed_in_title: "Si has iniciado sesión",
    acct_del_how_signed_in_body: "Ve a Configuración → «Eliminar cuenta». Recibirás una confirmación antes de la acción irreversible.",
    acct_del_go_settings: "Abrir configuración",
    acct_del_how_email_title: "Si no tienes acceso a la cuenta",
    acct_del_how_email_body: "Escribe a info@toclean.app desde el correo asociado a la cuenta. El equipo ToClean procesará la solicitud.",
  
    tip_event_scope: "Un evento extraordinario se refiere a emergencias de área extendida (incendio, inundación, deslizamiento, tormenta, etc.), no a objetos individuales o reportes pequeños.",
    tip_event_polygon: "Dibuja el área en el mapa haciendo clic en los vértices del polígono: se necesitan al menos 3 puntos. Usa «Deshacer último» o «Limpiar» para corregir.",
    tip_event_moderation: "Si no eres una entidad verificada, la propuesta se envía a revisión de un Admin antes de hacerse pública en el mapa.",
    tip_map_colors: "Los marcadores están coloreados por riesgo: 🟢 Verde = ordinario, 🟡 Amarillo = a monitorear, 🔴 Rojo = urgente. El color se decide con el breve cuestionario al crear el reporte.",
    tip_map_filters: "Usa los filtros para elegir qué reportes u objetos visualizar. El mapa, la lista y el número de resultados se actualizarán juntos.",
    tip_map_duplicates: "Antes de abrir un nuevo reporte, verifica si ya existe uno cercano: ayuda a no generar duplicados y a reforzar los reportes existentes.",
    tip_rc_wizard: "Las 4 preguntas del código de color asignan automáticamente Verde/Amarillo/Rojo según riesgo percibido, urgencia, magnitud e impacto. No son un juicio: solo guían la prioridad de moderación.",
    tip_rc_privacy: "Tus fotos se procesan del lado del servidor: rostros y matrículas se difuminan automáticamente. La ubicación pública es aproximada: la dirección exacta permanece privada.",
    tip_rc_after_photo: "Para declarar resuelto un reporte ordinario, deberás luego agregar una foto «después» desde el mismo lugar. Un solo clic, pero indispensable para confirmar la resolución.",
  
    publish: "Publicar",
    submit_for_review: "Enviar para revisión",
    state_published: "Publicado",
    state_in_progress: "En proceso",
    state_pending: "En verificación",
    state_rejected: "Rechazado",
    state_draft: "Borrador",
    state_resolved: "Resuelto",
    state_closed: "Cerrado",
    state_active: "Activo",
    risk_green: "Verde",
    risk_yellow: "Amarillo",
    risk_red: "Rojo",
    stats_reports_solved: "Reportes resueltos",
    stats_reports_progress: "En proceso",
    stats_users_verified: "Usuarios verificados",
  
    no_period_data: "No hay datos para el período seleccionado.",
    awaiting_counterpart: "Esperando la confirmación de la otra parte.",
    no_messages_write_first: "Sin mensajes: escribe el primero.",
    no_chat_for_listing_msg: "Sin chat para este anuncio",
    // Fase 3 — chat privado (solo 18+)
    nav_messages: "Mensajes",
    chat_title: "Mensajes",
    chat_tab_chats: "Chats",
    chat_tab_requests: "Solicitudes",
    chat_tab_invites: "Invitaciones",
    chat_tab_blocked: "Bloqueados",
    chat_empty: "Aún no hay chats.",
    chat_no_requests: "Sin solicitudes.",
    chat_no_invites: "Sin invitaciones.",
    chat_send: "Enviar",
    chat_composer_placeholder: "Escribe un mensaje…",
    chat_request_dialog_title: "Solicitar chat privado",
    chat_request_dialog_desc: "Envía una solicitud para iniciar un chat privado. El destinatario debe aceptarla antes de que empiece la conversación.",
    chat_request_send: "Enviar solicitud",
    chat_request_sent: "Solicitud enviada",
    chat_message_optional_label: "Mensaje inicial (opcional)",
    chat_message_optional_ph: "Por ejemplo: estoy interesado en tu anuncio…",
    chat_accept: "Aceptar",
    chat_reject: "Rechazar",
    chat_cancel_req: "Cancelar solicitud",
    chat_incoming: "Recibidas",
    chat_outgoing: "Enviadas",
    chat_pending_status: "Pendiente",
    chat_group_create: "Crear grupo",
    chat_group_title_label: "Título del grupo",
    chat_group_desc_label: "Descripción (opcional)",
    chat_group_invitees_label: "Invitar usuarios (IDs separados por comas)",
    chat_group_picker_label: "Invitar usuarios",
    chat_group_picker_placeholder: "Buscar por nombre…",
    chat_group_picker_selected: "Seleccionados",
    chat_group_picker_no_results: "No se han encontrado usuarios.",
    chat_group_picker_min_chars: "Escribe al menos 2 caracteres.",
    chat_group_picker_add: "Añadir",
    chat_group_picker_remove: "Quitar",
    // Fase 4 — Enlaces sociales
    social_links_title: "Enlaces sociales y sitio web",
    social_links_desc: "Opcionales. Los enlaces se muestran en tu perfil público. ToClean no verifica ni respalda los contenidos externos.",
    social_links_add: "Añadir enlace",
    social_links_platform: "Plataforma",
    social_links_url: "URL",
    social_links_label: "Etiqueta (opcional)",
    social_links_save: "Guardar enlaces",
    social_links_saved: "Enlaces sociales guardados",
    social_links_url_scheme_err: "La URL debe empezar por http:// o https://",
    social_links_url_invalid_err: "URL no válida.",
    social_links_url_too_long_err: "URL demasiado larga.",
    social_links_adult_only: "Solo los usuarios de 18 años o más pueden añadir enlaces externos.",
    social_links_none: "Sin enlaces.",
    social_links_platform_website: "Sitio web",
    social_links_platform_other: "Otro",
    social_links_disclaimer: "Enlaces externos no verificados.",
    // Fase 4 — Vídeo
    video_upload_label: "Añadir vídeo",
    video_upload_hint: "Formatos admitidos: MP4, MOV, M4V, WebM (H.264 o VP8/VP9). Máximo {mb} MB.",
    video_uploading: "Subiendo…",
    video_upload_progress: "{p}%",
    video_upload_ok: "Vídeo subido",
    video_upload_err_format: "Formato no admitido. Usa MP4, MOV o WebM.",
    video_upload_err_hevc: "Tu vídeo es HEVC/H.265 y no se reproduce en todos los navegadores. En iPhone ve a Ajustes → Cámara → Formatos → \"Más compatible\" y vuelve a intentarlo.",
    hevc_help_title: "Compatibilidad de vídeo iPhone",
    hevc_help_desc: "Tu iPhone grabó este clip en HEVC/H.265. Sigue estos pasos para usar un formato compatible con ToClean.",
    hevc_help_step1: "Abre Ajustes",
    hevc_help_step2: "Ve a Cámara → Formatos",
    hevc_help_step3: "Elige \"Más compatible\"",
    hevc_help_step4: "Graba un vídeo nuevo y súbelo",
    hevc_help_note: "Los vídeos HEVC ya guardados en el carrete siguen igual. Los nuevos usarán H.264/MP4 — compatibles con ToClean y con la mayoría de dispositivos.",
    hevc_help_show: "¿Cómo lo soluciono?",
    video_upload_err_too_large: "Vídeo demasiado grande. Límite {mb} MB.",
    video_upload_err_generic: "No se pudo subir el vídeo.",
    video_delete: "Eliminar vídeo",
    video_delete_confirm: "¿Eliminar este vídeo?",
    video_privacy_notice: "Si el vídeo muestra personas, matrículas o datos personales directamente vinculados a una supuesta conducta ilícita o dañina, se aplica el mismo Privacy Prompt que a las fotos.",
    video_none: "Sin vídeos.",
    video_removed: "Vídeo eliminado.",
    chat_group_leave: "Salir del grupo",
    chat_group_member: "Miembro",
    chat_group_pending_label: "Invitación pendiente",
    chat_block_user: "Bloquear usuario",
    chat_unblock_user: "Desbloquear",
    chat_blocked_list: "Usuarios bloqueados",
    chat_report_message: "Reportar mensaje",
    chat_adult_only: "Los chats privados están disponibles solo para usuarios de 18 años o más.",
    chat_pending_invite_banner: "Debes aceptar la invitación para ver los mensajes del grupo.",
    chat_open: "Abrir",
    chat_leave: "Salir",
    chat_open_conversation: "Abrir conversación",
    chat_error_send: "No se pudo enviar el mensaje.",
    chat_group_created: "Grupo creado",
    chat_group_leave_confirm: "¿Seguro que quieres salir del grupo?",
    chat_from: "de",
    report_unavailable: "Reporte no disponible",
    open_report_in_app: "Abrir el reporte en la app",
    content_removed: "Este contenido ha sido eliminado o ya no está disponible.",
    no_pec_before_button: "No se envía ningún correo certificado antes de pulsar este botón.",
    no_reports_for_filters: "Ningún reporte coincide con los filtros.",
    reforestation_big_project: "Un proyecto tan grande como el futuro que queremos construir.",
    not_authorized_dot: "No autorizado.",
    support_reforestation: "Apoya la reforestación",
    my_searches_title: "Mis búsquedas",
    signup_dob_label: "Fecha de nacimiento",
    signup_dob_help: "Solo para verificar que tengas al menos 14 años. Nunca se muestra.",
    signup_terms_prefix: "He leído y acepto los",
    signup_terms_link: "Términos del servicio",
    signup_privacy_prefix: "He leído y acepto la",
    signup_privacy_link: "Política de privacidad",
    signup_terms_required: "Debes aceptar los Términos y la Privacidad para registrarte.",
    signup_age_required: "Debes tener al menos 14 años para usar ToClean.",
    signup_dob_invalid: "Fecha de nacimiento no válida.",
    complete_profile_title: "Completa tu perfil",
    complete_profile_desc: "Para seguir usando ToClean confirma tu edad y acepta los términos actualizados. No se piden más datos.",
    complete_profile_cta: "Confirmar y continuar",
    complete_profile_age_warning: "Si tienes menos de 14 años tu cuenta se eliminará automáticamente, como exigen las reglas de las app stores.",
    mk_adult_only_banner: "El Marketplace es solo de lectura hasta los 18. Puedes ver anuncios pero no publicar, contactar ni seguir.",
    mk_adult_only_button_tip: "Disponible a partir de los 18.",
    mk_new_disabled_minor: "Solo +18",
    report_content_btn: "Reportar contenido",
    report_content_title: "Reportar este contenido",
    report_content_desc: "Nuestro equipo de moderación será notificado. Nunca compartimos tu identidad con la persona reportada.",
    report_reason_harassment: "Acoso o amenazas",
    report_reason_hate: "Discurso de odio",
    report_reason_sexual: "Contenido sexual no solicitado",
    report_reason_spam: "Spam o estafa",
    report_reason_privacy: "Violación de privacidad",
    report_reason_illegal: "Contenido ilegal",
    report_reason_impersonation: "Suplantación",
    report_reason_abuse: "Abuso de la plataforma",
    report_reason_other: "Otro",
    report_content_details: "Detalles (opcional)",
    report_content_send: "Enviar reporte",
    report_content_sent: "Reporte enviado. Gracias.",
    block_user_btn: "Bloquear usuario",
    unblock_user_btn: "Desbloquear usuario",
    block_user_confirm_title: "¿Bloquear a este usuario?",
    block_user_confirm_desc: "Ya no recibirás sus mensajes ni verás su contenido. Puedes desbloquearlo en cualquier momento desde Configuración.",
    block_user_ok: "Bloqueado",
    unblock_user_ok: "Desbloqueado",
    pp_title: "Un momento antes de publicar",
    pp_question: "¿Estás haciendo reconocible a una persona, una matrícula u otros datos personales vinculándolos directamente a un presunto comportamiento ilícito o dañino?",
    pp_answer_no: "No",
    pp_answer_yes: "Sí",
    pp_warn_title: "Atención: privacidad, reputación y derechos de las personas",
    pp_warn_body: "Hacer identificable a una persona y vincularla públicamente a supuestos hechos ilícitos puede tener consecuencias legales para ti y para la persona representada: privacidad, reputación y derechos personales están en juego.\n\nPor este motivo, el contenido se enviará a ToClean para su revisión antes de una posible publicación.",
    pp_warn_body_review_only: "Hacer identificable a una persona y vincularla públicamente a supuestos hechos ilícitos puede tener consecuencias legales para ti y para la persona representada: privacidad, reputación y derechos personales están en juego.\n\nPor este motivo, el contenido se enviará a ToClean para su revisión antes de una posible publicación.",
    pp_send_review: "Enviar a revisión a ToClean",
    pp_ack_label: "Confirmo que soy responsable de los contenidos y declaraciones que publico y que he leído el aviso relativo a la privacidad, la reputación y los derechos de las personas representadas.",
    pp_publish_anyway: "Publicar de todos modos",
    pp_sent_review_toast: "Contenido enviado a revisión. Te avisaremos.",
    comment_like: "Me gusta",
    comment_unlike: "Quitar Me gusta",
    comment_likes_count_one: "1 me gusta",
    comment_likes_count_many: "{n} me gusta",
    comment_sort_label: "Ordenar",
    comment_sort_relevant: "Más relevantes",
    comment_sort_liked: "Más apreciados",
    comment_sort_recent: "Más recientes",
    comment_sort_oldest: "Más antiguos",
    comment_report: "Reportar comentario",
    admin_tab_content_reports: "Reportes de contenido",
    admin_tab_events: "Eventos extraordinarios",
    what_to_do_now: "Qué hacer ahora",
    reject_reason_prompt: "Motivo (opcional):",
    delete_event_confirm: "¿Eliminar permanentemente este evento?",
    cr_no_items: "No hay reportes de contenido para los filtros actuales.",
    cr_status_open: "Abierto",
    cr_status_in_review: "En revisión",
    cr_status_resolved: "Resuelto",
    cr_status_dismissed: "Descartado",
    cr_target_type: "Tipo",
    cr_target_report: "Reporte",
    cr_target_marketplace_listing: "Anuncio",
    cr_target_message: "Mensaje de chat",
    cr_target_marketplace_message: "Mensaje Marketplace",
    cr_reported_by: "Reportado por",
    cr_reporter_deleted: "usuario eliminado",
    cr_content_author: "Autor del contenido",
    cr_open_target: "Abrir contenido reportado",
    cr_action_review: "Tomar en revisión",
    cr_action_resolve: "Marcar como resuelto",
    legal_info_title: "Información Legal y Contactos",
    legal_privacy_title: "Política de Privacidad",
    legal_terms_title: "Términos del Servicio",
    legal_community_title: "Reglas de la Comunidad",
    legal_marketplace_title: "Reglas del Marketplace",
    legal_deletion_title: "Eliminación de Cuenta y Datos",
    footer_legal: "Documentos legales",
    footer_legal_info: "Información legal",
    footer_privacy: "Política de privacidad",
    footer_terms: "Términos del servicio",
    footer_community_rules: "Reglas de la comunidad",
    footer_marketplace_rules: "Reglas del Marketplace",
    footer_account_deletion: "Eliminación de cuenta",
    signup_consent_prefix: "Acepto los",
    signup_consent_and_the: "y las",
    signup_consent_privacy_note: "y declaro haber leído la",
    signup_community_link: "Reglas de la comunidad",
    mkt_rules_gate_title: "Reglas del Marketplace",
    mkt_rules_gate_kicker: "Primera operación en el Marketplace",
    mkt_rules_gate_desc: "Para publicar un anuncio, modificarlo o contactar a otro usuario, primero debes aceptar la versión vigente de las Reglas del Marketplace.",
    mkt_rules_gate_read: "Leer las Reglas del Marketplace",
    mkt_rules_gate_checkbox: "He leído y acepto las Reglas del Marketplace.",
    mkt_rules_gate_accept: "Aceptar y continuar",
    mkt_rules_gate_cancel: "Cancelar",
    mkt_rules_gate_required: "Debes aceptar las Reglas del Marketplace para continuar.",
    mkt_rules_gate_accepted_toast: "Reglas del Marketplace aceptadas.",
    mkt_rules_gate_error: "No se pudo registrar tu aceptación. Inténtalo de nuevo.",
    section_profile_photo: "Foto de perfil",
    profile_photo_desc: "Añade una foto de perfil pública. Es opcional y puedes quitarla en cualquier momento.",
    profile_photo_upload: "Subir foto",
    profile_photo_replace: "Sustituir foto",
    profile_photo_remove: "Quitar foto",
    profile_photo_uploading: "Subiendo…",
    profile_photo_removing: "Quitando…",
    profile_photo_updated: "Foto de perfil actualizada.",
    profile_photo_removed: "Foto de perfil eliminada.",
    profile_photo_invalid_type: "Formato de imagen no compatible. Usa JPG, PNG o WEBP.",
    profile_photo_too_large: "Imagen demasiado grande. Tamaño máximo: 5 MB.",
    profile_photo_error: "No se pudo actualizar la foto de perfil. Inténtalo de nuevo.",
    profile_photo_hint: "JPG, PNG o WEBP · máx. 5 MB.",
    username_label: "Nombre de usuario",
    username_placeholder: "p. ej. juan.perez",
    username_help: "3–30 caracteres, solo letras, dígitos, punto y guion bajo. Único y público.",
    email_private_hint: "Tu correo es privado y nunca se muestra a otros usuarios.",
    username_too_short: "El nombre de usuario debe tener al menos 3 caracteres.",
    username_too_long: "El nombre de usuario no puede superar los 30 caracteres.",
    username_invalid_chars: "El nombre de usuario solo puede contener letras, dígitos, puntos y guiones bajos.",
    username_reserved: "Ese nombre de usuario está reservado.",
    username_taken: "Ese nombre de usuario ya está en uso.",
    username_required: "Elige un nombre de usuario para continuar.",
    cr_action_dismiss: "Descartar",
  },
  pt: {
    tagline: "Deixar o mundo melhor do que o encontrámos.",
    hero_title: "Reporta. Verifica. Limpa.",
    hero_subtitle: "ToClean é a plataforma global para transformar um reporte numa ação concreta. Cidadãos, voluntários, associações e municípios, juntos no mesmo mapa.",
    cta_map: "Abrir o mapa",
    cta_report: "Criar reporte",
    cta_signin: "Entrar",
    cta_signup: "Registar",
    cta_google: "Continuar com Google",
    cta_donate: "Apoiar",
    nav_map: "Mapa",
    nav_stories: "Histórias positivas",
    nav_leaderboard: "Classificação",
    nav_profile: "Perfil",
    nav_admin: "Admin",
    nav_settings: "Definições",
    nav_admin_dashboard: "Painel Admin",
    stats_reports: "reportes totais",
    stats_resolved: "problemas resolvidos",
    stats_pending: "em processamento",
    stats_users: "membros ativos",
    filters: "Filtros",
    category: "Categoria",
    all: "Todas",
    risk_level: "Risco",
    status: "Estado",
    st_published: "Publicado",
    st_in_progress: "Em curso",
    st_resolved: "Resolvido",
    st_pending: "Pendente",
    st_pending_moderation: "A aprovar",
    st_concluded: "Concluído",
    st_archived: "Arquivado",
    cat_waste: "Resíduos",
    cat_environment: "Ambiente",
    cat_animals: "Animais",
    cat_urban: "Degradação urbana",
    cat_vegetation: "Vegetação perigosa na via",
    cat_reusable: "Objetos reutilizáveis",
    new_report: "Novo reporte",
    subcategory: "Subcategoria",
    description: "Descrição",
    upload_photos: "Carregar fotos",
    submit: "Enviar reporte",
    cancel: "Cancelar",
    email: "Email",
    password: "Palavra-passe",
    name: "Nome",
    role: "Papel",
    citizen: "Cidadão",
    volunteer: "Voluntário",
    association: "Associação",
    company: "Empresa / Patrocinador",
    municipality: "Município / Entidade",
    operator: "Operador",
    already: "Já tens uma conta?",
    new_here: "Novo no ToClean?",
    signin_now: "Entrar",
    signup_now: "Registar",
    coordinate: "Coordenar a intervenção",
    send_message: "Enviar",
    write_message: "Escreve uma mensagem…",
    confirm: "Confirmar",
    confirm_still: "O problema ainda existe",
    confirm_worsened: "Piorou",
    confirm_resolved: "Resolvido",
    confirm_not: "Já não está presente",
    take_item: "Levei o objeto",
    interested: "Tenho interesse",
    logout: "Sair",
    reports_created: "Reportes criados",
    confirmations_made: "Confirmações fornecidas",
    reputation: "Reputação",
    donation_title: "Apoia ToClean",
    donation_desc: "A tua contribuição financia intervenções verificadas, recompensas para voluntários e o desenvolvimento da plataforma.",
    donation_amount: "Montante",
    donation_message: "Mensagem (opcional)",
    donate_now: "Doar agora",
    donate_min_amount: "Montante mínimo: 0,50 €. Também podes doar sem te registares.",
    donate_min_error: "Montante mínimo 0,50 €",
    donate_stripe_error: "Erro Stripe",
    donate_redirect: "A redirecionar…",
    donate_message_placeholder: "Uma palavra para a comunidade…",
    donate_secure: "Pagamento seguro via Stripe. Cartão de teste:",
    positive_title: "Histórias positivas da comunidade",
    positive_desc: "Cada marcador cinzento é um problema que alguém tornou invisível.",
    positive_empty: "Ainda não há histórias. As tuas confirmações e as tuas intervenções podem ser a próxima.",
    positive_solved: "Resolvido",
    ai_analyze: "Analisar com IA",
    ai_suggested: "Sugestão IA",
    emergency_notice: "Em emergências imediatas (incêndios, animais em perigo de vida, substâncias perigosas) contacta imediatamente os serviços de emergência locais.",
    footer_mission: "ToClean é uma plataforma para a ação ambiental. Cada reporte conta.",
    footer_platform: "Plataforma",
    footer_platform_items: "Mapa · Reportes · Chat · Recompensas",
    footer_platform_lang: "Multilíngua (IT · EN)",
    footer_platform_ai: "Moderação IA (GPT-5.2)",
    footer_community: "Comunidade",
    footer_made: "Criado com os voluntários, para o planeta.",
    hero_slide1_title: "O planeta é belíssimo.",
    hero_slide1_sub: "Cada gesto minúsculo decide se continuará a ser.",
    hero_slide2_title: "Juntos é possível.",
    hero_slide2_sub: "Cidadãos, voluntários, associações, empresas, municípios — no mesmo mapa.",
    hero_slide3_title: "Uma ação, uma prova.",
    hero_slide3_sub: "Fotos antes e depois, recibos, histórico público de cada intervenção.",
    hero_prev: "Anterior",
    hero_next: "Seguinte",
    hero_play: "Reproduzir",
    hero_pause: "Pausa",
    hero_mute_on: "Ativar áudio",
    hero_mute_off: "Silenciar",
    community_verified: "Comunidade · verificado",
    hero_action_leaves_mark: "Cada ação deixa uma marca.",
    risk_green_low: "Verde · Baixo",
    risk_green_desc: "Pequenos resíduos, objetos, materiais não perigosos.",
    risk_red_high: "Vermelho · Alto",
    risk_red_desc: "Substâncias perigosas, maus-tratos a animais, provas sensíveis.",
    mission_kicker: "Missão & Propósito",
    mission_title: "Um planeta mais limpo não espera pela autorização de ninguém.",
    mission_p1: "ToClean é uma plataforma <b>independente</b> criada para ligar quem vê um problema a quem o pode resolver. Cidadãos, voluntários, associações, empresas e administrações — no mesmo mapa, com as mesmas ferramentas, para o mesmo objetivo.",
    mission_p2: "Não é mais uma rede social. Não é uma petição. É uma ferramenta operacional: <b>foto, verificação, coordenação, prova do resultado.</b> Simples, transparente, verificável.",
    // ---- MissionPage /missione (conteúdo aprovado, traduzido fielmente do italiano)
    missionpage_kicker: "Missão",
    missionpage_title: "A nossa missão",
    missionpage_intro: "O ToClean nasce para tornar a proteção do ambiente mais simples, concreta e partilhada. Queremos oferecer às pessoas um espaço onde reportar problemas ambientais, acompanhar o que acontece no território, colaborar com a comunidade e dar nova vida a objetos ainda utilizáveis.",
    missionpage_s1_title: "Participação ambiental",
    missionpage_s1_body: "O ToClean permite às pessoas contribuir para o cuidado do território através de reportes ambientais, atualizações, iniciativas locais e eventos extraordinários. Cada contributo pode ajudar a tornar os problemas mais visíveis e a favorecer intervenções, colaboração e responsabilidade partilhada.",
    missionpage_s2_title: "Reutilização e comunidade",
    missionpage_s2_body: "Através das secções Vendo, Ofereço e Objetos reutilizáveis encontrados, o ToClean pretende reduzir o desperdício e facilitar a reutilização daquilo que ainda pode ser útil. O objetivo não é apenas criar um Marketplace, mas promover uma comunidade mais atenta, responsável e próxima do território.",
    missionpage_s3_title: "Doações e crescimento do projeto",
    missionpage_s3_body: "As pessoas poderão apoiar o ToClean, os reportes ambientais e os projetos de reflorestação através de contribuições voluntárias. Os recursos angariados poderão contribuir para o desenvolvimento, gestão e crescimento do projeto, respeitando as regras e as informações que serão tornadas públicas.",
    missionpage_future_title: "Visão futura: patrocinadores e recompensas",
    missionpage_future_p1: "O ToClean acredita que quem dedica tempo, energia e empenho concreto à proteção do ambiente merece ser valorizado.",
    missionpage_future_p2: "Com o crescimento da comunidade e o futuro apoio de empresas, entidades e patrocinadores, queremos desenvolver um programa transparente de reconhecimento e recompensa para os voluntários mais ativos e para as iniciativas ambientais mais significativas.",
    missionpage_future_p3: "Os patrocinadores poderão apoiar o projeto, contribuir para as recompensas e obter uma visibilidade claramente identificável como patrocínio. Uma parte dos recursos poderá também contribuir para os custos necessários para manter e fazer crescer o ToClean.",
    missionpage_rewards_title: "Possíveis recompensas futuras",
    missionpage_rewards_1: "Vouchers ou descontos disponibilizados pelos patrocinadores",
    missionpage_rewards_2: "Produtos ecossustentáveis",
    missionpage_rewards_3: "Participação em experiências ou eventos",
    missionpage_rewards_4: "Distintivos e reconhecimentos digitais",
    missionpage_rewards_5: "Prémios ligados a iniciativas ambientais",
    missionpage_rewards_6: "Apoio concreto a grupos ou projetos de voluntariado",
    missionpage_disclaimer: "O programa de recompensas ainda não está ativo. Representa uma visão futura do ToClean e poderá ser implementado gradualmente apenas com um crescimento real da comunidade, recursos disponíveis e acordos concretos com patrocinadores e parceiros. Antes da ativação serão publicados critérios, regras, condições e modalidades de atribuição.",
    missionpage_updated_at: "Última atualização:",
    missionpage_back_home: "Voltar à Página inicial",
    publish_chooser_title: "O que queres publicar?",
    publish_chooser_desc: "Escolhe o tipo de conteúdo: um reporte ambiental ou um anúncio do Marketplace.",
    publish_chooser_report_title: "Reporte ambiental",
    publish_chooser_report_desc: "Resíduos, abusos, abandono: ajuda a monitorizar e resolver problemas comuns.",
    publish_chooser_sale_title: "Objeto à venda",
    publish_chooser_sale_desc: "Publica um anúncio com preço. Chat privado com potenciais compradores.",
    publish_chooser_gift_title: "Objeto para oferecer",
    publish_chooser_gift_desc: "Sem preço. Decide livremente no chat a quem entregar.",
    publish_chooser_reusable_title: "Reutilizável encontrado",
    publish_chooser_reusable_desc: "Reporta um objeto abandonado ou reutilizável. Quem chega primeiro leva.",
    listing_type_sale: "Vendo",
    listing_type_gift: "Ofereço",
    listing_type_reusable: "Reutilizável encontrado",
    pillar1_title: "Reporta o que vês",
    pillar1_desc: "Resíduos, degradação urbana, animais em perigo, incêndios, objetos reutilizáveis. Uma foto, a localização GPS, um nível de risco. É só isto.",
    pillar2_title: "Verifica com a comunidade",
    pillar2_desc: "Quem está perto confirma, adiciona fotos, indica se o problema piorou ou foi resolvido. A credibilidade aumenta com as confirmações.",
    pillar3_title: "Coordena pessoas e meios",
    pillar3_desc: "Cada reporte tem o seu chat. Voluntários, associações, municípios e operadores profissionais combinam tudo aí, sem se perderem em DMs privadas.",
    pillar4_title: "Apoia com doações e patrocínios",
    pillar4_desc: "Empresas e particulares podem financiar intervenções, prémios e equipamentos. Cada contributo é rastreado e ligado a um resultado real.",
    pillar5_title: "Recompensa quem contribui",
    pillar5_desc: "Vales, cupões, equipamentos, reconhecimentos dos patrocinadores. Não se ganha dinheiro com ToClean — mas o tempo doado nunca é esquecido.",
    pillar6_title: "Resultados verificáveis e transparentes",
    pillar6_desc: "Fotos antes e depois, comprovativos de entrega, histórico público de cada intervenção. A secção 'Histórias positivas' conta o que foi tornado invisível.",
    how_kicker: "Como funciona",
    how_title: "Cinco passos. Zero burocracia.",
    how_sub: "Da foto no telemóvel à prova pública do resultado.",
    how_step_1: "Reporta",
    how_step_1_desc: "Foto, GPS, categoria, risco percebido.",
    how_step_2: "Verifica",
    how_step_2_desc: "A comunidade confirma ou desmente.",
    how_step_3: "Coordena",
    how_step_3_desc: "Chat dedicado para voluntários e operadores.",
    how_step_4: "Intervém",
    how_step_4_desc: "Organiza-se a recolha, a limpeza, a recuperação.",
    how_step_5: "Demonstra",
    how_step_5_desc: "Foto antes/depois, comprovativos de entrega.",
    cat_kicker: "5 categorias · reportáveis em segundos",
    cat_headline: "Resíduos, ambiente, animais, degradação urbana e objetos reutilizáveis.",
    gray_markers: "Marcadores cinzentos: problemas tornados invisíveis.",
    emergency_label: "Emergências",
    support_chip: "Apoia ToClean",
    support_title_1: "Não pedimos uma subscrição.",
    support_title_2: "Pedimos um",
    support_title_3: "gesto voluntário.",
    support_p1: "ToClean é um projeto independente. Não pertence a nenhum fundo, não vende dados pessoais, não enche a interface de banners publicitários. Cresce graças a quem acredita que <b>cuidar do território é uma responsabilidade de todos</b> — e escolhe fazê-lo também com um pequeno contributo económico.",
    support_p2: "Cada euro doado é completamente <b>facultativo</b>. Não recebes funcionalidades premium, não obténs vias preferenciais, não apareces mais acima no ranking. Recebes algo mais importante: <b>a certeza de que uma plataforma para o bem comum permanece livre, aberta e útil para quem vem depois de ti.</b>",
    support_cta: "Apoia ToClean",
    support_discover: "Descobre a missão",
    support_uses_title: "Para que serve uma doação",
    support_use_1_title: "Servidores e infraestrutura",
    support_use_1_desc: "Mapa, fotos, chat: tudo tem de permanecer rápido e disponível 24/7.",
    support_use_2_title: "Novas funcionalidades",
    support_use_2_desc: "Deteção de duplicados com IA, notificações, prémios automáticos, app móvel nativa.",
    support_use_3_title: "Moderação",
    support_use_3_desc: "Conteúdos sensíveis, proteção animal, chats limpos: o trabalho invisível que torna a app confiável.",
    support_use_4_title: "Expansão para novos países",
    support_use_4_desc: "Traduções, adaptação regulamentar, parceiros locais.",
    support_use_5_title: "Iniciativas ambientais",
    support_use_5_desc: "Pequenos fundos para intervenções comunitárias verificadas (equipamento, materiais).",
    support_use_6_title: "Melhoria contínua",
    support_use_6_desc: "Escuta dos utilizadores, correções, acessibilidade, desempenho.",
    support_footnote: "Nenhuma doação é obrigatória. Podes usar ToClean para sempre, gratuitamente. Se um dia quiseres contribuir, encontrá-lo-ás ao alcance da mão — nunca à frente.",
    final_kicker: "Começa agora",
    final_slogan: "ToClean é simples, gratuita e respeitadora como a Terra. Ajuda-nos a ajudá-la.",
    final_desc: "Regista-te e transforma uma simples foto numa mudança real. Cada reporte é um passo.",
    feedback_kicker: "Feedback e propostas de melhoria",
    feedback_title: "Ajuda-nos a melhorar ToClean.",
    feedback_desc: "A tua sugestão vale mais do que dez roadmaps internos. Reporta um bug, propõe uma nova funcionalidade, diz-nos o que não bate certo. Podes escrever-nos mesmo sem te registares.",
    feedback_kind: "Tipo",
    feedback_kind_suggestion: "Sugestão",
    feedback_kind_bug: "Bug / Problema",
    feedback_kind_improvement: "Proposta de melhoria",
    feedback_email_label: "Email (opcional)",
    feedback_email_placeholder: "Só se quiseres ser recontactado",
    feedback_message: "Mensagem",
    feedback_message_placeholder: "O que podemos melhorar?",
    feedback_submit: "Enviar feedback",
    feedback_submitting: "A enviar…",
    feedback_no_signup: "Não é preciso registar.",
    feedback_min_words: "Escreve pelo menos algumas palavras",
    feedback_thanks: "Obrigado pelo teu feedback!",
    feedback_error: "Erro",
    support_title: "Não pedimos uma subscrição. Pedimos um gesto voluntário.",
    open_details: "Abrir detalhes",
    close: "Fechar",
    set_local_password: "Definir password local",
    set_password_desc: "Adiciona uma password local à tua conta Google para poderes aceder também via email + password.",
    new_password: "Nova password",
    save: "Guardar",
    confirmations_short: "conf.",
    map_locate_unsupported: "O teu navegador não suporta geolocalização.",
    map_geo_disabled: "Geolocalização desativada nas definições.",
    map_geo_denied: "Permissão GPS negada.",
    map_geo_failed: "Impossível obter a posição.",
    map_locate_title: "A minha posição",
    map_locate_here: "Centrar aqui",
    geo_no_results_for_area: "Sem resultados para esta área.",
    geo_search_error: "Erro de pesquisa",
    geo_temp_unavailable: "Pesquisa temporariamente indisponível — tenta novamente",
    map_hide_filters: "Ocultar filtros",
    map_show_filters: "Mostrar filtros",
    map_std: "Mapa",
    map_satellite: "Satélite",
    map_tiles_error: "Não foi possível carregar os tiles do mapa.",
    map_tiles_check: "Verifica a ligação e tenta novamente.",
    map_retry: "Tentar novamente",
    color: "Cor",
    show_all: "Mostrar todos",
    reset: "Repor",
    all_subcategories: "Todas as subcategorias",
    legend: "Legenda",
    legend_green_low: "Verde · baixo",
    legend_yellow_med: "Amarelo · médio",
    legend_red_high: "Vermelho · alto",
    legend_gray_resolved: "Cinzento · resolvido",
    legend_blue_progress: "Azul · em curso",
    legend_purple_reusable: "Roxo · reutilizável",
    st_active: "Ativa",
    st_taken: "Em tratamento",
    st_review: "Em revisão",
    st_standby: "Em espera",
    st_reopened: "Reaberta",
    active_prefix: "Ativa:",
    fab_expand: "Mostrar botão Criar denúncia",
    fab_minimize: "Minimizar",
    auth_home: "Início",
    auth_signin_kicker: "Entrar",
    auth_signup_kicker: "Criar conta",
    auth_signin_h: "Bem-vindo de volta.",
    auth_signup_h: "Junta-te ao movimento.",
    auth_slogan: "Cada foto é uma pequena mudança.",
    auth_or: "ou",
    welcome_back: "Bem-vindo de volta!",
    welcome_new: "Bem-vindo ao ToClean!",
    generic_error: "Erro",
    forgot_password: "Esqueceste-te da palavra-passe?",
    signin_remember_me: "Lembrar-me neste dispositivo",
    reset_back_to_login: "Voltar ao login",
    reset_title: "Redefinir palavra-passe",
    reset_request_desc: "Insere o teu email. Enviaremos um token para redefinir a palavra-passe.",
    reset_confirm_desc: "Insere o token recebido e a nova palavra-passe.",
    reset_send_link: "Enviar link",
    reset_update_pwd: "Atualizar palavra-passe",
    reset_updated: "Palavra-passe atualizada! Agora podes entrar.",
    reset_dev_notice_b: "Ambiente demo:",
    reset_dev_notice: "token pré-preenchido. Em produção chega por email.",
    reset_min_chars: "Mínimo 6 caracteres",
    token_label: "Token",
    settings_title: "A tua conta",
    settings_desc: "Gere perfil, segurança, notificações e privacidade.",
    section_profile: "Perfil",
    section_password: "Palavra-passe",
    section_notifications: "Notificações",
    section_language: "Idioma",
    section_geolocation: "Geolocalização",
    section_privacy: "Privacidade",
    section_feedback: "Feedback e Sugestões",
    section_session: "Sessão",
    current_password: "Palavra-passe atual",
    new_password_min: "Nova palavra-passe (mín. 6)",
    change_password: "Alterar palavra-passe",
    fill_both_fields: "Preenche ambos os campos",
    profile_updated: "Perfil atualizado",
    password_updated: "Palavra-passe atualizada",
    lang_updated: "Idioma atualizado",
    local_password_set: "Palavra-passe local definida!",
    notif_new_reports: "Novas denúncias na tua zona",
    notif_mentions: "Menções nas conversas",
    notif_status_changes: "Atualizações de estado",
    notif_rewards: "Prémios e vouchers disponíveis",
    geo_desc: "Se ativa, o ToClean pode solicitar o GPS do navegador para centrar o mapa e pré-preencher a localização das denúncias. Podes revogar a permissão a qualquer momento nas definições do navegador.",
    geo_browser_denied: "O navegador negou o GPS. Ativa-o nas definições do navegador.",
    privacy_public_b: "Perfil público.",
    privacy_public_desc: "O teu nome, reputação e denúncias são visíveis na classificação e na página de perfil. Podes desativar a visibilidade aqui.",
    privacy_footnote: "As fotos das denúncias são sempre públicas. Os dados sensíveis (matrículas, rostos) são ocultados até aprovação dos moderadores.",
    logout_label: "Terminar sessão",
    delete_account: "Eliminar conta",
    delete_account_title: "Eliminar definitivamente a conta?",
    delete_account_desc: "O teu perfil será apagado. As tuas denúncias permanecerão visíveis de forma anónima para preservar a integridade do histórico. Esta ação é irreversível.",
    delete: "Eliminar",
    account_deleted: "Conta eliminada",
    loading: "A carregar…",
    reputation_short: "reputação",
    new_report_title: "Transforma a foto numa ação.",
    new_report_desc: "Preenche os campos com cuidado. A IA pode ajudar-te a categorizar corretamente.",
    add: "Adicionar",
    latitude: "Latitude",
    longitude: "Longitude",
    detect: "Detetar",
    position_on_map: "Posição no mapa · toca para selecionar",
    geo_denied_msg: "Permissão GPS negada. Podes na mesma selecionar a posição tocando no mapa ou inserindo-a manualmente.",
    tiles_not_loaded: "Tiles não carregados.",
    risk_green_label: "Verde · risco baixo",
    risk_green_short_desc: "Pequenos resíduos, objetos não perigosos",
    risk_yellow_label: "Amarelo · risco médio",
    risk_yellow_short_desc: "Muitos sacos, vidros, materiais pesados",
    risk_red_label: "Vermelho · risco alto",
    risk_red_short_desc: "Substâncias perigosas, animais, conteúdos sensíveis",
    ai_analyze_desc: "Analisa foto e descrição para sugerir categoria, subcategoria e nível de risco.",
    ai_analyze_action: "Analisar",
    ai_unavailable: "IA não disponível",
    ai_completed: "Análise de IA concluída",
    sensitive_content_b: "Conteúdo sensível.",
    sensitive_content_desc: "O conteúdo inclui rostos, matrículas, menores, provas ou acusações. Será revisto pelos moderadores antes da publicação.",
    describe_placeholder: "O que viste? Dimensão, contexto, materiais…",
    photo_uploaded: "Foto carregada",
    photo_upload_failed: "Carregamento falhou",
    add_photo_or_desc: "Adiciona pelo menos uma foto ou descrição",
    gps_missing: "Posição GPS em falta",
    select_subcategory: "Seleciona subcategoria",
    description_too_short: "Descrição demasiado curta",
    photo_required: "Pelo menos uma foto é obrigatória",
    report_submitted: "Reporte enviado!",
    gps_updated: "GPS atualizado",
    gps_unavailable: "Geolocalização não suportada",
    gps_pick_manual: "Impossível obter a posição — toca no mapa abaixo para a selecionares manualmente.",
    position_set: "Posição definida",
    navigate: "Navegar",
    donate_short: "Doar",
    report_sent_b: "Reporte enviado!",
    report_sent_desc: "Obrigado pela tua contribuição. A comunidade poderá confirmar e coordenar-se aqui abaixo.",
    back_to_map: "Voltar ao mapa",
    risk_prefix: "risco",
    confirmations_label: "confirmações",
    still_exists: "Ainda existe",
    worsened: "Agravado",
    resolved_short: "Resolvido",
    not_present: "Não presente",
    reusable_not_available: "Provavelmente já não disponível",
    timeline: "Cronologia",
    no_messages: "Nenhuma mensagem. Inicia a conversa.",
    login_to_join: "Entra para participar",
    of_author: "de",
    fullscreen: "Ecrã inteiro",
    edit_message: "Editar",
    message_edited: "editado",
    saved_confirmation: "Confirmação registada",
    thanks: "Obrigado!",
    donate_report_title: "Apoia este reporte",
    donate_report_desc_p1: "Os fundos serão usados",
    donate_report_desc_b1: "prioritariamente para resolver este reporte",
    donate_report_desc_p2: ". Se não for possível, serão destinados a intervenções análogas",
    donate_report_desc_b2: "no mesmo Município ou território",
    donate_report_desc_p3: ". Podes doar",
    donate_report_desc_b3: "mesmo sem registo",
    donate_free_offer: "Donativo livre (mín. 0,50 €)",
    donate_report_placeholder: "Uma mensagem para a comunidade (opcional)",
    not_authenticated: "Não autenticado",
    admin_dashboard_kicker: "Painel de administração",
    admin_overview: "Visão geral da moderação",
    admin_users: "Utilizadores",
    admin_reports: "Reportes",
    admin_pending: "Pendentes",
    admin_red: "Vermelhos",
    admin_resolved: "Resolvidos",
    admin_donations: "Donativos",
    tab_moderation: "Moderação",
    tab_all_reports: "Todos os reportes",
    tab_users: "Utilizadores",
    tab_donations: "Donativos & Patrocinadores",
    tab_logs: "Registos",
    no_pending: "Nenhum reporte pendente.",
    no_reports: "Nenhum reporte.",
    all_statuses: "Todos os estados",
    only_red_risk: "Apenas risco vermelho",
    search_by_name_email: "Pesquisar por nome ou email…",
    admin_rep_short: "rep",
    admin_suspended: "suspenso",
    admin_banned: "banido",
    admin_reactivate: "Reativar",
    admin_suspend: "Suspender",
    admin_remove_ban: "Remover banimento",
    admin_ban: "Banir",
    approve: "Aprovar",
    reject: "Rejeitar",
    archive: "Arquivar",
    reopen: "Reabrir",
    hide_evidence: "Ocultar",
    show_evidence: "Mostrar provas",
    sensitive_badge: "sensível",
    proposed_label: "proposto:",
    author_line_by: "de",
    make_public: "Tornar público",
    mark_sensitive: "Marcar como sensível",
    st_pub_visible: "Visível",
    st_hidden: "Oculto",
    st_archived: "Arquivado",
    st_rejected: "Rejeitado",
    change_state_title: "Alterar estado do reporte",
    current_status: "Estado atual:",
    reason_optional: "Motivo (opcional)",
    state_change_note: "Ocultar, suspender ou arquivar",
    state_change_note_b: "não elimina",
    state_change_note_2: "o reporte. Fotos, coordenadas, autor e cronologia permanecem inalterados.",
    state_arrow: "Estado →",
    color_short: "Cor",
    admin_actions_title: "Ações administrativas",
    delete_report_confirm_title: "Eliminar esta denúncia?",
    delete_report_confirm_body: "A denúncia será removida definitivamente. Esta ação não pode ser revertida.",
    change_color_title: "Alterar cor (nível de risco)",
    current_color: "Cor atual:",
    color_reason_placeholder: "Porque estás a alterar a cor?",
    state_reason_placeholder: "Porque estás a alterar o estado?",
    color_change_note: "A modificação da cor",
    color_change_note_b: "não",
    color_change_note_2: "publica, oculta, arquiva ou elimina a denúncia — altera apenas o nível de risco visível no mapa e nos filtros. Histórico registado.",
    apply: "Aplicar",
    delete_report_title: "Eliminar a denúncia?",
    delete_report_desc: "Esta ação elimina definitivamente a denúncia, as fotos e o chat associados. Não é possível anulá-la.",
    load_error: "Erro ao carregar",
    approved: "Aprovada",
    updated: "Atualizada",
    report_updated: "Denúncia atualizada",
    role_updated: "Papel atualizado",
    user_updated: "Utilizador atualizado",
    report_deleted: "Denúncia eliminada",
    report_reopened: "Denúncia reaberta",
    // Bulk selection (Lotto 3 #7/#8)
    bulk_select_all: "Selecionar todos",
    bulk_selected_of: "{n} de {total} selecionados",
    bulk_select_row: "Selecionar esta linha",
    bulk_clear_selection: "Desselecionar",
    bulk_delete_confirm_title: "Eliminar os elementos selecionados?",
    bulk_delete_confirm_body: "Estás prestes a eliminar permanentemente {n} elementos. Esta ação não pode ser revertida.",
    bulk_deleted_ok: "{n} elementos eliminados",
    bulk_updated_ok: "{n} elementos atualizados",
    bulk_notif_mark_read: "Marcar como lidas",
    bulk_notif_archive: "Arquivar",
    no_donations: "Nenhum donativo registado.",
    mod_logs: "Registos de moderação",
    no_logs: "Nenhum registo disponível.",
    leaderboard_h: "Quem está a fazer a diferença.",
    leaderboard_empty: "Ainda nenhum membro ativo.",
    thanks_donation: "Muito obrigado!",
    donation_recorded: "O teu donativo de €{amount} foi registado.",
    confirming: "A confirmar…",
    waiting_stripe: "A aguardar confirmação da Stripe.",
    payment_cancelled: "Pagamento cancelado",
    no_charge: "Nenhum débito efetuado.",
    back_to_map_btn: "Voltar ao mapa",
    stat_reports_created: "Denúncias criadas",
    stat_confirmations_made: "Confirmações fornecidas",
    stat_reputation: "Reputação",
    back: "Voltar",
    sub_small_pile: "Pequena pilha",
    sub_bags: "Sacos de lixo",
    sub_plastic: "Plástico",
    sub_glass: "Vidro",
    sub_paper: "Papel",
    sub_organic: "Orgânico",
    sub_tires: "Pneus",
    sub_appliances: "Eletrodomésticos",
    sub_furniture: "Móveis",
    sub_construction: "Materiais de construção",
    sub_industrial: "Resíduos industriais",
    sub_hazardous: "Resíduos perigosos",
    sub_asbestos: "Amianto",
    sub_chemicals: "Substâncias químicas",
    sub_oil: "Óleos",
    sub_batteries: "Pilhas",
    sub_illegal_dump: "Descarga ilegal",
    sub_marine: "Resíduos no mar",
    sub_river: "Resíduos no rio",
    sub_forest: "Resíduos na floresta",
    sub_sewage_spill: "Derrame de esgoto",
    sub_medical_waste: "Resíduos hospitalares",
    sub_explosive_flammable: "Explosivos / inflamáveis",
    sub_water_pollution: "Poluição da água",
    sub_soil_pollution: "Poluição do solo",
    sub_suspicious_discharge: "Descarga suspeita",
    sub_smoke_emissions: "Emissões de fumo",
    sub_fire: "Incêndio",
    sub_fire_damage: "Danos de incêndio",
    sub_damaged_trees: "Árvores danificadas",
    sub_degraded_green: "Espaço verde degradado",
    sub_water_leak: "Fuga de água",
    sub_erosion: "Erosão",
    sub_contamination: "Contaminação",
    sub_beach_coast_degradation: "Degradação costeira",
    sub_injured: "Animal ferido",
    sub_abandoned: "Animal abandonado",
    sub_trapped: "Animal preso",
    sub_in_danger: "Animal em perigo",
    sub_suspected_mistreatment: "Suspeita de maus tratos",
    sub_poor_conditions: "Condições precárias",
    sub_wildlife_distress: "Fauna em dificuldade",
    sub_broken_light: "Candeeiro avariado",
    sub_broken_bench: "Banco partido",
    sub_damaged_playground: "Parque infantil danificado",
    sub_pothole: "Buraco na estrada",
    sub_architectural_barrier: "Barreira arquitetónica",
    sub_dangerous_sidewalk: "Passeio perigoso",
    sub_broken_signage: "Sinalização partida",
    sub_abandoned_public: "Edifício público abandonado",
    sub_vandalism: "Vandalismo",
    sub_other: "Outro",
    sub_tall_grass: "Erva alta",
    sub_brambles: "Silvas",
    sub_dangerous_branches: "Ramos perigosos",
    sub_obstructing_visibility: "Obstrui a visibilidade",
    sub_fallen_tree: "Árvore caída",
    sub_invasive_plants: "Plantas invasoras",
    sub_road_encroachment: "Invasão da faixa de rodagem",
    sub_bed: "Cama",
    sub_mattress: "Colchão",
    sub_table: "Mesa",
    sub_chair: "Cadeira",
    sub_wardrobe: "Roupeiro",
    sub_sofa: "Sofá",
    sub_home_decor: "Complementos de decoração",
    sub_appliance: "Eletrodoméstico",
    sub_electronics: "Eletrónica",
    sub_computer: "Computador",
    sub_bicycle: "Bicicleta",
    sub_tools: "Ferramentas",
    sub_clothing: "Vestuário",
    sub_toys: "Brinquedos",
    sub_construction_materials: "Materiais de construção",
    sub_books: "Livros",
    take_photo: "Tirar foto",
    from_gallery: "Escolher da galeria",
    camera_permission_denied: "Permissão de câmara negada. Podes na mesma escolher uma foto da galeria.",
    suggested_color: "Cor sugerida",
    severity: "Gravidade",
    urgency: "Urgência",
    confidence: "Confiança",
    trust: "Fiabilidade",
    coherence: "Foto↔texto",
    ai_action: "Ação sugerida",
    add_photo: "Adicionar uma foto",
    add_photo_desc: "Documenta agravamentos, alterações, progressos de obras ou resolução.",
    add_photo_note: "Nota opcional",
    add_photo_note_placeholder: "Ex. agravou depois da chuva, ou quase resolvido…",
    add_photo_confirm: "Adicionar",
    add_photo_success: "Foto adicionada",
    add_photo_pending: "Foto enviada para revisão admin (conteúdo ou coerência a verificar)",
    add_photo_failed: "Falha ao adicionar",
    additional_photos: "Fotos adicionais",
    pending_review: "Em revisão",
    urgent_alert: "Aviso urgente temporário",
    urgent_new: "Novo aviso urgente",
    urgent_desc: "Reporta um problema temporário (isco suspeito, obstáculos, ramo caído, inundação, fumo, substância perigosa…).",
    urgent_duration: "Duração",
    urgent_radius: "Raio (m)",
    urgent_other: "Outro aviso urgente",
    urgent_free_desc: "Descreve livremente o problema e porque é urgente e temporário",
    urgent_submit: "Publicar aviso",
    urgent_created: "Aviso publicado",
    urgent_state_active: "Ativo",
    urgent_state_expired: "Expirado — a verificar",
    urgent_state_resolved: "Resolvido",
    urgent_state_archived: "Arquivado",
    urgent_state_pending: "Em revisão",
    urgent_still_present: "Confirmo que ainda está presente",
    urgent_not_present: "Já não está presente",
    urgent_time_remaining: "Tempo restante",
    urgent_extend: "Prorrogar",
    urgent_expired: "Expirado",
    fab_urgent: "Evento extraordinário",
    fab_event: "Novo evento extraordinário",
    extraordinary_event: "Evento extraordinário",
    extraordinary_events: "Eventos extraordinários",
    urgent_alerts_list: "Eventos extraordinários ativos",
    no_urgent_alerts: "Nenhum evento extraordinário ativo.",
    ai_panel_title: "Análise IA (GPT-5.2)",
    ai_problem: "Problema reconhecido",
    ai_reason: "Justificação",
    ai_act_publish_auto: "Publicação automática",
    ai_act_review_admin: "Revisão admin",
    ai_act_reject: "Rejeitar",
    legal_badge: "legal",
    filter_urgent_alerts: "Eventos extraordinários",
    filter_extraordinary_events: "Eventos extraordinários",
    event_kind_wildfire: "Incêndio florestal",
    event_kind_flood: "Inundação",
    event_kind_river_overflow: "Cheia / transbordamento",
    event_kind_landslide: "Deslizamento de terras",
    event_kind_storm: "Tempestade excecional",
    event_kind_hailstorm: "Granizo excecional",
    event_kind_tornado: "Tornado",
    event_kind_heavy_snow: "Queda de neve intensa",
    event_kind_avalanche: "Avalanche",
    event_kind_sea_storm: "Temporal marítimo",
    event_kind_heatwave: "Onda de calor",
    event_kind_coldwave: "Vaga de frio",
    urgent_pending_approval: "A aguardar aprovação",
    urgent_approved: "Aviso aprovado",
    urgent_rejected: "Aviso rejeitado",
    approve_urgent: "Aprovar aviso",
    reject_urgent: "Rejeitar aviso",
    urgent_map_pick: "Move o mapa e toca para selecionar o ponto",
    urgent_center_me: "Centrar na minha posição",
    urgent_short_explanation: "Usa esta função para reportar um problema urgente mas temporário. Indica o problema, a localização, o raio da área afetada e escolhe quanto tempo deve durar o aviso. Após aprovação do Admin, o aviso ficará visível com uma contagem decrescente até expirar.",
    notifications: "Notificações",
    notif_empty: "Nenhuma notificação.",
    notif_gone: "Notificação já não disponível",
    notif_mark_read: "Marcar como lida",
    notif_mark_unread: "Marcar como não lida",
    notif_archive: "Arquivar",
    notif_delete: "Eliminar",
    notif_open: "Abrir",
    notif_all_read: "Marcar tudo como lido",
    notif_view_all: "Ver todas as notificações",
    extensions_pending: "Prorrogações pendentes",
    no_extensions_pending: "Nenhuma prorrogação a aprovar.",
    photos_pending: "Fotos em revisão",
    admin_home_title: "Visão geral de moderação",
    admin_home_desc: "Seleciona uma secção para começar.",
    admin_card_red: "Vermelhas",
    admin_card_yellow: "Amarelas",
    admin_card_green: "Verdes",
    admin_card_photos_review: "Moderação Admin",
    admin_card_urgent: "Eventos extraordinários",
    admin_section_others: "Outro",
    admin_others_desc: "Utilizadores · Feedback · Donativos · Chat · Registo · Arquivo · Definições",
    admin_tab_users: "Utilizadores",
    admin_tab_feedback: "Feedback",
    admin_tab_donations: "Donativos",
    admin_tab_logs: "Registo",
    admin_tab_archive: "Arquivo",
    admin_tab_settings: "Definições",
    admin_filter_status: "Filtrar por estado",
    admin_st_in_progress: "Em curso",
    admin_st_pending_approval: "Aprovação pendente",
    admin_st_approved: "Aprovadas",
    admin_st_archived: "Arquivadas",
    admin_st_all: "Todas",
    admin_urgent_state_pending: "Por aprovar",
    admin_urgent_state_active: "Ativos",
    admin_urgent_state_expired: "Expirados — a verificar",
    admin_urgent_ext_pending: "Prorrogações pendentes",
    admin_urgent_state_archived: "Arquivados",
    admin_urgent_state_rejected: "Rejeitados",
    admin_urgent_state_all: "Todos",
    advanced_filters: "Filtros avançados",
    filter_search_placeholder: "Procurar por título, descrição, autor, local ou ID",
    filter_ai_conf: "Confiança IA",
    filter_sensitive: "Conteúdos sensíveis",
    filter_legal: "Possíveis problemas legais",
    photos_review_title: "Moderação Admin",
    photos_review_empty: "Nenhuma foto para rever.",
    photos_review_source: "Proveniência",
    photos_review_reason: "Motivo",
    photos_review_priority: "Prioridade",
    src_new_report: "Nova denúncia",
    src_added_photo: "Foto adicionada",
    src_urgent: "Aviso urgente",
    src_extension: "Pedido de prorrogação",
    reason_photo_incoherent: "Foto incoerente",
    reason_photo_text_incoherent: "Foto e descrição não coerentes",
    reason_category_mismatch: "Categoria errada",
    reason_subcategory_mismatch: "Subcategoria errada",
    reason_severity_higher: "Gravidade superior",
    reason_color_mismatch: "Cor não coerente",
    reason_sensitive_content: "Conteúdo sensível",
    reason_legal_issues: "Possível problema legal",
    reason_spam_or_irrelevant: "Spam ou irrelevante",
    reason_low_ai_confidence: "Baixa confiança IA",
    reason_ai_suggests_review: "IA sugere revisão",
    reason_face_blur_failed: "Desfocagem de rostos falhou",
    reason_face_blur_uncertain: "Desfocagem de rostos incerta",
    reason_red_requires_approval: "Vermelha: aprovação necessária",
    reason_sensitive_animal_category: "Subcategoria animal sensível",
    reason_possibly_criminal_content: "Possível cena de crime",
    publish_as_green: "Publicar como Verde",
    publish_as_yellow: "Publicar como Amarela",
    publish_as_red: "Publicar como Vermelha",
    photo_approved_as_color: "Foto aprovada e publicada como {color}",
    original_unavailable: "Original já não disponível",
    original_unavailable_hint: "Original já não disponível — pode aplicar uma desfocagem adicional sobre a versão atual.",
    admin_card_events: "Eventos extraordinários",
    total: "totais",
    admin_card_marketplace: "Marketplace",
    mk_type_sale: "Vendo",
    mk_type_gift: "Ofereço",
    mk_type_reusable: "Reutilizável encontrado",
    mk_st_published: "Ativo",
    mk_st_archived: "Arquivado",
    mk_st_closed: "Concluído",
    mk_st_pending: "Aguarda confirmação",
    mk_search_placeholder: "Procurar título, autor, província…",
    mk_empty: "Sem anúncios nesta vista",
    mk_admin_details: "Detalhes admin",
    mk_found_checks_title: "Confirmações de utilizadores",
    mk_found_present: "Objeto presente",
    mk_found_not_present: "Objeto não presente",
    mk_found_present_short: "Presente",
    mk_found_not_present_short: "Não presente",
    mk_found_no_checks: "Sem confirmações ainda.",
    mk_found_check_saved: "Obrigado! A tua confirmação foi guardada.",
    mk_found_intro: "Estiveste no local? Ajuda a comunidade: indica se o objeto ainda lá está.",
    mk_found_note_optional: "Nota (opcional)",
    delete_listing_title: "Eliminar anúncio",
    delete_listing_desc: "O anúncio será eliminado definitivamente. Esta ação não pode ser revertida.",
    reactivate: "Reativar",
    reactivated: "Reativado",
    close: "Fechar",
    chat_translate: "Traduzir",
    chat_show_original: "Mostrar original",
    chat_translated_badge: "tradução automática",
    chat_translating: "A traduzir…",
    chat_translate_error: "Tradução falhou",
    report_user: "Denunciar utilizador",
    report_user_title: "Denunciar este utilizador",
    report_user_reason: "Motivo",
    ur_reason_spam: "Spam",
    ur_reason_offensive: "Linguagem ofensiva",
    ur_reason_harassment: "Assédio ou ameaças",
    ur_reason_misleading: "Conteúdos falsos ou enganosos",
    ur_reason_bad_chat: "Comportamento inadequado nas conversas",
    ur_reason_misuse: "Uso indevido da aplicação",
    ur_reason_false_reports: "Denúncias repetidamente falsas",
    ur_reason_other: "Outro motivo",
    report_user_explanation: "Breve explicação (opcional)",
    report_user_send: "Enviar denúncia",
    report_user_sent: "Denúncia enviada de forma privada",
    report_user_privacy: "A denúncia é privada e não será mostrada ao utilizador denunciado.",
    admin_tab_user_reports: "Denúncias de utilizadores",
    ur_status_new: "Novas",
    ur_status_in_review: "Em revisão",
    ur_status_resolved: "Resolvidas",
    ur_status_archived: "Arquivadas",
    ur_status_rejected: "Rejeitadas",
    ur_status_all: "Todas",
    ur_reports_count: "Anteriores",
    ur_action_warn: "Aviso",
    ur_action_limit_chat: "Limitar chat",
    ur_action_limit_publish: "Limitar publicações",
    ur_action_suspend: "Suspender temporariamente",
    ur_action_ban: "Bloquear conta",
    ur_action_close: "Arquivar sem sanções",
    ur_action_hours: "Duração (horas)",
    ur_open_context: "Abrir contexto",
    ur_no_items: "Nenhuma denúncia de utilizador.",
    confirm_choose_status: "Escolhe o estado",
    confirm_in_progress: "Em curso",
    confirm_worse: "Agravada",
    confirm_undo: "Anular confirmação",
    confirm_change_title: "Modificar confirmação",
    confirm_change_desc: "Queres modificar a tua confirmação de \"{from}\" para \"{to}\"?",
    confirm_change_ok: "Sim, modificar",
    confirm_your_current: "A tua confirmação atual",
    manual_blur: "Desfocar manualmente",
    manual_blur_title: "Editor de desfocagem",
    manual_blur_desc: "Desenha retângulos sobre as áreas sensíveis. As fotos são publicadas apenas após guardar.",
    manual_blur_mode_blur: "Desfocagem",
    manual_blur_mode_pixel: "Pixelização",
    manual_blur_undo: "Anular",
    manual_blur_redo: "Refazer",
    manual_blur_clear: "Limpar tudo",
    manual_blur_save: "Guardar versão desfocada",
    manual_blur_saved: "Versão desfocada guardada",
    manual_blur_no_regions: "Adiciona pelo menos uma área antes de guardar.",
    manual_blur_hint: "Clica e arrasta para desenhar. Arrasta o contorno para redimensionar. Duplo clique para eliminar.",
    download_original: "Descarregar original",
    upload_replacement: "Carregar versão desfocada",
    replacement_uploaded: "Versão substituída",
    admin_only_action: "Reservado a Admins autorizados",
    sub_gift: "Objeto para oferecer",
    nav_reforestation: "Reflorestação",
    share: "Partilhar",
    deleted_user_label: "Utilizador eliminado",
    copy_link: "Copiar link",
    copy_link_ok: "Link copiado para a área de transferência",
    copy_link_err: "Não foi possível copiar",
    filter_area: "Distrito / área administrativa",
    notif_type_chat_message: "Nova mensagem no chat",
    notif_type_report_update: "Atualização de denúncia",
    notif_type_photo_approved: "Fotografia aprovada",
    notif_type_photo_rejected: "Fotografia rejeitada",
    notif_type_photo_review: "Fotografia em revisão",
    notif_type_urgent_approved: "Aviso aprovado",
    notif_type_urgent_rejected: "Aviso rejeitado",
    notif_type_urgent_expiring: "Aviso a expirar",
    notif_type_report_status: "Mudança de estado da denúncia",
    notif_type_content_report_resolved: "Reporte de conteúdo tratado",
    notif_type_content_report_dismissed: "Reporte de conteúdo revisto",
    notif_type_new_feedback: "Novo feedback",
    notif_type_new_urgent: "Novo aviso urgente para aprovar",
    notif_type_new_red: "Nova denúncia vermelha",
    notif_type_photo_pending: "Fotografia para rever",
    notif_type_face_uncertain: "Rostos para verificar",
    notif_type_manual_mod: "Moderação manual necessária",
    notif_type_sensitive: "Conteúdo sensível",
    notif_type_legal: "Possíveis problemas legais",
    notif_type_severe: "Denúncia muito grave",
    tour_start: "Guia rápido",
    tour_next: "Seguinte",
    tour_prev: "Anterior",
    tour_skip: "Saltar",
    tour_close: "Fechar guia",
    tour_dont_show: "Não mostrar novamente",
    tour_restart: "Reiniciar guia",
    tour_step1_title: "Bem-vindo ao ToClean",
    tour_step1_desc: "Mostramos-te como funciona em poucos segundos. Podes saltar a qualquer momento.",
    tour_step2_title: "Cria uma denúncia",
    tour_step2_desc: "Usa o botão verde para denunciar um problema ambiental, urbano ou relacionado com animais.",
    tour_step3_title: "Abre uma denúncia",
    tour_step3_desc: "Toca num marcador no mapa para abrir a ficha da denúncia.",
    tour_step4_title: "Segue e participa",
    tour_step4_desc: "No chat da denúncia podes escrever mensagens, coordenar intervenções e receber atualizações.",
    tour_step5_title: "Marketplace",
    tour_step5_desc: "Vende, oferece ou publica objetos reutilizáveis encontrados. Toque no botão Publicar e escolha a tipologia.",
    tour_step6_title: "Eventos extraordinários",
    tour_step6_desc: "Reporte emergências de grande escala como incêndios, inundações ou tempestades desenhando a área no mapa. As publicações seguem as permissões e a moderação previstas pela função do utilizador.",
    tour_step7_title: "Confirma ou desmente",
    tour_step7_desc: "Se estiveres no local, podes confirmar que o problema ainda existe ou indicar a sua resolução.",
    swipe_values_kicker: "Juntos mudamos mesmo",
    swipe_values_title: "Um pequeno gesto, um impacto real no território.",
    swipe_value_1_title: "Denuncia um problema",
    swipe_value_1_desc: "Fotografa, adiciona a localização e publica: a tua denúncia fica geolocalizada e visível para todos.",
    swipe_value_2_title: "Acompanha o que acontece no teu território",
    swipe_value_2_desc: "Mapa em tempo real, avisos urgentes e rankings das zonas mais ativas.",
    swipe_value_3_title: "Contribui para a solução",
    swipe_value_3_desc: "Verifica, confirma a resolução ou faz um donativo para um projeto real de reflorestação.",
    swipe_cta_enter: "Entrar no ToClean",
    swipe_cta_hint: "Podes explorar o mapa sem te registares.",
    map_status_all: "Todos os estados",
    map_status_selected: "{n} estados selecionados",
    map_legend_hint_in_filter: "A legenda abre-se a partir do botão no canto inferior esquerdo do mapa.",
    cat_reusable_found: "Objetos reutilizáveis encontrados",
    cat_gift: "Objetos para oferecer",
    cat_sale: "Objetos à venda",
    guest_gate_action: "Para continuar tens de entrar ou registar-te.",
    guest_gate_category_hidden: "Para ver esta secção tens de entrar ou registar-te.",
    guest_gate_marketplace: "Para ver esta secção tens de entrar ou registar-te.",
    guest_gate_title: "Acesso necessário",
    guest_gate_login: "Entrar",
    guest_gate_signup: "Registar",
    cw_intro: "Responde a algumas perguntas: vamos propor a cor certa.",
    cw_step_label: "Passo {n}",
    cw_examples: "Exemplos",
    cw_yes: "Sim",
    cw_no: "Não",
    cw_unsure: "Não tenho a certeza",
    cw_restart: "Refazer o teste",
    cw_q1: "A situação está a pôr em perigo, neste momento, a vida ou a integridade física de pessoas ou animais?",
    cw_q1_examples: "Incêndio ativo, animal preso, deslizamento de terras ou inundação com pessoas envolvidas.",
    cw_q1_reason: "Perigo imediato para pessoas ou animais.",
    cw_q2: "Vês uma fuga, dispersão ou emissão de substâncias perigosas na água, no solo ou no ar?",
    cw_q2_examples: "Combustíveis, óleos, produtos químicos, fumos tóxicos, amianto danificado, bidões com fugas, mortandade súbita de peixes ou aves, dano grave no ecossistema mesmo de causa desconhecida.",
    cw_q2_reason: "Contaminação ambiental grave, ativa ou difícil de reparar.",
    cw_q3: "O problema é extenso, pode piorar ou requer uma intervenção especializada?",
    cw_q3_examples: "Grande lixeira, árvore perigosa, resíduos eletrónicos, seringas, curso de água visivelmente poluído.",
    cw_q3_reason: "Problema sério, extenso ou que requer pessoal especializado.",
    cw_q4: "O problema é circunscrito, sem riscos evidentes e pode ser resolvido com uma limpeza ou manutenção normal?",
    cw_q4_examples: "Pequenos resíduos, caixote do lixo cheio, degradação ligeira, objeto abandonado não perigoso.",
    cw_q4_reason: "Problema comum, circunscrito e sem riscos evidentes.",
    cw_unsure_reason: "Em caso de dúvida, aplicamos um amarelo provisório: será reavaliado.",
    cw_result_red: "Vermelho — Prioridade máxima",
    cw_result_yellow: "Amarelo — Prioridade média",
    cw_result_green: "Verde — Prioridade normal",
    cw_red_admin_note: "As denúncias vermelhas são sempre verificadas por um Admin antes da publicação.",
    cw_required: "Completa o guia para estabelecer a cor da denúncia.",
    green: "Verde",
    yellow: "Amarelo",
    red: "Vermelho",
    urgent_1h: "1 hora",
    urgent_3h: "3 horas",
    urgent_6h: "6 horas",
    urgent_12h: "12 horas",
    urgent_24h: "24 horas",
    urg_low: "Baixa",
    urg_medium: "Média",
    urg_high: "Alta",
    notif_tab_all: "Todas",
    notif_tab_unread: "Não lidas",
    notif_tab_archived: "Arquivadas",
  
    save_changes: "Guardar alterações",
    all_categories: "Todas as categorias",
    all_types: "Todos os tipos",
    reject_reason_title: "Motivo da rejeição",
    only_photo: "Apenas foto",
    entire_report: "Relatório completo",
    location_placeholder: "País, província ou concelho…",
    sort_by: "Ordenar por",
    sort_recent: "Mais recentes",
    sort_oldest: "Menos recentes",
    sort_price_asc: "Preço crescente",
    sort_price_desc: "Preço decrescente",
    condition_like_new: "Como novo",
    condition_fair: "Razoável",
    gift_delivered: "Entregue",
    gift_unavailable: "Já não disponível",
    gift_reopen: "Reabrir como disponível",
    manage_subscriptions: "Gerir subscrições",
    one_time: "Uma vez",
    reject_photo_placeholder: "Ex. Rosto reconhecível não mascarado corretamente",
    admin_log_note: "Nota para o registo Admin",
    repeat_password: "Repete a password",
    back_to_login: "Voltar ao login",
    report_not_available: "Relatório não disponível",
    moderation_admin: "Moderação admin",
    no_auto_dispatch: "Sem envio automático",
    certified_delivery: "Entrega certificada",
    cancel_dispatch: "Cancelar preparação",
    personal_section: "Secção pessoal",
    stop_following: "Deixar de seguir",
    classifications_title: "Classificações",
    concluded_events: "Eventos concluídos",
    past_extraordinary_events_label: "Histórico de eventos extraordinários",
    previous_label: "Anterior",
    next_label: "Seguinte",
    assistant_label: "Assistente",
    reforestation_new_title: "Novo projeto de reflorestação",
    reforestation_update_title: "Atualizar projeto",
    no_chat_for_listing: "Nenhum chat para este anúncio",
    reports_list_label: "Lista de relatórios",
    reset_province_filter: "Limpar filtro de província",
    remove_prox_filter: "Remover filtro de proximidade",
    publish_new_tooltip: "Publica um novo relatório ou anúncio",
    seller_actions_label: "Ações do vendedor",
    selected_as_buyer_label: "Foste selecionado como comprador",
    sort_by_field: "Ordenar por",
    search_placeholder_marketplace: "Título, descrição, categoria, província…",
    search_placeholder_map: "Título, descrição, província…",
    clear_search: "Limpar pesquisa",
    tab_territories: "Territórios",
    tab_generous: "Províncias mais generosas",
    most_generous_province_badge: "Província mais generosa",
    assistant_open_tips: "Assistente: abrir dicas",
    page_tips_title: "Dicas da página",
    delete_label: "Eliminar",
    back_label: "Voltar",
    show_hide: "Mostrar/ocultar",
  
    announcement_status: "Estado do anúncio",
    in_agreement: "De acordo",
    closed_listing_note: "Este anúncio está fechado. O histórico do chat continua visível, mas não são permitidas novas mensagens de pedido.",
    reject_reason_help: "A motivação é obrigatória. A nota é opcional e não será mostrada ao autor.",
    scope_label: "Âmbito",
    motivation_required: "Motivação *",
    internal_note_optional: "Nota (interna, opcional)",
    reject_action: "Rejeitar",
    confirm_reject: "Confirmar rejeição",
    chi_siamo: "Quem somos",
    la_nostra_missione: "A nossa missão",
    search_marketplace_placeholder: "Título, descrição, categoria, distrito…",
    search_map_placeholder: "Título, descrição, distrito…",
    type_specific_label: "Tipo específico",
    reset_password: "Redefinir palavra-passe",
    declare_event_ended_title: "Declarar evento concluído",
    new_reforestation_project: "Novo projeto de reflorestação",
    update_reforestation_project: "Atualizar projeto",
    no_chat_yet: "Ainda sem chat para este anúncio",
    extraordinary_events_history: "Histórico de eventos extraordinários",
    province_label: "Distrito",
  
    category_first: "Primeiro a categoria",
    subcategory_first: "Primeiro a subcategoria",
    no_active_subscriptions: "Ainda não tens subscrições ativas.",
    monthly: "Mensal",
    near_me: "Perto de mim",
    near_me_activate: "Perto de mim (ativa a localização)",
    lb_subtitle: "Comparação positiva — apostamos nos resultados e na participação, não nos problemas.",
    period_week: "Semana",
    period_month: "Mês",
    period_year: "Ano",
    period_all: "Geral",
    assistant_status_on: "Assistente: Ativo",
    assistant_status_off: "Assistente: Desativo",
    on: "Ativa",
    off: "Desativa",
    reforestation_new_project_title: "Novo projeto de reflorestação",
    reforestation_update_project_title: "Atualizar projeto",
    declare_event_ended_title_v2: "Declarar evento concluído",
    reject_motivation_title: "Motivo da rejeição",
    past_events_kicker: "Histórico de eventos extraordinários",
    events_ended: "Eventos concluídos",
    search_by_word: "Pesquisar por palavra",
    category_marketplace: "Categoria · Marketplace",
    min_currency: "Mín €",
    max_currency: "Máx €",
    condition_all: "Todas",
    condition_new: "Novo",
    condition_good_v2: "Bom",
    condition_used: "Usado",
    condition_negotiable: "Negociável",
    condition_label: "Condição",
    score_label: "Pontuação",
    no_data_period: "Sem dados para o período selecionado.",
    no_donations_period: "Nenhuma doação registada no período selecionado.",
    sale_price_only: "Preço (só Vendo)",
    price_min_gt_max: "O mínimo é maior que o máximo: aplicamos na mesma o intervalo correto.",
    publish_new_report_tooltip: "Publica uma nova denúncia ou anúncio",
    show_hide_label: "Mostrar/ocultar",
    activate_position_note: "ativa a localização",
  
    nav_marketplace: "Marketplace",
  
    backend_unauthorized: "Não autorizado",
    backend_user_not_found: "Utilizador não encontrado",
    backend_invalid_credentials: "Credenciais inválidas",
    backend_email_already_registered: "Email já registado",
    backend_report_not_found: "Relato não encontrado",
    backend_listing_not_found: "Anúncio não encontrado",
    backend_event_not_found: "Evento não encontrado",
    backend_project_not_found: "Projeto não encontrado",
    backend_invalid_session: "Sessão inválida",
    backend_token_expired: "Token expirado",
    backend_bad_request: "Pedido inválido",
    backend_server_error: "Erro interno do servidor",
    backend_operation_completed: "Operação concluída",
    backend_saved: "Guardado",
    backend_updated: "Atualizado",
    backend_deleted: "Eliminado",
    backend_published: "Publicado",
    backend_config_incomplete: "Configuração incompleta",
    backend_forbidden: "Permissões insuficientes",
    backend_file_too_large: "Ficheiro demasiado grande",
    backend_file_bad_format: "Formato de ficheiro não suportado",
    backend_photo_required: "Foto obrigatória",
    backend_location_required: "Localização obrigatória",
    backend_category_required: "Categoria obrigatória",
    backend_title_required: "Título obrigatório",
    backend_description_required: "Descrição obrigatória",
    backend_amount_invalid: "Valor inválido",
    backend_password_too_short: "Password demasiado curta",
    backend_passwords_mismatch: "Passwords não coincidem",
    backend_email_invalid: "Email inválido",
    backend_too_many_attempts: "Demasiadas tentativas. Tenta mais tarde.",
    admin_verified_entities: "Entidades verificadas",
    admin_verified_entities_super: "Entidades verificadas (Super Admin)",
    admin_management: "Gestão Admin",
    admin_management_super: "Gestão Admin (Super Admin)",
    admin_reset_super_password: "Redefinir password Super Admin",
    admin_content_pages: "Páginas de conteúdo (Missão / Quem somos)",
    admin_pec_config: "Configuração PEC",
    admin_reforestation_manage: "Reflorestação — gestão de projetos",
    admin_reject_dialog_title: "Motivo da rejeição",
    admin_reject_reason_help: "O motivo é obrigatório. A nota é opcional e não será mostrada ao autor.",
    admin_scope_label: "Âmbito",
    admin_reason_required: "Motivo *",
    admin_internal_note: "Nota (interna, opcional)",
    admin_moderation_label: "Moderação admin",
    admin_pec_required_msg: "Configuração PEC necessária. Podes preparar e visualizar a pré-visualização, mas o envio será bloqueado até o Super Admin completar a configuração.",
    admin_pec_locked_msg: "Configuração PEC necessária. Enquanto não preencheres todos os campos, os envios de PEC ficam bloqueados.",
    admin_no_auto_dispatch: "Sem envio automático",
    admin_certified_delivery: "Entrega certificada",
    admin_save_changes: "Guardar alterações",
    admin_cancel_dispatch: "Cancelar preparação",
    admin_declare_event_ended: "Declarar evento concluído",
    admin_reforestation_new: "Novo projeto de reflorestação",
    admin_reforestation_update: "Atualizar projeto",
    admin_content_edit_desc: "Edita o texto de \"A nossa missão\" e \"Quem somos\" sem tocar no código. Se uma página não estiver publicada, os utilizadores veem o conteúdo predefinido ou um placeholder simples.",
    admin_password_reset_title: "Redefinir password",
    admin_new_password: "Nova password",
    admin_repeat_password: "Repetir password",
    admin_back_to_login: "Voltar ao login",
    admin_stop_following: "Deixar de seguir",
    admin_seller_actions: "Ações do vendedor",
    admin_buyer_selected: "Foste selecionado como comprador",
    admin_no_chat_yet: "Ainda sem chat para este anúncio",
    admin_publish_new_report: "Publicar um novo relato ou anúncio",
    admin_reset_province_filter: "Limpar filtro de província",
    admin_reports_list: "Lista de relatos",
    admin_country_province_place: "País, província ou concelho…",
    admin_content_placeholder_desc: "Um nome/função por linha (ex. Mário Silva — Fundador)",
    admin_content_placeholder_contact: "Email, PEC, morada, redes sociais…",
  
    create: "Criar",
    confirm_conclusion: "Confirmar conclusão",
    optional_note_followers: "Nota facultativa (visível para os seguidores)",
    admin_reset_super_password_confirm: "Gerar um link de redefinição de palavra-passe para a tua conta de Super Admin? O link é de utilização única e expira em 15 minutos. Serás encaminhado imediatamente para o ecrã de escolha da palavra-passe.",
  
    be_ai_not_configured: "IA não configurada",
    be_account_sospeso_o_bannato: "Conta suspensa ou banida",
    be_admin_only: "Só administradores",
    be_admin_role_required: "Precisas de ser administrador",
    be_alert_not_found: "Alerta não encontrado",
    be_almeno_un_tra_ritiro_e_spedizione_deve_essere_selezionato: "Escolhe recolha ou envio",
    be_amount_out_of_range_min_0_50_max_100000: "Valor fora do intervalo (mín. 0,50€, máx. 100000€)",
    be_cannot_report_yourself: "Não podes denunciar-te a ti próprio",
    be_duplicate_report_please_wait_before_re_reporting_the_same_co: "Denúncia duplicada — aguarda antes de denunciar novamente",
    be_duration_must_be_1_3_6_12_or_24_hours: "Duração deve ser 1, 3, 6, 12 ou 24 horas",
    be_email_already_registered: "Email já registado",
    be_email_gi_in_uso: "Email já em uso",
    be_evento_non_attivo: "Evento inativo",
    be_extension_not_found: "Extensão não encontrada",
    be_failed_to_upload_blurred_version: "Erro ao enviar versão desfocada",
    be_file_too_large_max_8mb: "Ficheiro muito grande (máx. 8MB)",
    be_forbidden: "Acesso negado",
    be_il_nome_della_ricerca_obbligatorio: "Nome da pesquisa é obrigatório",
    be_il_prezzo_obbligatorio_per_vendo: "Preço é obrigatório para Venda",
    be_invalid_action: "Ação inválida",
    be_invalid_category: "Categoria inválida",
    be_invalid_credentials: "Credenciais inválidas",
    be_invalid_image: "Imagem inválida",
    be_invalid_reason: "Motivo inválido",
    be_invalid_risk_level: "Nível de risco inválido",
    be_invalid_role: "Função inválida",
    be_invalid_session: "Sessão inválida",
    be_invalid_status: "Estado inválido",
    be_la_nuova_password_deve_avere_almeno_6_caratteri: "Nova palavra-passe precisa de pelo menos 6 caracteres",
    be_la_nuova_password_deve_avere_almeno_8_caratteri: "Nova palavra-passe precisa de pelo menos 8 caracteres",
    be_la_password_deve_avere_almeno_6_caratteri: "Palavra-passe precisa de pelo menos 6 caracteres",
    be_la_segnalazione_deve_essere_approvata_pubblicata_prima: "Denúncia precisa de ser aprovada/publicada primeiro",
    be_le_chat_non_sono_previste_per_gli_oggetti_riutilizzabili_tro: "Chat não disponível para objetos reutilizáveis encontrados",
    be_login_required_for_this_category: "Precisas de fazer login para esta categoria",
    be_message_cannot_be_empty: "Mensagem não pode estar vazia",
    be_message_not_found: "Mensagem não encontrada",
    be_messaggio_troppo_breve: "Mensagem muito curta",
    be_motivazione_obbligatoria: "Motivo obrigatório",
    be_moderation_note_required: "Motivação obrigatória (mín. 10 caracteres).",
    ur_note_required_prompt: "Motivação da medida (obrigatória, mín. 10 caracteres):",
    ur_note_required_toast: "Motivação obrigatória (mín. 10 caracteres).",
    be_nessun_abbonamento_trovato_per_questo_utente: "Nenhuma subscrição encontrada para este utilizador",
    be_nessuna_richiesta_di_conferma_attiva: "Nenhum pedido de confirmação ativo",
    be_non_annullabile_dispatch_gi_inviato: "Não cancelável: envio já feito",
    be_non_modificabile_dispatch_gi_inviato: "Não editável: envio já feito",
    be_non_puoi_rimuovere_il_tuo_ruolo_admin: "Não podes remover a tua função de Administrador",
    be_non_puoi_seguire_un_annuncio_di_cui_sei_il_proprietario: "Não podes seguir o teu próprio anúncio",
    be_not_a_reusable_item_report: "Não é uma denúncia de objeto reutilizável",
    be_not_authenticated: "Não autenticado",
    be_not_found: "Não encontrado",
    be_notification_has_no_actionable_target: "Notificação sem destino acionável",
    be_notification_not_found: "Notificação não encontrada",
    be_only_admin: "Só administradores",
    be_only_admin_can_apply_user_actions: "Só administradores podem aplicar ações de utilizador",
    be_only_admin_can_delete_reports: "Só administradores podem eliminar denúncias",
    be_only_admin_moderator: "Só administradores/moderadores",
    be_only_gift_subcategory_reports_support_this: "Só denúncias de subcategoria Oferta suportam isto",
    be_only_moderators_can_update_reports: "Só moderadores podem atualizar denúncias",
    be_only_owner_or_admin_can_set_this_status: "Só proprietário ou administrador podem definir este estado",
    be_pagina_non_trovata: "Página não encontrada",
    be_password_attuale_errata: "Palavra-passe atual incorreta",
    be_password_non_impostabile_per_questo_account_google: "Palavra-passe não configurável para esta conta (Google)",
    be_photo_not_found: "Foto não encontrada",
    be_puoi_salvare_al_massimo_20_ricerche_elimina_prima_una_vecchi: "Podes guardar no máximo 20 pesquisas. Elimina uma antiga primeiro",
    be_recurring_donations_are_only_available_for_platform_and_refo: "Doações recorrentes só disponíveis para plataforma e reflorestação",
    be_report_not_found: "Denúncia não encontrada",
    be_ricerca_non_trovata: "Pesquisa não encontrada",
    be_seleziona_prima_l: "Seleciona primeiro o",
    be_sign_in_required: "Login necessário",
    be_sign_in_required_to_view_marketplace: "Login necessário para ver Marketplace",
    be_slug_non_valido: "Slug inválido",
    be_solo_super_admin: "Só super-administradores",
    be_solo_vendo: "Só Venda",
    be_solo_admin_o_ente_verificato: "Só administradores ou entidade verificada",
    be_solo_admin_moderator_o_ente_verificato: "Só administradores/moderadores ou entidade verificada",
    be_solo_il_proprietario_pu_modificare: "Só o proprietário pode editar",
    be_solo_il_venditore: "Só o vendedor",
    be_solo_l: "Só o",
    be_solo_la_controparte_pu_confermare: "Só a outra parte pode confirmar",
    be_solo_la_controparte_pu_rifiutare: "Só a outra parte pode recusar",
    be_solo_super_admin_pu_assegnare_o_revocare_admin: "Só super-administradores podem atribuir ou revogar Administrador",
    be_source_photo_not_found: "Foto de origem não encontrada",
    be_stato_non_valido: "Estado inválido",
    be_super_admin_only: "Só super-administradores",
    be_target_user_not_found: "Utilizador alvo não encontrado",
    be_token_non_valido_o_gi_usato: "Token inválido ou já usado",
    be_token_non_valido_o_scaduto: "Token inválido ou expirado",
    be_token_scaduto: "Token expirado",
    be_too_many_reports_in_a_short_time_try_again_later: "Demasiadas denúncias num curto espaço de tempo — tenta mais tarde",
    be_transaction_not_found: "Transação não encontrada",
    be_translation_failed: "Tradução falhou",
    be_unsupported_file_type: "Tipo de ficheiro não suportado",
    be_you_can_only_edit_your_own_messages: "Só podes editar as tuas próprias mensagens",
    be_already_moderated: "já moderado",
    be_annuncio_concluso_la_chat_chiusa: "anúncio concluído: chat fechada",
    be_categoria_non_valida: "categoria inválida",
    be_invalid_hours: "horas inválidas",
    be_invalid_kind: "tipo inválido",
    be_invalid_token: "token inválido",
    be_invalid_type: "tipo inválido",
    be_kind_must_be_one_of_resolved_in_progress_worse_undo: "tipo deve ser: resolved, in_progress, worse, undo",
    be_new_path_not_found_in_files: "novo caminho não encontrado nos ficheiros",
    be_no_changes: "sem alterações",
    be_peer_id_richiesto_per_il_proprietario: "peer_id necessário para o proprietário",
    be_photo_path_required: "caminho da foto necessário",
    be_photo_index_out_of_range: "índice da foto fora do intervalo",
    be_platform_must_be_ios_android_web: "plataforma deve ser ios|android|web",
    be_polygon_needs_at_least_3_points: "polígono precisa de pelo menos 3 pontos",
    be_reason_required_min_5_chars: "motivo necessário (mín. 5 caracteres)",
    be_regions_required: "regiões necessárias",
    be_role_must_be: "função deve ser",
    be_solo_vendo_ha_il_prezzo: "só Venda tem preço",
    be_sottocategoria_non_valida: "subcategoria inválida",
    be_text_required: "texto necessário",
    be_tipo_specifico_non_valido: "tipo específico inválido",
    be_token_required: "token necessário",
    be_utente_non_trovato: "utilizador não encontrado",
    be_cosa_fare_ora_riservato_ad_admin_ed_enti_verificati: "\"O que fazer agora\" reservado a Administradores e entidades verificadas",
  
    menu_my_listings: "Os meus anúncios",
    menu_following: "Seguidos",
    menu_saved_searches: "Pesquisas guardadas",
    unread_messages: "mensagens por ler",
  
    mk_type_sale: "À venda",
    mk_type_gift: "Oferta",
    mk_type_reusable: "Reutilizável encontrado",
  
    mk_title_row: "À venda · Oferta · Reutilizáveis",
    new_listing: "Novo anúncio",
    guest_login_sale: "Entra para ver os anúncios à venda.",
    tab_all: "Todos",
    mk_kicker: "MARKETPLACE",
    tip_mk_3cats: "O Marketplace tem três categorias distintas: 🟣 À venda (com preço, recolha/envio), 🔵 Oferta (grátis, escolhida pelo proprietário no chat), 🟤 Reutilizável encontrado (objeto abandonado: quem chega primeiro leva).",
    tip_mk_guest: "Os anúncios à venda são visíveis apenas para utilizadores registados. Ofertas e reutilizáveis são visíveis para todos no mapa, mas para contactar ou criar tens de entrar.",
  
    event_new_proposal: "Nova proposta",
    event_extraordinary_kicker: "Evento extraordinário",
    event_intro_line: "Reporta um evento em curso numa área extensa (incêndio, cheia, deslizamento, tempestade, etc.).",
    event_intro_verified_pub: "A tua publicação será imediata enquanto entidade verificada.",
    event_intro_review_pub: "A proposta será revista por um Admin antes de ser publicada.",
    event_title_label: "Título",
    event_kind_label: "Categoria",
    event_whattodo_admin_only: "O que fazer agora (apenas Admin / entidades verificadas)",
    event_started_label: "Data e hora de início (opcional)",
    event_publish_btn: "Publicar evento",
    event_send_proposal_btn: "Enviar proposta",
    event_area_involved: "Área envolvida",
    event_area_hint: "Pesquisa o território (opcional) e/ou clica no mapa para adicionar os vértices do polígono. São necessários pelo menos 3 pontos.",
    event_territory_prefix: "Território",
    event_undo_last: "Anular último",
    event_clear_all: "Limpar",
    event_points_count_suffix: "pontos",
    event_title_required: "O título é obrigatório",
    event_polygon_required: "Desenha uma área com pelo menos 3 pontos",
    event_published_ok: "Evento publicado",
    event_proposal_sent: "Proposta enviada para revisão Admin",
    event_generic_error: "Erro",
    event_title_placeholder: "Ex. Incêndio florestal — Costa norte",
    event_desc_placeholder: "O que está a acontecer, onde, há quanto tempo",
    event_whattodo_placeholder: "Ex. Não te aproximes. Liga 112. Evacua zona X.",
    event_photos_label: "Fotografias",
    add_photo_short: "Adicionar",
    mkc_description_label: "Descrição",
    mkc_choose_placeholder: "Escolhe…",
    mkc_condition_label: "Condição",
    mkc_color_label: "Cor",
    mkc_color_placeholder: "Ex. azul, madeira natural",
    mkc_keywords_label: "Palavras-chave",
    mkc_photos_label: "Fotografias",
    country_or_province: "País, distrito ou concelho…",
    reports_solved_kicker: "Reportes resolvidos",
    in_progress_kicker: "Em progresso",
    verified_users_kicker: "Utilizadores verificados",
    close_tips: "Fechar dicas",
    what_are_you_selling: "O que vendes?",
    what_are_you_giving: "O que ofereces?",
    what_did_you_find: "O que encontraste?",
    change_type: "Mudar tipo",
    publish_listing: "Publicar anúncio",
    approximate_location: "Localização aproximada",
    category_first_short: "Categoria primeiro",
    mkc_new_listing_kicker: "Marketplace · Novo anúncio",
    mkc_what_type_heading: "Que tipo de anúncio queres publicar?",
    mkc_type_choice_desc: "Escolhe uma das três modalidades. Cada tipo tem regras próprias (preço, chat, encerramento). Podes alterar a escolha antes de publicar.",
    mkc_hint_sale: "Preço obrigatório. O anúncio é visível apenas para utilizadores registados. Chat privado com potenciais compradores; no final, tu (vendedor) e o comprador confirmam a conclusão.",
    mkc_hint_gift: "Ofereces um objeto a outro utilizador. Sem preço. Decide livremente no chat a quem entregar.",
    mkc_hint_reusable: "Reportas um objeto abandonado ou reutilizável que encontraste. Sem preço, sem atribuição: quem chega primeiro leva. O chat é apenas informativo.",
    mkc_subtitle_sale: "Publica um anúncio de venda: preço obrigatório, recolha em mão ou envio, chat privado com os compradores.",
    mkc_subtitle_gift: "Oferece um objeto a outro utilizador: escolhes livremente no chat a quem entregar.",
    mkc_subtitle_reusable: "Reporta um objeto reutilizável que encontraste ou abandonado: quem chega primeiro leva. Chat apenas informativo.",
    mkc_title_label: "Título",
    mkc_category_label: "Categoria",
    mkc_subcategory_label: "Subcategoria",
    mkc_itemtype_label: "Tipo específico",
    mkc_subcategory_first: "Primeiro a subcategoria",
    mkc_condition_new: "Novo",
    mkc_condition_good: "Bom",
    mkc_condition_used: "Usado",
    mkc_keywords_placeholder: "ikea, duplo, 180cm (separados por vírgula)",
    mkc_price_label: "Preço (€)",
    mkc_negotiable: "Negociável",
    mkc_pickup: "Recolha em mão",
    mkc_shipping: "Envio",
    mkc_position_label: "Posição aproximada",
    mkc_position_hint: "Pesquisa o território (opcional) e/ou clica no mapa. A posição pública é aproximada; partilharás o endereço exato no chat.",
    mkc_territory_prefix: "Território",
    mkc_err_title_required: "O título é obrigatório",
    mkc_err_taxonomy_required: "Categoria, subcategoria e tipo específico são obrigatórios",
    mkc_err_position_required: "Seleciona a posição aproximada no mapa",
    mkc_err_price_required: "O preço é obrigatório",
    mkc_success_published: "Anúncio publicado",
    mkc_err_generic: "Erro",
    mkc_upload_failed: "Upload falhou",
    map_reports_list_title: "Lista de reportes",
    map_within_km: "num raio de {km} km",
    map_within_area: "em {area}",
    map_count_results: "resultados",
    map_count_reports: "reportes",
    map_clear_area_filter: "Repor filtro província",
    details_arrow: "Detalhes →",
    events_popup_state_prefix: "Estado",
    mk_popup_following: "✓ A seguir",
    mk_popup_follow: "🔔 Seguir",
    events_history_kicker: "Histórico de eventos extraordinários",
    events_history_count_suffix: "eventos",
    events_history_none: "Nenhum evento encontrado.",
    legal_kicker: "Documento legal",
    legal_placeholder_title: "Conteúdo em finalização",
    legal_placeholder_body: "O texto definitivo deste documento será publicado em breve. Para informações contacta-nos em",
    legal_privacy_title: "Política de privacidade",
    legal_terms_title: "Termos e Condições",
    legal_community_title: "Regras da comunidade",
    legal_marketplace_title: "Regras do Marketplace",
    acct_del_kicker: "Eliminação de conta",
    acct_del_title: "Elimina a tua conta ToClean",
    acct_del_intro: "Podes pedir a eliminação da tua conta ToClean e dos dados pessoais associados em qualquer momento. A ação é irreversível.",
    acct_del_what_happens_title: "O que acontece na eliminação",
    acct_del_what_1: "A tua conta é removida da base de dados.",
    acct_del_what_2: "Os teus anúncios do Marketplace são removidos.",
    acct_del_what_3: "As tuas publicações e mensagens são anonimizadas (conteúdo preservado, autor mostrado como «Utilizador eliminado»).",
    acct_del_what_4: "As tuas sessões e tokens push são revogados imediatamente.",
    acct_del_what_5: "Os reportes públicos já enviados às autoridades permanecem no seu registo (obrigação legal).",
    acct_del_how_signed_in_title: "Se estiveres autenticado",
    acct_del_how_signed_in_body: "Vai a Definições → «Eliminar conta». Receberás uma confirmação antes da ação irreversível.",
    acct_del_go_settings: "Abrir definições",
    acct_del_how_email_title: "Se não tens acesso à conta",
    acct_del_how_email_body: "Escreve para info@toclean.app do email associado à conta. A equipa ToClean processará o pedido.",
  
    tip_event_scope: "Um evento extraordinário diz respeito a emergências de área alargada (incêndio, inundação, deslizamento, tempestade, etc.), não a objetos individuais ou pequenas sinalizações.",
    tip_event_polygon: "Desenha a área no mapa clicando nos vértices do polígono: são necessários pelo menos 3 pontos. Usa «Anular último» ou «Limpar» para corrigir.",
    tip_event_moderation: "Se não és uma entidade verificada, a proposta é enviada para revisão de um Admin antes de se tornar pública no mapa.",
    tip_map_colors: "Os marcadores são coloridos por risco: 🟢 Verde = normal, 🟡 Amarelo = a monitorizar, 🔴 Vermelho = urgente. A cor é decidida pelo breve questionário na fase de criação da sinalização.",
    tip_map_filters: "Usa os filtros para escolher que sinalizações ou objetos visualizar. O mapa, a lista e o número de resultados atualizam-se em conjunto.",
    tip_map_duplicates: "Antes de abrir uma nova sinalização, verifica se já existe uma próxima: ajuda a não gerar duplicados e a reforçar os relatórios existentes.",
    tip_rc_wizard: "As 4 perguntas do código de cores atribuem automaticamente Verde/Amarelo/Vermelho com base no risco percebido, urgência, dimensão e impacto. Não são um julgamento: apenas orientam a prioridade da moderação.",
    tip_rc_privacy: "As tuas fotos são processadas no servidor: rostos e matrículas são automaticamente desfocados. A localização pública é aproximada: a morada exata permanece privada.",
    tip_rc_after_photo: "Para declarar resolvida uma sinalização normal, terás de adicionar mais tarde uma foto «depois» do mesmo local. Apenas um clique, mas indispensável para confirmar a resolução.",
  
    publish: "Publicar",
    submit_for_review: "Enviar para revisão",
    state_published: "Publicado",
    state_in_progress: "Em andamento",
    state_pending: "Em verificação",
    state_rejected: "Rejeitado",
    state_draft: "Rascunho",
    state_resolved: "Resolvido",
    state_closed: "Fechado",
    state_active: "Ativo",
    risk_green: "Verde",
    risk_yellow: "Amarelo",
    risk_red: "Vermelho",
    stats_reports_solved: "Denúncias resolvidas",
    stats_reports_progress: "Em andamento",
    stats_users_verified: "Utilizadores verificados",
  
    no_period_data: "Sem dados para o período selecionado.",
    awaiting_counterpart: "A aguardar a confirmação da outra parte.",
    no_messages_write_first: "Sem mensagens — escreve a primeira.",
    no_chat_for_listing_msg: "Sem chat para este anúncio",
    // Fase 3 — chat privado (só 18+)
    nav_messages: "Mensagens",
    chat_title: "Mensagens",
    chat_tab_chats: "Chats",
    chat_tab_requests: "Pedidos",
    chat_tab_invites: "Convites",
    chat_tab_blocked: "Bloqueados",
    chat_empty: "Ainda sem chats.",
    chat_no_requests: "Sem pedidos.",
    chat_no_invites: "Sem convites.",
    chat_send: "Enviar",
    chat_composer_placeholder: "Escreve uma mensagem…",
    chat_request_dialog_title: "Pedir chat privado",
    chat_request_dialog_desc: "Envia um pedido para iniciar um chat privado. O destinatário tem de o aceitar antes que a conversa possa começar.",
    chat_request_send: "Enviar pedido",
    chat_request_sent: "Pedido enviado",
    chat_message_optional_label: "Mensagem inicial (opcional)",
    chat_message_optional_ph: "Por exemplo: estou interessado no teu anúncio…",
    chat_accept: "Aceitar",
    chat_reject: "Recusar",
    chat_cancel_req: "Cancelar pedido",
    chat_incoming: "Recebidos",
    chat_outgoing: "Enviados",
    chat_pending_status: "Pendente",
    chat_group_create: "Criar grupo",
    chat_group_title_label: "Título do grupo",
    chat_group_desc_label: "Descrição (opcional)",
    chat_group_invitees_label: "Convidar utilizadores (IDs separados por vírgulas)",
    chat_group_picker_label: "Convidar utilizadores",
    chat_group_picker_placeholder: "Pesquisar por nome…",
    chat_group_picker_selected: "Selecionados",
    chat_group_picker_no_results: "Nenhum utilizador encontrado.",
    chat_group_picker_min_chars: "Escreve pelo menos 2 caracteres.",
    chat_group_picker_add: "Adicionar",
    chat_group_picker_remove: "Remover",
    // Fase 4 — Ligações sociais
    social_links_title: "Ligações sociais e site",
    social_links_desc: "Opcionais. As ligações aparecem no teu perfil público. A ToClean não verifica nem aprova conteúdos externos.",
    social_links_add: "Adicionar ligação",
    social_links_platform: "Plataforma",
    social_links_url: "URL",
    social_links_label: "Rótulo (opcional)",
    social_links_save: "Guardar ligações",
    social_links_saved: "Ligações sociais guardadas",
    social_links_url_scheme_err: "O URL deve começar por http:// ou https://",
    social_links_url_invalid_err: "URL inválido.",
    social_links_url_too_long_err: "URL demasiado longo.",
    social_links_adult_only: "Só utilizadores com 18 anos ou mais podem adicionar ligações externas.",
    social_links_none: "Sem ligações.",
    social_links_platform_website: "Site",
    social_links_platform_other: "Outro",
    social_links_disclaimer: "Ligações externas não verificadas.",
    // Fase 4 — Vídeo
    video_upload_label: "Adicionar vídeo",
    video_upload_hint: "Formatos suportados: MP4, MOV, M4V, WebM (H.264 ou VP8/VP9). Máximo {mb} MB.",
    video_uploading: "A carregar…",
    video_upload_progress: "{p}%",
    video_upload_ok: "Vídeo carregado",
    video_upload_err_format: "Formato não suportado. Usa MP4, MOV ou WebM.",
    video_upload_err_hevc: "O teu vídeo está em HEVC/H.265 e não é reproduzível em todos os navegadores. No iPhone vai a Definições → Câmara → Formatos → \"Mais compatível\" e tenta de novo.",
    hevc_help_title: "Compatibilidade de vídeo iPhone",
    hevc_help_desc: "O teu iPhone gravou este clipe em HEVC/H.265. Segue estes passos para usar um formato compatível com a ToClean.",
    hevc_help_step1: "Abre as Definições",
    hevc_help_step2: "Vai a Câmara → Formatos",
    hevc_help_step3: "Escolhe \"Mais compatível\"",
    hevc_help_step4: "Grava um vídeo novo e carrega-o de novo",
    hevc_help_note: "Os vídeos HEVC já no carretel mantêm-se inalterados. As novas gravações serão em H.264/MP4 — compatíveis com a ToClean e com a maioria dos dispositivos.",
    hevc_help_show: "Como resolvo?",
    video_upload_err_too_large: "Vídeo demasiado grande. Limite {mb} MB.",
    video_upload_err_generic: "Não foi possível carregar o vídeo.",
    video_delete: "Eliminar vídeo",
    video_delete_confirm: "Eliminar este vídeo?",
    video_privacy_notice: "Se o vídeo mostrar pessoas, matrículas ou dados pessoais diretamente ligados a um comportamento presumivelmente ilícito ou prejudicial, aplica-se o mesmo Privacy Prompt das fotos.",
    video_none: "Sem vídeos.",
    video_removed: "Vídeo removido.",
    chat_group_leave: "Sair do grupo",
    chat_group_member: "Membro",
    chat_group_pending_label: "Convite pendente",
    chat_block_user: "Bloquear utilizador",
    chat_unblock_user: "Desbloquear",
    chat_blocked_list: "Utilizadores bloqueados",
    chat_report_message: "Denunciar mensagem",
    chat_adult_only: "Os chats privados estão disponíveis apenas para utilizadores com 18 anos ou mais.",
    chat_pending_invite_banner: "Tens de aceitar o convite para ver as mensagens do grupo.",
    chat_open: "Abrir",
    chat_leave: "Sair",
    chat_open_conversation: "Abrir conversa",
    chat_error_send: "Não foi possível enviar a mensagem.",
    chat_group_created: "Grupo criado",
    chat_group_leave_confirm: "Tens a certeza de que queres sair do grupo?",
    chat_from: "de",
    report_unavailable: "Denúncia indisponível",
    open_report_in_app: "Abrir a denúncia na app",
    content_removed: "Este conteúdo foi removido ou já não está acessível.",
    no_pec_before_button: "Nenhum e-mail certificado é enviado antes deste botão.",
    no_reports_for_filters: "Nenhuma denúncia corresponde aos filtros.",
    reforestation_big_project: "Um projeto tão grande como o futuro que queremos construir.",
    not_authorized_dot: "Não autorizado.",
    support_reforestation: "Apoia a reflorestação",
    my_searches_title: "As minhas pesquisas",
    signup_dob_label: "Data de nascimento",
    signup_dob_help: "Usada apenas para verificar que tens pelo menos 14 anos. Nunca é mostrada.",
    signup_terms_prefix: "Li e aceito os",
    signup_terms_link: "Termos de Serviço",
    signup_privacy_prefix: "Li e aceito a",
    signup_privacy_link: "Política de Privacidade",
    signup_terms_required: "Tens de aceitar os Termos e a Privacidade para te registares.",
    signup_age_required: "Tens de ter pelo menos 14 anos para usar o ToClean.",
    signup_dob_invalid: "Data de nascimento inválida.",
    complete_profile_title: "Completa o teu perfil",
    complete_profile_desc: "Para continuar a usar o ToClean confirma a tua idade e aceita as condições atualizadas. Não pedimos mais dados.",
    complete_profile_cta: "Confirmar e continuar",
    complete_profile_age_warning: "Se tens menos de 14 anos a tua conta será removida automaticamente, conforme exigem as regras das app stores.",
    mk_adult_only_banner: "O Marketplace é apenas de leitura até aos 18. Podes ver anúncios mas não publicar, contactar ou seguir.",
    mk_adult_only_button_tip: "Disponível a partir dos 18.",
    mk_new_disabled_minor: "Só +18",
    report_content_btn: "Reportar conteúdo",
    report_content_title: "Reportar este conteúdo",
    report_content_desc: "A nossa equipa de moderação será notificada. Nunca partilhamos a tua identidade com a pessoa reportada.",
    report_reason_harassment: "Assédio ou ameaças",
    report_reason_hate: "Discurso de ódio",
    report_reason_sexual: "Conteúdo sexual não solicitado",
    report_reason_spam: "Spam ou fraude",
    report_reason_privacy: "Violação de privacidade",
    report_reason_illegal: "Conteúdo ilegal",
    report_reason_impersonation: "Personificação",
    report_reason_abuse: "Abuso da plataforma",
    report_reason_other: "Outro",
    report_content_details: "Detalhes (opcional)",
    report_content_send: "Enviar reporte",
    report_content_sent: "Reporte enviado. Obrigado.",
    block_user_btn: "Bloquear utilizador",
    unblock_user_btn: "Desbloquear utilizador",
    block_user_confirm_title: "Bloquear este utilizador?",
    block_user_confirm_desc: "Deixarás de receber as suas mensagens e conteúdos. Podes desbloqueá-lo a qualquer momento nas Definições.",
    block_user_ok: "Bloqueado",
    unblock_user_ok: "Desbloqueado",
    pp_title: "Um momento antes de publicar",
    pp_question: "Estás a tornar reconhecível uma pessoa, uma matrícula ou outros dados pessoais associando-os diretamente a um alegado comportamento ilícito ou prejudicial?",
    pp_answer_no: "Não",
    pp_answer_yes: "Sim",
    pp_warn_title: "Atenção: privacidade, reputação e direitos das pessoas",
    pp_warn_body: "Tornar uma pessoa identificável e ligá-la publicamente a alegados factos ilícitos pode ter consequências legais para ti e para a pessoa representada: privacidade, reputação e direitos pessoais estão em jogo.\n\nPor este motivo, o conteúdo será enviado à ToClean para verificação antes de uma eventual publicação.",
    pp_warn_body_review_only: "Tornar uma pessoa identificável e ligá-la publicamente a alegados factos ilícitos pode ter consequências legais para ti e para a pessoa representada: privacidade, reputação e direitos pessoais estão em jogo.\n\nPor este motivo, o conteúdo será enviado à ToClean para verificação antes de uma eventual publicação.",
    pp_send_review: "Enviar para revisão ao ToClean",
    pp_ack_label: "Confirmo que sou responsável pelos conteúdos e declarações que publico e que li o aviso relativo à privacidade, reputação e direitos das pessoas representadas.",
    pp_publish_anyway: "Publicar mesmo assim",
    pp_sent_review_toast: "Conteúdo enviado para revisão. Vamos manter-te informado.",
    comment_like: "Gosto",
    comment_unlike: "Remover Gosto",
    comment_likes_count_one: "1 gosto",
    comment_likes_count_many: "{n} gostos",
    comment_sort_label: "Ordenar",
    comment_sort_relevant: "Mais relevantes",
    comment_sort_liked: "Mais apreciados",
    comment_sort_recent: "Mais recentes",
    comment_sort_oldest: "Mais antigos",
    comment_report: "Reportar comentário",
    admin_tab_content_reports: "Reportes de conteúdo",
    admin_tab_events: "Eventos extraordinários",
    what_to_do_now: "O que fazer agora",
    reject_reason_prompt: "Motivo (opcional):",
    delete_event_confirm: "Eliminar definitivamente este evento?",
    cr_no_items: "Nenhum reporte de conteúdo para os filtros atuais.",
    cr_status_open: "Aberto",
    cr_status_in_review: "Em revisão",
    cr_status_resolved: "Resolvido",
    cr_status_dismissed: "Descartado",
    cr_target_type: "Tipo",
    cr_target_report: "Reporte",
    cr_target_marketplace_listing: "Anúncio",
    cr_target_message: "Mensagem de chat",
    cr_target_marketplace_message: "Mensagem Marketplace",
    cr_reported_by: "Reportado por",
    cr_reporter_deleted: "utilizador eliminado",
    cr_content_author: "Autor do conteúdo",
    cr_open_target: "Abrir conteúdo reportado",
    cr_action_review: "Colocar em revisão",
    cr_action_resolve: "Marcar como resolvido",
    legal_info_title: "Informações Legais e Contactos",
    legal_privacy_title: "Política de Privacidade",
    legal_terms_title: "Termos de Serviço",
    legal_community_title: "Regras da Comunidade",
    legal_marketplace_title: "Regras do Marketplace",
    legal_deletion_title: "Eliminação de Conta e Dados",
    footer_legal: "Documentos legais",
    footer_legal_info: "Informações legais",
    footer_privacy: "Política de privacidade",
    footer_terms: "Termos de serviço",
    footer_community_rules: "Regras da comunidade",
    footer_marketplace_rules: "Regras do Marketplace",
    footer_account_deletion: "Eliminação da conta",
    signup_consent_prefix: "Aceito os",
    signup_consent_and_the: "e as",
    signup_consent_privacy_note: "e declaro ter lido a",
    signup_community_link: "Regras da comunidade",
    mkt_rules_gate_title: "Regras do Marketplace",
    mkt_rules_gate_kicker: "Primeira operação no Marketplace",
    mkt_rules_gate_desc: "Para publicar um anúncio, editar o seu ou contactar outro utilizador, precisa primeiro de aceitar a versão em vigor das Regras do Marketplace.",
    mkt_rules_gate_read: "Ler as Regras do Marketplace",
    mkt_rules_gate_checkbox: "Li e aceito as Regras do Marketplace.",
    mkt_rules_gate_accept: "Aceitar e continuar",
    mkt_rules_gate_cancel: "Cancelar",
    mkt_rules_gate_required: "Precisa de aceitar as Regras do Marketplace para continuar.",
    mkt_rules_gate_accepted_toast: "Regras do Marketplace aceites.",
    mkt_rules_gate_error: "Não foi possível registar a sua aceitação. Tente novamente.",
    section_profile_photo: "Foto de perfil",
    profile_photo_desc: "Adicione uma foto de perfil pública. É opcional e pode ser removida a qualquer momento.",
    profile_photo_upload: "Carregar foto",
    profile_photo_replace: "Substituir foto",
    profile_photo_remove: "Remover foto",
    profile_photo_uploading: "A carregar…",
    profile_photo_removing: "A remover…",
    profile_photo_updated: "Foto de perfil atualizada.",
    profile_photo_removed: "Foto de perfil removida.",
    profile_photo_invalid_type: "Formato de imagem não suportado. Utilize JPG, PNG ou WEBP.",
    profile_photo_too_large: "Imagem demasiado grande. Tamanho máximo: 5 MB.",
    profile_photo_error: "Não foi possível atualizar a foto de perfil. Tente novamente.",
    profile_photo_hint: "JPG, PNG ou WEBP · máx. 5 MB.",
    username_label: "Nome de utilizador",
    username_placeholder: "ex. joao.silva",
    username_help: "3–30 caracteres, apenas letras, dígitos, ponto e underscore. Único e público.",
    email_private_hint: "O seu email é privado e nunca é mostrado a outros utilizadores.",
    username_too_short: "O nome de utilizador tem de ter pelo menos 3 caracteres.",
    username_too_long: "O nome de utilizador não pode exceder 30 caracteres.",
    username_invalid_chars: "O nome de utilizador só pode conter letras, dígitos, pontos e underscores.",
    username_reserved: "Esse nome de utilizador é reservado.",
    username_taken: "Esse nome de utilizador já está em uso.",
    username_required: "Escolha um nome de utilizador para continuar.",
    cr_action_dismiss: "Descartar",
  },
};

const I18nContext = createContext(null);

// Map UI language code → BCP-47 locale tag used by Intl.* APIs.
const LOCALE_MAP = { it: "it-IT", en: "en-GB", fr: "fr-FR", de: "de-DE", es: "es-ES", pt: "pt-PT" };

// Map backend Italian error/success strings (raised by FastAPI) → i18n keys.
// Exported so it can be reused by the axios interceptor (which cannot call hooks).
export const BACKEND_MSG_MAP = {
  "Non hai ancora abbonamenti attivi.": "no_active_subscriptions",
  "Non autorizzato": "backend_unauthorized",
  "Utente non trovato": "backend_user_not_found",
  "Credenziali non valide": "backend_invalid_credentials",
  "Email già registrata": "backend_email_already_registered",
  "Segnalazione non trovata": "backend_report_not_found",
  "Annuncio non trovato": "backend_listing_not_found",
  "Evento non trovato": "backend_event_not_found",
  "Progetto non trovato": "backend_project_not_found",
  "Sessione non valida": "backend_invalid_session",
  "Token scaduto": "backend_token_expired",
  "Richiesta non valida": "backend_bad_request",
  "Errore interno del server": "backend_server_error",
  "Operazione completata": "backend_operation_completed",
  "Salvato": "backend_saved",
  "Aggiornato": "backend_updated",
  "Eliminato": "backend_deleted",
  "Pubblicato": "backend_published",
  "Configurazione non completata": "backend_config_incomplete",
  "Permessi insufficienti": "backend_forbidden",
  "File troppo grande": "backend_file_too_large",
  "Formato file non supportato": "backend_file_bad_format",
  "Foto obbligatoria": "backend_photo_required",
  "Posizione obbligatoria": "backend_location_required",
  "Categoria obbligatoria": "backend_category_required",
  "Titolo obbligatorio": "backend_title_required",
  "Descrizione obbligatoria": "backend_description_required",
  "Importo non valido": "backend_amount_invalid",
  "Password troppo corta": "backend_password_too_short",
  "Password non corrispondenti": "backend_passwords_mismatch",
  "Email non valida": "backend_email_invalid",
  "Troppi tentativi. Riprova più tardi.": "backend_too_many_attempts",

  "AI not configured": "be_ai_not_configured",
  "Account sospeso o bannato": "be_account_sospeso_o_bannato",
  "Admin only": "be_admin_only",
  "Admin role required": "be_admin_role_required",
  "Alert not found": "be_alert_not_found",
  "Almeno un tra ritiro e spedizione deve essere selezionato": "be_almeno_un_tra_ritiro_e_spedizione_deve_essere_selezionato",
  "Amount out of range (min 0.50€, max 100000€)": "be_amount_out_of_range_min_0_50_max_100000",
  "Cannot report yourself": "be_cannot_report_yourself",
  "Duplicate report — please wait before re-reporting the same content.": "be_duplicate_report_please_wait_before_re_reporting_the_same_co",
  "Duration must be 1, 3, 6, 12 or 24 hours": "be_duration_must_be_1_3_6_12_or_24_hours",
  "Email already registered": "be_email_already_registered",
  "Email già in uso": "be_email_gi_in_uso",
  "Evento non attivo": "be_evento_non_attivo",
  "Extension not found": "be_extension_not_found",
  "Failed to upload blurred version": "be_failed_to_upload_blurred_version",
  "File too large (max 8MB)": "be_file_too_large_max_8mb",
  "Forbidden": "be_forbidden",
  "Il nome della ricerca è obbligatorio": "be_il_nome_della_ricerca_obbligatorio",
  "Il prezzo è obbligatorio per Vendo": "be_il_prezzo_obbligatorio_per_vendo",
  "Invalid action": "be_invalid_action",
  "Invalid category": "be_invalid_category",
  "Invalid credentials": "be_invalid_credentials",
  "Invalid image": "be_invalid_image",
  "Invalid reason": "be_invalid_reason",
  "Invalid risk_level": "be_invalid_risk_level",
  "Invalid role": "be_invalid_role",
  "Invalid session": "be_invalid_session",
  "invalid status": "be_invalid_status",
  "La nuova password deve avere almeno 6 caratteri": "be_la_nuova_password_deve_avere_almeno_6_caratteri",
  "La nuova password deve avere almeno 8 caratteri": "be_la_nuova_password_deve_avere_almeno_8_caratteri",
  "La password deve avere almeno 6 caratteri": "be_la_password_deve_avere_almeno_6_caratteri",
  "La segnalazione deve essere approvata/pubblicata prima": "be_la_segnalazione_deve_essere_approvata_pubblicata_prima",
  "Le chat non sono previste per gli oggetti riutilizzabili trovati": "be_le_chat_non_sono_previste_per_gli_oggetti_riutilizzabili_tro",
  "Login required for this category": "be_login_required_for_this_category",
  "Message cannot be empty": "be_message_cannot_be_empty",
  "Message not found": "be_message_not_found",
  "Messaggio troppo breve": "be_messaggio_troppo_breve",
  "Motivazione obbligatoria": "be_motivazione_obbligatoria",
  "moderation_note_required": "be_moderation_note_required",
  "Nessun abbonamento trovato per questo utente": "be_nessun_abbonamento_trovato_per_questo_utente",
  "Nessuna richiesta di conferma attiva": "be_nessuna_richiesta_di_conferma_attiva",
  "Non annullabile: dispatch già inviato": "be_non_annullabile_dispatch_gi_inviato",
  "Non modificabile: dispatch già inviato": "be_non_modificabile_dispatch_gi_inviato",
  "Non puoi rimuovere il tuo ruolo Admin": "be_non_puoi_rimuovere_il_tuo_ruolo_admin",
  "Non puoi seguire un annuncio di cui sei il proprietario": "be_non_puoi_seguire_un_annuncio_di_cui_sei_il_proprietario",
  "Not a reusable item report": "be_not_a_reusable_item_report",
  "Not authenticated": "be_not_authenticated",
  "Not found": "be_not_found",
  "Notification has no actionable target": "be_notification_has_no_actionable_target",
  "Notification not found": "be_notification_not_found",
  "Only admin": "be_only_admin",
  "Only admin can apply user actions": "be_only_admin_can_apply_user_actions",
  "Only admin can delete reports": "be_only_admin_can_delete_reports",
  "Only admin/moderator": "be_only_admin_moderator",
  "Only gift subcategory reports support this": "be_only_gift_subcategory_reports_support_this",
  "Only moderators can update reports": "be_only_moderators_can_update_reports",
  "Only owner or admin can set this status": "be_only_owner_or_admin_can_set_this_status",
  "Pagina non trovata": "be_pagina_non_trovata",
  "Password attuale errata": "be_password_attuale_errata",
  "Password non impostabile per questo account (Google)": "be_password_non_impostabile_per_questo_account_google",
  "Photo not found": "be_photo_not_found",
  "Puoi salvare al massimo 20 ricerche. Elimina prima una vecchia.": "be_puoi_salvare_al_massimo_20_ricerche_elimina_prima_una_vecchi",
  "Recurring donations are only available for platform and reforestation": "be_recurring_donations_are_only_available_for_platform_and_refo",
  "report not found": "be_report_not_found",
  "Ricerca non trovata": "be_ricerca_non_trovata",
  "Seleziona prima l": "be_seleziona_prima_l",
  "Sign in required": "be_sign_in_required",
  "Sign in required to view Marketplace": "be_sign_in_required_to_view_marketplace",
  "Slug non valido": "be_slug_non_valido",
  "Solo super-admin": "be_solo_super_admin",
  "Solo Vendo": "be_solo_vendo",
  "Solo admin o ente verificato": "be_solo_admin_o_ente_verificato",
  "Solo admin/moderator o ente verificato": "be_solo_admin_moderator_o_ente_verificato",
  "Solo il proprietario può modificare": "be_solo_il_proprietario_pu_modificare",
  "Solo il venditore": "be_solo_il_venditore",
  "Solo l": "be_solo_l",
  "Solo la controparte può confermare": "be_solo_la_controparte_pu_confermare",
  "Solo la controparte può rifiutare": "be_solo_la_controparte_pu_rifiutare",
  "Solo super-admin può assegnare o revocare Admin": "be_solo_super_admin_pu_assegnare_o_revocare_admin",
  "Source photo not found": "be_source_photo_not_found",
  "Stato non valido": "be_stato_non_valido",
  "Super admin only": "be_super_admin_only",
  "Target user not found": "be_target_user_not_found",
  "Token non valido o già usato": "be_token_non_valido_o_gi_usato",
  "Token non valido o scaduto": "be_token_non_valido_o_scaduto",
  "Too many reports in a short time — try again later.": "be_too_many_reports_in_a_short_time_try_again_later",
  "Transaction not found": "be_transaction_not_found",
  "Translation failed": "be_translation_failed",
  "Unsupported file type": "be_unsupported_file_type",
  "You can only edit your own messages": "be_you_can_only_edit_your_own_messages",
  "already moderated": "be_already_moderated",
  "annuncio è concluso: la chat è chiusa": "be_annuncio_concluso_la_chat_chiusa",
  "categoria non valida": "be_categoria_non_valida",
  "invalid hours": "be_invalid_hours",
  "invalid kind": "be_invalid_kind",
  "invalid token": "be_invalid_token",
  "invalid type": "be_invalid_type",
  "kind must be one of: resolved, in_progress, worse, undo": "be_kind_must_be_one_of_resolved_in_progress_worse_undo",
  "new_path not found in files": "be_new_path_not_found_in_files",
  "no changes": "be_no_changes",
  "peer_id richiesto per il proprietario": "be_peer_id_richiesto_per_il_proprietario",
  "photo path required": "be_photo_path_required",
  "photo_index out of range": "be_photo_index_out_of_range",
  "platform must be ios|android|web": "be_platform_must_be_ios_android_web",
  "polygon needs at least 3 points": "be_polygon_needs_at_least_3_points",
  "reason required (min 5 chars)": "be_reason_required_min_5_chars",
  "regions required": "be_regions_required",
  "role must be": "be_role_must_be",
  "solo Vendo ha il prezzo": "be_solo_vendo_ha_il_prezzo",
  "sottocategoria non valida": "be_sottocategoria_non_valida",
  "text required": "be_text_required",
  "tipo specifico non valido": "be_tipo_specifico_non_valido",
  "token required": "be_token_required",
  "utente non trovato": "be_utente_non_trovato",
  "«Cosa fare ora» riservato ad Admin ed enti verificati": "be_cosa_fare_ora_riservato_ad_admin_ed_enti_verificati",
};

// Translate a backend Italian message to the currently-selected UI language.
// Works OUTSIDE of React components (used by the axios response interceptor).
export function translateBackendMessage(msg, lang) {
  if (!msg || typeof msg !== "string") return msg;
  const l = lang || (typeof localStorage !== "undefined" ? localStorage.getItem("tc_lang") : null) || "it";
  const key = BACKEND_MSG_MAP[msg.trim()];
  if (!key) return msg;
  return (dict[l] && dict[l][key]) || (dict.en && dict.en[key]) || msg;
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tc_lang") || "it");
  useEffect(() => { localStorage.setItem("tc_lang", lang); }, [lang]);
  const t = (key) => (dict[lang] && dict[lang][key]) || dict.en[key] || key;

  const locale = LOCALE_MAP[lang] || "en-GB";

  // Locale-aware formatters. All accept Date | ISO string | number.
  const _asDate = (d) => (d instanceof Date ? d : (d ? new Date(d) : null));
  const fmtDate = (d, opts = { day: "2-digit", month: "short", year: "numeric" }) => {
    const dd = _asDate(d); if (!dd || isNaN(dd)) return "";
    try { return new Intl.DateTimeFormat(locale, opts).format(dd); } catch { return dd.toLocaleDateString(); }
  };
  const fmtDateTime = (d, opts = { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) => {
    const dd = _asDate(d); if (!dd || isNaN(dd)) return "";
    try { return new Intl.DateTimeFormat(locale, opts).format(dd); } catch { return dd.toLocaleString(); }
  };
  const fmtTime = (d, opts = { hour: "2-digit", minute: "2-digit" }) => {
    const dd = _asDate(d); if (!dd || isNaN(dd)) return "";
    try { return new Intl.DateTimeFormat(locale, opts).format(dd); } catch { return dd.toLocaleTimeString(); }
  };
  const fmtNumber = (n, opts) => {
    if (n === null || n === undefined || Number.isNaN(Number(n))) return "";
    try { return new Intl.NumberFormat(locale, opts).format(Number(n)); } catch { return String(n); }
  };
  const fmtCurrency = (amount, currency = "EUR", opts = {}) => {
    if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return "";
    try {
      return new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: 2, ...opts }).format(Number(amount));
    } catch { return `${currency} ${amount}`; }
  };
  // Translate a backend-returned error/success message. Falls back to the
  // original text when we don't have a mapping for it.
  const tBackend = (msg) => translateBackendMessage(msg, lang);

  return (
    <I18nContext.Provider value={{ lang, setLang, t, locale, fmtDate, fmtDateTime, fmtTime, fmtNumber, fmtCurrency, tBackend }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
